function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCashBooking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M435.87,203.985c0,33.81-14.05,66.03-37.07,93.83c-3.28,3.96-6.75,7.83-10.4,11.61 c-1.81,1.88-3.67,3.74-5.56,5.56c-8.89,8.62-18.66,16.66-29.13,24.04c-3.92,2.77-7.95,5.45-12.07,8.03 c-10.34,6.48-21.24,12.32-32.52,17.45c-0.02,0.01-0.05,0.02-0.07,0.03c-2.96,1.35-5.96,2.65-8.97,3.9 c-4.46,1.84-8.96,3.57-13.52,5.18c-14.73,5.23-29.93,9.23-45.27,11.84c-3.31,0.56-6.63,1.06-9.95,1.49 c-3.47,0.45-6.94,0.83-10.41,1.13c-5.36,0.47-10.73,0.75-16.08,0.85h-0.01c-1.43,0.03-2.84,0.04-4.27,0.04h-1.28 c-0.01,0-0.01,0-0.02,0c-1.38-0.01-2.74-0.03-4.1-0.06c0,0,0-0.01-0.01,0c-0.27-0.01-0.53-0.02-0.79-0.03 c-3.62-0.09-7.16-0.27-10.63-0.54c-0.17-0.01-0.33-0.02-0.5-0.04c-1.33-0.1-2.65-0.22-3.96-0.36c-0.34-0.02-0.67-0.06-1-0.1 c-1.1-0.11-2.19-0.23-3.28-0.36c-0.45-0.06-0.89-0.11-1.33-0.17c-0.07-0.01-0.13-0.01-0.19-0.02c-32.03-4.16-57.5-15.82-77.16-33 c-6.39-5.58-12.16-11.74-17.35-18.42c-3.78-4.86-7.25-9.99-10.4-15.37c-18.37-31.21-26.59-70.7-26.59-113.32 c0-30.14,9.78-58.55,26.59-83.51c3.21-4.78,6.68-9.43,10.4-13.94v-0.01c5.48-6.67,11.49-13.04,17.95-19.05 c10.81-10.09,22.9-19.22,35.99-27.2c0.25-0.16,0.51-0.32,0.77-0.47c0.07-0.04,0.13-0.08,0.2-0.12 c25.93-15.66,55.71-26.87,87.05-32.2c13.55-2.31,27.39-3.52,41.34-3.52c54.79,0,97.04,17.91,126.13,47.57 c3.68,3.75,7.15,7.69,10.4,11.8C423.34,117.505,435.87,158.435,435.87,203.985z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M78.97,109.725v226.14c-3.78-4.86-7.25-9.99-10.4-15.37v-196.83 C71.78,118.885,75.25,114.235,78.97,109.725z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M231.34,30.675v356.27c-3.47,0.45-6.94,0.83-10.41,1.13v-357.4H231.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M398.8,86.525v211.29c-3.28,3.96-6.75,7.83-10.4,11.61v-234.7 C392.08,78.475,395.55,82.415,398.8,86.525z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M76.202,136.223c40.216,0,80.432,0,120.648,0c40.011,0,80.021,0,120.032,0 c22.57,0,45.14,0,67.71,0c3.217,0,3.223-5,0-5c-40.216,0-80.432,0-120.648,0c-40.011,0-80.021,0-120.032,0 c-22.57,0-45.14,0-67.71,0C72.985,131.223,72.979,136.223,76.202,136.223L76.202,136.223z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M76.915,286.501c41.169,0,82.339,0,123.508,0c41.169,0,82.339,0,123.508,0 c23.224,0,46.447,0,69.671,0c3.217,0,3.223-5,0-5c-41.169,0-82.339,0-123.508,0c-41.169,0-82.339,0-123.508,0 c-23.224,0-46.447,0-69.671,0C73.698,281.501,73.693,286.501,76.915,286.501L76.915,286.501z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M243.41,202.173c-0.141,1.751-5.112,74.545,0,77.101c5.112,2.556,133.329,11.075,134.607,0 c1.278-11.075,7.667-73.705-2.13-79.663C366.089,193.653,243.956,195.393,243.41,202.173z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M351.141,210.136c0.312-3.058,4.783-1.951,2.39-4.453c-1.019-0.229-1.765,1.007-1.808,1.895 c0.017,1.3-2.04,0.681-3.027,1.379C348.666,210.279,350.787,212.041,351.141,210.136z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M349.008,239.658c0.449,0.102,0.791,0.178,1.162,0.26 C354.28,238.05,347.856,235.418,349.008,239.658z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M354.432,276.091c-0.211-1.951-2.497-1.643-2.836,0.24 C352.748,277.503,353.756,277.821,354.432,276.091z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M347.762,240.254c-0.902,0.184-1.695,0.286-1.921,1.3c0.273,2.046,2.104,1.247,2.845-0.056 C348.575,240.994,348.328,240.567,347.762,240.254z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M360.594,284.071c0.759-0.058,1.499-0.121,2.219-0.187c-0.008-0.021-0.018-0.048-0.025-0.068 C361.82,283.359,361.017,283.605,360.594,284.071z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M379.813,233.915c0.207-0.498,0.389-0.936,0.598-1.438 C377.886,228.964,376.497,234.85,379.813,233.915z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M379.11,268.576c0.073-0.792,0.147-1.613,0.222-2.459c-0.175-0.09-0.382-0.156-0.633-0.188 C376.927,266.914,377.986,268.611,379.11,268.576z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M346.943,225.564c0.475-0.118,0.922-0.23,1.368-0.34 C350.421,221.836,343.342,223.24,346.943,225.564z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M342.239,219.253c0.143-0.703,0.143-0.703,0.644-1.21c-0.247-0.4-0.608-0.696-1.024-1.053 C338.929,217.171,340.765,221.425,342.239,219.253z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M376.762,242.52c0.335-0.142,0.209-0.464,0.192-0.735c0.617-0.727-0.068-1.56-0.871-1.723 c-0.418,0.31-0.919,0.485-1.433,0.391C374.369,241.815,375.353,243.149,376.762,242.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M351.372,204.257c0.179-1.442-2.096-2.062-2.392-0.573 C348.518,205.363,351.248,206.118,351.372,204.257z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M346.082,235.288c0.359,1.939,1.62,2.437,2.649,0.589 C348.072,234.755,346.672,233.274,346.082,235.288z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M345.427,210.363c1.148-1.643-2.223-2.788-2.216-0.813 C343.026,210.788,344.924,211.891,345.427,210.363z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M362.741,210.451c1.356-1.624-1.632-2.515-2.456-0.944 C360.82,210.77,361.599,211.863,362.741,210.451z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M342.675,229.683c-0.892-1.436-1.947-1.548-2.558,0.228 C340.195,231.772,343.184,231.256,342.675,229.683z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M342.584,263.591c-0.292-0.148-0.642-0.326-1.103-0.561 C338.072,265.329,343.226,267.508,342.584,263.591z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M367.954,260.186c-1.029-0.021-1.59,0.547-1.92,1.472c0.271,0.377,0.542,0.752,0.789,1.095 c0.548-0.106,1.007-0.194,1.516-0.293c0.18-0.362,0.368-0.741,0.557-1.12C368.557,260.925,368.262,260.563,367.954,260.186z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M347.255,274.912c-3.237,0.151,0.822,4.616,1.234,1.236 C348.591,275.065,348.037,275.144,347.255,274.912z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M344.536,234.175c0.588-0.34,0.882-0.957,1.348-1.662c-0.877-1.544-1.881-1.188-2.752,0.116 C343.148,233.527,343.529,234.112,344.536,234.175z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M370.641,199.745c-0.389,0.101-0.797,0.206-1.131,0.292c-0.724,1.117-0.269,2.321,1.102,2.482 c0.398-0.459,0.779-0.9,1.14-1.317C371.557,200.548,371.21,200.09,370.641,199.745z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M345.479,216.357c0.474-2.155-1.346-2.998-2.269-0.893 C343.107,216.659,345.119,217.614,345.479,216.357z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M351.499,255.734c-0.037-0.835-0.553-1.168-1.306-1.254c-1.097,0.416-0.946,1.354-1.14,2.2 C350.26,257.711,351.007,257.013,351.499,255.734z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M371.954,215.451c0.003,1.486,1.378,1.907,2.265,0.631c0.032-0.62,0.302-1.131,0.068-1.668 c-0.273-0.087-0.534-0.171-0.78-0.25C372.873,214.584,372.091,214.62,371.954,215.451z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M359.001,274.615c-3.847,1.233,0.473,4.461,1.198,1.033 C359.805,275.308,359.427,274.983,359.001,274.615z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M363.286,224.74c0.529,1.097,2.243,1.245,2.242-0.348 C365.234,222.143,362.969,222.533,363.286,224.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M373.774,222.553c2.463-2.216-1.585-3.734-1.955-0.95 C372.286,222.344,373.169,221.999,373.774,222.553z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M377.108,206.209c-0.878-0.563-1.786-0.252-2.747-0.655c0.765,1.258,0.765,1.258,0.733,2.389 C376.129,208.42,378.544,207.294,377.108,206.209z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M367.71,225.54c-1.135,0.976-2.234,1.897-0.511,2.816c0.722,0.409,1.092-0.534,1.49-0.985 C369.287,226.562,368.194,226.149,367.71,225.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M341.236,271.64c1.583-0.668,2.293-1.26,0.815-2.557c-0.697-0.113-1.146,0.322-1.637,0.57 c-0.103,0.342-0.193,0.638-0.284,0.938C340.487,271.005,340.808,271.4,341.236,271.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M359.741,223.202c-3.066-0.479-3.269,2.69,0.044,1.773 C360.261,224.388,360.436,223.836,359.741,223.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M337.742,226.019v0.192c0.106,0.289,0.106,0.521,0,0.747v0.984c0.374,0.323,1.1,0.325,1.56,0.289 C340.995,227.333,339.22,225.085,337.742,226.019z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M353.405,265.619c1.288-1.131,1.189-1.809-0.326-2.508 C351.13,263.61,351.35,265.664,353.405,265.619z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M378.719,222.621c1.581,0.13,2.398-2.224,0.523-2.297 C377.596,220.023,377.236,222.112,378.719,222.621z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M340.406,253.529c0.958,1.066,1.904,0.527,2.524-0.57 C342.128,251.064,340.067,251.353,340.406,253.529z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M351.366,243.687c-0.448-0.296-0.807-0.533-1.14-0.753c-0.918,0.411-0.918,0.411-1.379,1.602 C349.789,246.104,351.773,245.676,351.366,243.687z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M373.619,202.994c-1.49-0.576-1.421,1.363-1.835,2.291c0.605,0.152,1.129-0.521,1.798-0.194 c0.099,0.042,0.31-0.079,0.419-0.179C374.627,204.354,374.605,203.067,373.619,202.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M374.491,267.075c-0.298-0.278-0.613-0.574-0.906-0.849c-1.395,0.379-1.395,0.379-1.674,1.584 C372.677,269.261,374.673,268.812,374.491,267.075z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M377.678,227.609c0.367,0.272,0.772,0.572,1.209,0.895 C382.104,226.766,378.127,223.802,377.678,227.609z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M359.961,253.775c0.084-1.625,0.009-1.77-1.128-2.225c-0.45,0.396-0.913,0.805-1.36,1.197 c0.232,0.502,0.424,0.914,0.597,1.287C358.805,253.85,359.363,254.357,359.961,253.775z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M370.552,211.242c-0.366,0.25-0.749,0.51-1.102,0.75 C368.333,215.56,374.137,213.296,370.552,211.242z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M355.063,232.156c-0.092,0.314-0.189,0.646-0.281,0.961 C357.138,236.79,358.826,229.86,355.063,232.156z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M361.506,251.242c3.597-0.693,0.174-3.921-1.207-1.15 C360.445,250.717,360.824,251.081,361.506,251.242z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M354.758,256.151c0.427,0.681,1.105,0.87,1.771,1.103c0.455-0.389,0.561-0.914,0.82-1.358 C356.978,254.292,354.457,254.279,354.758,256.151z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M364.622,246.003c-1.485-0.188-1.74,2.044-0.475,2.369 C365.643,248.858,366.56,245.906,364.622,246.003z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M343.366,250.568c0.556,0.935,2.556,0.987,2.46-0.4 C345.45,248.461,342.613,248.643,343.366,250.568z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M381.017,219.233c-0.028-0.541-0.059-1.075-0.092-1.601 C380.377,218.16,380.26,218.8,381.017,219.233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M369.131,270.284c0.438,0.477,0.564,1.129,1.193,1.36c0.72-0.297,1.176-0.793,1.359-1.605 C370.629,268.703,369.673,268.328,369.131,270.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M364.831,228.552c-1.088,0.344-1.088,0.344-1.453,1.375c0.182,0.265,0.381,0.554,0.588,0.856 c0.378,0.094,0.758,0.189,1.223,0.307C366.445,230.348,366.016,229.046,364.831,228.552z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M373.372,271.738c-0.44,0.285-0.998,0.347-1.336,0.883c0.17,0.45,0.348,0.922,0.51,1.353 c0.38,0.122,0.68,0.218,1.025,0.328C374.797,273.534,375.196,271.959,373.372,271.738z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M350.396,262.972c0.542-0.424,0.979-0.895,1.229-1.518 C350.125,258.852,347.398,261.921,350.396,262.972z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M356.729,216.693c0.234-0.336,0.434-0.621,0.664-0.952c-0.513-0.526-0.689-1.286-1.498-1.626 c-0.438,0.319-0.908,0.66-1.421,1.034C354.776,216.416,355.664,216.554,356.729,216.693z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M343.406,198.88c0.635,1.275,2.294,0.168,2.39-0.914 C344.688,196.283,342.781,197.11,343.406,198.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M352.58,199.665c-0.367,0.508-0.804,0.912-0.923,1.594c0.441,0.336,0.902,0.688,1.343,1.022 c0.429-0.116,0.802-0.218,1.242-0.339c-0.127-0.636-0.247-1.234-0.37-1.852C353.421,199.943,353.018,199.81,352.58,199.665z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M366.559,210.599c1.534,0.549,1.76,0.463,2.206-0.769c-0.565-1.392-2.069-1.726-2.675-0.176 C366.277,210.031,366.432,210.343,366.559,210.599z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M360.339,214.715c-0.093,0.711,0.458,0.911,0.377,1.665c0.844,0.118,1.706,0.686,2.117-0.283 C362.807,214.307,361.808,213.896,360.339,214.715z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M361.767,280.248c1.022-0.295,1.25-0.985,1.214-1.858 C361.206,276.765,359.194,279.561,361.767,280.248z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M378.143,278.156c-0.512,0.5-0.582,1.066-0.228,1.455c0.041-0.112,0.088-0.222,0.102-0.338 C378.054,278.946,378.097,278.571,378.143,278.156z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M339.351,233.905c0.057-0.566,0.26-1.048,0.646-1.419c-0.222-1.088-1.544-1.471-2.254-0.675 v0.751c0.089,0.438,0.274,0.861,0.237,1.315C338.473,234.036,338.886,234.027,339.351,233.905z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M353.249,214.031c0.541-0.554,1.13-1.033,0.951-1.924c-0.37-0.294-0.732-0.582-1.078-0.857 c-0.858,0.236-1.358,0.706-1.36,1.597C352.103,213.405,352.674,213.667,353.249,214.031z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M337.742,220.39v1.68c0.081,0.119,0.159,0.236,0.246,0.365 C341.592,222.938,339.039,219.124,337.742,220.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M367.551,222.423c2.967-1.426-0.962-3.964-1.63-0.856 C366.551,221.898,367.065,222.169,367.551,222.423z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M361.91,225.577c-1.502,0.411-2.022,2.199-0.435,2.761 C362.86,227.658,363.461,226.447,361.91,225.577z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M377.585,273.186c0.364,0.445,0.681,0.72,0.997,0.845c0.073-0.712,0.148-1.47,0.227-2.271 C378.34,271.793,377.866,272.237,377.585,273.186z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M381.234,230.98c0.006-0.694,0.009-1.383,0.009-2.068 C380.641,229.372,380.5,230.383,381.234,230.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M339.275,243.211c-0.841-0.093-1.306,0.09-1.533,0.383v1.136 c0.461,0.891,1.729,1.513,2.278-0.317C339.74,243.954,339.677,243.539,339.275,243.211z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M351.835,247.738c0.877,0.688,2.392,0.695,2.668-0.596 C353.621,245.538,351.222,245.809,351.835,247.738z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M346.989,268.761c-1.267,1.376-0.683,2.481,0.96,2.873c0.388-0.432,0.542-0.921,0.772-1.396 C348.433,269.453,347.692,269.297,346.989,268.761z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M365.513,240.46c-0.762-0.756-1.348-0.377-2.043,0.121 C362.128,242.576,366.402,243.461,365.513,240.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M369.379,235.384c-0.146,0.813,0.36,1.714,1.283,1.444 C373.289,236.174,369.297,232.479,369.379,235.384z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M346.989,265.664c1.511,0.161,2.221-2.43,0.311-2.381 C345.877,263.146,345.723,265.506,346.989,265.664z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M362.729,197.341c-0.559-0.043-1.147-0.088-1.807-0.14 C358.864,199.67,364.462,200.205,362.729,197.341z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M370.957,206.017c-0.99-0.55-1.8,0.032-2.106,1.101c0.642,0.391,1.393,1.732,2.119,0.892 C371.547,207.511,371.671,206.443,370.957,206.017z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M364.694,274.69c-1.52,0.113-1.92,2.236-0.221,2.487 C365.906,277.092,366.176,274.922,364.694,274.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M360.086,212.626c-0.518-0.873-1.234-1.635-2.183-0.791c0.056,0.236,0.099,0.422,0.146,0.625 c-0.216,0.136-0.436,0.274-0.701,0.441C358.238,214.111,360.047,214.399,360.086,212.626z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M376.159,274.616c-0.797,0.186-1.156,0.655-1.256,1.338c0.216,0.396,0.42,0.772,0.625,1.147 C377.254,277.357,378.183,275.392,376.159,274.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M355.033,227.859c1.016,0.898,1.36,0.758,2.245-0.439 C356.903,225.057,354.568,225.551,355.033,227.859z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M368.903,218.41c0.519,1.332,1.589,1.459,2.42,0.328 C372.083,216.903,369.214,216.652,368.903,218.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M381.214,225.222c-0.012-0.739-0.026-1.473-0.046-2.196c-0.644,0.143-0.128,1.269-0.474,1.674 C380.849,224.964,381.024,225.122,381.214,225.222z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M365.334,254.15c0.241-0.319,0.452-0.598,0.683-0.903 C365.208,249.248,361.503,254.578,365.334,254.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M342.51,246.56c-1.38-1.33-2.02,0.161-2.442,1.41C341.187,248.87,343.276,248.072,342.51,246.56z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M368.638,199.507c0.13-0.544,0.03-1.169-0.223-1.646c-0.614-0.08-1.259-0.157-1.933-0.231 C366.274,199.308,366.949,199.592,368.638,199.507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M359.895,240.712c-1.047-0.887-1.889-0.544-2.266,0.75c0.25,0.369,0.492,0.729,0.758,1.123 c0.391,0,0.782,0,1.207,0C360.137,242.044,360.066,241.398,359.895,240.712z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M348.997,267.388c0.593,0.326,0.412,1.297,1.294,1.36c0.419-0.36,0.865-0.745,1.316-1.134 C351.435,265.839,349.521,265.745,348.997,267.388z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M359.989,219.109c-0.013-0.646,0.245-1.371-0.629-1.835 C356.204,217.507,358.049,220.777,359.989,219.109z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M353.003,222.781c-1.876,1.089-1.222,3.229,0.974,2.215 C354.348,224.106,354.209,222.987,353.003,222.781z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M360.555,220.73c0.066,1.12,0.55,1.637,1.68,1.744c0.295-0.49,0.748-0.799,0.785-1.404 C362.02,220.117,361.636,219.145,360.555,220.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M363.712,206.045c-0.116,0.468-0.228,0.917-0.322,1.292c0.929,1.603,2.567,0.574,2.364-0.961 c-0.262-0.449-0.665-0.526-1.041-0.691C364.385,205.804,364.053,205.923,363.712,206.045z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M368.108,245.458c0.18-0.472,0.347-0.91,0.525-1.379 C366.617,241.073,364.706,246.2,368.108,245.458z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M340.969,280.397c-0.502,0.607-0.555,1.268-0.609,1.938c0.497,0.564,1.081,0.741,1.822,0.524 c0.007-0.693,0.186-1.098,0.566-1.697C342.128,280.892,341.825,280.123,340.969,280.397z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M350.32,228.393c0.397-0.3,0.803-0.608,1.319-1c-0.225-0.458-0.415-0.844-0.629-1.279 C348.935,225.267,348.293,227.833,350.32,228.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M347.878,251.775c-0.899,0.501-2.235,0.454-1.547,1.764 C347.394,255.625,349.682,253.118,347.878,251.775z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M370.698,230.397c1.958-1.355-1.645-2.593-1.79-0.576 C368.79,231.053,371.699,232.042,370.698,230.397z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M348.68,229.839c-0.197-0.375-0.336-0.844-0.847-1.038c-0.371,0.081-0.75,0.165-1.108,0.244 c-0.273,0.359-0.526,0.693-0.77,1.015c0.234,0.359,0.426,0.652,0.638,0.976C347.531,231.301,348.507,230.834,348.68,229.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M340.711,236.915c0.905-0.282,1.85-0.212,2.228-1.259 C341.934,233.462,339.623,234.729,340.711,236.915z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M374.211,245.1c0.818-1.922-0.9-2.851-2.17-1.095C372.341,245.12,373.172,246.081,374.211,245.1z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M361.93,237.113c-0.381,0.672-1.417,0.666-1.411,1.715c0.313,0.511,0.614,1.122,1.524,1.041 C363.291,239.315,362.895,237.875,361.93,237.113z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M354.776,204.226c-0.111,1.188,2.358,1.238,2.347,0.058 C357.024,202.5,354.858,202.271,354.776,204.226z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M343.997,228.156c1.235,0.102,1.235,0.102,1.748-0.992c-0.299-0.498-0.598-0.997-0.944-1.575 c-0.694,0.272-1.186,0.574-1.646,1.1C343.457,227.174,343.57,227.767,343.997,228.156z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M354.54,281.909c-0.412-0.499-0.806-0.975-1.309-1.581c-0.521,0.346-0.941,0.623-1.346,0.892 c-0.038,0.485-0.072,0.907-0.113,1.416C352.884,282.599,353.812,282.968,354.54,281.909z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M350.218,214.329c-0.298,0.199-0.622,0.416-0.919,0.614c-0.092,0.383-0.175,0.725-0.275,1.141 c0.998,1.08,1.215,1.098,2.215,0.213C351.29,215.529,351.265,214.547,350.218,214.329z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M375.253,223.298c-0.401,0.746-0.084,1.28,0.271,2.041c1.1,0.248,2.025-0.496,1.727-1.656 C377.029,223.1,375.548,222.654,375.253,223.298z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M339.79,255.304c-0.477-0.438-1-0.433-1.615-0.52c-0.14,0.153-0.289,0.288-0.432,0.426v1.316 C338.731,257.388,340.219,257.056,339.79,255.304z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M347.879,246.074c-0.459-0.084-0.849-0.15-1.248,0.088c-0.182,0.375-0.371,0.767-0.563,1.166 C347.159,249.491,349.535,247.853,347.879,246.074z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M352.014,219.099c0.922,1.459,2.227,0.251,2.419-1c-0.372-0.297-0.708-0.564-1.03-0.819 C352.07,217.539,352.105,217.887,352.014,219.099z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M342.612,275.133c-1.153-0.576-1.894-0.254-2.321,0.977c0.679,0.541,1.747,1.805,2.278,0.477 C342.762,276.124,343.288,275.459,342.612,275.133z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M349.367,221.987c1.131,0.816,2.376-0.23,1.955-1.55 C350.066,219.235,348.443,220.56,349.367,221.987z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M351.799,270.382c0.561,1.105,2.112,1.628,2.451,0.172 C354.272,268.733,352.19,268.658,351.799,270.382z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M369.691,275.108c-0.862,0.701-0.273,2.032,0.781,2.067 C372.427,276.98,371.075,273.324,369.691,275.108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M337.742,209.065v1.56c0.211,0.233,0.565,0.4,0.965,0.624 C341.469,209.403,338.426,208.117,337.742,209.065z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M371.653,252.22c-0.832-1.018-2.426-0.089-2.259,1.137 C370.224,255.003,371.903,253.814,371.653,252.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M371.485,241.972c0.062-0.219,0.125-0.445,0.189-0.674c-0.621-1.107-1.649-0.975-2.721-0.928 c0.182,0.594,0.191,0.986,0.168,1.593C369.968,242.336,370.807,242.447,371.485,241.972z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M367.046,248.935c-0.325,0.416-0.798,0.672-0.991,1.147c0.545,0.754,1.096,1.071,2.018,1.155 C369.573,250.352,368.505,249.052,367.046,248.935z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M363.611,258.226c0.242,1.917,1.455,2.155,2.434,0.411 C365.903,257.366,363.965,256.903,363.611,258.226z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M341.854,257.47c-1.335,0.031-2.363,2.305-0.266,2.415 C342.865,259.635,343.22,257.862,341.854,257.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M350.384,280.227c0.399-0.391,0.9-0.727,1.099-1.379 C349.955,276.32,347.393,279.263,350.384,280.227z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M367.862,239.954c0.276-0.4,0.557-0.806,0.842-1.218 C367.552,235.377,364.734,239.096,367.862,239.954z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M380.571,246.605c0.048,0.092,0.094,0.184,0.139,0.274c0.006-0.121,0.013-0.242,0.019-0.363 C380.673,246.548,380.631,246.571,380.571,246.605z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M376.125,263.292c-1.465,0.122-1.579,2.199-0.057,2.375 C377.566,265.598,377.6,263.465,376.125,263.292z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M381.174,234.833c-0.075,0.088-0.146,0.189-0.204,0.321c0.057,0.326,0.114,0.648,0.173,0.988 C381.154,235.705,381.164,235.269,381.174,234.833z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M377.821,210.111c0.692,0.695,1.176,1.027,1.522,1.029c0.249-0.186,0.526-0.392,0.776-0.58 c-0.321-0.563-0.173-1.027-0.48-1.6C378.748,207.855,377.811,209.036,377.821,210.111z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M341.821,199.75c-0.117-0.041-0.397,0.038-0.409,0.101c-0.105,0.551-0.6,0.534-0.995,0.674 c0.059,0.442,0.112,0.848,0.165,1.241c0.644,0.12,1.222,0.507,1.872,0.203C343.394,200.851,342.776,200.418,341.821,199.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M362.261,245.363c1.306-0.784,0.833-1.781-0.412-2.324c-0.679,0.396-1.895,0.903-1.056,1.695 C361.229,245.051,361.706,245.754,362.261,245.363z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M364.777,213.806c0.741-0.283,1.137-0.759,1.167-1.54c-0.108-0.175-0.228-0.37-0.335-0.541 c-0.942-0.071-1.84-0.231-2.375,0.867C363.535,213.251,364.18,213.523,364.777,213.806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M337.742,198.595c0.124,0.258,0.329,0.539,0.636,0.837c0.515-0.194,0.952-0.36,1.523-0.576 c0.012-2.002-1.648-2.156-2.159-1.377V198.595z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M339.364,268.296c0.8-0.627,0.391-2.096-0.53-2.133c-0.709-0.128-0.924,0.194-1.091,0.677v1.334 C338.156,268.411,338.977,268.261,339.364,268.296z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M337.742,272.488v1.287c0.159,0.142,0.306,0.273,0.484,0.431 C341.571,274.204,339.039,270.703,337.742,272.488z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M359.428,259.808c0.184-0.264,0.387-0.552,0.587-0.839c-0.115-0.444-0.224-0.861-0.366-1.411 c-0.924,0.028-1.717,0.136-1.978,1.163C358.006,259.976,358.317,260.046,359.428,259.808z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M339.428,249.152c-0.976-0.265-1.563,0.148-1.686,0.733v0.449 c0.072,0.392,0.315,0.803,0.79,1.124C339.861,250.995,340.6,250.183,339.428,249.152z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M372.016,209.298c0.155,0.773,0.462,1.955,1.514,1.581c0.212-0.532,0.539-0.887,1.078-1.062 C374.426,208.023,373.072,208.43,372.016,209.298z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M354.825,243.973c0.063,0.551,0.113,1.004,0.164,1.459c0.336,0.097,0.673,0.194,0.996,0.288 c0.891-0.748,0.943-0.887,0.832-2.236c-0.453-0.113-0.93-0.232-1.402-0.351C355.168,243.484,354.967,243.77,354.825,243.973z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M343.278,244.318c0.543,1.196,1.495,1.485,2.428,0.572 C345.87,243.133,343.735,242.439,343.278,244.318z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M359.235,236.779c0.886-0.777,1.07-1.5,0.035-2.284c-0.693,0.234-1.744,0.165-1.77,1.13 c0.209,0.316,0.403,0.613,0.604,0.918C358.499,236.624,358.879,236.704,359.235,236.779z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M339.856,239.048c0.104-1.052-1.158-2.214-2.092-1.377c-0.009,0.01-0.013,0.02-0.022,0.03v1.456 C338.245,239.634,339.229,239.745,339.856,239.048z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M378.548,254.648c-1.489,0.175-0.669,2.785,0.852,1.918c0.346-0.066,0.578-0.175,0.721-0.306 c0.019-0.26,0.037-0.518,0.056-0.78C379.898,255.03,379.199,254.625,378.548,254.648z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M352.112,240.716c-0.498,2.231,1.28,2.48,2.36,0.828 C354.194,240.213,353.123,240.169,352.112,240.716z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M372.297,255.054c-0.031,0.471-0.063,0.94-0.092,1.379c0.45,0.465,0.975,0.572,1.641,0.502 c0.111-0.437,0.129-0.816,0.514-1.086C375.348,254.725,372.955,254.547,372.297,255.054z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M357.374,278.822c-0.49-0.511-0.844-1.109-1.565-1.248c-0.595,0.299-0.825,0.869-1.16,1.369 C355.692,280.162,356.592,280.466,357.374,278.822z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M354.83,284.43c0.714-0.035,1.412-0.073,2.102-0.112c-0.05-0.205-0.104-0.423-0.166-0.676 C355.705,282.824,354.954,283.343,354.83,284.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M362.51,266.417c-1.968-0.314-2.755,0.734-1.308,2.098 C362.527,268.704,363.246,267.521,362.51,266.417z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M367.889,266.176c-1.021,0.389-1.918,0.368-1.631,1.689c1.059,0.98,1.371,0.958,2.391-0.122 C368.415,267.24,368.456,266.594,367.889,266.176z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M348.104,200.384c-1.337-0.561-1.337-0.561-1.914-0.086 C345.691,203.023,349.133,202.861,348.104,200.384z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M376.816,270.743c0.964-0.683,0.135-1.276-0.344-1.924c-0.438,0.148-0.805,0.272-1.063,0.359 c-0.16,0.681-0.294,1.248-0.442,1.882C375.738,271.492,376.342,271.557,376.816,270.743z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M362.649,255.903c-0.005-1.843-2.462-1.403-2.356,0.198 C360.42,256.867,362.922,257.277,362.649,255.903z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M375.542,252.071c-1.061,1.339-0.678,1.222,0.357,1.972c0.802,0.369,1.453-0.611,1.604-1.35 C376.995,251.785,376.241,251.985,375.542,252.071z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M345.757,284.275c-0.343-0.386-0.629-0.707-0.889-0.998c-1.012,0.202-1.522,0.904-1.562,1.49 c0.731-0.01,1.456-0.022,2.174-0.035C345.562,284.564,345.657,284.404,345.757,284.275z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M342.396,242.181c0.074-0.377,0.149-0.755,0.222-1.124 C340.297,238.46,339.018,243.624,342.396,242.181z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M354.243,235.653c-0.525-1.855-2.468-1.462-2.326,0.492 C351.999,237.507,354.02,236.503,354.243,235.653z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M354.75,209.524c0.104,1.729,2.479,1.951,2.263-0.224 C355.849,208.108,355.301,208.522,354.75,209.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M338.696,262.994c0.684-0.34,0.958-0.879,1.064-1.596c-0.278-0.886-1.421-1.326-2.018-0.678 v1.298C338.04,262.363,338.487,262.66,338.696,262.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M373.526,280.203c0.337-0.817,1.186-0.859,0.821-1.933 C372.162,276.558,371.201,279.871,373.526,280.203z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M347.748,208.076c1.526-0.743,0.501-2.353-0.758-2.325c-0.539,0.494-0.995,0.75-1.167,1.497 C346.516,207.546,347.131,207.81,347.748,208.076z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M376.501,231.023c0.423,0.121,0.578-0.579,0.771-0.815c-0.177-0.345-0.319-0.622-0.508-0.989 c-1.545-0.782-2.715,0.596-1.311,1.795C375.774,231.075,376.143,230.535,376.501,231.023z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M342.893,224.339c-0.591-0.507-0.597-1.184-1.225-1.467c-1.362,0.244-1.728,1.441-0.752,2.414 C341.585,225.01,342.391,225.032,342.893,224.339z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M357.348,270.331c0.119,0.265,0.229,0.511,0.388,0.866 C361.932,271.961,359.369,267.217,357.348,270.331z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M380.988,240.895c-0.092,0.091-0.182,0.175-0.278,0.292c0.009,0.322,0.101,0.584,0.233,0.802 C380.958,241.624,380.974,241.26,380.988,240.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M343.51,239.516c1.771,0.022,1.966,0.292,2.047-1.626c-0.377-0.24-0.705-0.449-1.012-0.644 c-0.531,0.361-1.016,0.692-1.571,1.07C343.301,238.707,343.389,239.001,343.51,239.516z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M369.896,246.175c-0.349,0.242-0.683,0.475-1.017,0.707c0.868,1.341,1.734,2.046,2.863,0.647 C371.503,246.558,370.917,246.138,369.896,246.175z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M354.528,198.212c0.58,0.835,1.238,1.371,2.317,1.121c0-0.61,0-1.16,0-1.68 C355.672,196.538,355.301,197.288,354.528,198.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M373.163,199.65c0.965,0.119,1.321-0.173,1.334-0.619c-0.621-0.197-1.384-0.383-2.267-0.559 c0,0,0,0.001,0,0.001C372.533,198.856,372.822,199.22,373.163,199.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M344.167,205.313c0.506-0.252,0.95-0.473,1.518-0.758c-0.599-0.753-0.103-1.592-0.972-1.931 c-0.646,0.146-1.08,0.502-1.406,1.049c0.195,0.236,0.366,0.441,0.529,0.637c-0.092,0.234-0.174,0.443-0.273,0.697 C343.809,205.131,344.014,205.236,344.167,205.313z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M350.305,231.464c-0.867,0.453-0.867,0.453-1.38,1.559 C350.671,235.222,352.537,232.857,350.305,231.464z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M376.107,199.769c-1.43,0.424-1.49,2.111,0.162,2.286c1.056,0.157,1.156-0.555,0.875-1.262 C376.822,200.369,376.475,200.032,376.107,199.769z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M350.075,283.331c-0.647,0.31-0.818,0.784-0.881,1.312c0.69-0.02,1.368-0.042,2.041-0.066 c-0.078-0.283-0.154-0.557-0.23-0.833C350.667,283.593,350.347,283.453,350.075,283.331z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M348.981,272.787c-0.057,2.049,2.38,1.724,2.533-0.144 C350.854,272.269,349.218,271.7,348.981,272.787z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M357.971,206.014c-0.42,0.93-0.146,1.616,0.688,2.22c1.304-0.35,1.307-0.621,1.49-1.548 c-0.212-0.243-0.393-0.45-0.539-0.618C358.952,206.182,358.594,206.149,357.971,206.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M365.43,263.642c-1.512-0.305-1.629-0.018-2.262,1.104 C364.053,266.508,366.228,265.387,365.43,263.642z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M355.715,251.495c0.889-0.145,1.255-0.918,1.377-1.853c-0.213-0.223-0.479-0.502-0.748-0.781 c-0.709,0.346-1.555,0.232-1.733,1.102C354.99,250.488,355.327,250.956,355.715,251.495z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M379.442,216.617c0.297-0.292,0.621-0.57,0.936-0.826c-0.585-1.359-1.246-1.811-2.4-1.046 C378.482,215.965,377.381,216.464,379.442,216.617z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M368.583,279.207c0.116-0.548-0.345-1.488-0.928-1.716c-0.652,0.523-1.451,1.126-1.37,1.99 C367.208,280.129,367.979,280.227,368.583,279.207z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M368.553,204.577c0.317-1.438-1.223-2.431-2.243-1.144 C366.279,204.922,367.391,205.343,368.553,204.577z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M358.942,283.123c0.365-0.436,0.74-0.883,1.096-1.309c-0.119-0.512-0.246-0.916-0.662-1.199 C357.708,280.781,356.796,282.894,358.942,283.123z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M350.465,199.41c0.565-0.339,0.925-0.786,1.123-1.451c-0.639-0.496-1.733-0.969-2.555-0.496 c-0.192,0.58,0.221,1.031,0.314,1.569C349.751,199.167,350.115,199.29,350.465,199.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M363.378,281.692c-0.075,1.061,0.553,1.023,1.254,1.165 C367.093,282.386,363.807,278.847,363.378,281.692z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M374.366,239.322c-0.198-0.386-0.014-0.842,0.022-1.212c-0.671-0.876-2.363-0.377-2.48,0.573 C372.319,239.556,373.694,240.143,374.366,239.322z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M366.289,215.583c0.348,0.457,0.655,0.862,0.964,1.269c0.514-0.453,1.323-0.477,1.527-1.243 C368.245,214.146,366.947,213.898,366.289,215.583z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M338.837,283.206c-0.368,0.4-0.663,0.825-1.095,1.092v0.513c0.676-0.002,1.348-0.004,2.015-0.008 c-0.007-0.041-0.007-0.077-0.018-0.121C339.434,284.073,339.616,283.452,338.837,283.206z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M354.641,221.456c0.692,1.418,2.962,0.938,2.571-0.681 C355.553,220.093,355.112,220.214,354.641,221.456z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M369.096,224.345c0.23,0.332,0.449,0.646,0.65,0.936c1.266,0.091,1.279,0.079,1.741-1.439 C370.798,222.457,369.482,223.123,369.096,224.345z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M377.21,217.77c-0.439-0.212-0.826-0.397-1.152-0.556c-0.822,0.125-1.08,0.684-1.303,1.343 C375.637,219.809,377.764,219.505,377.21,217.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M376.09,236.839c0.601-0.137,0.912-0.274,1.357-0.661c-0.779-1.361-0.339-2.22-2.257-1.321 C375.248,235.752,374.941,236.584,376.09,236.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M376.257,260.13c0.345-0.4,0.671-0.779,1.026-1.192c-0.327-0.396-0.162-1.019-0.748-1.362 c-0.504,0.494-1.381,0.407-1.863,1.115C375.008,259.468,375.595,259.8,376.257,260.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M343.203,255.873c0.151,0.756,0.507,1.256,1.282,1.351c0.754-0.598,0.754-0.598,1.066-1.459 C344.994,254.441,343.775,254.835,343.203,255.873z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M359.451,248.292c0.829-2.041-0.253-3.076-2.016-1.461c0.213,0.209,0.397,0.389,0.582,0.568 c-0.026,0.256-0.054,0.51-0.088,0.833C358.46,248.257,358.893,248.489,359.451,248.292z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M374.316,227.902c0.591-1.447-1.305-2.101-2.243-1.145 C371.616,228.174,373.522,228.715,374.316,227.902z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M356.124,237.292c-0.712,0.752-1.964,0.495-1.297,1.927c0.776,0.354,1.498,0.56,2.223-0.196 C356.612,238.299,357.135,237.38,356.124,237.292z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M358.334,263.378c-0.075-0.033-0.415,0.283-0.396,0.323c0.225,0.463-0.292,0.771-0.266,1.235 c1.184,0.59,1.929,1.227,2.549-0.417C359.864,263.558,358.982,263.665,358.334,263.378z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M342.132,196.232c-0.44-0.012-0.877-0.024-1.322-0.035 C341.272,196.522,341.76,196.536,342.132,196.232z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M345.792,221.209c-1.052-1.197-2.789-0.955-2.24,0.907 C344.367,222.912,345.386,222.561,345.792,221.209z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M366.253,255.86c0.364,0.85,1.849,1.446,2.289,0.345 C368.614,254.401,366.455,253.963,366.253,255.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M341.387,205.833c-0.701,0.463-0.701,0.463-1.155,1.161 C341.07,209.641,344.503,205.764,341.387,205.833z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M377.293,212.708c-0.084-1.713-2.783-0.837-2.342,0.504 C375.443,214.345,377.128,213.722,377.293,212.708z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M344.684,260.469c-2.569,0.766-1.254,3.27,0.891,1.679 C345.293,261.559,345.52,260.779,344.684,260.469z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M380.383,238.842c-0.75-1.697-2.936-1.41-2.504,0.351c0.293,0.154,0.641,0.336,0.982,0.515 C379.415,239.437,380.083,239.46,380.383,238.842z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M344.297,280.199c0.657-0.036,0.658-0.894,1.115-1.246c0.749-1.049-0.929-1.096-1.621-1.166 c-0.346,0.25-0.463,0.622-0.605,1.096C343.892,279.167,343.675,279.957,344.297,280.199z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M362.833,204.788c0.294-1.386-1.721-2.398-2.448-0.935 C360.702,204.88,361.964,205.731,362.833,204.788z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M362.467,260.699c-0.292-0.084-0.553-0.159-0.914-0.264c-1.751,1.771-0.193,3.148,1.561,1.475 C362.887,261.484,362.672,261.081,362.467,260.699z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M348.479,212.499c-0.129-0.35-0.248-0.67-0.372-1.007c-0.861-0.108-1.558,0.66-2.131,1.222 c0.112,0.855,0.827,0.988,1.357,1.346C347.667,213.409,347.971,212.991,348.479,212.499z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M347.006,217.797c-0.427-0.17-0.744,0.368-1.08,0.548c0.564,1.895,2.114,1.529,2.742-0.108 c-0.257-0.243-0.504-0.476-0.754-0.712C347.598,217.724,347.366,217.99,347.006,217.797z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M363.35,201.775c0.647,0.266,1.211,0.498,1.809,0.744 C366.913,200.38,363.969,198.999,363.35,201.775z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M347.317,280.317c-0.459,0.505-0.957,0.881-1.195,1.503c0.207,0.284,0.41,0.564,0.623,0.857 C348.786,283.058,348.877,281.186,347.317,280.317z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M356.514,274.222c0.658-0.689,0.299-1.346-0.063-2.037c-0.81,0.004-1.427,0.338-1.934,0.896 C355.113,274.362,355.156,274.386,356.514,274.222z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M372.309,231.945c-0.059,0.418-0.108,0.762-0.164,1.16c0.402,0.24,0.602,0.718,1.168,0.893 c0.456-0.496,0.855-0.946,1.313-1.476C374.065,231.79,373.115,231.401,372.309,231.945z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M365.481,236.268c0.061-0.439,0.102-0.863-0.102-1.376c-0.393-0.131-0.83-0.278-1.318-0.442 C362.666,236.031,363.595,237.206,365.481,236.268z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M365.323,219.338c0.957-1.205,0.136-1.636-0.756-2.386c-0.424,0.424-0.798,0.795-1.156,1.152 c0.1,0.322,0.18,0.582,0.277,0.898C364.218,219.112,364.781,219.227,365.323,219.338z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M342.302,211.704c-0.665,0.01-1.325-0.223-1.835,0.521 C340.452,214.966,343.694,213.499,342.302,211.704z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M364.776,269.066c-0.466,0.395-0.91,0.771-1.417,1.201c0.786,1.883,1.879,1.085,2.616-0.213 C365.549,269.754,365.308,269.278,364.776,269.066z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M359.056,199.89c-0.433,0.156-0.792,0.287-1.113,0.404c-0.108,0.319-0.195,0.579-0.314,0.932 C359.016,203.506,360.857,201.238,359.056,199.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M374.926,247.468c0.374,1.019,1.547,1.238,2,0.33c-0.3-0.445,0.324-0.688,0.248-1.057 C376.142,245.886,375.624,246.052,374.926,247.468z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M361.373,234.042c1.483-0.475,1.96-1.321,0.715-2.38c-0.946,0.113-1.199,0.82-1.645,1.545 C360.721,233.456,361.012,233.718,361.373,234.042z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M378.395,243.415c-0.381,0.65-0.762,1.255-0.111,2.04c0.293-0.134,0.531-0.243,0.735-0.337 c0.245,0.143,0.307,0.377,0.573,0.285C380.606,244.178,379.927,243.131,378.395,243.415z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M358.668,228.939c-2.606,0.836,0.794,3.62,1.467,0.824 C359.848,229.173,359.218,229.212,358.668,228.939z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M353.831,252.031c-1.347-0.45-2.921,0.908-1.332,1.827 C353.381,254.197,354.917,252.966,353.831,252.031z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M369.168,264.207c0.195,0.429,0.354,0.779,0.51,1.123c0.468,0.114,0.919-0.055,1.563-0.064 C371.722,263.526,370.111,262.516,369.168,264.207z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M351.141,250.568c-0.024-0.481-0.043-0.906-0.065-1.338c-1.305-0.926-1.761,0.232-1.786,1.45 C350.145,251.763,350.545,251.147,351.141,250.568z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M345.325,273.667c0.309-0.712-0.875-2.174-1.594-1.555c0.063,0.589-0.338,0.99-0.797,1.497 C343.506,274.324,344.657,274.242,345.325,273.667z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M339.864,204.43c-0.065-1.848-1.593-1.359-2.121-0.541v1.002 C338.409,205.445,339.528,205.324,339.864,204.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M352.488,257.849c-1.133,0.785,0.463,2.905,1.534,1.64 C353.781,258.108,354.421,257.179,352.488,257.849z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M368.331,233.406c0.076-0.236,0.158-0.492,0.244-0.757c-0.17-0.323-0.335-0.636-0.505-0.958 c-0.665-0.182-1.126-0.03-1.521,0.357c-0.169,0.621,0.088,1.137,0.319,1.613C367.448,233.882,367.846,233.548,368.331,233.406z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M379.095,205.108c-0.188-0.647-0.391-1.246-0.608-1.799c-0.233,0.312-0.454,0.607-0.659,0.88 C378.106,205.038,378.628,205.234,379.095,205.108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M372.292,261.635c0.117,0.296,0.228,0.581,0.337,0.856c0.382,0.074,0.724,0.142,1.125,0.22 c0.231-0.411,0.456-0.807,0.704-1.249C373.946,260.257,372.48,260.456,372.292,261.635z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M378.611,260.746c-0.305,0.867-0.825,2.608,0.722,2.2c0.113-0.111,0.213-0.234,0.302-0.363 c0.047-0.563,0.093-1.135,0.139-1.714C379.554,260.666,379.191,260.581,378.611,260.746z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M369.549,259.529c1.156-0.146,1.253-0.193,1.7-0.856c-0.279-0.352-0.495-0.775-0.605-1.211 C369.283,257.296,368.475,258.537,369.549,259.529z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M375.373,281.574c0.559-0.226,1.025-0.466,1.412-0.719c-0.339,0-0.684,0-1.05,0 C375.607,281.11,375.487,281.347,375.373,281.574z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M356.501,260.445c-0.389-0.043-0.734-0.081-1.139-0.125c-0.115,0.496-0.22,0.943-0.27,1.154 c0.354,0.449,0.596,0.758,0.853,1.085C357.434,262.398,357.187,261.4,356.501,260.445z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M361.014,272.345c-0.584,1.474-0.079,2.661,1.459,1.351 C362.937,272.204,362.282,271.91,361.014,272.345z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M369.27,281.65c0.175,0.344,0.348,0.682,0.525,1.029c0.453,0,0.879,0,1.373,0 C372.298,280.892,369.474,280.099,369.27,281.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M338.807,216.687c0.378-0.532,1.224-1.341,0.57-1.951c-0.806-0.508-1.137,0.112-1.635,0.564 v0.961C338.034,216.738,338.357,217.162,338.807,216.687z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M379.147,251.269c1.225,0.022,0.655-1.311,0.662-2.131c-0.298,0.065-0.552,0.122-0.807,0.176 c-0.249,0.053-0.488-0.344-0.743-0.021c0.222,0.554,0.081,1.093-0.2,1.565C378.337,251.369,378.764,251.276,379.147,251.269z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M347.821,257.831c-0.816-0.274-1.178,0.417-1.732,0.657c0.298,1.214,1.223,2.035,1.456,0.758 c0.368-0.168,0.635-0.29,0.916-0.418C348.212,258.441,348.01,258.125,347.821,257.831z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M373.11,251.432c0.418-0.4,0.836-0.8,1.316-1.259c-0.474-1.781-1.64-0.365-2.397,0.363 C372.245,251.044,372.619,251.297,373.11,251.432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M366.559,273.248c0.259,0.314,0.533,0.646,0.844,1.025 C370.163,273.33,367.177,270.533,366.559,273.248z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M352.473,231.035c1.431-0.631,1.899-0.174,1.425-1.984c-0.164-0.085-0.34-0.176-0.605-0.314 c-0.268,0.184-0.516,0.354-0.728,0.518C352.95,230.01,351.422,230.451,352.473,231.035z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M345.293,267.939c0.093-1.061,0.093-1.061-0.435-1.608 C342.317,266.577,343.298,268.69,345.293,267.939z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M338.079,278.237c-0.35,0.645,0.214,1.109,0.111,1.709 C340.473,280.584,339.833,277.503,338.079,278.237z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M355.044,267.523c0.063,1.32,1.367,0.623,1.964,0.088 C356.84,265.883,355.763,266.479,355.044,267.523z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M337.117,197.577c0,22.823,0,45.645,0,68.468c0,6.255,0,12.511,0,18.766 c0,0.804,1.25,0.806,1.25,0c0-22.823,0-45.645,0-68.468c0-6.255,0-12.511,0-18.766 C338.367,196.773,337.117,196.771,337.117,197.577L337.117,197.577z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M286.762,196.67c0,0-3.613,20.694-0.985,21.515c2.628,0.821,13.796,0.328,14.945,0 c1.15-0.329,2.299-22.01,2.299-22.01S290.54,195.684,286.762,196.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M372.957,222.826c-0.69-1.761-2.439-3.458-4.327-3.35l0.193,0.005 c-4.859-0.119-9.719-0.238-14.578-0.357c-1.473-0.036-3.017-0.057-4.331,0.612c-1.283,0.654-2.209,1.963-2.405,3.389 c-0.197,1.427,0.337,2.934,1.383,3.924c1.587,1.504,3.977,1.679,6.161,1.772c3.409,0.145,6.818,0.29,10.228,0.435 c2.208,0.094,4.64,0.117,6.344-1.291C373.084,226.761,373.647,224.587,372.957,222.826z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M208.36,347.305c0,0.55,0,1.1-0.01,1.66c-0.01,1.02-0.02,2.05-0.05,3.09 c0,0.34-0.01,0.69-0.02,1.03c0,0.01,0,0.01,0,0.02c-0.03,1.27-0.08,2.55-0.13,3.82c-0.01,0.29-0.02,0.58-0.03,0.86 c-0.05,1.22-0.11,2.43-0.17,3.63h-0.01c0,0.1,0,0.2-0.01,0.3c-0.12,2.35-0.27,4.66-0.43,6.88v0.07 c-0.01,0.19-0.02,0.38-0.04,0.57c-0.09,1.26-0.18,2.49-0.28,3.69c-0.04,0.47-0.07,0.93-0.11,1.38v0.01 c-0.08,0.98-0.16,1.92-0.24,2.82c-0.01,0.11-0.02,0.22-0.03,0.32c-0.04,0.41-0.07,0.81-0.11,1.2c-0.01,0.15-0.03,0.3-0.04,0.45 c-0.08,0.9-0.17,1.76-0.24,2.56c-0.05,0.44-0.09,0.87-0.13,1.27c-0.02,0.19-0.04,0.37-0.06,0.55c-0.13,1.31-0.25,2.43-0.35,3.31 c-0.03,0.33-0.07,0.63-0.1,0.89c-0.01,0.05-0.02,0.1-0.03,0.15c-0.1,0.4-0.4,0.76-0.89,1.09h-0.01 c-0.02,0.02-0.04,0.03-0.05,0.03c-0.08,0.05-0.16,0.1-0.25,0.15c-0.26,0.15-0.55,0.29-0.89,0.43c-2.08,0.84-5.57,1.44-10.07,1.85 c-0.44,0.04-0.88,0.07-1.33,0.11c-0.15,0.01-0.29,0.03-0.44,0.03l-0.01,0.01c-0.94,0.07-1.92,0.13-2.93,0.19 c-0.21,0.02-0.43,0.03-0.65,0.04c-0.23,0.02-0.46,0.03-0.7,0.04c-0.11,0-0.23,0.01-0.34,0.01c-0.93,0.05-1.89,0.09-2.88,0.12 c-0.15,0.01-0.31,0.01-0.47,0.02c-0.38,0.01-0.78,0.02-1.17,0.03c-0.97,0.03-1.97,0.06-2.98,0.08c-0.45,0.01-0.91,0.02-1.37,0.02 h-0.37c-0.93,0.02-1.89,0.03-2.85,0.03c-0.53,0.01-1.07,0.01-1.61,0.01v-4.84c-32.03-4.16-57.5-15.82-77.16-33 c0.53-14.23,1.46-27.75,1.51-28.42c0.18-2.16,15.68-3.68,34.82-4.43c4.17-0.17,8.52-0.29,12.91-0.38c0.05,0,0.08,0,0.08,0 c10.35-0.22,20.97-0.22,30.3,0.01c0.35,0.01,0.7,0.02,1.06,0.03c7.79,0.21,14.61,0.58,19.52,1.12c0.34,0.04,0.66,0.07,0.98,0.12 c0.19,0.02,0.38,0.04,0.57,0.07c1.81,0.23,3.29,0.49,4.38,0.79c0.04,0.01,0.07,0.02,0.1,0.03c0.67,0.18,1.18,0.37,1.52,0.58 c0.29,0.18,0.56,0.41,0.81,0.71c0.06,0.07,0.13,0.16,0.19,0.24c0.41,0.53,0.77,1.21,1.08,2.02c0.09,0.22,0.17,0.45,0.25,0.69 c0.06,0.17,0.11,0.34,0.16,0.51c0.03,0.08,0.06,0.16,0.07,0.24h0.01c0.75,2.58,1.21,6.05,1.47,10.04v0.01 c0.02,0.42,0.05,0.84,0.07,1.28c0.05,0.99,0.09,2,0.12,3.04c0.02,0.58,0.03,1.17,0.04,1.76 C208.35,345.315,208.36,346.305,208.36,347.305z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.222,332.247c0.25-2.452,3.835-1.564,1.917-3.571c-0.817-0.183-1.415,0.808-1.45,1.52 c0.013,1.042-1.636,0.546-2.427,1.105C182.237,332.361,183.938,333.775,184.222,332.247z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.512,355.92c0.36,0.081,0.634,0.142,0.932,0.208 C186.739,354.631,181.588,352.52,182.512,355.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.861,385.136c-0.169-1.565-2.003-1.317-2.274,0.193 C185.511,386.268,186.319,386.523,186.861,385.136z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.513,356.398c-0.723,0.148-1.359,0.229-1.54,1.042c0.219,1.641,1.687,1,2.281-0.045 C182.164,356.991,181.966,356.649,181.513,356.398z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.802,391.534c0.609-0.047,1.202-0.097,1.779-0.15c-0.006-0.017-0.014-0.039-0.02-0.055 C192.785,390.964,192.141,391.161,191.802,391.534z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M207.214,351.315c0.166-0.399,0.312-0.75,0.479-1.153 C205.669,347.345,204.555,352.065,207.214,351.315z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.65,379.109c0.059-0.635,0.118-1.294,0.178-1.972c-0.14-0.072-0.306-0.125-0.507-0.151 C204.899,377.776,205.749,379.137,206.65,379.109z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.855,344.618c0.381-0.095,0.739-0.184,1.097-0.272 C183.645,341.629,177.968,342.755,180.855,344.618z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.083,339.558c0.114-0.564,0.114-0.564,0.516-0.97c-0.198-0.32-0.488-0.558-0.821-0.844 C174.429,337.888,175.902,341.3,177.083,339.558z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.767,358.215c0.268-0.113,0.168-0.372,0.154-0.59c0.495-0.583-0.054-1.251-0.699-1.381 c-0.335,0.249-0.737,0.389-1.149,0.313C202.849,357.65,203.637,358.72,204.767,358.215z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.407,327.533c0.144-1.157-1.681-1.654-1.918-0.46 C182.119,328.419,184.308,329.025,184.407,327.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.165,352.416c0.288,1.555,1.299,1.954,2.125,0.472 C181.761,351.989,180.638,350.801,180.165,352.416z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.64,332.429c0.92-1.318-1.783-2.236-1.777-0.652 C177.715,332.769,179.236,333.654,179.64,332.429z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.524,332.499c1.087-1.303-1.309-2.017-1.97-0.757 C191.983,332.756,192.608,333.632,193.524,332.499z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.433,347.922c-0.715-1.151-1.561-1.242-2.051,0.183 C175.444,349.597,177.841,349.183,177.433,347.922z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.36,375.112c-0.234-0.119-0.514-0.262-0.884-0.449 C173.742,376.506,177.875,378.253,177.36,375.112z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.704,372.381c-0.825-0.016-1.275,0.439-1.54,1.18c0.218,0.302,0.435,0.603,0.633,0.878 c0.439-0.085,0.807-0.156,1.215-0.235c0.144-0.29,0.295-0.594,0.446-0.898C198.188,372.974,197.951,372.684,197.704,372.381z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.105,384.19c-2.596,0.121,0.66,3.702,0.99,0.991 C182.177,384.312,181.733,384.376,181.105,384.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.925,351.524c0.471-0.273,0.707-0.768,1.081-1.333c-0.703-1.238-1.508-0.953-2.207,0.093 C177.812,351.004,178.118,351.473,178.925,351.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.859,323.914c-0.312,0.081-0.639,0.165-0.907,0.234c-0.581,0.896-0.215,1.861,0.883,1.991 c0.319-0.368,0.625-0.722,0.914-1.056C200.593,324.559,200.315,324.191,199.859,323.914z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.681,337.235c0.38-1.728-1.079-2.404-1.82-0.716 C177.78,337.477,179.393,338.243,179.681,337.235z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.509,368.811c-0.03-0.67-0.443-0.937-1.047-1.006c-0.879,0.334-0.759,1.085-0.914,1.764 C183.515,370.397,184.114,369.837,184.509,368.811z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.912,336.509c0.002,1.192,1.105,1.529,1.816,0.506c0.026-0.497,0.242-0.907,0.055-1.337 c-0.219-0.07-0.428-0.137-0.626-0.201C201.648,335.814,201.022,335.842,200.912,336.509z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.524,383.952c-3.085,0.989,0.379,3.577,0.961,0.829 C191.17,384.508,190.867,384.247,190.524,383.952z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.961,343.957c0.424,0.88,1.799,0.998,1.798-0.279 C195.523,341.875,193.707,342.188,193.961,343.957z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.371,342.204c1.975-1.777-1.271-2.994-1.568-0.762 C201.178,342.036,201.886,341.76,202.371,342.204z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.045,329.098c-0.704-0.451-1.432-0.202-2.203-0.526c0.613,1.009,0.613,1.009,0.588,1.915 C204.259,330.871,206.196,329.967,205.045,329.098z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.509,344.599c-0.91,0.783-1.792,1.521-0.41,2.258c0.579,0.328,0.875-0.428,1.195-0.79 C198.773,345.419,197.897,345.088,197.509,344.599z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.279,381.566c1.27-0.535,1.839-1.01,0.654-2.05c-0.559-0.091-0.919,0.258-1.313,0.457 c-0.083,0.274-0.155,0.511-0.228,0.752C175.678,381.057,175.936,381.374,176.279,381.566z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.118,342.725c-2.458-0.384-2.621,2.157,0.035,1.422 C191.535,343.676,191.676,343.233,191.118,342.725z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.478,344.983v0.154c0.085,0.232,0.085,0.418,0,0.599v0.789c0.3,0.259,0.882,0.26,1.251,0.231 C176.086,346.037,174.663,344.234,173.478,344.983z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.037,376.738c1.033-0.907,0.954-1.45-0.262-2.011 C184.213,375.127,184.39,376.774,186.037,376.738z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.337,342.258c1.268,0.104,1.923-1.783,0.419-1.842 C205.436,340.175,205.147,341.85,206.337,342.258z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.613,367.043c0.768,0.855,1.526,0.422,2.024-0.457 C176.994,365.066,175.342,365.298,175.613,367.043z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.402,359.151c-0.359-0.237-0.647-0.428-0.914-0.604c-0.736,0.33-0.736,0.33-1.106,1.285 C183.138,361.089,184.729,360.746,184.402,359.151z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.247,326.52c-1.195-0.462-1.139,1.093-1.471,1.837c0.485,0.122,0.905-0.418,1.442-0.156 c0.079,0.034,0.248-0.063,0.336-0.143C203.055,327.61,203.037,326.579,202.247,326.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.946,377.905c-0.239-0.223-0.492-0.46-0.727-0.681c-1.118,0.304-1.118,0.304-1.342,1.27 C201.492,379.659,203.092,379.298,202.946,377.905z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.502,346.258c0.294,0.219,0.62,0.459,0.969,0.717 C209.051,345.583,205.862,343.206,205.502,346.258z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.295,367.24c0.067-1.303,0.007-1.419-0.905-1.784c-0.361,0.318-0.732,0.645-1.091,0.96 c0.186,0.402,0.34,0.733,0.479,1.032C190.368,367.301,190.815,367.707,191.295,367.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.788,333.134c-0.294,0.2-0.601,0.409-0.883,0.601 C198.008,336.596,202.663,334.781,199.788,333.134z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.367,349.904c-0.074,0.252-0.152,0.518-0.226,0.771 C189.031,353.621,190.385,348.063,187.367,349.904z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.534,365.209c2.885-0.556,0.14-3.144-0.968-0.923 C191.683,364.789,191.986,365.08,192.534,365.209z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.123,369.146c0.342,0.546,0.886,0.698,1.421,0.884c0.365-0.312,0.449-0.733,0.658-1.089 C188.902,367.655,186.881,367.645,187.123,369.146z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.032,361.009c-1.19-0.151-1.395,1.639-0.381,1.9 C195.851,363.297,196.586,360.93,195.032,361.009z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.987,364.669c0.446,0.75,2.05,0.791,1.973-0.321 C179.658,362.979,177.384,363.125,177.987,364.669z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M208.18,339.542c-0.022-0.434-0.047-0.862-0.074-1.284 C207.666,338.681,207.572,339.194,208.18,339.542z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.648,380.479c0.351,0.382,0.452,0.905,0.957,1.091c0.577-0.238,0.943-0.636,1.09-1.287 C199.849,379.211,199.083,378.91,198.648,380.479z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.199,347.015c-0.872,0.276-0.872,0.276-1.165,1.103c0.146,0.212,0.305,0.444,0.471,0.686 c0.303,0.075,0.608,0.152,0.98,0.246C196.494,348.454,196.15,347.411,195.199,347.015z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.048,381.645c-0.352,0.229-0.8,0.278-1.071,0.708c0.136,0.361,0.279,0.739,0.409,1.085 c0.305,0.098,0.545,0.175,0.822,0.263C203.191,383.085,203.512,381.822,202.048,381.645z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.625,374.616c0.435-0.34,0.786-0.717,0.986-1.217 C183.407,371.312,181.221,373.772,183.625,374.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.703,337.505c0.188-0.269,0.348-0.498,0.532-0.763c-0.411-0.421-0.553-1.031-1.201-1.304 c-0.351,0.255-0.728,0.529-1.139,0.829C187.136,337.283,187.849,337.393,188.703,337.505z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.019,323.221c0.509,1.022,1.84,0.135,1.916-0.733 C179.048,321.138,177.518,321.802,178.019,323.221z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.376,323.851c-0.294,0.407-0.645,0.731-0.74,1.278c0.354,0.269,0.724,0.551,1.077,0.82 c0.344-0.093,0.643-0.175,0.996-0.272c-0.102-0.51-0.198-0.99-0.297-1.485C186.051,324.073,185.727,323.967,185.376,323.851z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.586,332.618c1.23,0.44,1.411,0.371,1.769-0.616c-0.453-1.117-1.659-1.384-2.145-0.141 C196.359,332.163,196.484,332.413,196.586,332.618z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.598,335.919c-0.074,0.57,0.367,0.73,0.302,1.335c0.677,0.094,1.368,0.55,1.698-0.227 C193.576,335.592,192.776,335.262,191.598,335.919z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.743,388.469c0.82-0.237,1.002-0.79,0.973-1.49 C192.293,385.676,190.68,387.918,192.743,388.469z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.874,386.792c-0.41,0.401-0.466,0.855-0.183,1.167c0.033-0.089,0.071-0.178,0.081-0.271 C205.803,387.425,205.837,387.124,205.874,386.792z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.768,351.307c0.046-0.454,0.208-0.841,0.518-1.138c-0.178-0.873-1.238-1.18-1.808-0.541 v0.602c0.071,0.351,0.22,0.69,0.19,1.054C174.064,351.412,174.395,351.405,174.768,351.307z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.912,335.37c0.434-0.444,0.906-0.828,0.763-1.543c-0.297-0.236-0.587-0.467-0.865-0.688 c-0.688,0.189-1.089,0.566-1.091,1.28C184.993,334.868,185.451,335.079,185.912,335.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.478,340.47v1.347c0.064,0.096,0.128,0.189,0.197,0.293 C176.564,342.512,174.517,339.454,173.478,340.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.381,342.1c2.379-1.144-0.771-3.179-1.307-0.687 C196.579,341.679,196.991,341.896,197.381,342.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.857,344.629c-1.204,0.33-1.621,1.763-0.348,2.214 C193.619,346.298,194.101,345.326,192.857,344.629z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.427,382.806c0.292,0.357,0.546,0.577,0.799,0.678c0.058-0.571,0.119-1.179,0.182-1.821 C206.033,381.689,205.652,382.045,205.427,382.806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M208.353,348.962c0.005-0.556,0.007-1.109,0.007-1.659 C207.877,347.672,207.765,348.483,208.353,348.962z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.707,358.77c-0.674-0.074-1.047,0.072-1.229,0.307v0.911c0.37,0.714,1.386,1.213,1.826-0.254 C175.079,359.366,175.029,359.032,174.707,358.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.779,362.399c0.704,0.552,1.918,0.557,2.14-0.478 C186.211,360.635,184.287,360.852,184.779,362.399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.892,379.258c-1.016,1.104-0.547,1.989,0.77,2.304c0.311-0.346,0.435-0.738,0.62-1.12 C182.05,379.812,181.456,379.687,180.892,379.258z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.747,356.564c-0.611-0.606-1.081-0.302-1.639,0.097 C193.032,358.26,196.46,358.97,195.747,356.564z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.847,352.493c-0.117,0.652,0.289,1.375,1.029,1.158 C201.982,353.126,198.781,350.163,198.847,352.493z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.892,376.774c1.212,0.129,1.781-1.949,0.249-1.909 C180.001,374.755,179.877,376.647,180.892,376.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.514,321.987c-0.448-0.035-0.919-0.07-1.449-0.112 C190.415,323.854,194.904,324.283,193.514,321.987z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.112,328.944c-0.794-0.441-1.444,0.026-1.689,0.883c0.515,0.313,1.117,1.388,1.699,0.715 C200.585,330.142,200.685,329.285,200.112,328.944z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.09,384.012c-1.219,0.091-1.54,1.793-0.177,1.995 C196.062,385.938,196.278,384.198,195.09,384.012z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.395,334.244c-0.415-0.7-0.99-1.311-1.75-0.634c0.045,0.19,0.079,0.338,0.117,0.501 c-0.173,0.109-0.349,0.22-0.562,0.354C189.913,335.434,191.363,335.665,191.395,334.244z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.283,383.952c-0.639,0.15-0.927,0.526-1.007,1.073c0.173,0.318,0.337,0.62,0.501,0.92 C205.162,386.151,205.906,384.575,204.283,383.952z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.343,346.459c0.814,0.72,1.091,0.608,1.8-0.352 C188.842,344.211,186.97,344.608,187.343,346.459z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.465,338.881c0.416,1.068,1.274,1.17,1.941,0.263 C201.015,337.673,198.715,337.472,198.465,338.881z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M208.337,344.344c-0.009-0.593-0.021-1.181-0.037-1.761c-0.516,0.115-0.102,1.018-0.38,1.342 C208.044,344.137,208.185,344.264,208.337,344.344z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.603,367.541c0.193-0.256,0.362-0.479,0.547-0.724 C195.502,363.611,192.531,367.885,195.603,367.541z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.301,361.455c-1.107-1.067-1.62,0.129-1.958,1.131 C176.24,363.307,177.915,362.668,177.301,361.455z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.253,323.724c0.104-0.436,0.024-0.937-0.179-1.32c-0.492-0.064-1.01-0.126-1.55-0.186 C196.357,323.564,196.898,323.792,198.253,323.724z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.242,356.766c-0.84-0.711-1.515-0.436-1.817,0.601c0.2,0.296,0.395,0.584,0.608,0.901 c0.313,0,0.627,0,0.968,0C191.436,357.834,191.379,357.315,191.242,356.766z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.502,378.157c0.475,0.262,0.331,1.04,1.038,1.091c0.336-0.289,0.694-0.597,1.056-0.909 C184.458,376.915,182.923,376.839,182.502,378.157z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.317,339.442c-0.01-0.518,0.197-1.1-0.504-1.471 C188.282,338.158,189.761,340.78,191.317,339.442z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.715,342.387c-1.504,0.873-0.98,2.589,0.781,1.776 C186.793,343.449,186.682,342.552,185.715,342.387z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.771,340.742c0.053,0.898,0.441,1.313,1.347,1.399c0.237-0.393,0.6-0.641,0.63-1.126 C192.946,340.25,192.638,339.471,191.771,340.742z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.303,328.967c-0.093,0.375-0.183,0.735-0.258,1.036c0.745,1.285,2.059,0.46,1.896-0.771 c-0.21-0.36-0.533-0.422-0.835-0.554C194.842,328.773,194.576,328.869,194.303,328.967z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.828,360.572c0.144-0.378,0.278-0.73,0.421-1.106 C196.632,357.055,195.1,361.166,197.828,360.572z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.065,388.588c-0.402,0.487-0.445,1.017-0.489,1.554c0.399,0.453,0.867,0.594,1.461,0.421 c0.005-0.556,0.149-0.881,0.454-1.361C176.995,388.985,176.751,388.369,176.065,388.588z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.563,346.887c0.318-0.24,0.644-0.488,1.058-0.802c-0.18-0.367-0.333-0.677-0.504-1.026 C182.453,344.38,181.938,346.438,183.563,346.887z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.605,365.637c-0.721,0.402-1.792,0.364-1.241,1.414 C181.217,368.724,183.052,366.714,181.605,365.637z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.904,348.494c1.57-1.087-1.319-2.079-1.435-0.462 C198.374,349.02,200.707,349.813,199.904,348.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.249,348.047c-0.158-0.301-0.269-0.677-0.679-0.833c-0.298,0.065-0.602,0.132-0.889,0.196 c-0.219,0.288-0.422,0.556-0.617,0.814c0.188,0.288,0.341,0.523,0.511,0.783C181.327,349.219,182.109,348.844,182.249,348.047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.859,353.72c0.726-0.226,1.483-0.17,1.786-1.01 C176.839,350.951,174.986,351.967,175.859,353.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.722,360.284c0.656-1.541-0.722-2.286-1.74-0.878 C201.222,360.3,201.888,361.071,202.722,360.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.874,353.879c-0.305,0.539-1.136,0.534-1.132,1.375c0.251,0.41,0.493,0.9,1.222,0.835 C193.965,355.645,193.647,354.49,192.874,353.879z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.137,327.508c-0.089,0.953,1.891,0.992,1.882,0.046 C188.94,326.123,187.203,325.94,187.137,327.508z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.493,346.697c0.991,0.081,0.991,0.081,1.402-0.796c-0.24-0.399-0.479-0.799-0.757-1.263 c-0.557,0.218-0.951,0.46-1.32,0.882C178.06,345.91,178.151,346.385,178.493,346.697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.947,389.801c-0.33-0.4-0.646-0.782-1.049-1.268c-0.418,0.277-0.755,0.5-1.079,0.715 c-0.031,0.389-0.058,0.728-0.091,1.136C185.62,390.354,186.363,390.65,186.947,389.801z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.482,335.609c-0.239,0.16-0.499,0.334-0.737,0.493c-0.074,0.307-0.14,0.581-0.221,0.915 c0.8,0.866,0.974,0.88,1.776,0.171C184.342,336.572,184.321,335.784,183.482,335.609z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.557,342.802c-0.321,0.598-0.067,1.026,0.217,1.637c0.882,0.199,1.624-0.398,1.384-1.328 C204.981,342.642,203.794,342.285,203.557,342.802z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.119,368.467c-0.382-0.351-0.802-0.348-1.295-0.417c-0.112,0.122-0.232,0.231-0.346,0.342 v1.055C174.27,370.138,175.463,369.872,175.119,368.467z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.607,361.065c-0.368-0.067-0.681-0.121-1.001,0.071c-0.146,0.301-0.298,0.615-0.452,0.935 C181.029,363.805,182.934,362.492,181.607,361.065z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.922,339.434c0.739,1.17,1.786,0.202,1.94-0.802c-0.298-0.238-0.568-0.453-0.826-0.657 C184.967,338.183,184.995,338.463,184.922,339.434z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.383,384.367c-0.925-0.462-1.519-0.204-1.862,0.784c0.545,0.434,1.401,1.447,1.827,0.382 C177.503,385.162,177.925,384.629,177.383,384.367z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.8,341.75c0.907,0.654,1.906-0.185,1.568-1.243C183.36,339.543,182.059,340.605,182.8,341.75 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.75,380.558c0.45,0.886,1.693,1.306,1.966,0.138 C186.733,379.236,185.063,379.175,184.75,380.558z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.097,384.347c-0.691,0.562-0.218,1.63,0.626,1.658 C201.291,385.848,200.207,382.917,199.097,384.347z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.478,331.388v1.251c0.169,0.187,0.453,0.321,0.774,0.5 C176.466,331.659,174.026,330.628,173.478,331.388z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.67,365.994c-0.667-0.817-1.945-0.071-1.812,0.911 C199.524,368.225,200.871,367.272,200.67,365.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.535,357.776c0.049-0.175,0.1-0.357,0.152-0.54c-0.498-0.887-1.323-0.782-2.182-0.744 c0.146,0.476,0.153,0.791,0.135,1.277C199.319,358.068,199.992,358.156,200.535,357.776z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.976,363.359c-0.261,0.334-0.64,0.539-0.795,0.92c0.437,0.605,0.879,0.859,1.618,0.926 C199.002,364.495,198.146,363.453,196.976,363.359z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.221,370.81c0.194,1.537,1.167,1.728,1.952,0.33 C196.059,370.12,194.505,369.749,194.221,370.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.775,370.203c-1.071,0.025-1.895,1.849-0.213,1.937 C177.586,371.94,177.87,370.518,176.775,370.203z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.615,388.452c0.32-0.313,0.722-0.583,0.881-1.106 C183.27,385.319,181.216,387.679,183.615,388.452z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.63,356.157c0.222-0.32,0.446-0.646,0.675-0.977 C197.381,352.487,195.122,355.47,197.63,356.157z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M207.821,361.491c0.038,0.074,0.075,0.147,0.111,0.22c0.005-0.097,0.01-0.194,0.015-0.291 C207.903,361.445,207.87,361.464,207.821,361.491z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.256,374.872c-1.175,0.098-1.267,1.764-0.046,1.904 C205.412,376.721,205.439,375.011,204.256,374.872z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M208.305,352.051c-0.061,0.071-0.117,0.152-0.164,0.257c0.046,0.261,0.091,0.52,0.139,0.793 C208.289,352.75,208.297,352.401,208.305,352.051z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.616,332.227c0.555,0.558,0.943,0.824,1.221,0.825c0.2-0.149,0.422-0.315,0.622-0.465 c-0.258-0.452-0.139-0.823-0.385-1.283C206.36,330.417,205.608,331.365,205.616,332.227z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.748,323.919c-0.094-0.033-0.318,0.031-0.328,0.081c-0.085,0.442-0.481,0.428-0.798,0.54 c0.047,0.355,0.09,0.68,0.132,0.995c0.516,0.096,0.98,0.406,1.501,0.163C178.01,324.801,177.514,324.454,176.748,323.919z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.139,360.495c1.047-0.628,0.668-1.428-0.33-1.864c-0.544,0.317-1.52,0.724-0.847,1.359 C192.312,360.245,192.694,360.809,193.139,360.495z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.156,335.19c0.594-0.227,0.911-0.609,0.936-1.235c-0.087-0.14-0.183-0.297-0.268-0.434 c-0.756-0.057-1.475-0.186-1.905,0.695C194.16,334.745,194.678,334.963,195.156,335.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.478,322.992c0.1,0.207,0.264,0.432,0.51,0.671c0.413-0.156,0.764-0.289,1.222-0.462 c0.01-1.605-1.321-1.729-1.732-1.104V322.992z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.778,378.885c0.642-0.503,0.314-1.681-0.425-1.71c-0.568-0.102-0.741,0.156-0.875,0.543v1.07 C173.809,378.977,174.468,378.857,174.778,378.885z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.478,382.246v1.032c0.128,0.114,0.245,0.219,0.388,0.346 C176.548,383.622,174.518,380.815,173.478,382.246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.867,372.078c0.147-0.211,0.31-0.443,0.471-0.673c-0.092-0.356-0.179-0.691-0.294-1.132 c-0.741,0.023-1.377,0.109-1.586,0.933C189.727,372.213,189.976,372.269,190.867,372.078z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.83,363.533c-0.783-0.213-1.253,0.119-1.352,0.588v0.36c0.058,0.314,0.252,0.644,0.634,0.902 C175.176,365.012,175.77,364.36,174.83,363.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.961,331.575c0.125,0.62,0.37,1.568,1.214,1.268c0.17-0.426,0.432-0.711,0.865-0.851 C202.894,330.552,201.808,330.879,200.961,331.575z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.176,359.38c0.05,0.442,0.091,0.805,0.132,1.17c0.269,0.078,0.54,0.156,0.799,0.231 c0.714-0.6,0.757-0.711,0.667-1.793c-0.363-0.091-0.746-0.186-1.125-0.281C187.451,358.988,187.29,359.218,187.176,359.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.917,359.657c0.436,0.959,1.199,1.191,1.947,0.459 C179.995,358.707,178.283,358.151,177.917,359.657z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.712,353.611c0.71-0.623,0.858-1.203,0.028-1.832c-0.556,0.188-1.398,0.133-1.419,0.906 c0.168,0.254,0.323,0.492,0.484,0.736C190.122,353.488,190.427,353.552,190.712,353.611z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.173,355.431c0.083-0.844-0.928-1.776-1.677-1.104c-0.007,0.008-0.011,0.016-0.017,0.024 v1.168C173.881,355.901,174.67,355.99,175.173,355.431z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.2,367.94c-1.194,0.141-0.537,2.233,0.684,1.538c0.278-0.053,0.463-0.14,0.578-0.245 c0.015-0.208,0.03-0.415,0.045-0.625C207.281,368.247,206.722,367.922,206.2,367.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185,356.769c-0.399,1.789,1.027,1.989,1.893,0.664C186.671,356.366,185.811,356.33,185,356.769z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.187,368.266c-0.025,0.378-0.05,0.753-0.074,1.106c0.361,0.373,0.782,0.459,1.316,0.402 c0.089-0.35,0.103-0.654,0.412-0.871C203.633,368.003,201.714,367.86,201.187,368.266z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.22,387.325c-0.393-0.41-0.677-0.89-1.255-1.001c-0.477,0.24-0.662,0.697-0.93,1.098 C187.871,388.4,188.593,388.644,189.22,387.325z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.18,391.822c0.572-0.028,1.132-0.058,1.685-0.09c-0.04-0.164-0.083-0.34-0.133-0.542 C187.882,390.535,187.28,390.951,187.18,391.822z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.339,377.378c-1.578-0.252-2.209,0.589-1.049,1.682 C193.353,379.212,193.928,378.263,193.339,377.378z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.652,377.185c-0.819,0.312-1.538,0.295-1.308,1.355c0.849,0.785,1.1,0.768,1.917-0.098 C198.073,378.038,198.106,377.52,197.652,377.185z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.787,324.427c-1.072-0.45-1.072-0.45-1.535-0.069 C179.852,326.543,182.612,326.413,181.787,324.427z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.81,380.847c0.773-0.548,0.109-1.023-0.276-1.543c-0.352,0.119-0.645,0.218-0.852,0.288 c-0.128,0.546-0.236,1.001-0.355,1.509C203.946,381.448,204.43,381.5,204.81,380.847z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.45,368.947c-0.004-1.478-1.975-1.125-1.889,0.159 C191.662,369.72,193.669,370.049,193.45,368.947z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.788,365.874c-0.85,1.074-0.544,0.98,0.287,1.581c0.643,0.296,1.165-0.49,1.286-1.082 C204.954,365.644,204.349,365.805,203.788,365.874z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.905,391.698c-0.275-0.309-0.504-0.567-0.713-0.8c-0.811,0.162-1.22,0.725-1.253,1.195 c0.587-0.008,1.168-0.017,1.743-0.028C179.748,391.93,179.824,391.802,179.905,391.698z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.209,357.944c0.06-0.302,0.12-0.605,0.178-0.901 C175.526,354.959,174.5,359.1,177.209,357.944z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.709,352.708c-0.421-1.488-1.979-1.172-1.865,0.395 C184.91,354.195,186.531,353.39,186.709,352.708z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.116,331.756c0.083,1.387,1.988,1.565,1.814-0.179 C187.997,330.621,187.558,330.953,187.116,331.756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.242,374.633c0.548-0.273,0.768-0.705,0.854-1.28c-0.223-0.711-1.14-1.063-1.618-0.543v1.041 C173.716,374.127,174.075,374.365,174.242,374.633z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.172,388.432c0.27-0.655,0.951-0.689,0.658-1.55 C201.079,385.51,200.308,388.167,202.172,388.432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.501,330.595c1.224-0.596,0.402-1.887-0.608-1.865c-0.432,0.396-0.798,0.601-0.936,1.201 C180.513,330.17,181.007,330.382,181.501,330.595z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.557,348.996c0.339,0.097,0.463-0.465,0.618-0.654c-0.142-0.276-0.256-0.499-0.407-0.793 c-1.239-0.627-2.177,0.478-1.051,1.439C203.975,349.037,204.271,348.604,204.557,348.996z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.608,343.636c-0.474-0.406-0.479-0.95-0.983-1.176c-1.092,0.195-1.386,1.156-0.603,1.936 C176.559,344.174,177.205,344.191,177.608,343.636z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.199,380.517c0.096,0.212,0.183,0.41,0.311,0.695 C192.875,381.824,190.82,378.02,189.199,380.517z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M208.156,356.912c-0.073,0.073-0.146,0.141-0.223,0.234c0.007,0.258,0.081,0.468,0.186,0.643 C208.132,357.497,208.145,357.205,208.156,356.912z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.103,355.806c1.42,0.018,1.577,0.234,1.641-1.304c-0.302-0.193-0.565-0.36-0.811-0.517 c-0.426,0.29-0.814,0.555-1.26,0.858C177.936,355.158,178.006,355.393,178.103,355.806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.261,361.146c-0.28,0.194-0.547,0.381-0.815,0.567c0.697,1.076,1.39,1.641,2.296,0.518 C200.55,361.453,200.08,361.117,199.261,361.146z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.938,322.685c0.465,0.67,0.993,1.1,1.858,0.899c0-0.49,0-0.93,0-1.347 C187.855,321.342,187.558,321.945,186.938,322.685z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.881,323.838c0.774,0.095,1.059-0.138,1.069-0.497c-0.498-0.158-1.11-0.307-1.818-0.449 c0,0,0,0,0,0.001C201.376,323.202,201.608,323.494,201.881,323.838z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.629,328.379c0.406-0.202,0.762-0.38,1.218-0.608c-0.48-0.604-0.083-1.277-0.779-1.548 c-0.518,0.118-0.866,0.402-1.128,0.841c0.157,0.19,0.294,0.354,0.424,0.511c-0.074,0.188-0.139,0.355-0.219,0.559 C178.343,328.234,178.507,328.317,178.629,328.379z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.552,349.35c-0.695,0.363-0.695,0.363-1.106,1.25 C183.845,352.363,185.341,350.466,183.552,349.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.242,323.933c-1.147,0.34-1.194,1.693,0.13,1.833c0.847,0.126,0.927-0.445,0.702-1.012 C204.815,324.415,204.537,324.144,204.242,323.933z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.367,390.941c-0.519,0.249-0.656,0.629-0.707,1.052c0.553-0.016,1.097-0.034,1.637-0.053 c-0.063-0.227-0.123-0.447-0.184-0.668C183.841,391.151,183.585,391.039,183.367,390.941z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.49,382.486c-0.046,1.643,1.908,1.382,2.031-0.115 C183.992,382.071,182.68,381.615,182.49,382.486z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.699,328.942c-0.337,0.746-0.118,1.296,0.551,1.78c1.046-0.28,1.048-0.498,1.195-1.241 c-0.17-0.195-0.315-0.361-0.432-0.496C190.485,329.077,190.199,329.05,189.699,328.942z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.68,375.153c-1.212-0.244-1.307-0.014-1.814,0.885 C194.576,377.451,196.32,376.552,195.68,375.153z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.89,365.412c0.713-0.116,1.006-0.736,1.104-1.486c-0.171-0.179-0.385-0.402-0.6-0.626 c-0.568,0.277-1.247,0.186-1.39,0.883C187.308,364.604,187.578,364.98,187.89,365.412z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.916,337.444c0.238-0.234,0.498-0.457,0.75-0.663c-0.469-1.09-0.999-1.452-1.925-0.839 C206.146,336.922,205.263,337.321,206.916,337.444z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.208,387.634c0.093-0.44-0.277-1.193-0.744-1.376c-0.522,0.419-1.164,0.903-1.099,1.596 C197.106,388.374,197.724,388.452,198.208,387.634z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.185,327.79c0.254-1.153-0.98-1.95-1.799-0.918 C196.361,328.066,197.252,328.403,198.185,327.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.477,390.774c0.293-0.349,0.594-0.708,0.879-1.049c-0.096-0.41-0.197-0.734-0.531-0.962 C189.488,388.896,188.757,390.591,190.477,390.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.68,323.646c0.453-0.272,0.742-0.63,0.901-1.164c-0.513-0.398-1.389-0.777-2.049-0.398 c-0.154,0.465,0.177,0.827,0.252,1.258C183.107,323.451,183.399,323.55,183.68,323.646z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.034,389.627c-0.06,0.851,0.444,0.82,1.006,0.934 C197.014,390.183,194.378,387.346,194.034,389.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.846,355.651c-0.159-0.31-0.011-0.675,0.017-0.972c-0.538-0.702-1.895-0.303-1.989,0.46 C201.205,355.839,202.307,356.309,202.846,355.651z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.369,336.615c0.279,0.366,0.525,0.691,0.773,1.017c0.412-0.363,1.061-0.382,1.225-0.997 C197.937,335.462,196.897,335.264,196.369,336.615z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.09,392.115v0.01h-1.61v-0.41c0.34-0.21,0.58-0.55,0.88-0.87c0.62,0.19,0.47,0.69,0.72,1.18 C175.09,392.055,175.09,392.075,175.09,392.115z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.029,341.324c0.555,1.137,2.375,0.752,2.062-0.546 C187.76,340.232,187.406,340.329,187.029,341.324z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.62,343.641c0.185,0.266,0.36,0.518,0.521,0.75c1.015,0.073,1.026,0.064,1.396-1.154 C199.984,342.127,198.929,342.661,198.62,343.641z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.126,338.368c-0.352-0.17-0.663-0.319-0.924-0.446c-0.659,0.1-0.866,0.549-1.045,1.077 C203.865,340.003,205.571,339.76,205.126,338.368z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.229,353.66c0.482-0.11,0.731-0.22,1.088-0.53c-0.625-1.092-0.272-1.78-1.81-1.06 C203.553,352.788,203.307,353.455,204.229,353.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.362,372.337c0.276-0.321,0.538-0.625,0.823-0.956c-0.262-0.317-0.13-0.818-0.6-1.092 c-0.404,0.396-1.107,0.326-1.494,0.894C203.361,371.806,203.831,372.072,204.362,372.337z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.856,368.922c0.121,0.606,0.406,1.007,1.028,1.084c0.605-0.479,0.605-0.479,0.855-1.17 C179.293,367.775,178.316,368.091,177.856,368.922z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.885,362.844c0.665-1.637-0.203-2.466-1.616-1.172c0.171,0.168,0.319,0.312,0.467,0.456 c-0.021,0.205-0.043,0.409-0.071,0.668C190.091,362.816,190.438,363.001,190.885,362.844z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.806,346.493c0.474-1.16-1.046-1.685-1.799-0.918 C200.641,346.712,202.169,347.145,202.806,346.493z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.217,354.023c-0.571,0.603-1.575,0.397-1.04,1.545c0.623,0.284,1.201,0.449,1.782-0.157 C188.609,354.831,189.029,354.094,188.217,354.023z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.99,374.941c-0.06-0.027-0.333,0.227-0.318,0.259c0.18,0.371-0.234,0.619-0.213,0.991 c0.949,0.473,1.547,0.984,2.044-0.334C191.217,375.085,190.509,375.172,189.99,374.941z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.998,321.097c-0.353-0.009-0.703-0.019-1.06-0.028 C176.308,321.33,176.699,321.341,176.998,321.097z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.932,341.126c-0.843-0.96-2.236-0.766-1.797,0.728 C178.79,342.492,179.607,342.211,179.932,341.126z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.34,368.912c0.292,0.681,1.482,1.159,1.835,0.277 C198.233,367.742,196.502,367.391,196.34,368.912z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.401,328.797c-0.562,0.371-0.562,0.371-0.926,0.931 C176.146,331.85,178.899,328.741,176.401,328.797z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.193,334.31c-0.067-1.374-2.232-0.671-1.878,0.404 C203.709,335.622,205.061,335.122,205.193,334.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.044,372.608c-2.06,0.614-1.006,2.622,0.714,1.346 C179.533,373.482,179.715,372.857,179.044,372.608z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M207.671,355.266c-0.601-1.361-2.354-1.131-2.008,0.281c0.235,0.124,0.514,0.269,0.788,0.413 C206.894,355.743,207.43,355.762,207.671,355.266z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.734,388.429c0.527-0.029,0.528-0.717,0.894-0.999c0.601-0.842-0.745-0.879-1.3-0.935 c-0.277,0.2-0.371,0.499-0.485,0.879C178.409,387.602,178.235,388.235,178.734,388.429z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.597,327.958c0.236-1.111-1.38-1.923-1.963-0.75 C191.889,328.032,192.9,328.714,193.597,327.958z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.304,372.793c-0.234-0.067-0.443-0.128-0.733-0.211c-1.404,1.421-0.154,2.524,1.252,1.183 C193.641,373.422,193.469,373.099,193.304,372.793z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.087,334.142c-0.103-0.28-0.199-0.537-0.298-0.807c-0.69-0.086-1.249,0.53-1.709,0.98 c0.09,0.686,0.663,0.792,1.089,1.079C181.436,334.872,181.68,334.536,182.087,334.142z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.906,338.39c-0.342-0.136-0.596,0.295-0.866,0.439c0.453,1.52,1.695,1.226,2.199-0.087 c-0.206-0.195-0.404-0.381-0.605-0.571C181.381,338.332,181.195,338.545,180.906,338.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.012,325.542c0.518,0.213,0.971,0.399,1.45,0.597 C196.87,324.423,194.508,323.316,194.012,325.542z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.155,388.524c-0.368,0.405-0.767,0.706-0.958,1.205c0.166,0.228,0.329,0.453,0.5,0.687 C182.333,390.722,182.406,389.221,181.155,388.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.531,383.637c0.528-0.553,0.24-1.079-0.05-1.634c-0.65,0.003-1.144,0.271-1.551,0.719 C187.407,383.749,187.441,383.768,188.531,383.637z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.196,349.735c-0.047,0.335-0.086,0.611-0.132,0.93c0.323,0.193,0.482,0.576,0.937,0.716 c0.366-0.398,0.685-0.758,1.053-1.183C202.605,349.611,201.843,349.299,201.196,349.735z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.721,353.202c0.049-0.352,0.081-0.692-0.081-1.103c-0.315-0.105-0.666-0.223-1.057-0.355 C193.464,353.012,194.209,353.954,195.721,353.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.594,339.626c0.767-0.966,0.109-1.312-0.606-1.913c-0.34,0.34-0.64,0.637-0.927,0.924 c0.08,0.258,0.144,0.467,0.222,0.72C194.708,339.444,195.16,339.537,195.594,339.626z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.134,333.505c-0.533,0.008-1.063-0.178-1.471,0.418 C175.65,336.12,178.25,334.944,177.134,333.505z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.156,379.502c-0.374,0.316-0.73,0.619-1.136,0.963c0.63,1.51,1.506,0.87,2.098-0.171 C195.776,380.054,195.582,379.672,195.156,379.502z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.569,324.031c-0.347,0.125-0.635,0.23-0.893,0.323c-0.087,0.256-0.157,0.464-0.252,0.747 C190.537,326.931,192.013,325.111,190.569,324.031z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.295,362.183c0.3,0.817,1.241,0.993,1.604,0.265c-0.24-0.357,0.26-0.551,0.199-0.847 C204.27,360.914,203.854,361.048,203.295,362.183z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.426,351.416c1.189-0.381,1.572-1.059,0.573-1.909c-0.759,0.091-0.962,0.658-1.319,1.239 C191.904,350.947,192.138,351.157,192.426,351.416z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.077,358.933c-0.305,0.522-0.611,1.006-0.089,1.636c0.235-0.107,0.426-0.195,0.59-0.27 c0.197,0.115,0.246,0.302,0.46,0.229C207.849,359.545,207.305,358.705,206.077,358.933z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.258,347.325c-2.09,0.671,0.637,2.903,1.176,0.661 C191.204,347.513,190.699,347.544,190.258,347.325z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.379,365.842c-1.08-0.361-2.342,0.728-1.068,1.465 C186.018,367.578,187.249,366.592,186.379,365.842z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.678,375.606c0.157,0.344,0.283,0.625,0.409,0.901c0.375,0.092,0.736-0.044,1.253-0.051 C200.726,375.06,199.434,374.25,198.678,375.606z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.222,364.669c-0.019-0.386-0.035-0.727-0.052-1.073c-1.046-0.743-1.412,0.186-1.432,1.163 C183.423,365.627,183.744,365.133,184.222,364.669z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.558,383.192c0.248-0.571-0.702-1.743-1.278-1.247c0.05,0.472-0.271,0.794-0.639,1.201 C178.1,383.719,179.022,383.653,179.558,383.192z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.179,327.671c-0.052-1.482-1.278-1.09-1.701-0.434v0.803 C174.012,328.485,174.909,328.388,175.179,327.671z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.302,370.507c-0.908,0.63,0.371,2.33,1.23,1.315 C186.339,370.716,186.852,369.97,185.302,370.507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.006,350.907c0.061-0.19,0.127-0.395,0.196-0.607c-0.136-0.259-0.269-0.51-0.405-0.768 c-0.533-0.146-0.903-0.024-1.219,0.286c-0.135,0.498,0.071,0.912,0.256,1.294C197.298,351.289,197.618,351.021,198.006,350.907z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.638,328.215c-0.151-0.519-0.313-0.999-0.488-1.443c-0.187,0.25-0.364,0.487-0.529,0.706 C205.845,328.159,206.263,328.316,206.638,328.215z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.182,373.544c0.094,0.237,0.183,0.466,0.27,0.687c0.306,0.06,0.58,0.114,0.902,0.176 c0.186-0.33,0.366-0.647,0.565-1.001C202.509,372.438,201.333,372.598,201.182,373.544z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.25,372.83c-0.244,0.695-0.662,2.091,0.579,1.764c0.091-0.089,0.171-0.188,0.242-0.291 c0.037-0.452,0.074-0.91,0.111-1.375C207.006,372.767,206.715,372.698,206.25,372.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.983,371.854c0.927-0.117,1.005-0.155,1.363-0.686c-0.224-0.282-0.397-0.622-0.486-0.971 C198.77,370.064,198.122,371.059,198.983,371.854z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.653,389.532c0.448-0.181,0.822-0.374,1.132-0.577c-0.272,0-0.548,0-0.842,0 C203.841,389.16,203.745,389.35,203.653,389.532z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.52,372.589c-0.312-0.034-0.589-0.065-0.913-0.1c-0.092,0.398-0.176,0.756-0.216,0.926 c0.284,0.36,0.478,0.608,0.684,0.87C189.268,374.155,189.07,373.355,188.52,372.589z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.139,382.132c-0.468,1.182-0.063,2.134,1.17,1.084 C193.681,382.019,193.156,381.783,192.139,382.132z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.759,389.593c0.14,0.276,0.279,0.547,0.421,0.825c0.363,0,0.705,0,1.101,0 C201.187,388.985,198.923,388.35,198.759,389.593z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.332,337.5c0.303-0.427,0.981-1.075,0.457-1.565c-0.646-0.407-0.912,0.09-1.311,0.452v0.771 C173.712,337.541,173.971,337.881,174.332,337.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.68,365.231c0.982,0.018,0.526-1.052,0.531-1.709c-0.239,0.053-0.442,0.098-0.647,0.141 c-0.2,0.042-0.392-0.276-0.596-0.017c0.178,0.444,0.065,0.876-0.161,1.255C206.03,365.311,206.373,365.236,206.68,365.231z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.56,370.493c-0.655-0.22-0.945,0.334-1.389,0.527c0.239,0.973,0.981,1.632,1.168,0.608 c0.295-0.135,0.509-0.233,0.734-0.335C181.874,370.982,181.711,370.728,181.56,370.493z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.839,365.362c0.335-0.321,0.67-0.641,1.056-1.009c-0.38-1.428-1.315-0.292-1.923,0.291 C201.145,365.051,201.445,365.254,201.839,365.362z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.586,382.855c0.208,0.252,0.428,0.518,0.677,0.822 C199.475,382.922,197.081,380.679,196.586,382.855z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.29,349.005c1.147-0.506,1.523-0.14,1.143-1.591c-0.132-0.068-0.272-0.141-0.485-0.252 c-0.215,0.147-0.413,0.284-0.583,0.415C185.673,348.184,184.448,348.537,185.29,349.005z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.532,378.598c0.074-0.85,0.074-0.85-0.348-1.289 C177.146,377.506,177.933,379.201,179.532,378.598z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.747,386.856c-0.28,0.518,0.172,0.89,0.089,1.37 C175.667,388.739,175.154,386.268,173.747,386.856z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.352,378.265c0.05,1.059,1.096,0.5,1.575,0.07 C188.792,376.95,187.928,377.428,187.352,378.265z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.105,387.285c0-16.774,0-33.548,0-50.323c0-4.929,0-9.858,0-14.788 c0-0.804-1.25-0.806-1.25,0c0,16.935,0,33.87,0,50.805c0,4.768,0,9.537,0,14.305 C172.855,388.089,174.105,388.091,174.105,387.285L174.105,387.285z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M132.597,321.448c0,0-2.897,16.594-0.79,17.252c2.107,0.659,11.063,0.263,11.984,0 s1.844-17.65,1.844-17.65S135.626,320.658,132.597,321.448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.716,342.423c-0.553-1.412-1.955-2.773-3.469-2.687l0.154,0.004 c-3.897-0.095-7.793-0.191-11.69-0.286c-1.181-0.029-2.42-0.046-3.473,0.491c-1.029,0.524-1.771,1.574-1.929,2.718 c-0.158,1.144,0.271,2.352,1.109,3.147c1.273,1.206,3.189,1.346,4.941,1.421c2.734,0.116,5.468,0.232,8.202,0.349 c1.771,0.075,3.721,0.094,5.087-1.035C201.818,345.578,202.269,343.835,201.716,342.423z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M95.274,151.982c-0.113,1.404-4.099,59.777,0,61.826c4.099,2.049,106.915,8.881,107.94,0 c1.025-8.881,6.148-59.103-1.708-63.881C193.649,145.15,95.712,146.546,95.274,151.982z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.663,158.368c0.25-2.452,3.835-1.564,1.917-3.571c-0.817-0.183-1.415,0.808-1.45,1.52 c0.013,1.042-1.636,0.546-2.427,1.105C179.678,158.482,181.379,159.895,181.663,158.368z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.952,182.041c0.36,0.081,0.634,0.143,0.932,0.208 C184.179,180.751,179.028,178.641,179.952,182.041z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.302,211.257c-0.169-1.565-2.003-1.317-2.274,0.193 C182.951,212.389,183.759,212.644,184.302,211.257z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.953,182.519c-0.723,0.148-1.359,0.229-1.54,1.042c0.219,1.641,1.687,1,2.281-0.045 C179.604,183.112,179.406,182.77,178.953,182.519z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.243,217.655c0.609-0.047,1.202-0.097,1.779-0.15c-0.006-0.017-0.014-0.039-0.02-0.055 C190.225,217.085,189.581,217.281,189.243,217.655z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.654,177.436c0.166-0.399,0.312-0.75,0.479-1.153 C203.109,173.465,201.995,178.186,204.654,177.436z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.09,205.23c0.059-0.635,0.118-1.294,0.178-1.972c-0.141-0.072-0.306-0.125-0.507-0.151 C202.34,203.897,203.189,205.258,204.09,205.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.296,170.739c0.381-0.095,0.739-0.184,1.097-0.272 C181.085,167.75,175.408,168.876,178.296,170.739z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.524,165.679c0.114-0.564,0.114-0.564,0.516-0.97c-0.198-0.32-0.488-0.558-0.822-0.844 C171.869,164.009,173.342,167.42,174.524,165.679z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.208,184.336c0.269-0.114,0.168-0.372,0.154-0.59c0.495-0.583-0.054-1.251-0.698-1.381 c-0.335,0.249-0.737,0.389-1.149,0.313C200.289,183.77,201.077,184.84,202.208,184.336z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.847,153.653c0.144-1.156-1.681-1.654-1.918-0.46 C179.559,154.54,181.748,155.146,181.847,153.653z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.605,178.536c0.288,1.555,1.299,1.954,2.124,0.472 C179.201,178.109,178.079,176.922,177.605,178.536z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.08,158.549c0.92-1.318-1.783-2.236-1.777-0.651 C175.155,158.89,176.677,159.775,177.08,158.549z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.964,158.62c1.087-1.303-1.309-2.017-1.97-0.757 C189.424,158.876,190.048,159.753,190.964,158.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.874,174.042c-0.715-1.151-1.561-1.242-2.051,0.183 C172.885,175.717,175.282,175.303,174.874,174.042z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.8,201.233c-0.234-0.119-0.515-0.262-0.884-0.45 C171.182,202.626,175.315,204.373,174.8,201.233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.144,198.502c-0.825-0.017-1.275,0.438-1.54,1.18c0.218,0.302,0.435,0.603,0.633,0.878 c0.439-0.085,0.807-0.156,1.215-0.235c0.144-0.291,0.295-0.594,0.446-0.898C195.628,199.095,195.392,198.804,195.144,198.502z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.546,210.311c-2.596,0.121,0.659,3.702,0.99,0.992 C179.617,210.433,179.173,210.497,178.546,210.311z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.365,177.644c0.472-0.272,0.707-0.767,1.081-1.333c-0.703-1.238-1.508-0.953-2.207,0.093 C175.253,177.124,175.558,177.594,176.365,177.644z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.299,150.035c-0.312,0.081-0.639,0.165-0.907,0.234c-0.581,0.896-0.215,1.861,0.883,1.991 c0.319-0.368,0.625-0.722,0.914-1.056C198.034,150.679,197.755,150.312,197.299,150.035z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.122,163.356c0.38-1.728-1.079-2.404-1.82-0.717 C175.22,163.598,176.833,164.364,177.122,163.356z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.949,194.932c-0.03-0.67-0.443-0.937-1.047-1.006c-0.879,0.334-0.759,1.085-0.914,1.764 C180.956,196.517,181.555,195.957,181.949,194.932z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.352,162.629c0.002,1.192,1.105,1.53,1.816,0.506c0.026-0.497,0.242-0.907,0.055-1.337 c-0.219-0.07-0.428-0.137-0.626-0.201C199.089,161.934,198.462,161.963,198.352,162.629z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.965,210.072c-3.085,0.989,0.379,3.577,0.961,0.829 C188.61,210.628,188.307,210.368,187.965,210.072z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.401,170.078c0.424,0.88,1.799,0.999,1.798-0.279 C192.964,167.996,191.147,168.309,191.401,170.078z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.811,168.325c1.975-1.777-1.271-2.994-1.568-0.762 C198.618,168.157,199.327,167.881,199.811,168.325z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.485,155.219c-0.704-0.451-1.432-0.202-2.203-0.525c0.613,1.009,0.613,1.009,0.588,1.915 C201.7,156.992,203.636,156.088,202.485,155.219z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.949,170.72c-0.91,0.783-1.792,1.521-0.41,2.258c0.579,0.328,0.875-0.428,1.195-0.79 C196.214,171.54,195.337,171.208,194.949,170.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.719,207.687c1.27-0.535,1.839-1.01,0.654-2.05c-0.559-0.091-0.919,0.258-1.312,0.457 c-0.083,0.274-0.155,0.511-0.228,0.752C173.119,207.178,173.376,207.494,173.719,207.687z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.558,168.846c-2.458-0.384-2.621,2.157,0.035,1.422 C188.976,169.796,189.116,169.354,188.558,168.846z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M170.918,171.104v0.154c0.085,0.232,0.085,0.418,0,0.599v0.789 c0.3,0.259,0.882,0.26,1.251,0.231C173.526,172.158,172.103,170.355,170.918,171.104z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.478,202.859c1.033-0.907,0.954-1.45-0.262-2.011 C181.654,201.248,181.83,202.895,183.478,202.859z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.777,168.379c1.268,0.104,1.923-1.783,0.419-1.842 C202.877,166.296,202.588,167.971,203.777,168.379z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.054,193.164c0.768,0.855,1.527,0.422,2.024-0.457 C174.434,191.187,172.782,191.419,173.054,193.164z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.842,185.272c-0.359-0.237-0.647-0.428-0.914-0.604c-0.736,0.33-0.736,0.33-1.106,1.285 C180.578,187.21,182.169,186.867,181.842,185.272z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.687,152.64c-1.194-0.462-1.139,1.093-1.471,1.837c0.485,0.122,0.905-0.418,1.442-0.156 c0.079,0.034,0.248-0.063,0.336-0.143C200.496,153.731,200.477,152.699,199.687,152.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.386,204.026c-0.239-0.223-0.492-0.46-0.727-0.681c-1.118,0.304-1.118,0.304-1.342,1.27 C198.932,205.779,200.532,205.419,200.386,204.026z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.942,172.379c0.294,0.219,0.619,0.459,0.969,0.717 C206.491,171.703,203.302,169.326,202.942,172.379z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.735,193.361c0.067-1.303,0.007-1.419-0.904-1.784c-0.361,0.318-0.732,0.645-1.091,0.96 c0.186,0.403,0.34,0.733,0.478,1.032C187.808,193.421,188.255,193.828,188.735,193.361z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.228,159.254c-0.294,0.2-0.601,0.409-0.883,0.601 C195.449,162.717,200.103,160.902,197.228,159.254z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.807,176.025c-0.074,0.252-0.152,0.518-0.226,0.771 C186.472,179.741,187.825,174.184,184.807,176.025z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.974,191.33c2.884-0.556,0.14-3.144-0.968-0.922 C189.123,190.909,189.427,191.201,189.974,191.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.563,195.266c0.342,0.546,0.886,0.698,1.421,0.884c0.365-0.312,0.449-0.733,0.658-1.089 C186.343,193.776,184.321,193.766,184.563,195.266z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.472,187.129c-1.19-0.151-1.395,1.639-0.381,1.9 C193.291,189.418,194.026,187.051,192.472,187.129z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.427,190.789c0.446,0.75,2.05,0.791,1.973-0.321 C177.099,189.1,174.824,189.246,175.427,190.789z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.62,165.662c-0.022-0.434-0.047-0.862-0.074-1.284 C205.106,164.802,205.013,165.315,205.62,165.662z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.089,206.599c0.351,0.382,0.452,0.905,0.957,1.091c0.577-0.238,0.943-0.636,1.09-1.287 C197.289,205.331,196.523,205.031,196.089,206.599z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.64,173.135c-0.872,0.276-0.872,0.276-1.165,1.103c0.146,0.212,0.305,0.444,0.471,0.686 c0.303,0.075,0.608,0.152,0.98,0.246C193.934,174.575,193.59,173.531,192.64,173.135z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.489,207.765c-0.352,0.229-0.8,0.278-1.071,0.708c0.136,0.361,0.279,0.739,0.409,1.085 c0.305,0.098,0.545,0.175,0.822,0.263C200.631,209.205,200.952,207.943,199.489,207.765z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.065,200.736c0.435-0.34,0.785-0.717,0.986-1.217 C180.847,197.432,178.661,199.893,181.065,200.736z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.143,163.625c0.188-0.269,0.348-0.498,0.533-0.764c-0.411-0.421-0.553-1.031-1.201-1.304 c-0.351,0.255-0.728,0.529-1.139,0.829C184.577,163.404,185.289,163.514,186.143,163.625z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.459,149.342c0.509,1.022,1.84,0.135,1.916-0.733 C176.488,147.259,174.959,147.923,175.459,149.342z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.816,149.971c-0.294,0.407-0.644,0.731-0.74,1.278c0.354,0.269,0.724,0.551,1.077,0.82 c0.344-0.093,0.643-0.175,0.996-0.272c-0.102-0.51-0.198-0.99-0.297-1.485C183.491,150.194,183.167,150.087,182.816,149.971z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.026,158.739c1.23,0.44,1.411,0.371,1.769-0.616c-0.453-1.117-1.659-1.384-2.145-0.141 C193.8,158.283,193.924,158.534,194.026,158.739z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.038,162.04c-0.074,0.57,0.368,0.73,0.302,1.335c0.677,0.094,1.368,0.55,1.698-0.227 C191.017,161.712,190.216,161.382,189.038,162.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.183,214.589c0.82-0.237,1.002-0.79,0.973-1.49 C189.733,211.797,188.12,214.039,190.183,214.589z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.315,212.913c-0.41,0.401-0.466,0.855-0.183,1.166c0.033-0.089,0.071-0.178,0.082-0.271 C203.244,213.546,203.278,213.245,203.315,212.913z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.208,177.428c0.046-0.454,0.208-0.841,0.518-1.138c-0.178-0.873-1.238-1.18-1.808-0.541 v0.602c0.071,0.351,0.22,0.69,0.19,1.054C171.504,177.533,171.835,177.525,172.208,177.428z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.352,161.491c0.434-0.444,0.906-0.829,0.763-1.543c-0.297-0.236-0.587-0.467-0.865-0.688 c-0.688,0.189-1.089,0.566-1.091,1.28C182.434,160.989,182.892,161.199,183.352,161.491z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M170.918,166.59v1.347c0.064,0.096,0.128,0.189,0.198,0.293 C174.005,168.633,171.957,165.575,170.918,166.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.821,168.221c2.38-1.144-0.771-3.179-1.307-0.687 C194.02,167.799,194.431,168.016,194.821,168.221z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.298,170.75c-1.204,0.33-1.621,1.763-0.348,2.214 C191.059,172.419,191.542,171.447,190.298,170.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.867,208.927c0.292,0.357,0.546,0.577,0.799,0.678c0.058-0.571,0.119-1.179,0.182-1.821 C203.473,207.81,203.092,208.165,202.867,208.927z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.793,175.082c0.005-0.556,0.007-1.109,0.007-1.659 C205.318,173.793,205.205,174.603,205.793,175.082z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.147,184.89c-0.674-0.075-1.047,0.072-1.229,0.307v0.911 c0.37,0.714,1.386,1.213,1.826-0.254C172.52,185.486,172.47,185.153,172.147,184.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.219,188.52c0.703,0.552,1.918,0.557,2.139-0.478 C183.651,186.756,181.727,186.973,182.219,188.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.333,205.378c-1.016,1.104-0.547,1.989,0.77,2.304c0.311-0.346,0.435-0.738,0.619-1.12 C179.491,205.933,178.896,205.808,178.333,205.378z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.187,182.684c-0.611-0.606-1.081-0.302-1.639,0.097 C190.473,184.381,193.9,185.091,193.187,182.684z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.287,178.614c-0.117,0.652,0.289,1.374,1.029,1.158 C199.423,179.247,196.221,176.284,196.287,178.614z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.333,202.894c1.212,0.129,1.781-1.949,0.249-1.909 C177.441,200.875,177.317,202.768,178.333,202.894z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.955,148.108c-0.448-0.035-0.919-0.071-1.449-0.112 C187.855,149.975,192.344,150.404,190.955,148.108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.552,155.065c-0.794-0.441-1.444,0.026-1.689,0.883c0.515,0.313,1.117,1.388,1.699,0.715 C198.025,156.263,198.125,155.406,197.552,155.065z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.53,210.133c-1.219,0.091-1.539,1.793-0.177,1.995 C193.502,212.059,193.719,210.319,192.53,210.133z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.835,160.365c-0.415-0.7-0.99-1.311-1.75-0.634c0.045,0.189,0.079,0.338,0.117,0.501 c-0.173,0.109-0.349,0.22-0.562,0.354C187.353,161.555,188.804,161.786,188.835,160.365z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.724,210.073c-0.639,0.149-0.927,0.525-1.007,1.073c0.173,0.318,0.337,0.619,0.501,0.92 C202.602,212.272,203.347,210.696,201.724,210.073z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.783,172.579c0.814,0.72,1.091,0.608,1.8-0.352 C186.283,170.332,184.41,170.729,184.783,172.579z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.905,165.002c0.416,1.068,1.274,1.17,1.941,0.263 C198.456,163.794,196.155,163.593,195.905,165.002z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.778,170.465c-0.01-0.593-0.021-1.181-0.037-1.761c-0.516,0.115-0.102,1.018-0.38,1.342 C205.484,170.258,205.625,170.385,205.778,170.465z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.043,193.662c0.193-0.256,0.363-0.479,0.547-0.724 C192.942,189.731,189.972,194.005,193.043,193.662z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.742,187.576c-1.106-1.067-1.62,0.129-1.958,1.131 C173.68,189.428,175.356,188.788,174.742,187.576z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.693,149.844c0.104-0.436,0.024-0.938-0.179-1.32c-0.493-0.064-1.01-0.126-1.55-0.186 C193.797,149.685,194.339,149.913,195.693,149.844z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.682,182.886c-0.84-0.711-1.515-0.436-1.817,0.601c0.201,0.296,0.395,0.584,0.608,0.901 c0.313,0,0.627,0,0.968,0C188.876,183.954,188.819,183.436,188.682,182.886z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.943,204.277c0.475,0.262,0.33,1.04,1.038,1.091c0.336-0.289,0.694-0.597,1.056-0.909 C181.898,203.036,180.363,202.96,179.943,204.277z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.757,165.563c-0.01-0.518,0.197-1.1-0.504-1.472 C185.723,164.278,187.202,166.901,188.757,165.563z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.156,168.507c-1.504,0.873-0.98,2.589,0.781,1.776 C184.233,169.57,184.122,168.673,183.156,168.507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.211,166.863c0.053,0.898,0.441,1.313,1.347,1.399c0.237-0.393,0.6-0.641,0.63-1.126 C190.386,166.371,190.078,165.591,189.211,166.863z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.743,155.087c-0.093,0.375-0.183,0.735-0.258,1.036c0.745,1.286,2.058,0.46,1.896-0.771 c-0.21-0.36-0.533-0.422-0.835-0.554C192.283,154.894,192.016,154.989,191.743,155.087z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.268,186.692c0.144-0.378,0.278-0.73,0.421-1.106 C194.072,183.176,192.54,187.287,195.268,186.692z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.506,214.709c-0.402,0.487-0.445,1.017-0.489,1.554c0.399,0.453,0.867,0.594,1.461,0.421 c0.005-0.555,0.149-0.881,0.454-1.361C174.435,215.106,174.192,214.49,173.506,214.709z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.004,173.008c0.318-0.24,0.644-0.488,1.058-0.802c-0.18-0.367-0.333-0.677-0.504-1.026 C179.893,170.501,179.379,172.559,181.004,173.008z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.045,191.757c-0.721,0.402-1.792,0.364-1.241,1.415 C178.658,194.845,180.492,192.835,179.045,191.757z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.345,174.615c1.57-1.087-1.319-2.079-1.435-0.462 C195.815,175.141,198.147,175.934,197.345,174.615z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.689,174.167c-0.158-0.301-0.269-0.677-0.679-0.832c-0.298,0.065-0.601,0.132-0.889,0.196 c-0.219,0.288-0.422,0.556-0.617,0.814c0.188,0.288,0.341,0.523,0.511,0.783C178.767,175.339,179.55,174.965,179.689,174.167z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.299,179.841c0.726-0.226,1.483-0.17,1.786-1.01 C174.279,177.072,172.426,178.088,173.299,179.841z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.162,186.405c0.656-1.541-0.722-2.286-1.74-0.878 C198.662,186.42,199.329,187.191,200.162,186.405z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.314,180c-0.305,0.539-1.136,0.534-1.132,1.375c0.251,0.41,0.493,0.9,1.222,0.835 C191.405,181.766,191.088,180.611,190.314,180z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.577,153.628c-0.089,0.953,1.891,0.992,1.882,0.046 C186.38,152.244,184.643,152.061,184.577,153.628z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.933,172.817c0.991,0.081,0.991,0.081,1.402-0.796c-0.24-0.4-0.479-0.8-0.757-1.263 c-0.557,0.218-0.951,0.46-1.319,0.882C175.5,172.03,175.591,172.506,175.933,172.817z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.388,215.921c-0.33-0.4-0.646-0.782-1.049-1.268c-0.418,0.277-0.755,0.5-1.079,0.715 c-0.031,0.388-0.058,0.728-0.091,1.136C183.06,216.475,183.804,216.77,184.388,215.921z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.922,161.73c-0.239,0.16-0.499,0.334-0.737,0.493c-0.074,0.307-0.14,0.581-0.221,0.915 c0.8,0.866,0.974,0.88,1.776,0.171C181.782,162.692,181.762,161.905,180.922,161.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.997,168.922c-0.321,0.598-0.067,1.026,0.217,1.637c0.883,0.199,1.624-0.398,1.385-1.328 C202.421,168.763,201.234,168.406,200.997,168.922z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.56,194.587c-0.382-0.351-0.802-0.348-1.295-0.417c-0.112,0.122-0.232,0.231-0.346,0.342 v1.055C171.711,196.259,172.904,195.992,172.56,194.587z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.047,187.186c-0.368-0.067-0.681-0.121-1.001,0.07c-0.146,0.301-0.298,0.615-0.452,0.935 C178.469,189.926,180.375,188.613,179.047,187.186z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.362,165.555c0.739,1.17,1.786,0.202,1.94-0.802c-0.298-0.238-0.568-0.453-0.826-0.657 C182.408,164.304,182.435,164.583,182.362,165.555z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.823,210.488c-0.925-0.462-1.519-0.204-1.861,0.784c0.545,0.434,1.401,1.447,1.827,0.382 C174.943,211.283,175.365,210.75,174.823,210.488z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.24,167.871c0.907,0.654,1.906-0.185,1.568-1.243 C180.8,165.664,179.499,166.726,180.24,167.871z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.19,206.678c0.45,0.886,1.693,1.305,1.966,0.138 C184.173,205.356,182.504,205.296,182.19,206.678z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.537,210.468c-0.691,0.562-0.219,1.63,0.626,1.658 C198.731,211.969,197.647,209.038,196.537,210.468z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M170.918,157.509v1.251c0.169,0.187,0.453,0.321,0.774,0.5 C173.907,157.78,171.466,156.749,170.918,157.509z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.11,192.114c-0.667-0.816-1.945-0.071-1.812,0.911 C196.964,194.346,198.311,193.392,198.11,192.114z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.976,183.897c0.049-0.175,0.1-0.357,0.152-0.54c-0.498-0.887-1.323-0.782-2.182-0.744 c0.146,0.476,0.153,0.791,0.135,1.277C196.759,184.188,197.432,184.277,197.976,183.897z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.417,189.48c-0.261,0.334-0.64,0.539-0.795,0.92c0.437,0.605,0.879,0.859,1.618,0.926 C196.443,190.616,195.587,189.574,194.417,189.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.662,196.93c0.194,1.537,1.167,1.728,1.952,0.33 C193.5,196.241,191.945,195.869,191.662,196.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.215,196.324c-1.071,0.025-1.895,1.849-0.213,1.937 C175.026,198.06,175.31,196.638,174.215,196.324z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.055,214.573c0.32-0.313,0.722-0.583,0.881-1.106 C180.711,211.439,178.657,213.8,181.055,214.573z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.07,182.278c0.222-0.32,0.446-0.646,0.675-0.976 C194.822,178.608,192.563,181.59,195.07,182.278z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.262,187.612c0.038,0.074,0.075,0.147,0.111,0.22c0.005-0.097,0.01-0.194,0.015-0.291 C205.344,187.566,205.31,187.585,205.262,187.612z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.696,200.993c-1.175,0.098-1.267,1.764-0.046,1.904 C202.852,202.842,202.88,201.132,201.696,200.993z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.745,178.172c-0.06,0.071-0.117,0.152-0.164,0.257c0.046,0.261,0.091,0.52,0.139,0.793 C205.729,178.871,205.737,178.521,205.745,178.172z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.057,158.347c0.555,0.558,0.943,0.824,1.221,0.825c0.2-0.149,0.422-0.315,0.622-0.465 c-0.258-0.452-0.138-0.823-0.385-1.283C203.8,156.538,203.048,157.486,203.057,158.347z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.189,150.04c-0.094-0.033-0.318,0.031-0.328,0.081c-0.085,0.442-0.481,0.428-0.798,0.54 c0.047,0.355,0.09,0.68,0.132,0.995c0.516,0.096,0.98,0.406,1.501,0.163C175.45,150.922,174.955,150.574,174.189,150.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.579,186.616c1.047-0.628,0.668-1.428-0.33-1.864c-0.544,0.317-1.52,0.724-0.846,1.36 C189.752,186.365,190.134,186.929,190.579,186.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.597,161.311c0.594-0.227,0.912-0.608,0.936-1.235c-0.087-0.14-0.183-0.297-0.268-0.434 c-0.756-0.057-1.475-0.186-1.905,0.695C191.601,160.866,192.118,161.083,192.597,161.311z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M170.918,149.113c0.1,0.207,0.264,0.432,0.51,0.671c0.413-0.156,0.763-0.289,1.222-0.462 c0.01-1.605-1.321-1.729-1.732-1.104V149.113z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.218,205.006c0.642-0.503,0.314-1.681-0.425-1.71c-0.568-0.102-0.741,0.156-0.875,0.543 v1.07C171.25,205.098,171.908,204.978,172.218,205.006z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M170.918,208.367v1.032c0.128,0.114,0.245,0.219,0.388,0.346 C173.988,209.743,171.958,206.936,170.918,208.367z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.308,198.199c0.147-0.211,0.31-0.442,0.471-0.673c-0.092-0.356-0.179-0.691-0.294-1.132 c-0.741,0.023-1.377,0.109-1.587,0.933C187.167,198.333,187.416,198.39,188.308,198.199z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.27,189.654c-0.783-0.213-1.254,0.119-1.352,0.588v0.36 c0.058,0.314,0.252,0.644,0.634,0.902C172.617,191.132,173.21,190.481,172.27,189.654z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.402,157.696c0.125,0.62,0.37,1.568,1.214,1.268c0.17-0.426,0.432-0.711,0.865-0.851 C200.334,156.673,199.248,157,198.402,157.696z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.616,185.501c0.05,0.442,0.091,0.805,0.132,1.17c0.269,0.077,0.54,0.156,0.799,0.231 c0.714-0.6,0.757-0.711,0.667-1.793c-0.363-0.091-0.745-0.186-1.125-0.281C184.892,185.109,184.731,185.338,184.616,185.501z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.357,185.778c0.436,0.959,1.199,1.191,1.947,0.459 C177.436,184.828,175.723,184.271,175.357,185.778z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.153,179.732c0.71-0.623,0.858-1.203,0.028-1.832c-0.556,0.188-1.398,0.132-1.419,0.906 c0.167,0.254,0.323,0.492,0.484,0.736C187.562,179.608,187.868,179.673,188.153,179.732z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.613,181.552c0.083-0.844-0.928-1.776-1.677-1.104c-0.007,0.008-0.011,0.016-0.018,0.024 v1.168C171.321,182.022,172.11,182.111,172.613,181.552z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.64,194.061c-1.194,0.141-0.537,2.233,0.684,1.538c0.278-0.053,0.463-0.14,0.578-0.245 c0.015-0.208,0.03-0.415,0.045-0.625C204.722,194.367,204.162,194.043,203.64,194.061z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.441,182.889c-0.399,1.789,1.027,1.989,1.893,0.664 C184.111,182.486,183.251,182.451,182.441,182.889z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.627,194.387c-0.025,0.378-0.05,0.753-0.074,1.106c0.361,0.373,0.781,0.459,1.316,0.402 c0.089-0.35,0.103-0.654,0.412-0.871C201.073,194.123,199.155,193.98,198.627,194.387z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.66,213.446c-0.393-0.41-0.676-0.89-1.255-1.001c-0.477,0.24-0.662,0.697-0.93,1.098 C185.312,214.52,186.033,214.765,186.66,213.446z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.621,217.943c0.572-0.028,1.132-0.058,1.685-0.09c-0.04-0.164-0.083-0.34-0.133-0.542 C185.322,216.656,184.72,217.071,184.621,217.943z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.779,203.498c-1.578-0.252-2.209,0.589-1.049,1.682 C190.793,205.333,191.369,204.384,190.779,203.498z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.092,203.306c-0.819,0.312-1.538,0.295-1.308,1.355c0.849,0.786,1.1,0.768,1.917-0.098 C195.514,204.158,195.547,203.641,195.092,203.306z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.227,150.548c-1.072-0.45-1.072-0.45-1.535-0.069 C177.292,152.664,180.052,152.533,179.227,150.548z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.251,206.968c0.774-0.548,0.109-1.023-0.276-1.543c-0.352,0.119-0.645,0.218-0.852,0.288 c-0.128,0.546-0.236,1.001-0.355,1.509C201.386,207.568,201.871,207.62,202.251,206.968z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.89,195.067c-0.004-1.478-1.975-1.125-1.889,0.159 C189.103,195.841,191.11,196.17,190.89,195.067z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.229,191.995c-0.85,1.074-0.544,0.98,0.287,1.581c0.643,0.296,1.165-0.49,1.286-1.082 C202.394,191.765,201.789,191.926,201.229,191.995z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.345,217.819c-0.275-0.309-0.504-0.567-0.713-0.8c-0.812,0.162-1.22,0.725-1.253,1.195 c0.587-0.008,1.168-0.017,1.743-0.028C177.189,218.051,177.264,217.923,177.345,217.819z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.65,184.064c0.059-0.302,0.12-0.605,0.178-0.901 C172.967,181.08,171.941,185.221,174.65,184.064z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.149,178.829c-0.421-1.488-1.979-1.172-1.865,0.395 C182.35,180.316,183.971,179.511,184.149,178.829z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.556,157.877c0.083,1.386,1.988,1.565,1.814-0.179 C185.438,156.741,184.998,157.073,184.556,157.877z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M171.683,200.754c0.548-0.273,0.768-0.705,0.854-1.28c-0.223-0.711-1.14-1.063-1.618-0.543 v1.041C171.156,200.248,171.515,200.486,171.683,200.754z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.612,214.553c0.27-0.656,0.951-0.689,0.659-1.55 C198.519,211.631,197.748,214.287,199.612,214.553z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.941,156.715c1.224-0.596,0.402-1.887-0.608-1.865c-0.432,0.396-0.798,0.601-0.936,1.201 C177.954,156.291,178.447,156.502,178.941,156.715z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.998,175.117c0.34,0.097,0.463-0.465,0.618-0.654c-0.142-0.277-0.256-0.499-0.407-0.793 c-1.239-0.627-2.177,0.478-1.051,1.439C201.415,175.158,201.711,174.725,201.998,175.117z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.048,169.757c-0.474-0.406-0.479-0.949-0.983-1.176c-1.092,0.195-1.386,1.156-0.603,1.936 C173.999,170.295,174.646,170.312,175.048,169.757z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.64,206.638c0.096,0.212,0.183,0.41,0.311,0.695 C190.316,207.945,188.26,204.14,186.64,206.638z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.596,183.033c-0.073,0.073-0.146,0.141-0.223,0.234c0.007,0.258,0.081,0.468,0.187,0.643 C205.572,183.618,205.585,183.325,205.596,183.033z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.543,181.927c1.42,0.018,1.577,0.234,1.641-1.304c-0.302-0.193-0.565-0.36-0.811-0.517 c-0.426,0.29-0.814,0.555-1.26,0.858C175.376,181.279,175.446,181.514,175.543,181.927z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.702,187.267c-0.28,0.194-0.547,0.381-0.815,0.567c0.696,1.076,1.39,1.64,2.296,0.518 C197.991,187.574,197.52,187.237,196.702,187.267z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.378,148.806c0.465,0.67,0.993,1.099,1.858,0.899c0-0.489,0-0.93,0-1.347 C185.296,147.463,184.998,148.065,184.378,148.806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.321,149.959c0.774,0.095,1.059-0.138,1.069-0.497c-0.498-0.158-1.11-0.307-1.818-0.449 c0,0,0,0.001,0,0.001C198.816,149.322,199.048,149.614,199.321,149.959z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.07,154.5c0.406-0.202,0.762-0.38,1.218-0.608c-0.48-0.604-0.083-1.277-0.779-1.548 c-0.518,0.117-0.866,0.403-1.128,0.841c0.157,0.19,0.294,0.354,0.424,0.511c-0.074,0.188-0.139,0.355-0.219,0.559 C175.783,154.354,175.947,154.438,176.07,154.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.992,175.471c-0.695,0.363-0.695,0.363-1.106,1.25 C181.285,178.484,182.781,176.587,180.992,175.471z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.682,150.054c-1.147,0.34-1.194,1.693,0.13,1.833c0.847,0.126,0.927-0.445,0.702-1.012 C202.256,150.536,201.978,150.265,201.682,150.054z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.807,217.062c-0.519,0.249-0.656,0.629-0.707,1.052c0.553-0.016,1.097-0.034,1.637-0.053 c-0.063-0.227-0.123-0.447-0.184-0.668C181.282,217.272,181.026,217.159,180.807,217.062z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.93,208.607c-0.046,1.643,1.908,1.382,2.031-0.115 C181.432,208.191,180.12,207.735,179.93,208.607z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.139,155.062c-0.337,0.746-0.117,1.296,0.551,1.78c1.046-0.28,1.048-0.498,1.195-1.241 c-0.17-0.195-0.315-0.361-0.432-0.496C187.926,155.197,187.639,155.171,187.139,155.062z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.121,201.273c-1.212-0.244-1.307-0.014-1.814,0.885 C192.016,203.571,193.76,202.673,193.121,201.273z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.33,191.533c0.713-0.116,1.006-0.736,1.104-1.486c-0.171-0.179-0.385-0.402-0.6-0.626 c-0.569,0.277-1.247,0.186-1.39,0.883C184.749,190.725,185.019,191.101,185.33,191.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.356,163.564c0.238-0.234,0.498-0.457,0.75-0.663c-0.469-1.09-0.999-1.452-1.925-0.839 C203.586,163.042,202.703,163.442,204.356,163.564z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.649,213.755c0.093-0.44-0.277-1.193-0.744-1.376c-0.522,0.419-1.164,0.903-1.099,1.596 C194.546,214.495,195.164,214.573,195.649,213.755z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.625,153.91c0.254-1.153-0.98-1.95-1.799-0.918 C193.801,154.187,194.693,154.524,195.625,153.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.918,216.895c0.293-0.349,0.593-0.708,0.879-1.049c-0.096-0.41-0.197-0.735-0.531-0.962 C186.928,215.017,186.197,216.712,187.918,216.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.12,149.766c0.453-0.272,0.742-0.63,0.901-1.164c-0.513-0.398-1.389-0.777-2.049-0.398 c-0.154,0.465,0.177,0.827,0.252,1.258C180.547,149.572,180.839,149.671,181.12,149.766z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.475,215.747c-0.06,0.851,0.444,0.82,1.006,0.934 C194.454,216.304,191.819,213.466,191.475,215.747z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.286,181.771c-0.159-0.309-0.011-0.675,0.017-0.972c-0.538-0.702-1.895-0.303-1.989,0.46 C198.645,181.959,199.747,182.43,200.286,181.771z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.809,162.736c0.279,0.367,0.525,0.692,0.773,1.017c0.412-0.363,1.061-0.382,1.225-0.997 C195.377,161.583,194.337,161.384,193.809,162.736z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M171.796,216.962c-0.295,0.321-0.532,0.662-0.878,0.876v0.411 c0.542-0.001,1.081-0.003,1.616-0.007c-0.006-0.033-0.006-0.062-0.015-0.097C172.275,217.657,172.42,217.159,171.796,216.962z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.469,167.445c0.555,1.137,2.376,0.752,2.062-0.546 C185.2,166.352,184.846,166.449,184.469,167.445z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.06,169.762c0.185,0.266,0.36,0.518,0.522,0.75c1.015,0.073,1.026,0.063,1.396-1.154 C197.425,168.247,196.369,168.781,196.06,169.762z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.566,164.489c-0.352-0.17-0.662-0.319-0.924-0.446c-0.659,0.1-0.866,0.549-1.045,1.077 C201.305,166.124,203.011,165.881,202.566,164.489z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.669,179.781c0.482-0.11,0.731-0.22,1.088-0.53c-0.625-1.092-0.272-1.78-1.81-1.06 C200.994,178.908,200.747,179.576,201.669,179.781z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.803,198.458c0.276-0.321,0.538-0.625,0.823-0.956c-0.262-0.317-0.13-0.817-0.6-1.092 c-0.404,0.396-1.107,0.326-1.494,0.894C200.801,197.926,201.272,198.193,201.803,198.458z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.297,195.043c0.121,0.606,0.406,1.007,1.028,1.084c0.605-0.479,0.605-0.479,0.855-1.17 C176.733,193.895,175.756,194.211,175.297,195.043z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.326,188.965c0.665-1.637-0.203-2.466-1.616-1.172c0.171,0.168,0.319,0.312,0.467,0.456 c-0.021,0.205-0.043,0.409-0.07,0.668C187.531,188.937,187.879,189.122,188.326,188.965z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.246,172.614c0.474-1.16-1.047-1.685-1.799-0.918 C198.081,172.832,199.609,173.266,200.246,172.614z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.658,180.144c-0.571,0.603-1.575,0.397-1.04,1.545c0.623,0.284,1.201,0.449,1.782-0.157 C186.049,180.952,186.469,180.215,185.658,180.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.43,201.062c-0.06-0.027-0.333,0.227-0.318,0.259c0.18,0.371-0.234,0.619-0.213,0.991 c0.949,0.473,1.547,0.984,2.044-0.334C188.657,201.206,187.95,201.292,187.43,201.062z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.438,147.218c-0.353-0.009-0.703-0.019-1.06-0.028 C173.748,147.451,174.139,147.462,174.438,147.218z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.373,167.247c-0.843-0.96-2.236-0.765-1.796,0.728 C176.23,168.613,177.048,168.331,177.373,167.247z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.78,195.033c0.292,0.681,1.482,1.159,1.835,0.277 C195.673,193.863,193.943,193.512,193.78,195.033z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.841,154.917c-0.562,0.371-0.562,0.371-0.926,0.931 C173.586,157.971,176.339,154.862,173.841,154.917z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.634,160.43c-0.068-1.374-2.232-0.671-1.878,0.404 C201.15,161.742,202.501,161.243,202.634,160.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.485,198.729c-2.06,0.614-1.006,2.622,0.714,1.346 C176.973,199.603,177.155,198.977,176.485,198.729z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.111,181.387c-0.601-1.361-2.354-1.131-2.008,0.281c0.235,0.124,0.514,0.269,0.788,0.413 C204.335,181.864,204.87,181.883,205.111,181.387z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.174,214.55c0.527-0.029,0.528-0.717,0.894-0.999c0.6-0.842-0.745-0.879-1.3-0.935 c-0.277,0.2-0.371,0.499-0.486,0.879C175.849,213.723,175.675,214.356,176.174,214.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.038,154.079c0.236-1.111-1.38-1.923-1.963-0.75 C189.329,154.153,190.341,154.835,191.038,154.079z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.745,198.913c-0.234-0.067-0.443-0.128-0.733-0.211c-1.404,1.421-0.154,2.524,1.252,1.182 C191.081,199.543,190.909,199.22,190.745,198.913z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.528,160.263c-0.103-0.28-0.199-0.537-0.298-0.807c-0.69-0.087-1.249,0.53-1.709,0.98 c0.09,0.686,0.663,0.792,1.089,1.079C178.877,160.992,179.12,160.657,179.528,160.263z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.347,164.511c-0.342-0.136-0.597,0.295-0.866,0.439c0.453,1.52,1.695,1.226,2.199-0.087 c-0.206-0.195-0.404-0.381-0.605-0.571C178.821,164.452,178.635,164.665,178.347,164.511z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.453,151.663c0.518,0.213,0.971,0.399,1.45,0.597 C194.31,150.544,191.949,149.437,191.453,151.663z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.596,214.645c-0.368,0.405-0.767,0.706-0.958,1.205c0.166,0.228,0.329,0.453,0.5,0.687 C179.773,216.843,179.846,215.342,178.596,214.645z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.971,209.758c0.528-0.553,0.24-1.079-0.05-1.634c-0.65,0.003-1.144,0.271-1.551,0.719 C184.847,209.87,184.882,209.889,185.971,209.758z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.637,175.856c-0.047,0.335-0.086,0.611-0.132,0.93c0.323,0.193,0.482,0.576,0.937,0.716 c0.366-0.398,0.685-0.758,1.053-1.183C200.045,175.732,199.283,175.42,198.637,175.856z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.161,179.322c0.049-0.352,0.081-0.692-0.081-1.103c-0.315-0.105-0.666-0.223-1.057-0.355 C190.904,179.132,191.649,180.074,193.161,179.322z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.035,165.747c0.767-0.966,0.109-1.312-0.606-1.913c-0.34,0.34-0.64,0.638-0.927,0.924 c0.08,0.258,0.144,0.467,0.222,0.72C192.149,165.565,192.6,165.658,193.035,165.747z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.575,159.625c-0.533,0.008-1.063-0.179-1.471,0.418 C173.091,162.241,175.69,161.064,174.575,159.625z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.596,205.623c-0.374,0.316-0.73,0.619-1.136,0.963c0.63,1.51,1.506,0.87,2.098-0.171 C193.216,206.175,193.023,205.793,192.596,205.623z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.009,150.151c-0.347,0.125-0.635,0.23-0.893,0.324c-0.087,0.256-0.157,0.464-0.252,0.747 C187.977,153.051,189.454,151.232,188.009,150.151z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.735,188.304c0.3,0.817,1.241,0.993,1.604,0.265c-0.24-0.357,0.26-0.551,0.199-0.847 C201.71,187.035,201.295,187.168,200.735,188.304z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.867,177.537c1.189-0.381,1.572-1.059,0.573-1.908c-0.759,0.091-0.962,0.658-1.319,1.239 C189.345,177.068,189.578,177.278,189.867,177.537z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.517,185.054c-0.305,0.522-0.611,1.006-0.089,1.636c0.235-0.107,0.426-0.195,0.59-0.27 c0.197,0.115,0.246,0.302,0.46,0.229C205.29,185.666,204.745,184.826,203.517,185.054z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.699,173.445c-2.09,0.671,0.637,2.903,1.176,0.661 C188.645,173.633,188.139,173.665,187.699,173.445z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.819,191.962c-1.08-0.361-2.342,0.729-1.068,1.465 C183.459,193.699,184.69,192.712,183.819,191.962z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.118,201.727c0.157,0.344,0.283,0.625,0.409,0.9c0.375,0.092,0.736-0.044,1.253-0.051 C198.166,201.18,196.874,200.37,196.118,201.727z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.662,190.789c-0.019-0.386-0.035-0.727-0.052-1.073c-1.046-0.743-1.412,0.186-1.432,1.163 C180.864,191.748,181.184,191.254,181.662,190.789z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.998,209.313c0.248-0.571-0.701-1.743-1.278-1.247c0.05,0.472-0.271,0.794-0.639,1.201 C175.54,209.84,176.462,209.774,176.998,209.313z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.619,153.792c-0.052-1.482-1.278-1.09-1.701-0.434v0.803 C171.453,154.606,172.35,154.509,172.619,153.792z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.742,196.628c-0.908,0.63,0.372,2.33,1.23,1.315 C183.779,196.836,184.292,196.091,182.742,196.628z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.446,177.027c0.061-0.19,0.127-0.395,0.196-0.607c-0.136-0.259-0.269-0.51-0.405-0.768 c-0.533-0.146-0.903-0.024-1.219,0.286c-0.135,0.498,0.07,0.912,0.256,1.294C194.738,177.409,195.058,177.142,195.446,177.027z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.078,154.336c-0.151-0.519-0.313-0.999-0.488-1.443c-0.187,0.25-0.365,0.487-0.529,0.706 C203.285,154.28,203.703,154.436,204.078,154.336z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.623,199.664c0.094,0.237,0.183,0.466,0.27,0.687c0.306,0.06,0.58,0.113,0.902,0.176 c0.186-0.33,0.366-0.648,0.565-1.001C199.949,198.559,198.773,198.719,198.623,199.664z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.69,198.951c-0.244,0.695-0.662,2.091,0.579,1.764c0.091-0.089,0.171-0.188,0.242-0.291 c0.037-0.452,0.074-0.91,0.111-1.375C204.446,198.887,204.155,198.819,203.69,198.951z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.424,197.975c0.927-0.117,1.005-0.155,1.363-0.686c-0.224-0.282-0.397-0.622-0.486-0.971 C196.21,196.184,195.562,197.18,196.424,197.975z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.093,215.653c0.448-0.181,0.822-0.374,1.132-0.577c-0.272,0-0.548,0-0.842,0 C201.281,215.281,201.185,215.471,201.093,215.653z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.96,198.71c-0.312-0.034-0.589-0.065-0.913-0.1c-0.092,0.398-0.176,0.756-0.216,0.926 c0.283,0.36,0.478,0.608,0.684,0.87C186.708,200.276,186.511,199.475,185.96,198.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.579,208.252c-0.468,1.182-0.063,2.134,1.17,1.084 C191.121,208.139,190.596,207.904,189.579,208.252z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.2,215.714c0.14,0.276,0.279,0.547,0.421,0.825c0.363,0,0.705,0,1.101,0 C198.628,215.106,196.363,214.471,196.2,215.714z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M171.772,163.621c0.303-0.427,0.981-1.075,0.457-1.565c-0.646-0.407-0.912,0.09-1.311,0.452 v0.771C171.152,163.662,171.411,164.001,171.772,163.621z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.12,191.352c0.982,0.018,0.526-1.052,0.531-1.709c-0.239,0.052-0.443,0.098-0.647,0.141 c-0.2,0.042-0.392-0.276-0.596-0.017c0.178,0.444,0.065,0.876-0.16,1.255C203.471,191.432,203.813,191.357,204.12,191.352z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179,196.613c-0.655-0.22-0.944,0.334-1.389,0.527c0.239,0.973,0.981,1.632,1.168,0.608 c0.295-0.135,0.509-0.233,0.734-0.335C179.314,197.103,179.152,196.849,179,196.613z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.279,191.482c0.335-0.321,0.67-0.641,1.056-1.009c-0.38-1.428-1.315-0.293-1.922,0.291 C198.585,191.171,198.885,191.374,199.279,191.482z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.026,208.976c0.208,0.252,0.428,0.518,0.677,0.822 C196.916,209.042,194.522,206.799,194.026,208.976z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.73,175.126c1.147-0.506,1.523-0.139,1.143-1.591c-0.132-0.068-0.272-0.141-0.486-0.252 c-0.215,0.147-0.413,0.284-0.583,0.415C183.113,174.304,181.888,174.658,182.73,175.126z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.972,204.719c0.074-0.85,0.074-0.85-0.348-1.289 C174.586,203.627,175.373,205.321,176.972,204.719z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M171.188,212.977c-0.28,0.518,0.172,0.89,0.089,1.37 C173.107,214.859,172.594,212.389,171.188,212.977z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.792,204.385c0.05,1.059,1.096,0.499,1.575,0.07 C186.232,203.071,185.368,203.548,184.792,204.385z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M170.293,148.296c0,18.286,0,36.573,0,54.859c0,5.031,0,10.062,0,15.093 c0,0.804,1.25,0.806,1.25,0c0-18.286,0-36.572,0-54.859c0-5.031,0-10.062,0-15.093 C171.543,147.492,170.293,147.491,170.293,148.296L170.293,148.296z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M130.038,147.569c0,0-2.897,16.594-0.79,17.252c2.107,0.658,11.063,0.263,11.984,0 c0.922-0.263,1.844-17.65,1.844-17.65S133.067,146.779,130.038,147.569z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.156,168.544c-0.553-1.412-1.955-2.773-3.469-2.687l0.155,0.004 c-3.897-0.095-7.793-0.191-11.69-0.286c-1.182-0.029-2.42-0.046-3.473,0.491c-1.029,0.524-1.771,1.574-1.929,2.718 c-0.158,1.144,0.27,2.352,1.109,3.147c1.273,1.206,3.189,1.347,4.941,1.421c2.734,0.116,5.468,0.233,8.201,0.349 c1.771,0.075,3.721,0.094,5.088-1.035C199.258,171.699,199.71,169.955,199.156,168.544z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M95.69,219.127c-0.113,1.404-4.099,59.777,0,61.826s106.915,8.881,107.94,0 c1.025-8.881,6.148-59.103-1.708-63.881C194.066,212.295,96.129,213.69,95.69,219.127z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.079,225.513c0.25-2.452,3.835-1.564,1.917-3.571c-0.817-0.183-1.415,0.808-1.45,1.52 c0.013,1.042-1.636,0.546-2.427,1.105C180.094,225.627,181.796,227.04,182.079,225.513z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.369,249.186c0.36,0.081,0.634,0.143,0.932,0.208 C184.596,247.896,179.445,245.786,180.369,249.186z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.718,278.401c-0.169-1.565-2.002-1.317-2.274,0.193 C183.368,279.533,184.176,279.789,184.718,278.401z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.37,249.664c-0.723,0.148-1.359,0.229-1.54,1.042c0.219,1.641,1.687,1,2.281-0.045 C180.021,250.257,179.823,249.915,179.37,249.664z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.66,284.8c0.609-0.047,1.202-0.097,1.779-0.15c-0.006-0.017-0.014-0.039-0.02-0.055 C190.642,284.23,189.998,284.426,189.66,284.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.071,244.581c0.166-0.399,0.312-0.75,0.479-1.153 C203.526,240.61,202.412,245.331,205.071,244.581z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.507,272.375c0.059-0.635,0.118-1.294,0.178-1.972c-0.141-0.072-0.306-0.125-0.507-0.151 C202.757,271.042,203.606,272.402,204.507,272.375z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.713,237.884c0.381-0.095,0.739-0.184,1.097-0.272 C181.502,234.895,175.825,236.02,178.713,237.884z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.941,232.824c0.114-0.564,0.114-0.564,0.516-0.97c-0.198-0.32-0.488-0.558-0.821-0.844 C172.286,231.154,173.759,234.565,174.941,232.824z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.625,251.481c0.269-0.114,0.168-0.372,0.154-0.59c0.495-0.583-0.054-1.251-0.699-1.381 c-0.335,0.249-0.737,0.389-1.149,0.313C200.706,250.915,201.494,251.985,202.625,251.481z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.264,220.798c0.144-1.156-1.681-1.654-1.918-0.46 C179.976,221.685,182.165,222.291,182.264,220.798z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.022,245.681c0.288,1.555,1.299,1.954,2.125,0.472 C179.618,245.254,178.496,244.066,178.022,245.681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.497,225.694c0.92-1.318-1.783-2.236-1.777-0.652 C175.572,226.035,177.093,226.92,177.497,225.694z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.381,225.765c1.087-1.303-1.309-2.017-1.97-0.757 C189.84,226.021,190.465,226.898,191.381,225.765z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.291,241.187c-0.715-1.151-1.561-1.242-2.051,0.183 C173.302,242.862,175.699,242.448,175.291,241.187z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.217,268.378c-0.234-0.119-0.514-0.262-0.884-0.449 C171.599,269.771,175.732,271.518,175.217,268.378z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.561,265.647c-0.825-0.016-1.275,0.439-1.54,1.18c0.218,0.302,0.435,0.603,0.633,0.878 c0.439-0.085,0.807-0.156,1.215-0.235c0.144-0.29,0.295-0.594,0.446-0.898C196.045,266.24,195.808,265.949,195.561,265.647z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.963,277.456c-2.596,0.121,0.66,3.702,0.99,0.991 C180.034,277.578,179.59,277.642,178.963,277.456z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.782,244.789c0.471-0.273,0.707-0.768,1.081-1.333c-0.703-1.238-1.508-0.953-2.207,0.093 C175.67,244.269,175.975,244.738,176.782,244.789z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.716,217.18c-0.312,0.081-0.639,0.165-0.907,0.234c-0.581,0.896-0.215,1.861,0.883,1.991 c0.319-0.368,0.625-0.722,0.914-1.056C198.451,217.824,198.172,217.457,197.716,217.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.539,230.501c0.38-1.728-1.079-2.404-1.82-0.717 C175.637,230.743,177.25,231.509,177.539,230.501z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.366,262.077c-0.03-0.67-0.443-0.937-1.047-1.005c-0.879,0.334-0.759,1.085-0.914,1.764 C181.372,263.662,181.972,263.102,182.366,262.077z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.769,229.774c0.002,1.192,1.105,1.53,1.816,0.506c0.026-0.497,0.242-0.907,0.055-1.337 c-0.219-0.07-0.428-0.137-0.626-0.201C199.505,229.079,198.879,229.108,198.769,229.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.382,277.217c-3.085,0.989,0.379,3.577,0.961,0.829 C189.027,277.773,188.724,277.512,188.382,277.217z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.818,237.223c0.424,0.88,1.799,0.998,1.798-0.279 C193.38,235.141,191.564,235.454,191.818,237.223z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.228,235.47c1.975-1.777-1.271-2.994-1.568-0.762 C199.035,235.302,199.743,235.026,200.228,235.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.902,222.364c-0.704-0.451-1.432-0.202-2.203-0.525c0.613,1.009,0.613,1.009,0.588,1.915 C202.117,224.137,204.053,223.233,202.902,222.364z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.366,237.865c-0.91,0.783-1.792,1.521-0.41,2.258c0.579,0.328,0.875-0.428,1.195-0.79 C196.631,238.684,195.754,238.353,195.366,237.865z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.136,274.832c1.27-0.535,1.839-1.01,0.654-2.05c-0.559-0.091-0.919,0.258-1.313,0.457 c-0.083,0.274-0.155,0.511-0.228,0.752C173.536,274.323,173.793,274.639,174.136,274.832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.975,235.99c-2.458-0.384-2.621,2.157,0.035,1.422 C189.393,236.941,189.533,236.499,188.975,235.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M171.335,238.249v0.154c0.085,0.232,0.085,0.418,0,0.599v0.789c0.3,0.259,0.882,0.26,1.251,0.231 C173.943,239.303,172.52,237.5,171.335,238.249z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.895,270.003c1.033-0.907,0.954-1.45-0.262-2.011 C182.07,268.392,182.247,270.04,183.895,270.003z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.194,235.524c1.268,0.104,1.923-1.783,0.419-1.842 C203.293,233.441,203.004,235.116,204.194,235.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.471,260.309c0.768,0.855,1.526,0.422,2.024-0.457 C174.851,258.332,173.199,258.564,173.471,260.309z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.259,252.417c-0.359-0.237-0.647-0.428-0.914-0.604c-0.736,0.33-0.736,0.33-1.106,1.285 C180.995,254.354,182.586,254.012,182.259,252.417z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.104,219.785c-1.194-0.462-1.139,1.093-1.471,1.837c0.485,0.122,0.905-0.418,1.442-0.156 c0.079,0.034,0.248-0.063,0.336-0.143C200.912,220.876,200.894,219.844,200.104,219.785z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.803,271.171c-0.239-0.223-0.492-0.46-0.727-0.681c-1.118,0.304-1.118,0.304-1.342,1.27 C199.349,272.924,200.949,272.564,200.803,271.171z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.359,239.524c0.294,0.219,0.619,0.459,0.969,0.717 C206.908,238.848,203.719,236.471,203.359,239.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.152,260.506c0.067-1.303,0.007-1.419-0.904-1.784c-0.361,0.318-0.732,0.645-1.091,0.96 c0.186,0.402,0.34,0.733,0.479,1.032C188.225,260.566,188.672,260.973,189.152,260.506z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.645,226.399c-0.294,0.2-0.601,0.409-0.883,0.601 C195.865,229.862,200.52,228.046,197.645,226.399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.224,243.17c-0.074,0.252-0.152,0.518-0.226,0.771 C186.888,246.886,188.242,241.329,185.224,243.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.391,258.475c2.885-0.556,0.14-3.144-0.968-0.923 C189.54,258.054,189.844,258.345,190.391,258.475z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.98,262.411c0.342,0.546,0.886,0.698,1.421,0.884c0.365-0.312,0.45-0.733,0.658-1.089 C186.759,260.921,184.738,260.91,184.98,262.411z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.889,254.274c-1.191-0.151-1.395,1.639-0.381,1.9 C193.708,256.563,194.443,254.196,192.889,254.274z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.844,257.934c0.446,0.75,2.05,0.791,1.973-0.321 C177.515,256.245,175.241,256.391,175.844,257.934z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.037,232.807c-0.022-0.434-0.047-0.862-0.074-1.284 C205.523,231.947,205.43,232.46,206.037,232.807z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.505,273.744c0.351,0.382,0.452,0.905,0.957,1.091c0.577-0.238,0.943-0.636,1.09-1.287 C197.706,272.476,196.94,272.176,196.505,273.744z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.057,240.28c-0.872,0.276-0.872,0.276-1.165,1.103c0.146,0.212,0.306,0.444,0.472,0.686 c0.303,0.075,0.608,0.152,0.98,0.246C194.351,241.72,194.007,240.676,193.057,240.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.906,274.91c-0.353,0.229-0.8,0.278-1.071,0.708c0.136,0.361,0.279,0.739,0.409,1.085 c0.305,0.098,0.545,0.175,0.822,0.263C201.048,276.35,201.369,275.087,199.906,274.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.482,267.881c0.435-0.34,0.785-0.717,0.986-1.217 C181.264,264.577,179.078,267.038,181.482,267.881z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.56,230.77c0.188-0.269,0.348-0.498,0.532-0.763c-0.411-0.421-0.553-1.031-1.201-1.304 c-0.351,0.255-0.728,0.529-1.139,0.829C184.994,230.548,185.706,230.659,186.56,230.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.876,216.487c0.509,1.022,1.84,0.135,1.916-0.733 C176.905,214.404,175.375,215.067,175.876,216.487z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.233,217.116c-0.294,0.407-0.645,0.731-0.74,1.278c0.354,0.269,0.724,0.551,1.077,0.82 c0.344-0.093,0.643-0.175,0.996-0.272c-0.102-0.51-0.198-0.99-0.297-1.485C183.908,217.339,183.584,217.232,183.233,217.116z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.443,225.884c1.23,0.44,1.411,0.371,1.769-0.616c-0.453-1.117-1.659-1.384-2.145-0.141 C194.216,225.428,194.341,225.679,194.443,225.884z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.455,229.184c-0.074,0.57,0.367,0.73,0.302,1.335c0.677,0.094,1.368,0.55,1.698-0.227 C191.434,228.857,190.633,228.527,189.455,229.184z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.6,281.734c0.82-0.237,1.002-0.79,0.973-1.49C190.15,278.942,188.537,281.184,190.6,281.734z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.732,280.057c-0.41,0.401-0.466,0.855-0.183,1.167c0.033-0.089,0.071-0.178,0.081-0.271 C203.661,280.691,203.695,280.389,203.732,280.057z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.625,244.572c0.046-0.454,0.208-0.841,0.518-1.138c-0.178-0.873-1.238-1.18-1.808-0.541 v0.602c0.071,0.351,0.22,0.691,0.19,1.054C171.921,244.678,172.252,244.67,172.625,244.572z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.769,228.636c0.434-0.444,0.906-0.829,0.763-1.543c-0.297-0.236-0.587-0.467-0.865-0.688 c-0.688,0.189-1.089,0.566-1.091,1.28C182.851,228.134,183.309,228.344,183.769,228.636z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M171.335,233.735v1.347c0.065,0.096,0.128,0.189,0.198,0.293 C174.422,235.778,172.374,232.719,171.335,233.735z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.238,235.365c2.379-1.144-0.771-3.179-1.307-0.687 C194.436,234.944,194.848,235.161,195.238,235.365z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.714,237.895c-1.204,0.33-1.621,1.763-0.348,2.214 C191.476,239.563,191.959,238.592,190.714,237.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.284,276.072c0.292,0.357,0.546,0.577,0.799,0.678c0.058-0.571,0.119-1.179,0.182-1.821 C203.89,274.954,203.509,275.31,203.284,276.072z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.21,242.227c0.005-0.556,0.007-1.109,0.007-1.659 C205.734,240.938,205.622,241.748,206.21,242.227z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.564,252.035c-0.674-0.075-1.047,0.072-1.229,0.307v0.911 c0.37,0.714,1.386,1.213,1.826-0.254C172.936,252.631,172.887,252.298,172.564,252.035z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.636,255.665c0.704,0.552,1.918,0.557,2.14-0.478 C184.068,253.901,182.144,254.118,182.636,255.665z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.749,272.523c-1.016,1.104-0.547,1.989,0.77,2.304c0.311-0.346,0.435-0.738,0.62-1.12 C179.908,273.078,179.313,272.953,178.749,272.523z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.604,249.829c-0.611-0.606-1.081-0.302-1.639,0.097 C190.89,251.526,194.317,252.236,193.604,249.829z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.704,245.759c-0.117,0.652,0.289,1.374,1.029,1.158 C199.84,246.392,196.638,243.429,196.704,245.759z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.749,270.039c1.212,0.129,1.781-1.949,0.249-1.909 C177.858,268.02,177.734,269.913,178.749,270.039z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.371,215.253c-0.448-0.035-0.919-0.07-1.449-0.112 C188.272,217.12,192.761,217.549,191.371,215.253z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.969,222.21c-0.794-0.441-1.443,0.026-1.689,0.883c0.515,0.313,1.117,1.388,1.699,0.715 C198.442,223.407,198.542,222.551,197.969,222.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.947,277.277c-1.219,0.091-1.539,1.793-0.177,1.995 C193.919,279.204,194.135,277.464,192.947,277.277z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.252,227.51c-0.415-0.7-0.99-1.311-1.75-0.634c0.045,0.189,0.079,0.338,0.117,0.501 c-0.173,0.109-0.349,0.22-0.562,0.354C187.77,228.7,189.221,228.931,189.252,227.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.141,277.218c-0.639,0.15-0.927,0.526-1.007,1.073c0.173,0.318,0.337,0.62,0.501,0.92 C203.019,279.417,203.763,277.841,202.141,277.218z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.2,239.724c0.814,0.72,1.091,0.608,1.8-0.352C186.7,237.477,184.827,237.874,185.2,239.724z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.322,232.147c0.416,1.068,1.274,1.17,1.941,0.263 C198.872,230.939,196.572,230.738,196.322,232.147z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.194,237.609c-0.01-0.593-0.021-1.181-0.037-1.761c-0.516,0.115-0.102,1.018-0.38,1.342 C205.901,237.403,206.042,237.53,206.194,237.609z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.46,260.807c0.193-0.256,0.362-0.479,0.547-0.724 C193.359,256.876,190.388,261.15,193.46,260.807z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.158,254.721c-1.107-1.067-1.62,0.129-1.958,1.131 C174.097,256.573,175.773,255.933,175.158,254.721z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.11,216.989c0.104-0.436,0.024-0.937-0.179-1.32c-0.493-0.064-1.01-0.126-1.55-0.186 C194.214,216.83,194.756,217.057,196.11,216.989z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.099,250.031c-0.84-0.711-1.515-0.436-1.817,0.601c0.201,0.296,0.395,0.584,0.608,0.901 c0.313,0,0.627,0,0.968,0C189.293,251.099,189.236,250.581,189.099,250.031z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.36,271.422c0.475,0.262,0.331,1.04,1.038,1.091c0.336-0.289,0.694-0.597,1.056-0.909 C182.315,270.18,180.78,270.105,180.36,271.422z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.174,232.708c-0.01-0.518,0.197-1.1-0.504-1.471 C186.139,231.423,187.618,234.046,189.174,232.708z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.573,235.652c-1.504,0.873-0.98,2.589,0.781,1.776 C184.65,236.715,184.539,235.818,183.573,235.652z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.628,234.008c0.053,0.898,0.441,1.313,1.347,1.399c0.237-0.393,0.6-0.641,0.63-1.126 C190.803,233.516,190.495,232.736,189.628,234.008z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.16,222.232c-0.093,0.375-0.183,0.735-0.258,1.036c0.745,1.285,2.059,0.46,1.896-0.771 c-0.21-0.36-0.533-0.422-0.835-0.554C192.7,222.039,192.433,222.134,192.16,222.232z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.685,253.837c0.144-0.378,0.278-0.73,0.421-1.106 C194.489,250.321,192.957,254.432,195.685,253.837z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.923,281.854c-0.402,0.487-0.445,1.017-0.489,1.554c0.399,0.453,0.867,0.594,1.461,0.421 c0.005-0.555,0.149-0.881,0.454-1.361C174.852,282.251,174.609,281.635,173.923,281.854z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.421,240.153c0.318-0.241,0.644-0.488,1.058-0.802c-0.18-0.367-0.333-0.677-0.504-1.026 C180.31,237.645,179.796,239.704,181.421,240.153z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.462,258.902c-0.721,0.402-1.792,0.364-1.241,1.415 C179.074,261.99,180.909,259.979,179.462,258.902z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.761,241.76c1.57-1.087-1.319-2.08-1.435-0.462 C196.232,242.286,198.564,243.079,197.761,241.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.106,241.312c-0.158-0.301-0.269-0.677-0.679-0.832c-0.298,0.065-0.602,0.132-0.889,0.196 c-0.219,0.288-0.422,0.556-0.617,0.814c0.188,0.288,0.341,0.523,0.511,0.783C179.184,242.484,179.967,242.11,180.106,241.312z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.716,246.986c0.726-0.226,1.483-0.17,1.786-1.01 C174.696,244.217,172.843,245.233,173.716,246.986z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.579,253.55c0.656-1.541-0.722-2.286-1.74-0.878 C199.079,253.565,199.745,254.336,200.579,253.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.731,247.145c-0.305,0.539-1.136,0.534-1.132,1.375c0.251,0.41,0.493,0.9,1.222,0.835 C191.822,248.911,191.505,247.756,190.731,247.145z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.994,220.773c-0.089,0.953,1.891,0.992,1.882,0.046 C186.797,219.389,185.06,219.206,184.994,220.773z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.35,239.962c0.991,0.081,0.991,0.081,1.402-0.796c-0.24-0.399-0.479-0.799-0.757-1.263 c-0.557,0.218-0.951,0.46-1.319,0.882C175.917,239.175,176.008,239.651,176.35,239.962z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.804,283.066c-0.33-0.4-0.646-0.782-1.049-1.268c-0.418,0.277-0.755,0.5-1.079,0.715 c-0.031,0.388-0.058,0.728-0.091,1.136C183.477,283.619,184.221,283.915,184.804,283.066z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.339,228.874c-0.239,0.16-0.499,0.334-0.737,0.493c-0.074,0.307-0.14,0.581-0.221,0.915 c0.8,0.866,0.974,0.88,1.776,0.171C182.199,229.837,182.178,229.05,181.339,228.874z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.414,236.067c-0.321,0.598-0.067,1.026,0.217,1.637c0.883,0.199,1.624-0.398,1.385-1.328 C202.838,235.908,201.651,235.551,201.414,236.067z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.977,261.732c-0.382-0.351-0.802-0.348-1.295-0.417c-0.112,0.122-0.232,0.231-0.346,0.342 v1.055C172.128,263.404,173.321,263.137,172.977,261.732z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.464,254.33c-0.368-0.067-0.681-0.121-1.001,0.07c-0.146,0.301-0.298,0.615-0.452,0.935 C178.886,257.071,180.792,255.758,179.464,254.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.779,232.7c0.739,1.17,1.786,0.202,1.94-0.802c-0.298-0.238-0.568-0.453-0.826-0.657 C182.824,231.449,182.852,231.728,182.779,232.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.24,277.632c-0.925-0.462-1.519-0.204-1.861,0.784c0.545,0.434,1.401,1.447,1.827,0.382 C175.36,278.427,175.782,277.895,175.24,277.632z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.657,235.016c0.907,0.654,1.906-0.185,1.568-1.243 C181.217,232.809,179.916,233.871,180.657,235.016z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.607,273.823c0.45,0.886,1.693,1.305,1.966,0.138 C184.59,272.501,182.92,272.44,182.607,273.823z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.954,277.613c-0.691,0.562-0.218,1.63,0.627,1.658 C199.148,279.114,198.064,276.183,196.954,277.613z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M171.335,224.654v1.251c0.169,0.187,0.453,0.321,0.774,0.5 C174.324,224.925,171.883,223.894,171.335,224.654z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.527,259.259c-0.667-0.816-1.945-0.071-1.812,0.911 C197.381,261.49,198.728,260.537,198.527,259.259z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.393,251.042c0.049-0.175,0.1-0.357,0.152-0.54c-0.498-0.887-1.323-0.782-2.182-0.744 c0.146,0.476,0.153,0.791,0.135,1.277C197.176,251.333,197.849,251.422,198.393,251.042z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.834,256.625c-0.261,0.334-0.64,0.539-0.795,0.92c0.437,0.605,0.879,0.859,1.618,0.926 C196.859,257.761,196.003,256.719,194.834,256.625z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.078,264.075c0.194,1.537,1.167,1.728,1.952,0.33 C193.916,263.386,192.362,263.014,192.078,264.075z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.632,263.469c-1.071,0.025-1.895,1.849-0.213,1.937 C175.443,265.205,175.727,263.783,174.632,263.469z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.472,281.718c0.32-0.313,0.722-0.583,0.881-1.106 C181.128,278.584,179.074,280.945,181.472,281.718z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.487,249.423c0.222-0.32,0.446-0.646,0.675-0.977 C195.239,245.753,192.979,248.735,195.487,249.423z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.679,254.757c0.038,0.074,0.075,0.147,0.111,0.22c0.005-0.097,0.01-0.194,0.015-0.291 C205.761,254.71,205.727,254.73,205.679,254.757z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.113,268.138c-1.175,0.098-1.267,1.764-0.046,1.905 C203.269,269.987,203.296,268.276,202.113,268.138z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.162,245.317c-0.061,0.071-0.117,0.152-0.164,0.257c0.046,0.261,0.091,0.52,0.139,0.793 C206.146,246.016,206.154,245.666,206.162,245.317z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.473,225.492c0.555,0.558,0.943,0.824,1.221,0.825c0.2-0.149,0.422-0.315,0.622-0.465 c-0.258-0.452-0.138-0.823-0.385-1.283C204.217,223.683,203.465,224.631,203.473,225.492z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.605,217.184c-0.094-0.033-0.318,0.031-0.328,0.081c-0.085,0.442-0.481,0.428-0.798,0.54 c0.047,0.355,0.09,0.68,0.132,0.995c0.516,0.096,0.98,0.406,1.501,0.163C175.867,218.067,175.372,217.719,174.605,217.184z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.996,253.76c1.047-0.628,0.668-1.428-0.33-1.864c-0.544,0.317-1.52,0.724-0.846,1.359 C190.169,253.51,190.551,254.074,190.996,253.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.014,228.456c0.594-0.227,0.911-0.609,0.936-1.235c-0.087-0.14-0.183-0.297-0.268-0.434 c-0.756-0.057-1.475-0.186-1.904,0.695C192.017,228.011,192.535,228.228,193.014,228.456z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M171.335,216.258c0.1,0.207,0.264,0.432,0.51,0.671c0.413-0.156,0.763-0.289,1.222-0.462 c0.01-1.605-1.321-1.729-1.732-1.104V216.258z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.635,272.151c0.642-0.503,0.314-1.681-0.425-1.71c-0.568-0.102-0.741,0.156-0.875,0.543v1.07 C171.667,272.243,172.325,272.122,172.635,272.151z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M171.335,275.512v1.032c0.128,0.114,0.245,0.219,0.388,0.346 C174.405,276.888,172.375,274.081,171.335,275.512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.725,265.344c0.147-0.211,0.31-0.443,0.471-0.673c-0.092-0.356-0.179-0.691-0.294-1.132 c-0.741,0.023-1.377,0.109-1.587,0.933C187.584,265.478,187.833,265.535,188.725,265.344z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.687,256.799c-0.783-0.213-1.253,0.119-1.352,0.588v0.36 c0.058,0.314,0.252,0.644,0.634,0.902C173.034,258.277,173.627,257.626,172.687,256.799z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.819,224.841c0.125,0.62,0.37,1.568,1.214,1.268c0.17-0.426,0.432-0.711,0.865-0.851 C200.751,223.818,199.665,224.145,198.819,224.841z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.033,252.646c0.05,0.442,0.091,0.805,0.132,1.17c0.27,0.078,0.54,0.156,0.799,0.231 c0.714-0.6,0.757-0.711,0.667-1.793c-0.363-0.091-0.746-0.186-1.125-0.281C185.309,252.254,185.147,252.483,185.033,252.646z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.774,252.923c0.436,0.959,1.199,1.191,1.947,0.459 C177.853,251.973,176.14,251.416,175.774,252.923z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.569,246.877c0.71-0.623,0.858-1.203,0.028-1.832c-0.556,0.188-1.398,0.132-1.419,0.906 c0.168,0.254,0.323,0.492,0.484,0.736C187.979,246.753,188.285,246.818,188.569,246.877z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.03,248.697c0.083-0.844-0.928-1.776-1.677-1.104c-0.007,0.008-0.011,0.016-0.018,0.024 v1.168C171.738,249.167,172.527,249.256,173.03,248.697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.057,261.206c-1.194,0.141-0.537,2.233,0.684,1.538c0.278-0.053,0.463-0.14,0.578-0.246 c0.015-0.208,0.03-0.415,0.045-0.625C205.139,261.512,204.579,261.188,204.057,261.206z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.858,250.034c-0.399,1.789,1.027,1.989,1.893,0.664 C184.528,249.631,183.668,249.596,182.858,250.034z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.044,261.532c-0.025,0.378-0.05,0.753-0.074,1.106c0.361,0.373,0.781,0.459,1.316,0.402 c0.089-0.35,0.103-0.654,0.412-0.871C201.49,261.268,199.572,261.125,199.044,261.532z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.077,280.591c-0.393-0.41-0.677-0.89-1.255-1.001c-0.477,0.24-0.662,0.697-0.93,1.098 C185.729,281.665,186.45,281.91,187.077,280.591z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.038,285.088c0.572-0.028,1.132-0.058,1.685-0.09c-0.04-0.164-0.083-0.34-0.133-0.542 C185.739,283.801,185.137,284.216,185.038,285.088z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.196,270.643c-1.578-0.252-2.209,0.589-1.049,1.682 C191.21,272.477,191.786,271.529,191.196,270.643z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.509,270.451c-0.819,0.312-1.538,0.295-1.308,1.355c0.849,0.785,1.099,0.768,1.917-0.098 C195.931,271.303,195.964,270.786,195.509,270.451z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.644,217.693c-1.072-0.45-1.072-0.45-1.535-0.069 C177.709,219.809,180.469,219.678,179.644,217.693z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.668,274.113c0.774-0.548,0.109-1.023-0.276-1.543c-0.352,0.119-0.645,0.218-0.852,0.288 c-0.128,0.546-0.236,1.001-0.355,1.509C201.803,274.713,202.288,274.765,202.668,274.113z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.307,262.212c-0.004-1.478-1.975-1.125-1.889,0.159 C189.52,262.986,191.527,263.315,191.307,262.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.646,259.139c-0.85,1.074-0.544,0.98,0.287,1.581c0.643,0.296,1.165-0.49,1.286-1.082 C202.811,258.91,202.206,259.071,201.646,259.139z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.762,284.964c-0.275-0.309-0.504-0.567-0.713-0.8c-0.811,0.162-1.22,0.725-1.253,1.195 c0.587-0.008,1.168-0.017,1.743-0.028C177.605,285.195,177.681,285.067,177.762,284.964z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.067,251.209c0.059-0.302,0.12-0.605,0.178-0.901 C173.384,248.225,172.357,252.366,175.067,251.209z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.566,245.974c-0.421-1.488-1.979-1.172-1.865,0.395 C182.767,247.461,184.388,246.656,184.566,245.974z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.973,225.022c0.083,1.386,1.988,1.565,1.814-0.179 C185.854,223.886,185.415,224.218,184.973,225.022z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.099,267.898c0.548-0.273,0.768-0.705,0.854-1.28c-0.223-0.711-1.14-1.063-1.618-0.543v1.041 C171.573,267.393,171.932,267.631,172.099,267.898z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.029,281.698c0.27-0.655,0.951-0.689,0.659-1.55 C198.936,278.776,198.165,281.432,200.029,281.698z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.358,223.86c1.224-0.596,0.402-1.887-0.608-1.865c-0.432,0.396-0.798,0.601-0.936,1.201 C178.37,223.436,178.864,223.647,179.358,223.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.415,242.262c0.339,0.097,0.463-0.465,0.618-0.654c-0.142-0.276-0.256-0.499-0.407-0.793 c-1.239-0.627-2.178,0.478-1.051,1.439C201.832,242.303,202.128,241.87,202.415,242.262z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.465,236.902c-0.473-0.406-0.479-0.949-0.983-1.176c-1.092,0.195-1.386,1.156-0.603,1.936 C174.416,237.44,175.063,237.457,175.465,236.902z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.057,273.783c0.096,0.212,0.183,0.41,0.311,0.695 C190.732,275.09,188.677,271.285,187.057,273.783z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.013,250.178c-0.073,0.073-0.146,0.141-0.223,0.234c0.007,0.258,0.081,0.468,0.187,0.643 C205.989,250.762,206.002,250.47,206.013,250.178z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.96,249.072c1.42,0.018,1.577,0.234,1.641-1.304c-0.302-0.193-0.565-0.36-0.811-0.517 c-0.426,0.29-0.814,0.555-1.26,0.858C175.793,248.423,175.863,248.659,175.96,249.072z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.119,254.412c-0.28,0.194-0.547,0.381-0.815,0.567c0.697,1.076,1.39,1.64,2.296,0.518 C198.408,254.719,197.937,254.382,197.119,254.412z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.795,215.951c0.465,0.67,0.993,1.1,1.858,0.899c0-0.49,0-0.93,0-1.347 C185.713,214.608,185.415,215.21,184.795,215.951z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.738,217.104c0.774,0.095,1.059-0.138,1.069-0.497c-0.498-0.158-1.11-0.307-1.818-0.449 c0,0,0,0.001,0,0.001C199.233,216.467,199.465,216.759,199.738,217.104z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.486,221.645c0.406-0.202,0.762-0.38,1.218-0.608c-0.481-0.604-0.083-1.277-0.779-1.548 c-0.518,0.118-0.866,0.402-1.128,0.841c0.157,0.19,0.294,0.354,0.424,0.511c-0.074,0.188-0.139,0.355-0.219,0.559 C176.2,221.499,176.364,221.583,176.486,221.645z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.409,242.615c-0.695,0.363-0.695,0.363-1.106,1.25 C181.702,245.629,183.198,243.732,181.409,242.615z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.099,217.199c-1.147,0.34-1.194,1.693,0.13,1.833c0.847,0.126,0.927-0.445,0.702-1.012 C202.673,217.681,202.395,217.41,202.099,217.199z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.224,284.207c-0.519,0.249-0.656,0.629-0.707,1.052c0.553-0.016,1.097-0.034,1.637-0.053 c-0.063-0.227-0.123-0.447-0.184-0.668C181.699,284.417,181.443,284.304,181.224,284.207z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.347,275.752c-0.046,1.643,1.908,1.382,2.031-0.115 C181.849,275.336,180.537,274.88,180.347,275.752z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.556,222.207c-0.337,0.746-0.117,1.296,0.551,1.78c1.046-0.281,1.048-0.498,1.195-1.241 c-0.17-0.195-0.315-0.361-0.432-0.496C188.343,222.342,188.056,222.315,187.556,222.207z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.537,268.418c-1.212-0.244-1.306-0.014-1.814,0.885 C192.433,270.716,194.177,269.817,193.537,268.418z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.747,258.677c0.713-0.116,1.006-0.736,1.104-1.486c-0.171-0.179-0.385-0.402-0.6-0.626 c-0.568,0.277-1.247,0.186-1.39,0.883C185.165,257.87,185.436,258.246,185.747,258.677z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.773,230.709c0.238-0.234,0.498-0.457,0.75-0.662c-0.469-1.09-0.999-1.452-1.925-0.839 C204.003,230.187,203.12,230.587,204.773,230.709z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.066,280.9c0.093-0.44-0.277-1.193-0.744-1.376c-0.523,0.419-1.164,0.903-1.099,1.596 C194.963,281.639,195.581,281.718,196.066,280.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.042,221.055c0.255-1.153-0.98-1.95-1.799-0.918 C194.218,221.331,195.11,221.669,196.042,221.055z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.335,284.04c0.293-0.349,0.593-0.708,0.879-1.049c-0.096-0.41-0.197-0.734-0.531-0.962 C187.345,282.162,186.614,283.857,188.335,284.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.537,216.911c0.453-0.272,0.742-0.631,0.901-1.164c-0.513-0.398-1.389-0.777-2.049-0.398 c-0.154,0.465,0.177,0.827,0.252,1.258C180.964,216.717,181.256,216.816,181.537,216.911z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.891,282.892c-0.06,0.851,0.444,0.82,1.006,0.934 C194.871,283.449,192.236,280.611,191.891,282.892z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.703,248.916c-0.159-0.309-0.011-0.675,0.017-0.972c-0.538-0.702-1.895-0.303-1.989,0.46 C199.062,249.104,200.164,249.575,200.703,248.916z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.226,229.881c0.279,0.366,0.525,0.691,0.773,1.017c0.412-0.363,1.061-0.382,1.225-0.997 C195.794,228.728,194.754,228.529,194.226,229.881z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.213,284.107c-0.295,0.321-0.532,0.662-0.878,0.876v0.411 c0.542-0.001,1.081-0.003,1.616-0.007c-0.006-0.033-0.006-0.062-0.015-0.097C172.691,284.802,172.837,284.303,172.213,284.107z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.886,234.589c0.555,1.137,2.375,0.752,2.062-0.546 C185.617,233.497,185.263,233.594,184.886,234.589z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.477,236.907c0.185,0.266,0.36,0.518,0.521,0.75c1.015,0.073,1.026,0.064,1.396-1.154 C197.841,235.392,196.786,235.926,196.477,236.907z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.983,231.634c-0.352-0.17-0.663-0.319-0.924-0.446c-0.659,0.1-0.866,0.549-1.045,1.077 C201.722,233.269,203.428,233.026,202.983,231.634z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.086,246.926c0.482-0.11,0.731-0.22,1.088-0.53c-0.625-1.092-0.272-1.78-1.81-1.059 C201.411,246.053,201.164,246.721,202.086,246.926z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.22,265.602c0.276-0.321,0.538-0.625,0.823-0.956c-0.262-0.317-0.13-0.818-0.6-1.092 c-0.404,0.396-1.107,0.327-1.494,0.894C201.218,265.071,201.689,265.338,202.22,265.602z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.714,262.188c0.121,0.606,0.406,1.007,1.028,1.084c0.604-0.479,0.604-0.479,0.855-1.17 C177.15,261.04,176.173,261.356,175.714,262.188z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.743,256.11c0.665-1.637-0.203-2.466-1.616-1.172c0.171,0.168,0.319,0.312,0.467,0.456 c-0.021,0.205-0.043,0.409-0.07,0.668C187.948,256.081,188.295,256.267,188.743,256.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.663,239.759c0.474-1.16-1.046-1.685-1.799-0.918 C198.498,239.977,200.026,240.411,200.663,239.759z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.075,247.289c-0.571,0.603-1.575,0.397-1.04,1.545c0.622,0.284,1.201,0.449,1.782-0.157 C186.466,248.096,186.886,247.359,186.075,247.289z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.847,268.207c-0.06-0.027-0.333,0.227-0.318,0.259c0.18,0.371-0.234,0.619-0.213,0.991 c0.949,0.473,1.547,0.984,2.044-0.334C189.074,268.351,188.367,268.437,187.847,268.207z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.855,214.363c-0.353-0.009-0.703-0.019-1.06-0.028 C174.165,214.596,174.556,214.607,174.855,214.363z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.789,234.392c-0.843-0.96-2.236-0.766-1.797,0.728 C176.647,235.758,177.464,235.476,177.789,234.392z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.197,262.178c0.292,0.681,1.482,1.159,1.835,0.277 C196.09,261.008,194.359,260.657,194.197,262.178z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.258,222.062c-0.562,0.371-0.562,0.371-0.926,0.931 C174.003,225.115,176.756,222.007,174.258,222.062z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.05,227.575c-0.067-1.374-2.232-0.671-1.878,0.404 C201.567,228.887,202.918,228.388,203.05,227.575z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.901,265.874c-2.06,0.614-1.006,2.622,0.714,1.346 C177.39,266.748,177.572,266.122,176.901,265.874z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.528,248.532c-0.601-1.361-2.354-1.131-2.008,0.281c0.235,0.124,0.514,0.269,0.788,0.413 C204.751,249.009,205.287,249.027,205.528,248.532z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.591,281.695c0.527-0.029,0.528-0.717,0.894-0.999c0.601-0.842-0.745-0.879-1.3-0.935 c-0.277,0.2-0.371,0.499-0.486,0.879C176.266,280.867,176.092,281.501,176.591,281.695z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.454,221.224c0.236-1.111-1.38-1.923-1.963-0.75 C189.746,221.298,190.758,221.98,191.454,221.224z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.162,266.058c-0.234-0.067-0.443-0.128-0.733-0.211c-1.404,1.421-0.154,2.524,1.252,1.182 C191.498,266.688,191.326,266.365,191.162,266.058z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.945,227.408c-0.103-0.28-0.199-0.537-0.298-0.807c-0.69-0.087-1.249,0.53-1.709,0.98 c0.09,0.686,0.663,0.792,1.089,1.079C179.293,228.137,179.537,227.802,179.945,227.408z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.764,231.656c-0.342-0.136-0.596,0.295-0.866,0.439c0.453,1.52,1.695,1.226,2.199-0.087 c-0.206-0.195-0.404-0.381-0.605-0.571C179.238,231.597,179.052,231.81,178.764,231.656z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.87,218.808c0.518,0.213,0.971,0.4,1.45,0.597 C194.727,217.689,192.365,216.582,191.87,218.808z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.013,281.79c-0.368,0.405-0.768,0.706-0.958,1.205c0.166,0.228,0.329,0.453,0.5,0.687 C180.19,283.988,180.263,282.487,179.013,281.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.388,276.902c0.528-0.553,0.24-1.079-0.05-1.634c-0.65,0.003-1.144,0.271-1.55,0.719 C185.264,277.014,185.299,277.034,186.388,276.902z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.054,243.001c-0.047,0.335-0.086,0.611-0.132,0.93c0.323,0.193,0.482,0.576,0.937,0.716 c0.366-0.398,0.685-0.758,1.053-1.183C200.462,242.877,199.7,242.565,199.054,243.001z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.578,246.467c0.049-0.352,0.081-0.692-0.081-1.103c-0.315-0.105-0.666-0.223-1.057-0.355 C191.321,246.277,192.066,247.219,193.578,246.467z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.451,232.892c0.767-0.966,0.109-1.312-0.606-1.913c-0.34,0.34-0.64,0.637-0.927,0.924 c0.08,0.258,0.144,0.467,0.222,0.72C192.566,232.71,193.017,232.803,193.451,232.892z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.992,226.77c-0.533,0.008-1.063-0.179-1.471,0.418 C173.507,229.385,176.107,228.209,174.992,226.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.013,272.768c-0.374,0.316-0.73,0.619-1.136,0.963c0.63,1.51,1.506,0.87,2.098-0.171 C193.633,273.32,193.44,272.938,193.013,272.768z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.426,217.296c-0.347,0.125-0.635,0.23-0.893,0.324c-0.087,0.256-0.157,0.464-0.252,0.747 C188.394,220.196,189.871,218.377,188.426,217.296z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.152,255.449c0.3,0.817,1.241,0.993,1.604,0.265c-0.24-0.357,0.26-0.551,0.199-0.847 C202.127,254.18,201.711,254.313,201.152,255.449z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.284,244.682c1.189-0.381,1.572-1.059,0.573-1.909c-0.759,0.091-0.962,0.658-1.319,1.239 C189.761,244.213,189.995,244.423,190.284,244.682z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.934,252.199c-0.305,0.521-0.611,1.006-0.089,1.636c0.235-0.107,0.426-0.195,0.59-0.27 c0.197,0.115,0.246,0.302,0.46,0.229C205.706,252.811,205.162,251.971,203.934,252.199z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.115,240.59c-2.09,0.671,0.637,2.903,1.176,0.661 C189.061,240.778,188.556,240.81,188.115,240.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.236,259.107c-1.08-0.361-2.342,0.728-1.068,1.465 C183.876,260.844,185.107,259.857,184.236,259.107z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.535,268.872c0.157,0.344,0.284,0.625,0.409,0.901c0.375,0.092,0.736-0.044,1.253-0.051 C198.583,268.325,197.291,267.515,196.535,268.872z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.079,257.934c-0.019-0.386-0.035-0.727-0.052-1.073c-1.046-0.743-1.412,0.186-1.432,1.163 C181.281,258.893,181.601,258.399,182.079,257.934z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.415,276.458c0.248-0.571-0.701-1.743-1.278-1.247c0.05,0.472-0.271,0.794-0.639,1.201 C175.957,276.984,176.879,276.919,177.415,276.458z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.036,220.937c-0.052-1.482-1.278-1.09-1.701-0.434v0.803 C171.869,221.751,172.766,221.654,173.036,220.937z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.159,263.773c-0.908,0.63,0.371,2.33,1.23,1.315 C184.196,263.981,184.709,263.236,183.159,263.773z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.863,244.172c0.061-0.19,0.127-0.395,0.196-0.607c-0.136-0.259-0.269-0.51-0.405-0.768 c-0.533-0.146-0.903-0.024-1.219,0.286c-0.135,0.498,0.071,0.912,0.256,1.294C195.155,244.554,195.475,244.286,195.863,244.172z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.495,221.48c-0.15-0.519-0.313-0.999-0.487-1.442c-0.187,0.25-0.364,0.487-0.529,0.706 C203.702,221.424,204.12,221.581,204.495,221.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.04,266.809c0.094,0.237,0.183,0.466,0.27,0.687c0.306,0.059,0.58,0.113,0.902,0.176 c0.186-0.33,0.366-0.647,0.565-1.001C200.366,265.704,199.19,265.863,199.04,266.809z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.107,266.096c-0.244,0.695-0.662,2.091,0.579,1.764c0.091-0.089,0.171-0.188,0.242-0.291 c0.037-0.452,0.074-0.91,0.111-1.375C204.863,266.032,204.572,265.964,204.107,266.096z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.841,265.12c0.927-0.117,1.005-0.155,1.363-0.686c-0.224-0.282-0.397-0.622-0.486-0.971 C196.627,263.329,195.979,264.325,196.841,265.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.51,282.798c0.448-0.181,0.822-0.374,1.132-0.577c-0.272,0-0.548,0-0.842,0 C201.698,282.426,201.602,282.616,201.51,282.798z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.377,265.854c-0.312-0.034-0.589-0.065-0.913-0.1c-0.092,0.398-0.176,0.756-0.216,0.926 c0.283,0.36,0.478,0.608,0.684,0.87C187.125,267.421,186.927,266.62,186.377,265.854z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.996,275.397c-0.468,1.182-0.063,2.134,1.17,1.084 C191.538,275.284,191.013,275.049,189.996,275.397z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.617,282.859c0.14,0.276,0.279,0.547,0.421,0.825c0.363,0,0.705,0,1.101,0 C199.044,282.251,196.78,281.615,196.617,282.859z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M172.189,230.766c0.303-0.427,0.981-1.075,0.457-1.565c-0.646-0.407-0.912,0.09-1.311,0.452 v0.771C171.569,230.807,171.828,231.146,172.189,230.766z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.537,258.496c0.982,0.018,0.526-1.052,0.531-1.709c-0.239,0.052-0.443,0.098-0.647,0.141 c-0.2,0.042-0.392-0.276-0.596-0.017c0.178,0.444,0.065,0.876-0.161,1.255C203.888,258.577,204.23,258.502,204.537,258.496z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.417,263.758c-0.655-0.22-0.945,0.334-1.389,0.527c0.239,0.973,0.981,1.632,1.168,0.608 c0.295-0.135,0.509-0.233,0.734-0.335C179.731,264.248,179.569,263.994,179.417,263.758z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.696,258.627c0.335-0.321,0.67-0.641,1.056-1.009c-0.38-1.428-1.315-0.292-1.923,0.291 C199.002,258.316,199.302,258.519,199.696,258.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.443,276.121c0.208,0.252,0.428,0.518,0.677,0.822 C197.333,276.187,194.938,273.944,194.443,276.121z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.147,242.271c1.147-0.506,1.523-0.14,1.143-1.591c-0.132-0.068-0.272-0.141-0.485-0.252 c-0.215,0.147-0.413,0.284-0.583,0.415C183.53,241.449,182.305,241.802,183.147,242.271z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.389,271.864c0.074-0.851,0.074-0.851-0.348-1.289 C175.003,270.772,175.79,272.466,177.389,271.864z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M171.605,280.122c-0.28,0.518,0.171,0.89,0.089,1.37 C173.524,282.004,173.011,279.533,171.605,280.122z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.209,271.53c0.05,1.059,1.096,0.5,1.575,0.07 C186.649,270.216,185.785,270.693,185.209,271.53z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M170.71,215.441c0,18.286,0,36.572,0,54.859c0,5.031,0,10.062,0,15.093 c0,0.804,1.25,0.806,1.25,0c0-18.286,0-36.572,0-54.859c0-5.031,0-10.062,0-15.093 C171.96,214.637,170.71,214.636,170.71,215.441L170.71,215.441z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M130.454,214.714c0,0-2.897,16.594-0.79,17.252c2.107,0.658,11.063,0.263,11.984,0 c0.922-0.263,1.844-17.65,1.844-17.65S133.484,213.924,130.454,214.714z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.573,235.688c-0.553-1.412-1.955-2.773-3.469-2.687l0.155,0.004 c-3.897-0.095-7.793-0.191-11.69-0.286c-1.182-0.029-2.42-0.046-3.473,0.491c-1.029,0.524-1.771,1.574-1.929,2.718 c-0.158,1.144,0.27,2.352,1.109,3.147c1.273,1.206,3.189,1.346,4.941,1.421c2.734,0.116,5.468,0.232,8.201,0.349 c1.771,0.075,3.721,0.094,5.087-1.035C199.675,238.844,200.127,237.1,199.573,235.688z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.08,368.435c-18.88,7.81-38.71,13.61-58.79,17.02c-0.69-21.27,0.74-76.27,0.79-77.88 c0.24-7.57,52.05-9.51,56.21-2.86C301.13,309.255,300.77,343.355,300.08,368.435z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M285.93,301.727c0,18.7,0,37.4,0,56.1c0,5.267,0,10.533,0,15.799c0,0.804,1.25,0.806,1.25,0 c0-18.7,0-37.4,0-56.1c0-5.266,0-10.533,0-15.799C287.18,300.922,285.93,300.921,285.93,301.727L285.93,301.727z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M258.261,301.28c0,0-3.613,20.694-0.985,21.515c2.628,0.821,13.796,0.328,14.945,0 c1.15-0.328,2.299-22.01,2.299-22.01S262.038,300.294,258.261,301.28z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M309.053,364.539c0,0-4.653-57.726,0-60.582c4.653-2.856,67.549-3.257,71.796-3.294 c4.247-0.037,1.995,14.34,1.995,14.34S357.229,347.543,309.053,364.539z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M351.673,301.659c0.017,12.722,1.402,25.394,1.419,38.116c0.001,0.804,1.251,0.806,1.25,0 c-0.017-12.722-1.402-25.394-1.419-38.116C352.922,300.855,351.672,300.853,351.673,301.659L351.673,301.659z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M310.09,364.175c11.957-15.521,23.249-31.553,33.82-48.049c2.984-4.656,5.909-9.35,8.779-14.077 c0.419-0.689-0.662-1.318-1.079-0.631c-10.169,16.748-21.054,33.058-32.632,48.864c-3.268,4.461-6.592,8.881-9.967,13.262 C308.52,364.181,309.606,364.804,310.09,364.175L310.09,364.175z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M308.165,305.082c11.123,14.845,22.681,29.354,34.198,43.893c0.499,0.63,1.378-0.259,0.884-0.884 c-11.451-14.456-22.943-28.88-34.003-43.64C308.768,303.815,307.682,304.437,308.165,305.082L308.165,305.082z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M97.533,218.658c25.795-4.483,52.15-5.632,78.238-3.412c7.528,0.641,15.029,1.567,22.489,2.765 c0.787,0.126,1.126-1.078,0.332-1.205c-26.204-4.209-52.923-5.033-79.333-2.38c-7.387,0.742-14.745,1.757-22.059,3.028 C96.41,217.59,96.745,218.795,97.533,218.658L97.533,218.658z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M208.74,88.895c0,0.55,0,1.1-0.01,1.66c-0.01,1.02-0.02,2.05-0.05,3.09 c0,0.34-0.01,0.69-0.02,1.03c0,0.01,0,0.01,0,0.02c-0.03,1.27-0.07,2.55-0.13,3.82c0,0.11,0,0.22-0.01,0.33 c-0.01,0.18-0.01,0.36-0.02,0.54c-0.05,1.22-0.11,2.43-0.17,3.63c-0.01,0.09-0.01,0.19-0.02,0.29c-0.12,2.35-0.27,4.67-0.42,6.89 v0.01c-0.02,0.21-0.03,0.41-0.05,0.62c-0.09,1.27-0.18,2.51-0.28,3.7c-0.04,0.46-0.07,0.92-0.11,1.37 c-0.08,0.98-0.16,1.93-0.24,2.84c-0.01,0.11-0.02,0.21-0.03,0.32c-0.04,0.41-0.07,0.81-0.11,1.2c-0.01,0.15-0.03,0.3-0.04,0.45 c-0.08,0.9-0.17,1.75-0.24,2.55c-0.05,0.47-0.1,0.92-0.14,1.34c-0.01,0.16-0.03,0.32-0.05,0.48c-0.13,1.31-0.25,2.43-0.35,3.31 v0.01c-0.03,0.33-0.07,0.62-0.1,0.89c-0.01,0.05-0.02,0.09-0.03,0.13c-0.02,0.05-0.04,0.1-0.05,0.14 c-0.004-0.004-0.004-0.009-0.008-0.014c-0.126,0.363-0.434,0.697-0.902,1.004c0,0,0,0,0,0c0,0-0.001,0-0.001,0.001 c-0.145,0.095-0.296,0.188-0.472,0.278c-0.199,0.104-0.414,0.205-0.656,0.302c-2.074,0.845-5.581,1.44-10.07,1.85c0,0,0,0,0,0 c-0.29,0.03-0.58,0.06-0.88,0.08c-1.21,0.11-2.5,0.2-3.84,0.27c-0.55,0.03-1.11,0.06-1.68,0.09c-0.94,0.05-1.9,0.09-2.88,0.12 c-0.4,0.01-0.8,0.03-1.21,0.04c-0.14,0-0.29,0.01-0.43,0.01c-1.52,0.05-3.1,0.08-4.72,0.1c-0.94,0.02-1.89,0.03-2.85,0.03 c-0.53,0-1.07,0-1.61,0.01c-30.85,0.07-73.05-3.15-75.65-4.44c-2.39-1.2-2.03-21.57-1.29-38.62 c10.81-10.09,22.9-19.22,35.99-27.2c0.04-0.27,0.07-0.42,0.07-0.42c0.04-0.01,0.07-0.02,0.11-0.02c0.19-0.01,0.39-0.02,0.59-0.03 c3.96-0.15,8.08-0.27,12.24-0.35c0.06,0,0.09,0,0.09,0c20.43-0.42,41.96-0.01,52.44,1.35c1.16,0.15,2.19,0.31,3.06,0.49 c0.49,0.09,0.92,0.19,1.31,0.3c0.04,0.01,0.08,0.02,0.11,0.03c0.66,0.18,1.17,0.37,1.51,0.58c0.06,0.04,0.12,0.08,0.18,0.13 c0.08,0.05,0.15,0.11,0.22,0.17c0.07,0.06,0.14,0.12,0.21,0.19c0.14,0.14,0.27,0.29,0.4,0.46v0.01c0.41,0.53,0.76,1.2,1.08,2.01 c0.09,0.22,0.17,0.45,0.25,0.69c0.06,0.17,0.11,0.34,0.16,0.51c0.03,0.08,0.05,0.16,0.07,0.24h0.01 c0.75,2.58,1.21,6.06,1.46,10.05c0.03,0.42,0.06,0.85,0.08,1.28c0.05,0.99,0.09,2,0.12,3.04c0.02,0.58,0.03,1.17,0.04,1.76 C208.73,86.905,208.74,87.895,208.74,88.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.602,73.84c0.25-2.452,3.835-1.564,1.917-3.571c-0.817-0.183-1.415,0.808-1.45,1.52 c0.013,1.042-1.636,0.546-2.427,1.105C182.617,73.954,184.318,75.368,184.602,73.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.891,97.513c0.36,0.081,0.634,0.143,0.932,0.208 C187.118,96.224,181.967,94.113,182.891,97.513z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.24,126.729c-0.169-1.565-2.003-1.317-2.274,0.193 C185.89,127.861,186.698,128.116,187.24,126.729z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.892,97.991c-0.723,0.148-1.359,0.229-1.54,1.042c0.219,1.641,1.687,1,2.281-0.045 C182.543,98.584,182.345,98.242,181.892,97.991z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.181,133.127c0.609-0.047,1.202-0.097,1.779-0.15c-0.006-0.017-0.014-0.039-0.02-0.055 C193.164,132.557,192.52,132.754,192.181,133.127z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M207.593,92.908c0.166-0.399,0.312-0.75,0.479-1.153 C206.048,88.938,204.934,93.658,207.593,92.908z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M207.029,120.702c0.059-0.635,0.118-1.294,0.178-1.972c-0.141-0.072-0.306-0.125-0.507-0.151 C205.279,119.369,206.128,120.73,207.029,120.702z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.235,86.211c0.381-0.095,0.739-0.184,1.097-0.272 C184.024,83.222,178.347,84.348,181.235,86.211z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.462,81.151c0.114-0.564,0.114-0.564,0.516-0.97c-0.198-0.32-0.488-0.558-0.821-0.844 C174.808,79.481,176.281,82.893,177.462,81.151z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.147,99.808c0.269-0.113,0.167-0.372,0.154-0.59c0.495-0.583-0.054-1.251-0.698-1.381 c-0.335,0.249-0.737,0.389-1.149,0.313C203.228,99.243,204.016,100.313,205.147,99.808z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.786,69.126c0.144-1.157-1.681-1.654-1.918-0.46 C182.498,70.012,184.687,70.618,184.786,69.126z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.544,94.008c0.288,1.555,1.299,1.954,2.125,0.472 C182.14,93.582,181.018,92.394,180.544,94.008z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.019,74.022c0.92-1.318-1.783-2.236-1.777-0.651 C178.094,74.362,179.615,75.247,180.019,74.022z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.903,74.092c1.087-1.303-1.309-2.017-1.97-0.757 C192.362,74.349,192.987,75.225,193.903,74.092z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.813,89.515c-0.715-1.151-1.561-1.242-2.051,0.183 C175.824,91.19,178.22,90.775,177.813,89.515z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.739,116.705c-0.234-0.119-0.515-0.262-0.884-0.45 C174.121,118.099,178.254,119.845,177.739,116.705z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.083,113.974c-0.825-0.016-1.275,0.439-1.54,1.18c0.218,0.302,0.435,0.603,0.633,0.878 c0.439-0.085,0.807-0.156,1.215-0.235c0.144-0.291,0.295-0.594,0.446-0.898C198.567,114.567,198.33,114.277,198.083,113.974z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.485,125.783c-2.595,0.121,0.659,3.702,0.99,0.991 C182.556,125.905,182.112,125.969,181.485,125.783z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.304,93.117c0.471-0.272,0.707-0.768,1.081-1.333c-0.703-1.238-1.508-0.953-2.207,0.093 C178.192,92.597,178.497,93.066,179.304,93.117z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.238,65.507c-0.312,0.081-0.639,0.165-0.907,0.234c-0.581,0.896-0.215,1.861,0.883,1.991 c0.319-0.368,0.625-0.722,0.914-1.056C200.973,66.151,200.694,65.784,200.238,65.507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.061,78.828c0.38-1.728-1.079-2.404-1.82-0.716C178.159,79.07,179.772,79.836,180.061,78.828 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.888,110.404c-0.03-0.67-0.443-0.937-1.047-1.006c-0.879,0.334-0.759,1.085-0.914,1.764 C183.894,111.99,184.494,111.43,184.888,110.404z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.291,78.101c0.002,1.192,1.105,1.529,1.816,0.506c0.026-0.497,0.242-0.907,0.055-1.337 c-0.219-0.07-0.428-0.137-0.626-0.201C202.027,77.407,201.401,77.435,201.291,78.101z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.904,125.545c-3.085,0.989,0.379,3.577,0.961,0.829 C191.549,126.101,191.246,125.84,190.904,125.545z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.34,85.55c0.424,0.88,1.799,0.998,1.798-0.279C195.902,83.468,194.086,83.781,194.34,85.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.75,83.797c1.975-1.777-1.271-2.994-1.568-0.762 C201.557,83.629,202.265,83.353,202.75,83.797z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.424,70.691c-0.704-0.451-1.432-0.202-2.203-0.525c0.613,1.009,0.613,1.009,0.588,1.915 C204.638,72.464,206.575,71.56,205.424,70.691z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.888,86.192c-0.91,0.783-1.792,1.521-0.41,2.258c0.579,0.328,0.875-0.428,1.195-0.79 C199.153,87.012,198.276,86.68,197.888,86.192z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.658,123.159c1.27-0.535,1.839-1.01,0.654-2.05c-0.559-0.091-0.919,0.258-1.313,0.457 c-0.083,0.274-0.155,0.511-0.228,0.752C176.058,122.65,176.315,122.967,176.658,123.159z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.497,84.318c-2.458-0.384-2.621,2.157,0.035,1.422 C191.915,85.268,192.055,84.826,191.497,84.318z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.857,86.576v0.154c0.085,0.232,0.085,0.418,0,0.599v0.789c0.3,0.259,0.882,0.26,1.251,0.231 C176.465,87.63,175.042,85.827,173.857,86.576z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.416,118.331c1.033-0.907,0.954-1.45-0.262-2.011 C184.592,116.72,184.769,118.367,186.416,118.331z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.716,83.851c1.268,0.104,1.923-1.783,0.419-1.842 C205.815,81.768,205.526,83.443,206.716,83.851z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.993,108.636c0.768,0.855,1.526,0.422,2.024-0.457 C177.373,106.659,175.721,106.891,175.993,108.636z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.781,100.744c-0.359-0.237-0.647-0.428-0.914-0.604c-0.736,0.33-0.736,0.33-1.106,1.285 C183.517,102.682,185.108,102.339,184.781,100.744z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.626,68.112c-1.194-0.462-1.139,1.093-1.471,1.837c0.485,0.122,0.905-0.418,1.442-0.156 c0.079,0.034,0.248-0.063,0.336-0.143C203.434,69.203,203.416,68.172,202.626,68.112z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.325,119.498c-0.239-0.223-0.492-0.46-0.727-0.681c-1.118,0.304-1.118,0.304-1.342,1.27 C201.871,121.252,203.471,120.891,203.325,119.498z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.881,87.851c0.294,0.219,0.619,0.459,0.97,0.717 C209.43,87.175,206.241,84.798,205.881,87.851z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.674,108.833c0.067-1.303,0.007-1.419-0.904-1.784c-0.361,0.318-0.732,0.645-1.091,0.96 c0.186,0.403,0.34,0.733,0.479,1.032C190.747,108.894,191.194,109.3,191.674,108.833z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.167,74.726c-0.294,0.2-0.601,0.409-0.883,0.601 C198.387,78.189,203.042,76.374,200.167,74.726z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.746,91.497c-0.074,0.252-0.152,0.518-0.226,0.771 C189.41,95.214,190.764,89.656,187.746,91.497z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.913,106.802c2.885-0.556,0.14-3.144-0.968-0.922 C192.062,106.381,192.366,106.673,192.913,106.802z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.502,110.739c0.342,0.546,0.886,0.698,1.421,0.884c0.365-0.312,0.449-0.733,0.658-1.089 C189.281,109.248,187.26,109.238,187.502,110.739z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.411,102.601c-1.19-0.151-1.395,1.639-0.381,1.9 C196.23,104.89,196.965,102.523,195.411,102.601z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.366,106.262c0.446,0.75,2.05,0.791,1.973-0.321 C180.037,104.572,177.763,104.718,178.366,106.262z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M208.559,81.134c-0.022-0.434-0.047-0.862-0.074-1.284 C208.045,80.274,207.952,80.787,208.559,81.134z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.027,122.072c0.351,0.382,0.452,0.905,0.957,1.091c0.577-0.238,0.943-0.636,1.09-1.287 C200.228,120.804,199.462,120.503,199.027,122.072z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.579,88.607c-0.872,0.276-0.872,0.276-1.165,1.103c0.146,0.212,0.305,0.444,0.471,0.686 c0.303,0.075,0.608,0.152,0.98,0.246C196.873,90.047,196.529,89.004,195.579,88.607z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.428,123.238c-0.352,0.229-0.8,0.278-1.071,0.708c0.136,0.361,0.279,0.739,0.409,1.085 c0.305,0.098,0.545,0.175,0.822,0.263C203.57,124.677,203.891,123.415,202.428,123.238z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.004,116.209c0.435-0.34,0.785-0.717,0.986-1.217 C183.786,112.905,181.6,115.365,184.004,116.209z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.082,79.098c0.188-0.269,0.348-0.498,0.533-0.764c-0.411-0.421-0.553-1.031-1.201-1.304 c-0.351,0.255-0.728,0.529-1.139,0.829C187.516,78.876,188.228,78.986,189.082,79.098z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.398,64.814c0.509,1.022,1.84,0.135,1.916-0.733 C179.427,62.731,177.897,63.395,178.398,64.814z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.755,65.443c-0.294,0.407-0.645,0.731-0.74,1.278c0.354,0.269,0.724,0.551,1.077,0.82 c0.344-0.093,0.643-0.175,0.996-0.272c-0.102-0.51-0.198-0.99-0.297-1.485C186.43,65.666,186.106,65.56,185.755,65.443z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.965,74.211c1.23,0.44,1.411,0.371,1.769-0.616c-0.453-1.117-1.659-1.384-2.145-0.141 C196.738,73.755,196.863,74.006,196.965,74.211z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.977,77.512c-0.074,0.57,0.368,0.73,0.302,1.335c0.677,0.094,1.368,0.55,1.698-0.227 C193.956,77.185,193.155,76.855,191.977,77.512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.122,130.061c0.82-0.237,1.002-0.79,0.973-1.49 C192.672,127.269,191.059,129.511,193.122,130.061z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.254,128.385c-0.41,0.401-0.466,0.855-0.183,1.166c0.033-0.089,0.071-0.178,0.081-0.271 C206.182,129.018,206.217,128.717,206.254,128.385z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.147,92.9c0.046-0.454,0.208-0.841,0.518-1.138c-0.178-0.873-1.238-1.18-1.808-0.541v0.602 c0.071,0.351,0.22,0.69,0.19,1.054C174.443,93.005,174.774,92.998,175.147,92.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.291,76.963c0.434-0.444,0.906-0.828,0.763-1.543c-0.297-0.236-0.587-0.467-0.865-0.688 c-0.688,0.189-1.089,0.566-1.091,1.28C185.373,76.461,185.831,76.672,186.291,76.963z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.857,82.063v1.347c0.065,0.096,0.128,0.189,0.198,0.293 C176.944,84.105,174.896,81.047,173.857,82.063z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.76,83.693c2.379-1.144-0.771-3.179-1.307-0.687C196.958,83.272,197.37,83.489,197.76,83.693 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.236,86.222c-1.204,0.33-1.621,1.763-0.348,2.214 C193.998,87.891,194.481,86.919,193.236,86.222z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.806,124.399c0.292,0.357,0.546,0.577,0.799,0.678c0.058-0.571,0.119-1.179,0.182-1.821 C206.412,123.282,206.031,123.637,205.806,124.399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M208.732,90.555c0.005-0.556,0.007-1.109,0.007-1.659 C208.256,89.265,208.144,90.076,208.732,90.555z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.086,100.363c-0.674-0.075-1.047,0.072-1.229,0.307v0.911 c0.37,0.714,1.386,1.213,1.826-0.254C175.458,100.959,175.409,100.625,175.086,100.363z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.158,103.992c0.703,0.552,1.918,0.557,2.139-0.478 C186.59,102.228,184.666,102.445,185.158,103.992z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.271,120.851c-1.016,1.104-0.547,1.989,0.77,2.304c0.311-0.346,0.435-0.738,0.62-1.12 C182.43,121.405,181.835,121.28,181.271,120.851z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.126,98.157c-0.611-0.606-1.081-0.302-1.639,0.097 C193.411,99.853,196.839,100.563,196.126,98.157z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.226,94.086c-0.117,0.652,0.288,1.375,1.029,1.158 C202.362,94.719,199.16,91.756,199.226,94.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.271,118.367c1.212,0.129,1.781-1.949,0.249-1.909 C180.38,116.348,180.256,118.24,181.271,118.367z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.893,63.58c-0.448-0.035-0.919-0.07-1.449-0.112 C190.794,65.447,195.283,65.876,193.893,63.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.491,70.537c-0.794-0.441-1.443,0.026-1.689,0.883c0.515,0.313,1.117,1.388,1.699,0.715 C200.964,71.735,201.064,70.878,200.491,70.537z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.469,125.605c-1.219,0.091-1.54,1.793-0.177,1.995 C196.441,127.531,196.657,125.791,195.469,125.605z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.774,75.837c-0.415-0.7-0.99-1.311-1.75-0.634c0.045,0.189,0.079,0.338,0.117,0.501 c-0.173,0.109-0.349,0.22-0.562,0.354C190.292,77.027,191.743,77.258,191.774,75.837z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.663,125.545c-0.639,0.149-0.927,0.525-1.007,1.073c0.173,0.318,0.337,0.619,0.501,0.92 C205.541,127.744,206.285,126.168,204.663,125.545z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.722,88.051c0.814,0.72,1.091,0.608,1.8-0.352C189.222,85.804,187.349,86.201,187.722,88.051 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.844,80.474c0.416,1.068,1.274,1.17,1.941,0.263 C201.395,79.266,199.094,79.065,198.844,80.474z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M208.716,85.937c-0.01-0.593-0.021-1.181-0.037-1.761c-0.516,0.115-0.102,1.018-0.38,1.342 C208.423,85.73,208.564,85.857,208.716,85.937z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.982,109.134c0.193-0.256,0.363-0.479,0.547-0.724 C195.881,105.203,192.91,109.478,195.982,109.134z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.68,103.048c-1.106-1.067-1.62,0.129-1.958,1.131 C176.619,104.9,178.295,104.261,177.68,103.048z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.632,65.317c0.104-0.436,0.024-0.938-0.179-1.32c-0.493-0.064-1.01-0.126-1.55-0.186 C196.736,65.157,197.278,65.385,198.632,65.317z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.621,98.359c-0.84-0.711-1.515-0.436-1.817,0.601c0.2,0.296,0.395,0.584,0.608,0.901 c0.313,0,0.627,0,0.968,0C191.815,99.427,191.758,98.908,191.621,98.359z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.882,119.75c0.475,0.262,0.331,1.04,1.038,1.091c0.336-0.289,0.694-0.597,1.056-0.909 C184.837,118.508,183.302,118.432,182.882,119.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.696,81.035c-0.01-0.518,0.197-1.1-0.504-1.472C188.661,79.751,190.14,82.373,191.696,81.035 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.095,83.979c-1.504,0.873-0.98,2.589,0.781,1.776 C187.172,85.042,187.061,84.145,186.095,83.979z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.15,82.335c0.053,0.898,0.441,1.313,1.347,1.399c0.236-0.393,0.6-0.64,0.63-1.126 C193.325,81.843,193.017,81.064,192.15,82.335z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.682,70.56c-0.093,0.375-0.183,0.735-0.258,1.036c0.745,1.286,2.059,0.46,1.896-0.771 c-0.21-0.36-0.533-0.422-0.835-0.554C195.222,70.366,194.955,70.462,194.682,70.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.207,102.164c0.144-0.378,0.278-0.73,0.421-1.106 C197.011,98.648,195.479,102.759,198.207,102.164z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.444,130.181c-0.402,0.487-0.445,1.017-0.489,1.554c0.399,0.453,0.867,0.594,1.461,0.421 c0.005-0.555,0.149-0.881,0.454-1.361C177.374,130.578,177.131,129.962,176.444,130.181z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.943,88.48c0.318-0.24,0.644-0.488,1.058-0.802c-0.18-0.367-0.333-0.677-0.504-1.026 C182.832,85.973,182.318,88.031,183.943,88.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.984,107.229c-0.721,0.402-1.792,0.364-1.241,1.414 C181.596,110.317,183.431,108.307,181.984,107.229z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.283,90.087c1.57-1.087-1.319-2.079-1.435-0.462 C198.754,90.613,201.086,91.406,200.283,90.087z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.628,89.64c-0.158-0.301-0.269-0.677-0.679-0.833c-0.298,0.065-0.601,0.132-0.889,0.196 c-0.219,0.288-0.422,0.556-0.617,0.814c0.188,0.288,0.341,0.523,0.511,0.783C181.706,90.812,182.489,90.437,182.628,89.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.238,95.313c0.726-0.226,1.483-0.17,1.786-1.009 C177.218,92.544,175.365,93.56,176.238,95.313z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.101,101.877c0.656-1.541-0.722-2.286-1.74-0.878 C201.601,101.893,202.267,102.664,203.101,101.877z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.253,95.472c-0.305,0.539-1.136,0.534-1.132,1.375c0.251,0.41,0.493,0.9,1.222,0.835 C194.344,97.238,194.026,96.083,193.253,95.472z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.516,69.101c-0.089,0.953,1.89,0.992,1.882,0.046 C189.319,67.716,187.582,67.533,187.516,69.101z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.872,88.29c0.991,0.081,0.991,0.081,1.402-0.796c-0.239-0.4-0.479-0.8-0.757-1.263 c-0.557,0.219-0.951,0.461-1.32,0.882C178.439,87.503,178.53,87.978,178.872,88.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.326,131.393c-0.331-0.4-0.646-0.782-1.049-1.268c-0.418,0.277-0.755,0.5-1.079,0.715 c-0.031,0.388-0.058,0.727-0.091,1.135C185.999,131.947,186.743,132.243,187.326,131.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.861,77.202c-0.239,0.16-0.499,0.334-0.737,0.493c-0.074,0.307-0.14,0.581-0.221,0.915 c0.8,0.866,0.974,0.88,1.776,0.171C184.721,78.164,184.7,77.377,183.861,77.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.936,84.394c-0.322,0.598-0.067,1.026,0.217,1.637c0.883,0.199,1.624-0.397,1.385-1.328 C205.36,84.235,204.173,83.878,203.936,84.394z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.498,110.06c-0.382-0.351-0.802-0.348-1.295-0.417c-0.112,0.122-0.232,0.231-0.346,0.342 v1.055C174.65,111.731,175.843,111.465,175.498,110.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.986,102.658c-0.368-0.067-0.68-0.121-1.001,0.07c-0.146,0.301-0.298,0.615-0.452,0.935 C181.408,105.398,183.314,104.085,181.986,102.658z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.301,81.027c0.739,1.17,1.786,0.201,1.94-0.802c-0.298-0.238-0.568-0.453-0.826-0.657 C185.346,79.776,185.374,80.056,185.301,81.027z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.762,125.96c-0.925-0.462-1.519-0.204-1.861,0.784c0.545,0.434,1.401,1.447,1.827,0.382 C177.882,126.755,178.304,126.222,177.762,125.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.179,83.343c0.907,0.654,1.906-0.185,1.568-1.243 C183.739,81.136,182.438,82.198,183.179,83.343z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.129,122.15c0.45,0.886,1.693,1.306,1.966,0.138 C187.112,120.828,185.442,120.768,185.129,122.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.476,125.94c-0.691,0.562-0.218,1.63,0.627,1.658 C201.67,127.441,200.586,124.51,199.476,125.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.857,72.981v1.251c0.169,0.187,0.453,0.321,0.774,0.5 C176.845,73.252,174.405,72.221,173.857,72.981z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.049,107.587c-0.667-0.816-1.945-0.071-1.812,0.911 C199.903,109.818,201.25,108.865,201.049,107.587z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M200.915,99.369c0.049-0.175,0.1-0.357,0.152-0.54c-0.498-0.887-1.323-0.782-2.182-0.744 c0.146,0.476,0.153,0.791,0.135,1.277C199.698,99.66,200.371,99.749,200.915,99.369z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M197.355,104.952c-0.261,0.334-0.64,0.539-0.795,0.92c0.437,0.605,0.879,0.859,1.618,0.926 C199.382,106.088,198.525,105.046,197.355,104.952z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.6,112.402c0.194,1.537,1.167,1.728,1.952,0.33 C196.438,111.713,194.884,111.341,194.6,112.402z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.154,111.796c-1.071,0.025-1.895,1.849-0.213,1.937 C177.965,113.533,178.249,112.11,177.154,111.796z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.994,130.045c0.32-0.313,0.722-0.583,0.881-1.106 C183.65,126.912,181.596,129.272,183.994,130.045z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.009,97.75c0.222-0.32,0.446-0.646,0.675-0.977C197.761,94.08,195.501,97.063,198.009,97.75z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M208.201,103.084c0.038,0.074,0.075,0.147,0.111,0.22c0.005-0.097,0.01-0.194,0.015-0.291 C208.283,103.038,208.249,103.057,208.201,103.084z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.635,116.465c-1.175,0.098-1.267,1.764-0.046,1.904 C205.791,118.314,205.818,116.604,204.635,116.465z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M208.684,93.644c-0.061,0.071-0.117,0.152-0.164,0.257c0.046,0.261,0.091,0.52,0.139,0.793 C208.668,94.343,208.676,93.993,208.684,93.644z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.995,73.82c0.555,0.558,0.943,0.824,1.221,0.825c0.2-0.149,0.422-0.315,0.623-0.465 c-0.258-0.452-0.139-0.823-0.385-1.283C206.739,72.01,205.987,72.958,205.995,73.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.127,65.512c-0.094-0.033-0.318,0.03-0.328,0.081c-0.085,0.442-0.481,0.428-0.798,0.54 c0.047,0.355,0.09,0.68,0.132,0.995c0.516,0.096,0.98,0.407,1.501,0.163C178.389,66.394,177.894,66.047,177.127,65.512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.518,102.088c1.047-0.628,0.668-1.428-0.33-1.864c-0.544,0.317-1.52,0.724-0.847,1.359 C192.691,101.838,193.073,102.401,193.518,102.088z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.536,76.783c0.594-0.227,0.911-0.608,0.936-1.235c-0.087-0.14-0.183-0.297-0.269-0.434 c-0.756-0.057-1.475-0.186-1.904,0.695C194.539,76.338,195.057,76.556,195.536,76.783z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.857,64.585c0.1,0.207,0.264,0.432,0.51,0.671c0.413-0.156,0.763-0.289,1.222-0.462 c0.01-1.605-1.321-1.729-1.732-1.104V64.585z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.157,120.478c0.642-0.503,0.314-1.681-0.425-1.71c-0.568-0.102-0.741,0.156-0.875,0.543v1.07 C174.189,120.57,174.847,120.45,175.157,120.478z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.857,123.839v1.032c0.128,0.114,0.245,0.219,0.388,0.346 C176.927,125.215,174.897,122.408,173.857,123.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.247,113.671c0.147-0.211,0.31-0.443,0.471-0.673c-0.092-0.356-0.179-0.691-0.294-1.132 c-0.741,0.023-1.377,0.109-1.587,0.933C190.106,113.806,190.355,113.862,191.247,113.671z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.209,105.126c-0.783-0.213-1.254,0.119-1.352,0.588v0.36 c0.058,0.314,0.253,0.644,0.634,0.902C175.556,106.604,176.149,105.953,175.209,105.126z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.341,73.168c0.124,0.619,0.37,1.568,1.214,1.268c0.17-0.426,0.433-0.711,0.865-0.851 C203.273,72.145,202.187,72.472,201.341,73.168z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.555,100.973c0.05,0.442,0.091,0.805,0.132,1.17c0.27,0.077,0.54,0.156,0.799,0.231 c0.714-0.6,0.757-0.711,0.667-1.793c-0.363-0.091-0.745-0.186-1.124-0.281C187.831,100.581,187.669,100.811,187.555,100.973z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.296,101.25c0.436,0.959,1.199,1.191,1.947,0.459 C180.375,100.3,178.662,99.743,178.296,101.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.091,95.204c0.71-0.623,0.858-1.203,0.028-1.832c-0.556,0.188-1.398,0.132-1.419,0.906 c0.168,0.254,0.323,0.492,0.484,0.736C190.501,95.081,190.806,95.145,191.091,95.204z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.552,97.024c0.083-0.844-0.928-1.776-1.677-1.104c-0.007,0.008-0.011,0.016-0.018,0.024 v1.168C174.26,97.494,175.049,97.583,175.552,97.024z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.579,109.533c-1.194,0.141-0.537,2.233,0.684,1.538c0.278-0.053,0.463-0.14,0.578-0.246 c0.015-0.208,0.03-0.415,0.045-0.625C207.661,109.84,207.101,109.515,206.579,109.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.38,98.362c-0.399,1.789,1.027,1.989,1.893,0.664C187.05,97.958,186.19,97.923,185.38,98.362 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.566,109.859c-0.025,0.378-0.05,0.753-0.074,1.106c0.361,0.373,0.781,0.459,1.316,0.403 c0.089-0.35,0.103-0.654,0.412-0.871C204.012,109.595,202.094,109.452,201.566,109.859z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.599,128.918c-0.393-0.41-0.676-0.89-1.255-1.001c-0.477,0.24-0.662,0.697-0.93,1.098 C188.251,129.993,188.972,130.237,189.599,128.918z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.56,133.415c0.572-0.028,1.132-0.058,1.685-0.09c-0.04-0.164-0.083-0.34-0.133-0.542 C188.261,132.128,187.659,132.543,187.56,133.415z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.718,118.97c-1.578-0.252-2.209,0.589-1.049,1.682 C193.732,120.805,194.308,119.856,193.718,118.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.031,118.778c-0.819,0.312-1.538,0.295-1.308,1.355c0.849,0.785,1.1,0.768,1.917-0.098 C198.453,119.631,198.485,119.113,198.031,118.778z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.166,66.02c-1.072-0.45-1.072-0.45-1.535-0.069C180.231,68.136,182.991,68.006,182.166,66.02 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.19,122.44c0.773-0.548,0.108-1.023-0.276-1.543c-0.352,0.119-0.645,0.218-0.852,0.288 c-0.128,0.546-0.236,1.001-0.355,1.509C204.325,123.041,204.81,123.093,205.19,122.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.829,110.54c-0.004-1.478-1.975-1.125-1.889,0.159 C192.041,111.313,194.048,111.642,193.829,110.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.168,107.467c-0.85,1.074-0.544,0.98,0.287,1.581c0.643,0.296,1.165-0.49,1.286-1.082 C205.333,107.237,204.728,107.398,204.168,107.467z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.284,133.291c-0.275-0.309-0.504-0.567-0.713-0.8c-0.811,0.162-1.22,0.725-1.253,1.195 c0.586-0.008,1.168-0.017,1.743-0.028C180.127,133.523,180.203,133.395,180.284,133.291z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.589,99.536c0.059-0.302,0.12-0.605,0.178-0.901 C175.905,96.552,174.88,100.693,177.589,99.536z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.088,94.301c-0.421-1.488-1.979-1.172-1.865,0.395 C185.289,95.788,186.91,94.983,187.088,94.301z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.495,73.349c0.083,1.386,1.988,1.565,1.814-0.179 C188.376,72.213,187.937,72.546,187.495,73.349z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.621,116.226c0.548-0.272,0.768-0.705,0.854-1.28c-0.223-0.711-1.14-1.063-1.618-0.543v1.041 C174.095,115.72,174.454,115.958,174.621,116.226z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.551,130.025c0.27-0.655,0.951-0.689,0.659-1.55 C201.458,127.103,200.687,129.759,202.551,130.025z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.88,72.188c1.224-0.596,0.402-1.887-0.608-1.865c-0.432,0.396-0.798,0.601-0.936,1.201 C180.893,71.763,181.386,71.975,181.88,72.188z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.937,90.589c0.339,0.097,0.463-0.465,0.618-0.654c-0.142-0.276-0.256-0.499-0.407-0.793 c-1.239-0.627-2.177,0.478-1.051,1.439C204.354,90.63,204.65,90.197,204.937,90.589z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.987,85.229c-0.474-0.406-0.479-0.95-0.983-1.176c-1.092,0.195-1.386,1.156-0.603,1.936 C176.938,85.767,177.585,85.784,177.987,85.229z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M189.579,122.11c0.096,0.212,0.183,0.41,0.311,0.695 C193.254,123.417,191.199,119.613,189.579,122.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M208.535,98.505c-0.073,0.073-0.146,0.141-0.223,0.234c0.007,0.258,0.081,0.468,0.186,0.643 C208.511,99.09,208.524,98.798,208.535,98.505z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.482,97.399c1.42,0.018,1.577,0.234,1.641-1.304c-0.302-0.193-0.565-0.36-0.811-0.517 c-0.426,0.29-0.815,0.555-1.26,0.858C178.315,96.751,178.385,96.986,178.482,97.399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.641,102.739c-0.28,0.194-0.547,0.381-0.815,0.567c0.696,1.076,1.39,1.64,2.296,0.518 C200.929,103.046,200.459,102.71,199.641,102.739z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.317,64.278c0.465,0.67,0.993,1.1,1.858,0.899c0-0.49,0-0.93,0-1.347 C188.235,62.935,187.937,63.537,187.317,64.278z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.26,65.431c0.774,0.095,1.059-0.138,1.069-0.496c-0.498-0.158-1.11-0.307-1.818-0.449 c0,0,0,0,0,0.001C201.755,64.794,201.987,65.087,202.26,65.431z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.008,69.972c0.406-0.202,0.762-0.38,1.218-0.608c-0.48-0.604-0.083-1.277-0.779-1.548 c-0.518,0.118-0.866,0.403-1.128,0.841c0.157,0.19,0.294,0.354,0.424,0.511c-0.074,0.188-0.139,0.355-0.219,0.559 C178.722,69.826,178.886,69.91,179.008,69.972z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.931,90.943c-0.695,0.363-0.695,0.363-1.107,1.25 C184.224,93.956,185.72,92.059,183.931,90.943z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.621,65.526c-1.147,0.34-1.194,1.693,0.13,1.833c0.847,0.126,0.927-0.445,0.702-1.012 C205.195,66.008,204.916,65.737,204.621,65.526z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M183.746,132.534c-0.518,0.249-0.656,0.629-0.707,1.052c0.553-0.016,1.097-0.034,1.637-0.053 c-0.063-0.227-0.123-0.447-0.184-0.668C184.221,132.744,183.965,132.632,183.746,132.534z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.869,124.079c-0.046,1.643,1.908,1.382,2.031-0.115 C184.371,123.664,183.059,123.207,182.869,124.079z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.078,70.535c-0.337,0.746-0.117,1.296,0.551,1.78c1.046-0.281,1.048-0.498,1.195-1.241 c-0.17-0.195-0.315-0.361-0.432-0.496C190.865,70.67,190.578,70.643,190.078,70.535z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.059,116.746c-1.212-0.244-1.306-0.014-1.814,0.885 C194.955,119.043,196.699,118.145,196.059,116.746z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.269,107.005c0.713-0.116,1.006-0.736,1.104-1.485c-0.171-0.179-0.384-0.403-0.6-0.627 c-0.569,0.277-1.247,0.186-1.39,0.883C187.687,106.197,187.958,106.573,188.269,107.005z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M207.295,79.036c0.238-0.234,0.498-0.457,0.75-0.662c-0.469-1.09-0.999-1.452-1.925-0.839 C206.525,78.514,205.642,78.914,207.295,79.036z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.587,129.227c0.093-0.44-0.277-1.193-0.744-1.376c-0.523,0.419-1.164,0.903-1.099,1.596 C197.485,129.967,198.103,130.045,198.587,129.227z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.564,69.382c0.255-1.153-0.98-1.95-1.799-0.918C196.74,69.659,197.632,69.996,198.564,69.382 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.857,132.367c0.293-0.349,0.594-0.708,0.879-1.049c-0.096-0.41-0.197-0.735-0.531-0.962 C189.867,130.489,189.136,132.184,190.857,132.367z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.059,65.238c0.453-0.272,0.742-0.63,0.901-1.164c-0.513-0.398-1.389-0.777-2.049-0.398 c-0.154,0.465,0.177,0.827,0.252,1.258C183.486,65.044,183.778,65.143,184.059,65.238z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.413,131.22c-0.06,0.851,0.444,0.82,1.006,0.934 C197.393,131.776,194.758,128.939,194.413,131.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.225,97.243c-0.159-0.31-0.011-0.675,0.017-0.972c-0.538-0.702-1.895-0.303-1.989,0.46 C201.584,97.432,202.686,97.902,203.225,97.243z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.748,78.208c0.279,0.367,0.526,0.691,0.773,1.017c0.412-0.364,1.061-0.382,1.225-0.997 C198.316,77.055,197.276,76.856,196.748,78.208z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.735,132.434c-0.295,0.321-0.532,0.662-0.878,0.876v0.411 c0.542-0.001,1.081-0.003,1.616-0.007c-0.006-0.033-0.006-0.062-0.015-0.097C175.213,133.129,175.359,132.631,174.735,132.434z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.408,82.917c0.555,1.137,2.376,0.752,2.062-0.546 C188.139,81.824,187.785,81.922,187.408,82.917z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.999,85.234c0.185,0.266,0.36,0.518,0.521,0.75c1.015,0.073,1.026,0.063,1.396-1.154 C200.363,83.719,199.308,84.254,198.999,85.234z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.505,79.961c-0.352-0.17-0.662-0.319-0.924-0.446c-0.659,0.1-0.866,0.549-1.045,1.077 C204.244,81.596,205.95,81.353,205.505,79.961z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.608,95.253c0.482-0.11,0.731-0.22,1.088-0.53c-0.625-1.092-0.272-1.78-1.81-1.06 C203.933,94.381,203.686,95.048,204.608,95.253z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.742,113.93c0.277-0.321,0.538-0.625,0.823-0.956c-0.262-0.317-0.13-0.818-0.6-1.092 c-0.404,0.396-1.107,0.326-1.494,0.894C203.74,113.399,204.211,113.665,204.742,113.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M178.235,110.515c0.121,0.606,0.406,1.007,1.028,1.084c0.605-0.479,0.605-0.479,0.855-1.17 C179.672,109.367,178.695,109.683,178.235,110.515z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M191.265,104.437c0.665-1.637-0.203-2.466-1.616-1.172c0.171,0.168,0.319,0.312,0.467,0.456 c-0.021,0.205-0.043,0.409-0.07,0.668C190.47,104.409,190.817,104.594,191.265,104.437z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.185,88.086c0.474-1.16-1.047-1.685-1.799-0.918 C201.02,88.304,202.548,88.738,203.185,88.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.597,95.616c-0.571,0.603-1.575,0.397-1.04,1.545c0.623,0.284,1.201,0.449,1.782-0.157 C188.988,96.424,189.408,95.687,188.597,95.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.369,116.534c-0.06-0.027-0.333,0.227-0.318,0.259c0.18,0.371-0.234,0.619-0.213,0.991 c0.949,0.473,1.547,0.984,2.044-0.334C191.596,116.678,190.889,116.764,190.369,116.534z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.377,62.69c-0.353-0.009-0.703-0.019-1.06-0.028 C176.687,62.923,177.078,62.934,177.377,62.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M180.311,82.719c-0.843-0.96-2.236-0.765-1.797,0.728 C179.169,84.085,179.986,83.804,180.311,82.719z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.719,110.505c0.292,0.681,1.483,1.159,1.835,0.277 C198.612,109.335,196.882,108.984,196.719,110.505z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M176.78,70.39c-0.562,0.371-0.562,0.371-0.926,0.931C176.525,73.443,179.278,70.334,176.78,70.39 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M205.572,75.903c-0.067-1.374-2.232-0.671-1.878,0.404 C204.089,77.215,205.44,76.715,205.572,75.903z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.423,114.201c-2.06,0.614-1.006,2.622,0.714,1.346 C179.912,115.075,180.094,114.45,179.423,114.201z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M208.05,96.859c-0.601-1.361-2.354-1.131-2.008,0.281c0.235,0.124,0.514,0.269,0.788,0.413 C207.273,97.336,207.809,97.355,208.05,96.859z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.113,130.022c0.527-0.029,0.528-0.717,0.894-0.999c0.601-0.842-0.745-0.879-1.3-0.935 c-0.277,0.2-0.371,0.499-0.486,0.879C178.788,129.195,178.614,129.828,179.113,130.022z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.976,69.551c0.236-1.111-1.38-1.923-1.963-0.75 C192.268,69.625,193.279,70.307,193.976,69.551z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M193.684,114.385c-0.234-0.067-0.443-0.128-0.733-0.211c-1.404,1.42-0.154,2.524,1.252,1.182 C194.02,115.015,193.848,114.692,193.684,114.385z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M182.467,75.735c-0.103-0.28-0.199-0.537-0.298-0.807c-0.69-0.086-1.249,0.53-1.709,0.98 c0.09,0.686,0.663,0.792,1.089,1.079C181.815,76.465,182.059,76.129,182.467,75.735z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.286,79.983c-0.342-0.136-0.597,0.295-0.866,0.439c0.453,1.52,1.695,1.226,2.199-0.087 c-0.206-0.195-0.404-0.381-0.604-0.571C181.76,79.925,181.574,80.137,181.286,79.983z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M194.391,67.135c0.518,0.213,0.971,0.399,1.45,0.597 C197.249,66.016,194.887,64.909,194.391,67.135z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.535,130.117c-0.368,0.405-0.768,0.706-0.959,1.205c0.166,0.228,0.329,0.453,0.5,0.687 C182.712,132.315,182.785,130.814,181.535,130.117z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.91,125.23c0.528-0.553,0.24-1.079-0.05-1.633c-0.65,0.003-1.144,0.271-1.551,0.719 C187.786,125.342,187.82,125.361,188.91,125.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.576,91.328c-0.047,0.335-0.086,0.611-0.132,0.93c0.323,0.193,0.482,0.576,0.937,0.716 c0.366-0.398,0.685-0.758,1.053-1.183C202.984,91.204,202.222,90.892,201.576,91.328z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.1,94.795c0.049-0.352,0.081-0.692-0.081-1.103c-0.315-0.105-0.666-0.223-1.057-0.355 C193.843,94.604,194.588,95.547,196.1,94.795z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.973,81.219c0.767-0.966,0.109-1.312-0.606-1.913c-0.34,0.34-0.64,0.637-0.927,0.924 c0.08,0.258,0.144,0.467,0.222,0.72C195.088,81.037,195.539,81.13,195.973,81.219z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M177.513,75.098c-0.533,0.008-1.063-0.179-1.471,0.418 C176.029,77.713,178.629,76.537,177.513,75.098z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M195.535,121.095c-0.373,0.316-0.73,0.619-1.136,0.963c0.63,1.51,1.506,0.87,2.098-0.171 C196.155,121.647,195.962,121.265,195.535,121.095z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.948,65.624c-0.347,0.125-0.635,0.23-0.893,0.324c-0.087,0.256-0.157,0.464-0.252,0.747 C190.916,68.524,192.393,66.704,190.948,65.624z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M203.674,103.776c0.3,0.817,1.241,0.993,1.604,0.265c-0.24-0.357,0.26-0.551,0.199-0.847 C204.649,102.507,204.233,102.641,203.674,103.776z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.806,93.009c1.189-0.381,1.572-1.059,0.573-1.909c-0.759,0.091-0.962,0.658-1.319,1.239 C192.283,92.54,192.517,92.75,192.806,93.009z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.456,100.526c-0.305,0.522-0.611,1.006-0.089,1.636c0.235-0.107,0.426-0.195,0.59-0.27 c0.197,0.115,0.246,0.302,0.46,0.229C208.229,101.138,207.684,100.298,206.456,100.526z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M190.637,88.918c-2.09,0.671,0.637,2.903,1.176,0.661 C191.583,89.105,191.078,89.137,190.637,88.918z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M186.758,107.435c-1.08-0.361-2.342,0.729-1.068,1.465 C186.398,109.171,187.629,108.185,186.758,107.435z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.057,117.199c0.157,0.344,0.283,0.625,0.409,0.901c0.375,0.092,0.737-0.044,1.253-0.051 C201.105,116.652,199.813,115.842,199.057,117.199z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M184.601,106.262c-0.019-0.386-0.034-0.727-0.052-1.073c-1.046-0.743-1.412,0.186-1.432,1.163 C183.803,107.22,184.123,106.726,184.601,106.262z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.937,124.785c0.248-0.571-0.702-1.743-1.278-1.247c0.05,0.472-0.271,0.794-0.639,1.201 C178.479,125.312,179.401,125.246,179.937,124.785z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M175.558,69.264c-0.052-1.482-1.278-1.09-1.701-0.434v0.804 C174.391,70.078,175.288,69.981,175.558,69.264z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.681,112.1c-0.908,0.63,0.371,2.33,1.23,1.315 C186.718,112.308,187.231,111.563,185.681,112.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M198.385,92.499c0.061-0.19,0.127-0.395,0.196-0.607c-0.136-0.259-0.269-0.51-0.405-0.768 c-0.533-0.146-0.903-0.024-1.219,0.286c-0.135,0.498,0.07,0.912,0.256,1.294C197.677,92.882,197.997,92.614,198.385,92.499z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M207.017,69.808c-0.15-0.519-0.313-0.999-0.488-1.443c-0.187,0.25-0.364,0.487-0.529,0.706 C206.224,69.752,206.642,69.909,207.017,69.808z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M201.561,115.136c0.094,0.237,0.183,0.466,0.27,0.687c0.306,0.06,0.58,0.114,0.902,0.176 c0.186-0.33,0.366-0.647,0.565-1.001C202.888,114.031,201.712,114.191,201.561,115.136z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M206.629,114.423c-0.244,0.695-0.662,2.092,0.579,1.764c0.091-0.089,0.171-0.188,0.242-0.291 c0.037-0.452,0.075-0.91,0.111-1.375C207.385,114.359,207.094,114.291,206.629,114.423z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.363,113.447c0.927-0.117,1.005-0.155,1.363-0.686c-0.224-0.282-0.397-0.622-0.486-0.971 C199.149,111.657,198.501,112.652,199.363,113.447z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M204.032,131.125c0.448-0.181,0.822-0.374,1.132-0.577c-0.272,0-0.548,0-0.842,0 C204.22,130.753,204.124,130.943,204.032,131.125z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M188.899,114.182c-0.312-0.034-0.589-0.065-0.913-0.1c-0.092,0.398-0.176,0.756-0.216,0.926 c0.283,0.36,0.478,0.608,0.684,0.87C189.647,115.748,189.449,114.948,188.899,114.182z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M192.518,123.725c-0.468,1.182-0.063,2.134,1.17,1.084 C194.06,123.612,193.535,123.376,192.518,123.725z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M199.139,131.186c0.14,0.276,0.279,0.547,0.421,0.825c0.363,0,0.705,0,1.101,0 C201.566,130.578,199.302,129.943,199.139,131.186z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.711,79.093c0.303-0.427,0.981-1.075,0.457-1.565c-0.646-0.407-0.912,0.09-1.311,0.452v0.771 C174.091,79.134,174.35,79.474,174.711,79.093z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M207.059,106.824c0.982,0.018,0.526-1.052,0.531-1.709c-0.239,0.052-0.443,0.098-0.647,0.141 c-0.2,0.042-0.391-0.276-0.596-0.017c0.178,0.444,0.065,0.876-0.161,1.255C206.41,106.904,206.752,106.829,207.059,106.824z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M181.939,112.086c-0.655-0.22-0.945,0.334-1.389,0.527c0.239,0.973,0.981,1.632,1.168,0.608 c0.295-0.135,0.509-0.233,0.734-0.335C182.253,112.575,182.091,112.321,181.939,112.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.218,106.955c0.335-0.321,0.67-0.641,1.056-1.009c-0.38-1.428-1.315-0.292-1.922,0.291 C201.524,106.644,201.824,106.847,202.218,106.955z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M196.965,124.448c0.207,0.252,0.428,0.518,0.676,0.822 C199.855,124.515,197.46,122.272,196.965,124.448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M185.669,90.598c1.147-0.506,1.523-0.139,1.143-1.591c-0.132-0.068-0.272-0.141-0.485-0.252 c-0.215,0.147-0.413,0.284-0.583,0.415C186.052,89.776,184.827,90.13,185.669,90.598z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M179.911,120.191c0.074-0.85,0.074-0.85-0.349-1.289 C177.525,119.099,178.312,120.793,179.911,120.191z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M174.127,128.449c-0.28,0.518,0.172,0.89,0.089,1.37 C176.046,130.332,175.533,127.861,174.127,128.449z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M187.731,119.858c0.05,1.059,1.096,0.5,1.575,0.07 C189.171,118.543,188.307,119.021,187.731,119.858z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M173.232,63.769c0,18.286,0,36.573,0,54.859c0,5.031,0,10.062,0,15.093 c0,0.804,1.25,0.806,1.25,0c0-18.286,0-36.572,0-54.859c0-5.031,0-10.062,0-15.093 C174.482,62.964,173.232,62.963,173.232,63.769L173.232,63.769z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M146.01,62.645c0,0-0.92,17.39-1.84,17.65c-0.92,0.26-9.88,0.66-11.98,0 c-1.91-0.6,0.28-14.24,0.72-16.83c0.04-0.27,0.07-0.42,0.07-0.42c0.04-0.01,0.07-0.02,0.11-0.02c0.23-0.06,0.5-0.11,0.79-0.15 c3.51-0.52,11.12-0.27,12.04-0.23C145.98,62.645,146.01,62.645,146.01,62.645z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6DE"
    },
    d: "M202.095,84.016c-0.553-1.412-1.955-2.773-3.469-2.687l0.155,0.004 c-3.897-0.095-7.793-0.191-11.69-0.286c-1.182-0.029-2.42-0.046-3.473,0.491c-1.029,0.524-1.771,1.574-1.929,2.718 c-0.158,1.144,0.271,2.352,1.109,3.147c1.273,1.206,3.189,1.346,4.941,1.421c2.734,0.116,5.468,0.232,8.201,0.349 c1.771,0.075,3.721,0.094,5.087-1.035C202.197,87.171,202.648,85.428,202.095,84.016z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M386.518,48.701c-3.434-8.467-167.981-9.187-168.381,1.699 c-0.097,2.657-0.781,117.052,6.675,125.391c3.087,3.452,30.794,5.19,62.547,5.415c-2.543,8.198-9.887,14.788-18.371,16.251 c6.928,2.947,15.154,2.663,21.862-0.754c6.176-3.146,10.953-8.895,12.992-15.512c40.503-0.354,81.853-2.999,84.381-7.55 C393.13,164.813,389.951,57.168,386.518,48.701z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M387.058,48.386c-0.672-1.582-3.591-2.056-5.015-2.391c-3.771-0.888-7.653-1.341-11.499-1.754 c-12.355-1.326-24.809-1.822-37.224-2.177c-15.222-0.435-30.457-0.512-45.684-0.268c-13.905,0.222-27.827,0.666-41.692,1.781 c-5.167,0.415-10.335,0.92-15.46,1.706c-3.285,0.504-6.701,1.036-9.808,2.267c-1.467,0.581-3.097,1.359-3.17,3.12 c-0.11,2.653-0.042,5.326-0.048,7.981c-0.029,12.702,0.061,25.404,0.268,38.104c0.255,15.603,0.649,31.216,1.59,46.795 c0.38,6.291,0.835,12.588,1.603,18.845c0.478,3.893,0.897,8.04,2.302,11.733c0.433,1.139,0.951,2.156,2.045,2.78 c2.303,1.314,5.285,1.67,7.854,2.075c10.828,1.705,21.907,2.079,32.844,2.439c7.129,0.235,14.262,0.358,21.395,0.41 c-0.201-0.264-0.402-0.527-0.603-0.791c-2.574,8.058-9.601,14.304-17.934,15.815c-0.681,0.124-0.498,0.999,0,1.205 c7.188,2.985,15.589,2.689,22.511-0.904c6.272-3.256,10.988-9.088,13.112-15.798c-0.201,0.153-0.402,0.306-0.603,0.459 c13.935-0.125,27.873-0.485,41.79-1.232c10.458-0.561,20.977-1.216,31.337-2.81c2.981-0.459,6.056-0.938,8.902-1.975 c1.349-0.492,2.63-1.071,3.177-2.471c1.159-2.968,1.243-6.52,1.488-9.654c1.019-13.034,0.913-26.184,0.791-39.247 c-0.143-15.338-0.567-30.679-1.341-45.998c-0.303-5.988-0.653-11.977-1.168-17.952c-0.308-3.569-0.545-7.242-1.349-10.744 c-0.093-0.406-0.195-0.813-0.349-1.2c-0.294-0.738-1.503-0.416-1.205,0.332c1.007,2.529,1.074,5.625,1.345,8.295 c0.548,5.407,0.898,10.834,1.208,16.259c0.847,14.81,1.304,29.647,1.53,44.479c0.208,13.652,0.31,27.347-0.404,40.988 c-0.211,4.037-0.388,8.171-1.208,12.141c-0.199,0.962-0.363,2.096-1.025,2.655c-1.517,1.282-4.111,1.637-5.974,2.034 c-9.09,1.935-18.523,2.52-27.775,3.139c-13.17,0.881-26.37,1.332-39.567,1.573c-3.4,0.062-6.801,0.107-10.201,0.137 c-0.284,0.003-0.519,0.194-0.603,0.459c-2.03,6.413-6.549,11.943-12.537,15.051c-6.645,3.449-14.668,3.635-21.548,0.778 c0,0.402,0,0.804,0,1.205c8.761-1.588,16.109-8.24,18.807-16.688c0.125-0.392-0.211-0.788-0.603-0.791 c-13.414-0.099-26.85-0.382-40.232-1.361c-4.65-0.34-9.313-0.743-13.919-1.482c-2.372-0.381-5.416-0.661-7.486-2.012 c-0.834-0.544-1.192-1.571-1.527-2.588c-0.541-1.642-0.884-3.35-1.188-5.049c-0.937-5.242-1.417-10.569-1.841-15.872 c-1.186-14.848-1.642-29.757-1.981-44.645c-0.316-13.916-0.46-27.837-0.481-41.756c-0.006-4.134-0.003-8.269,0.024-12.403 c0.006-0.904,0.008-1.808,0.026-2.712c0.01-0.528-0.033-0.532,0.432-0.938c1.547-1.348,4.523-1.919,6.686-2.383 c4.26-0.914,8.603-1.444,12.932-1.897c12.786-1.339,25.664-1.868,38.51-2.215c15.042-0.406,30.095-0.457,45.14-0.199 c13.288,0.228,26.59,0.652,39.843,1.675c4.755,0.367,9.515,0.796,14.233,1.502c2.673,0.4,5.811,0.825,8.181,1.867 c0.331,0.146,0.671,0.307,0.96,0.528c0.072,0.055,0.232,0.206,0.305,0.378C386.292,49.754,387.369,49.118,387.058,48.386z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M233.878,57.95c-0.005-1.038-1.303,15.48,0.709,16.977c1.422,1.059,100.667,0.937,101.989-1.254 c1.321-2.191,0-15.724,0-15.724C295.124,57.523,250.939,56.934,233.878,57.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M235.607,61.658c-0.065-0.103-0.098-0.214-0.098-0.336c0-0.112,0.025-0.214,0.077-0.308 c0.051-0.093,0.121-0.168,0.21-0.224c0.089-0.056,0.189-0.084,0.301-0.084c0.103,0,0.205,0.031,0.308,0.091 c0.103,0.061,0.187,0.142,0.252,0.245c0.708,1.017,1.364,1.945,1.965,2.784c0.602,0.839,1.159,1.609,1.672,2.308 c0.513,0.7,0.996,1.353,1.448,1.959c0.453,0.606,0.889,1.189,1.308,1.748c0-0.7,0.007-1.375,0.021-2.028 c0.014-0.653,0.033-1.299,0.056-1.938c0.023-0.639,0.054-1.289,0.091-1.952c0.037-0.662,0.075-1.348,0.112-2.056 c0.018-0.196,0.091-0.343,0.217-0.441c0.125-0.098,0.272-0.147,0.44-0.147c0.103,0,0.203,0.021,0.301,0.063 c0.098,0.042,0.177,0.107,0.238,0.196c0.061,0.089,0.087,0.198,0.077,0.329c-0.047,0.755-0.086,1.455-0.119,2.098 c-0.033,0.644-0.061,1.259-0.084,1.847c-0.023,0.588-0.044,1.175-0.063,1.763c-0.019,0.588-0.033,1.199-0.042,1.833 c-0.009,0.634-0.019,1.324-0.028,2.07c0,0.112-0.023,0.208-0.07,0.287c-0.047,0.079-0.107,0.142-0.182,0.188 c-0.075,0.047-0.149,0.082-0.224,0.105c-0.075,0.023-0.14,0.035-0.196,0.035c-0.056,0-0.114-0.007-0.175-0.021 c-0.061-0.014-0.117-0.037-0.168-0.07c-0.051-0.033-0.101-0.077-0.147-0.133c-0.858-1.091-1.711-2.201-2.56-3.33 c-0.849-1.128-1.686-2.269-2.511-3.42C237.208,63.968,236.399,62.814,235.607,61.658z M235.984,61.853 c0-0.214,0.066-0.368,0.196-0.462c0.131-0.093,0.27-0.14,0.42-0.14c0.177,0,0.331,0.047,0.462,0.14 c0.131,0.094,0.196,0.248,0.196,0.462c0.019,1.623,0.035,3.255,0.049,4.897c0.014,1.642,0.025,3.278,0.035,4.911 c0.009,0.196-0.051,0.34-0.182,0.434c-0.131,0.093-0.285,0.14-0.462,0.14c-0.093,0-0.188-0.021-0.287-0.063 c-0.098-0.042-0.177-0.107-0.238-0.196c-0.061-0.088-0.096-0.198-0.105-0.329c-0.009-1.082-0.018-2.168-0.028-3.26 c-0.009-1.091-0.019-2.182-0.028-3.273C236.003,64.022,235.993,62.935,235.984,61.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M247.148,71.646c0.009-0.373,0.021-0.828,0.035-1.364c0.014-0.537,0.028-1.12,0.042-1.749 c0.014-0.629,0.028-1.268,0.042-1.917c0.014-0.648,0.028-1.273,0.042-1.875c0.014-0.602,0.023-1.144,0.028-1.629 c0.004-0.485,0.007-0.872,0.007-1.162c0-0.196,0.042-0.35,0.126-0.461c0.084-0.112,0.247-0.168,0.49-0.168 c0.942,0,1.814-0.004,2.616-0.014c0.802-0.009,1.585-0.014,2.35-0.014c0.243,0,0.418,0.051,0.525,0.154 c0.107,0.102,0.16,0.247,0.16,0.434c0,0.187-0.054,0.336-0.16,0.448c-0.107,0.112-0.282,0.168-0.525,0.168 c-0.709,0-1.425,0.002-2.147,0.007c-0.723,0.005-1.443,0.012-2.162,0.021l-0.07,3.4c0.448-0.038,0.854-0.061,1.217-0.07 c0.364-0.009,0.725-0.014,1.084-0.014c0.359,0,0.753,0.009,1.183,0.028c0.185,0,0.328,0.063,0.426,0.189 c0.099,0.126,0.147,0.268,0.147,0.427s-0.049,0.296-0.147,0.413c-0.098,0.117-0.24,0.175-0.426,0.175 c-0.42-0.019-0.814-0.028-1.183-0.028c-0.368,0-0.739,0.005-1.112,0.014c-0.374,0.01-0.779,0.033-1.217,0.07l-0.084,3.875 c0.662-0.046,1.327-0.07,1.994-0.07c0.667,0,1.327,0.009,1.979,0.028c0.205,0,0.354,0.059,0.448,0.175 c0.093,0.117,0.14,0.254,0.14,0.413c0,0.149-0.047,0.289-0.14,0.419c-0.094,0.13-0.243,0.196-0.448,0.196 c-0.746-0.019-1.473-0.028-2.182-0.028c-0.708,0-1.501,0.037-2.378,0.112c-0.131,0.009-0.25-0.007-0.357-0.049 c-0.107-0.042-0.191-0.109-0.252-0.203C247.178,71.903,247.148,71.786,247.148,71.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M255.024,62.175c-0.009-0.028-0.017-0.056-0.021-0.084c-0.005-0.028-0.007-0.056-0.007-0.084 c0-0.112,0.029-0.212,0.091-0.301c0.061-0.088,0.142-0.159,0.244-0.21c0.102-0.051,0.21-0.077,0.322-0.077 c0.131,0,0.254,0.037,0.371,0.112c0.116,0.075,0.193,0.191,0.23,0.35c0.214,0.793,0.436,1.635,0.664,2.525 c0.229,0.891,0.46,1.793,0.693,2.707c0.233,0.914,0.452,1.814,0.657,2.7c0.718-2.117,1.298-3.84,1.741-5.169 c0.443-1.329,0.781-2.306,1.015-2.931c0.074-0.177,0.163-0.301,0.266-0.371c0.103-0.07,0.219-0.105,0.35-0.105 c0.158,0,0.287,0.04,0.385,0.119c0.098,0.079,0.175,0.198,0.23,0.356c0.149,0.411,0.329,0.968,0.539,1.672 c0.21,0.705,0.469,1.583,0.776,2.637c0.308,1.054,0.667,2.304,1.077,3.749c0.28-1.007,0.553-1.956,0.818-2.847 c0.266-0.891,0.534-1.765,0.805-2.623c0.271-0.858,0.541-1.73,0.811-2.616c0.047-0.149,0.123-0.261,0.23-0.336 c0.107-0.074,0.235-0.112,0.385-0.112c0.14,0,0.259,0.024,0.357,0.07c0.098,0.047,0.172,0.11,0.224,0.189 c0.051,0.08,0.072,0.166,0.063,0.259c0,0.047-0.005,0.096-0.014,0.147c-0.01,0.051-0.019,0.091-0.028,0.119 c-0.392,1.203-0.743,2.306-1.056,3.309c-0.313,1.002-0.591,1.898-0.833,2.686c-0.242,0.788-0.452,1.467-0.629,2.036 c-0.178,0.569-0.327,1.021-0.448,1.357c-0.065,0.205-0.133,0.364-0.203,0.476c-0.069,0.112-0.145,0.187-0.224,0.224 s-0.17,0.056-0.272,0.056c-0.168,0-0.306-0.054-0.413-0.161c-0.107-0.107-0.212-0.319-0.314-0.637 c-0.131-0.41-0.306-0.975-0.525-1.693c-0.22-0.718-0.475-1.592-0.77-2.623c-0.294-1.03-0.632-2.217-1.015-3.56 c-0.103,0.327-0.208,0.66-0.315,1c-0.107,0.34-0.231,0.72-0.371,1.14c-0.14,0.419-0.306,0.912-0.496,1.476 c-0.191,0.564-0.42,1.229-0.686,1.994c-0.267,0.765-0.581,1.665-0.945,2.7c-0.046,0.159-0.123,0.28-0.23,0.364 c-0.107,0.084-0.24,0.126-0.399,0.126c-0.14,0-0.268-0.045-0.385-0.133c-0.116-0.088-0.193-0.208-0.23-0.357 c-0.271-1.026-0.548-2.085-0.833-3.176c-0.284-1.091-0.568-2.185-0.853-3.28C255.572,64.248,255.295,63.192,255.024,62.175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M275.099,62.119c0.018-0.233,0.107-0.413,0.266-0.539c0.159-0.126,0.346-0.189,0.56-0.189h4.743 c0.224,0,0.385,0.052,0.482,0.154c0.098,0.103,0.147,0.247,0.147,0.434c0,0.186-0.047,0.335-0.141,0.448 c-0.093,0.112-0.252,0.167-0.476,0.167h-4.365c-0.046,0.653-0.093,1.243-0.14,1.77c-0.047,0.527-0.084,1.052-0.111,1.574 c0.728-0.056,1.45-0.084,2.168-0.084c0.215,0,0.429,0,0.644,0c0.215,0,0.429,0.01,0.644,0.028 c0.186,0.009,0.329,0.07,0.427,0.182c0.098,0.112,0.151,0.252,0.161,0.42c0.009,0.177-0.047,0.324-0.168,0.44 c-0.121,0.117-0.262,0.17-0.42,0.161c-0.215-0.009-0.429-0.016-0.644-0.021c-0.215-0.005-0.429-0.007-0.644-0.007 c-0.373,0-0.744,0.007-1.112,0.021c-0.368,0.014-0.739,0.04-1.112,0.077c-0.018,0.532-0.035,1.098-0.049,1.7 s-0.021,1.28-0.021,2.036c0.792-0.046,1.546-0.07,2.259-0.07c0.714,0,1.435,0.009,2.162,0.028 c0.186,0.009,0.333,0.061,0.44,0.154c0.108,0.093,0.161,0.233,0.161,0.42c0,0.205-0.059,0.364-0.175,0.476 c-0.117,0.112-0.282,0.163-0.497,0.154c-0.531-0.028-1.091-0.042-1.679-0.042s-1.166,0.005-1.734,0.014 c-0.569,0.009-1.092,0.028-1.567,0.056c-0.112,0-0.217-0.028-0.314-0.084c-0.099-0.056-0.178-0.133-0.238-0.23 c-0.061-0.098-0.091-0.203-0.091-0.315c0-1.268,0.017-2.434,0.049-3.498c0.033-1.063,0.082-2.07,0.148-3.022 C274.926,63.98,275.007,63.042,275.099,62.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M284.501,71.786c-0.01,0.196-0.075,0.34-0.196,0.434c-0.121,0.093-0.266,0.14-0.434,0.14 c-0.103,0-0.205-0.021-0.308-0.063c-0.102-0.042-0.186-0.107-0.252-0.196c-0.065-0.088-0.094-0.198-0.084-0.329 c0.065-0.858,0.121-1.744,0.168-2.658c0.047-0.914,0.081-1.812,0.104-2.693c0.023-0.881,0.037-1.707,0.042-2.477 c0.005-0.77-0.002-1.438-0.021-2.007c-0.01-0.168,0.051-0.315,0.182-0.441c0.131-0.126,0.28-0.189,0.448-0.189 c0.121,0,0.235,0.028,0.343,0.084c0.106,0.056,0.188,0.135,0.244,0.238c0.242,0.374,0.536,0.816,0.882,1.329 c0.345,0.513,0.718,1.063,1.119,1.651c0.4,0.588,0.807,1.185,1.217,1.791c0.41,0.606,0.807,1.198,1.19,1.776 c0.382,0.579,0.718,1.11,1.007,1.595c0.01-0.588,0.028-1.224,0.057-1.91c0.027-0.686,0.063-1.383,0.104-2.092 c0.042-0.709,0.086-1.396,0.133-2.063c0.047-0.667,0.094-1.28,0.14-1.839c0.01-0.177,0.07-0.32,0.183-0.427 c0.111-0.107,0.256-0.166,0.434-0.175c0.177-0.009,0.333,0.049,0.469,0.175c0.135,0.126,0.198,0.277,0.189,0.455 c-0.047,0.438-0.091,0.963-0.133,1.574c-0.042,0.611-0.084,1.273-0.126,1.987c-0.042,0.713-0.082,1.443-0.119,2.189 c-0.037,0.746-0.067,1.478-0.091,2.196c-0.023,0.718-0.04,1.39-0.049,2.015c0,0.121-0.033,0.229-0.098,0.322 c-0.065,0.093-0.148,0.163-0.245,0.21c-0.098,0.046-0.203,0.07-0.314,0.07c-0.121,0-0.231-0.026-0.329-0.077 c-0.098-0.051-0.18-0.133-0.245-0.245c-0.41-0.718-0.83-1.418-1.259-2.099c-0.429-0.681-0.862-1.357-1.301-2.028 c-0.438-0.672-0.887-1.345-1.344-2.022c-0.457-0.676-0.923-1.364-1.398-2.063c0.009,1.371-0.014,2.705-0.07,4.001 C284.682,69.221,284.603,70.509,284.501,71.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M294.084,62.525c-0.196,0-0.341-0.058-0.434-0.175c-0.094-0.117-0.141-0.259-0.141-0.427 c0-0.158,0.047-0.301,0.141-0.427c0.093-0.126,0.237-0.189,0.434-0.189c1.222-0.019,2.45-0.032,3.687-0.042 c1.235-0.009,2.464-0.019,3.685-0.028c0.178-0.009,0.315,0.049,0.413,0.175c0.098,0.126,0.147,0.273,0.147,0.441 c0,0.261-0.099,0.434-0.294,0.518c-0.196,0.084-0.43,0.121-0.7,0.112c-0.251-0.009-0.59-0.014-1.014-0.014 c-0.425,0-0.898,0.002-1.42,0.007c-0.522,0.005-1.057,0.009-1.603,0.014c-0.545,0.004-1.07,0.012-1.573,0.021 C294.909,62.52,294.465,62.525,294.084,62.525z M296.923,62.161c0.018-0.196,0.093-0.34,0.224-0.434 c0.131-0.093,0.275-0.14,0.434-0.14c0.159,0,0.306,0.047,0.44,0.14c0.136,0.093,0.194,0.238,0.176,0.434 c-0.094,1.157-0.166,2.325-0.217,3.504c-0.052,1.18-0.077,2.367-0.077,3.561c0,0.401,0.002,0.802,0.007,1.203 c0.005,0.401,0.012,0.798,0.021,1.189c0.019,0.177-0.039,0.319-0.175,0.427c-0.135,0.107-0.286,0.166-0.454,0.175 c-0.178,0.009-0.327-0.049-0.448-0.175c-0.121-0.126-0.187-0.268-0.195-0.427c-0.01-0.392-0.017-0.788-0.022-1.189 c-0.005-0.401-0.007-0.802-0.007-1.203c0-1.193,0.025-2.38,0.077-3.561C296.757,64.486,296.83,63.318,296.923,62.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M303.932,62.077c0-0.121,0.03-0.226,0.091-0.314c0.06-0.089,0.14-0.156,0.238-0.203 c0.098-0.046,0.197-0.07,0.301-0.07c0.074,0,0.151,0.014,0.23,0.042c0.079,0.028,0.146,0.07,0.203,0.126 c0.064,0.056,0.114,0.133,0.146,0.231c0.032,0.098,0.049,0.212,0.049,0.342c0,0.224-0.019,0.462-0.056,0.714 c-0.037,0.251-0.075,0.494-0.112,0.728c-0.037,0.233-0.056,0.429-0.056,0.587c-0.084,0.802-0.158,1.604-0.224,2.406 c-0.065,0.802-0.121,1.614-0.168,2.435c-0.047,0.821-0.089,1.66-0.126,2.518c-0.01,0.205-0.079,0.354-0.21,0.448 c-0.131,0.093-0.289,0.14-0.476,0.14c-0.149,0-0.289-0.047-0.42-0.14c-0.131-0.093-0.191-0.243-0.182-0.448 c0.065-1.632,0.163-3.241,0.294-4.827C303.587,65.206,303.746,63.635,303.932,62.077z M304.799,62.693 c-0.233,0.038-0.408-0.012-0.525-0.147c-0.117-0.135-0.175-0.287-0.175-0.455c0-0.075,0.014-0.149,0.042-0.224 c0.027-0.075,0.074-0.142,0.14-0.203c0.065-0.061,0.145-0.1,0.238-0.119c0.298-0.047,0.603-0.084,0.916-0.112 c0.313-0.028,0.627-0.042,0.944-0.042c0.484,0,0.973,0.047,1.462,0.14c0.489,0.093,0.94,0.243,1.35,0.448 c0.411,0.205,0.739,0.476,0.986,0.811c0.247,0.336,0.366,0.751,0.357,1.245c-0.01,0.597-0.154,1.119-0.434,1.567 c-0.28,0.447-0.65,0.823-1.112,1.126c-0.462,0.303-0.978,0.541-1.546,0.713c-0.569,0.173-1.143,0.282-1.721,0.329 c0.811,0.653,1.548,1.287,2.21,1.902c0.662,0.616,1.334,1.278,2.015,1.987c0.056,0.056,0.098,0.119,0.126,0.189 c0.028,0.07,0.042,0.142,0.042,0.217c0,0.112-0.028,0.217-0.084,0.314c-0.056,0.098-0.133,0.177-0.23,0.238 c-0.099,0.061-0.208,0.091-0.329,0.091c-0.112,0-0.22-0.038-0.321-0.112c-0.104-0.075-0.267-0.224-0.49-0.447 c-0.447-0.466-0.946-0.963-1.497-1.49c-0.55-0.527-1.107-1.042-1.672-1.546c-0.564-0.503-1.103-0.951-1.615-1.343l0.321-0.979 c0.877-0.009,1.635-0.091,2.273-0.245c0.639-0.154,1.163-0.357,1.574-0.609c0.41-0.252,0.716-0.539,0.916-0.86 c0.2-0.322,0.301-0.655,0.301-1c0-0.308-0.128-0.574-0.385-0.798c-0.257-0.224-0.613-0.396-1.07-0.518 c-0.457-0.121-0.979-0.182-1.566-0.182c-0.131,0-0.282,0.005-0.455,0.014c-0.173,0.01-0.345,0.021-0.518,0.035 C305.095,62.644,304.939,62.665,304.799,62.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M312.858,61.643c0.019-0.186,0.089-0.331,0.21-0.434c0.121-0.103,0.266-0.154,0.434-0.154 c0.205,0,0.361,0.07,0.469,0.21c0.106,0.14,0.151,0.345,0.133,0.615c-0.028,0.392-0.059,0.865-0.091,1.42 c-0.033,0.555-0.063,1.136-0.091,1.742c-0.028,0.606-0.05,1.196-0.063,1.77c-0.014,0.574-0.021,1.08-0.021,1.518 c0,0.56,0.009,1.117,0.027,1.672c0.018,0.555,0.042,1.107,0.07,1.658c0.009,0.196-0.054,0.34-0.188,0.434 c-0.136,0.093-0.282,0.14-0.441,0.14c-0.149,0-0.294-0.047-0.434-0.14c-0.14-0.093-0.21-0.238-0.21-0.434 c-0.027-0.55-0.049-1.103-0.063-1.658c-0.014-0.555-0.022-1.107-0.022-1.658c0-0.438,0.008-0.951,0.022-1.539 c0.014-0.588,0.035-1.196,0.063-1.826c0.028-0.63,0.059-1.236,0.091-1.819C312.786,62.578,312.821,62.073,312.858,61.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M317.391,61.643c0.018-0.196,0.086-0.34,0.202-0.434c0.117-0.093,0.254-0.14,0.413-0.14 c0.112,0,0.212,0.019,0.301,0.056c0.089,0.038,0.156,0.079,0.203,0.126c0.242-0.066,0.553-0.109,0.93-0.133 c0.378-0.023,0.734-0.035,1.07-0.035c0.578,0,1.085,0.012,1.519,0.035c0.434,0.023,0.753,0.049,0.958,0.077 c0.279,0.038,0.464,0.11,0.553,0.217c0.088,0.107,0.133,0.236,0.133,0.385c0,0.177-0.054,0.329-0.161,0.455 c-0.107,0.126-0.282,0.18-0.524,0.161c-0.168-0.018-0.383-0.037-0.644-0.056c-0.262-0.019-0.522-0.035-0.783-0.049 c-0.262-0.014-0.485-0.021-0.672-0.021c-0.373,0-0.753,0.009-1.14,0.028c-0.388,0.019-0.777,0.052-1.169,0.098l-0.294,3.399 c0.233-0.019,0.518-0.032,0.853-0.042c0.336-0.009,0.69-0.014,1.064-0.014c0.373,0,0.728,0.007,1.064,0.021 c0.336,0.014,0.615,0.044,0.839,0.091c0.215,0.037,0.371,0.107,0.469,0.21c0.099,0.103,0.147,0.229,0.147,0.378 c0,0.159-0.054,0.306-0.161,0.441c-0.107,0.135-0.254,0.194-0.44,0.175c-0.625-0.075-1.287-0.117-1.987-0.126 c-0.699-0.009-1.343,0.009-1.93,0.056c-0.057,0.671-0.107,1.348-0.154,2.028c-0.047,0.681-0.094,1.353-0.14,2.015 c0.447-0.046,0.953-0.081,1.518-0.105c0.565-0.023,1.124-0.04,1.679-0.049c0.555-0.009,1.042,0,1.462,0.028 c0.196,0,0.341,0.061,0.434,0.182c0.094,0.121,0.141,0.261,0.141,0.419c0,0.149-0.047,0.291-0.141,0.427 c-0.093,0.135-0.242,0.198-0.447,0.189c-0.793-0.038-1.481-0.051-2.064-0.042c-0.583,0.009-1.105,0.03-1.567,0.063 c-0.461,0.033-0.907,0.077-1.336,0.133c-0.177,0.019-0.345,0.014-0.504-0.014c-0.158-0.028-0.282-0.098-0.37-0.21 c-0.089-0.112-0.129-0.28-0.119-0.504c0.103-1.651,0.222-3.304,0.356-4.959C317.086,64.948,317.232,63.294,317.391,61.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M331.801,62.217c0.056,0.056,0.1,0.119,0.133,0.189c0.032,0.07,0.049,0.151,0.049,0.245 c0,0.112-0.027,0.215-0.084,0.308c-0.056,0.094-0.131,0.168-0.224,0.224c-0.094,0.056-0.2,0.084-0.321,0.084 c-0.084,0-0.185-0.033-0.301-0.098c-0.117-0.065-0.259-0.145-0.427-0.238c-0.28-0.159-0.567-0.275-0.86-0.35 c-0.294-0.075-0.651-0.112-1.07-0.112c-0.475,0-0.873,0.065-1.189,0.196c-0.317,0.13-0.555,0.303-0.714,0.517 c-0.158,0.214-0.237,0.448-0.237,0.699c0,0.308,0.114,0.579,0.343,0.812c0.228,0.233,0.521,0.446,0.881,0.637 c0.359,0.191,0.734,0.385,1.127,0.581c0.727,0.345,1.316,0.695,1.77,1.049c0.452,0.354,0.783,0.737,0.993,1.147 c0.21,0.411,0.314,0.877,0.314,1.399c0,0.401-0.082,0.774-0.245,1.12c-0.163,0.345-0.396,0.648-0.699,0.909 s-0.66,0.464-1.07,0.608c-0.41,0.145-0.862,0.217-1.356,0.217c-0.336,0-0.709-0.044-1.119-0.133 c-0.411-0.089-0.793-0.205-1.147-0.35c-0.354-0.145-0.635-0.291-0.84-0.441c-0.261-0.224-0.392-0.443-0.392-0.657 c0-0.112,0.025-0.214,0.077-0.308c0.051-0.093,0.121-0.168,0.21-0.224c0.089-0.056,0.18-0.084,0.272-0.084 c0.075,0,0.161,0.023,0.259,0.07c0.099,0.047,0.208,0.107,0.329,0.182c0.261,0.149,0.58,0.308,0.958,0.476 c0.378,0.168,0.837,0.252,1.378,0.252c0.392,0,0.744-0.072,1.057-0.217s0.562-0.338,0.748-0.581 c0.186-0.243,0.28-0.513,0.28-0.812c0-0.327-0.089-0.637-0.266-0.931c-0.178-0.293-0.436-0.571-0.776-0.832 c-0.341-0.261-0.768-0.499-1.28-0.714c-0.346-0.158-0.7-0.326-1.064-0.503c-0.363-0.177-0.699-0.385-1.007-0.622 c-0.309-0.238-0.556-0.527-0.742-0.868c-0.186-0.34-0.279-0.748-0.279-1.224c0-0.513,0.148-0.96,0.447-1.343 c0.299-0.382,0.711-0.683,1.238-0.902c0.526-0.219,1.141-0.329,1.84-0.329c0.578,0,1.133,0.083,1.665,0.251 C330.99,61.685,331.437,61.919,331.801,62.217z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M233.766,84.148c-0.003-1.038-0.953,15.48,0.518,16.977c1.04,1.059,73.646,0.937,74.613-1.254 c0.967-2.191,0-15.724,0-15.724C278.573,83.721,246.247,83.132,233.766,84.148z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M346.872,83.959c0,0-0.277,15.498,0.241,15.724c0.518,0.226,23.961,0.456,26.286,0 c0.888-0.174,0-15.724,0-15.724C362.693,83.531,361.533,83.396,346.872,83.959z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M233.598,109.247c0,0,0,32.271,2.301,35.034c1.563,1.876,137.544,1.085,138.912-1.27 c1.347-2.318-1.017-36.387-1.017-36.387L233.598,109.247z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8380FF"
    },
    d: "M317.061,151.701c0,0.782,0.558,15.63,2.645,17.596c2.086,1.967,53.786,0.449,55.319-1.236 c1.533-1.685,2.443-17.583,0-18.63C373.064,148.59,317.061,148.9,317.061,151.701z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M335.789,155.082c0.121,0.131,0.182,0.271,0.182,0.42c0,0.112-0.03,0.219-0.091,0.322 c-0.061,0.103-0.141,0.184-0.238,0.245c-0.098,0.06-0.203,0.091-0.315,0.091c-0.075,0-0.152-0.023-0.231-0.07 c-0.079-0.046-0.184-0.13-0.315-0.252c-0.195-0.214-0.469-0.392-0.818-0.532c-0.35-0.14-0.758-0.21-1.224-0.21 c-0.43,0-0.814,0.067-1.154,0.203c-0.341,0.135-0.609,0.322-0.805,0.559c-0.196,0.238-0.294,0.516-0.294,0.833 c0,0.187,0.049,0.366,0.146,0.539c0.099,0.173,0.28,0.345,0.546,0.518c0.266,0.173,0.65,0.357,1.154,0.553 c0.672,0.252,1.257,0.537,1.756,0.854c0.499,0.317,0.884,0.695,1.154,1.133c0.27,0.439,0.405,0.975,0.405,1.609 c0,0.541-0.123,1.047-0.37,1.518c-0.247,0.471-0.642,0.851-1.183,1.14c-0.541,0.289-1.245,0.434-2.112,0.434 c-0.252,0-0.548-0.035-0.889-0.105c-0.341-0.07-0.671-0.168-0.993-0.294c-0.321-0.126-0.588-0.285-0.797-0.476 c-0.21-0.191-0.315-0.403-0.315-0.637c0-0.13,0.025-0.24,0.077-0.329c0.051-0.089,0.121-0.159,0.21-0.21 c0.089-0.051,0.18-0.077,0.272-0.077c0.103,0,0.203,0.028,0.301,0.084c0.099,0.056,0.208,0.135,0.329,0.238 c0.195,0.168,0.45,0.31,0.763,0.427c0.313,0.117,0.641,0.175,0.986,0.175c0.82,0,1.432-0.158,1.832-0.476 c0.401-0.317,0.602-0.774,0.602-1.371c0-0.447-0.107-0.818-0.321-1.112c-0.215-0.294-0.499-0.541-0.854-0.742 s-0.751-0.385-1.189-0.553c-0.363-0.14-0.713-0.293-1.049-0.461c-0.336-0.168-0.639-0.361-0.909-0.581 c-0.271-0.219-0.483-0.474-0.637-0.763c-0.154-0.289-0.232-0.629-0.232-1.021c0-0.457,0.105-0.86,0.315-1.21 c0.21-0.35,0.489-0.646,0.839-0.888c0.35-0.243,0.739-0.424,1.169-0.546c0.429-0.121,0.857-0.182,1.287-0.182 c0.382,0,0.755,0.045,1.119,0.133c0.363,0.089,0.708,0.222,1.035,0.399C335.261,154.588,335.546,154.811,335.789,155.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M338.406,164.847c-0.065,0.14-0.152,0.233-0.26,0.28c-0.106,0.046-0.222,0.07-0.343,0.07 c-0.121,0-0.23-0.028-0.328-0.084c-0.098-0.056-0.178-0.128-0.238-0.217c-0.061-0.089-0.091-0.184-0.091-0.287 c0-0.046,0.01-0.096,0.028-0.147c0.018-0.051,0.037-0.1,0.056-0.147c0.186-0.41,0.41-0.919,0.672-1.525 c0.261-0.606,0.543-1.259,0.846-1.959c0.304-0.7,0.605-1.401,0.903-2.105c0.298-0.704,0.58-1.364,0.846-1.979 c0.266-0.616,0.49-1.143,0.672-1.581c0.182-0.438,0.306-0.732,0.371-0.881c0.074-0.159,0.162-0.275,0.266-0.35 c0.103-0.075,0.228-0.112,0.377-0.112c0.233,0,0.406,0.091,0.518,0.273c0.111,0.182,0.205,0.39,0.279,0.623 c0.345,0.989,0.732,2.024,1.161,3.106c0.429,1.082,0.902,2.164,1.42,3.246c0.518,1.082,1.07,2.127,1.658,3.134 c0.018,0.038,0.035,0.082,0.049,0.133c0.014,0.051,0.021,0.1,0.021,0.147c0,0.168-0.063,0.31-0.189,0.427 c-0.126,0.117-0.277,0.175-0.455,0.175c-0.121,0-0.235-0.028-0.343-0.084c-0.107-0.056-0.193-0.135-0.259-0.238 c-0.326-0.578-0.662-1.215-1.007-1.91c-0.345-0.695-0.688-1.427-1.028-2.196c-0.341-0.77-0.669-1.558-0.986-2.364 c-0.317-0.807-0.615-1.616-0.896-2.428c-0.289,0.747-0.587,1.499-0.896,2.26c-0.308,0.76-0.615,1.518-0.923,2.273 c-0.308,0.755-0.62,1.504-0.938,2.245C339.053,163.385,338.732,164.12,338.406,164.847z M340.392,161.448 c-0.102,0-0.203-0.028-0.301-0.084c-0.099-0.056-0.178-0.133-0.238-0.231c-0.061-0.098-0.091-0.203-0.091-0.315 c0-0.168,0.074-0.298,0.224-0.392c0.149-0.093,0.357-0.159,0.623-0.196c0.266-0.037,0.561-0.056,0.889-0.056 c0.392,0,0.778,0.012,1.161,0.035c0.382,0.023,0.732,0.051,1.049,0.084c0.317,0.033,0.564,0.063,0.741,0.091 c0.196,0.028,0.343,0.086,0.441,0.175c0.098,0.089,0.147,0.212,0.147,0.371c0,0.178-0.052,0.332-0.154,0.462 c-0.103,0.131-0.247,0.186-0.434,0.168c-0.484-0.056-0.939-0.098-1.363-0.126c-0.425-0.028-0.857-0.042-1.295-0.042 c-0.232,0-0.466,0.005-0.699,0.014C340.858,161.415,340.625,161.429,340.392,161.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M347.877,154.816c-0.057-0.159-0.057-0.296,0-0.413c0.056-0.116,0.145-0.207,0.266-0.272 s0.252-0.098,0.392-0.098c0.131,0,0.242,0.03,0.336,0.091c0.093,0.061,0.172,0.17,0.237,0.329 c0.28,0.699,0.541,1.387,0.784,2.063c0.242,0.676,0.471,1.35,0.685,2.021c0.214,0.671,0.417,1.348,0.608,2.029 c0.19,0.681,0.37,1.38,0.538,2.098c0.401-1.016,0.81-2.005,1.225-2.966c0.415-0.96,0.842-1.905,1.28-2.833 c0.438-0.928,0.886-1.849,1.343-2.763c0.065-0.112,0.142-0.193,0.23-0.245c0.089-0.051,0.185-0.077,0.287-0.077 c0.149,0,0.284,0.04,0.405,0.119c0.121,0.079,0.208,0.187,0.259,0.322c0.052,0.135,0.035,0.282-0.049,0.44 c-0.447,0.877-0.893,1.784-1.336,2.721c-0.443,0.938-0.865,1.854-1.266,2.749c-0.401,0.896-0.768,1.733-1.099,2.511 c-0.331,0.779-0.604,1.443-0.818,1.994c-0.037,0.122-0.112,0.229-0.224,0.322c-0.112,0.093-0.243,0.14-0.392,0.14 c-0.15,0.009-0.285-0.033-0.406-0.126c-0.121-0.093-0.195-0.21-0.224-0.35c-0.205-0.886-0.415-1.73-0.63-2.532 c-0.214-0.802-0.442-1.593-0.686-2.371c-0.242-0.779-0.506-1.569-0.79-2.371C348.55,156.546,348.231,155.702,347.877,154.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M358.999,165.015c-0.103,0-0.222-0.009-0.357-0.028c-0.136-0.019-0.252-0.07-0.351-0.154 c-0.098-0.084-0.146-0.219-0.146-0.406c0.084-1.044,0.161-2.105,0.23-3.183c0.07-1.077,0.136-2.154,0.196-3.232 c0.061-1.078,0.114-2.138,0.161-3.183c0.019-0.224,0.077-0.398,0.175-0.524c0.098-0.126,0.267-0.193,0.511-0.203 c0.484-0.037,0.983-0.067,1.497-0.091c0.513-0.023,1.054-0.042,1.622-0.056c0.569-0.014,1.176-0.021,1.819-0.021 c0.232,0,0.398,0.054,0.496,0.161c0.099,0.107,0.147,0.245,0.147,0.413c0,0.187-0.049,0.338-0.147,0.455 c-0.098,0.117-0.264,0.175-0.496,0.175c-0.448,0-0.865,0.002-1.252,0.007c-0.388,0.005-0.756,0.014-1.105,0.028 c-0.35,0.014-0.688,0.028-1.015,0.042c-0.326,0.014-0.657,0.035-0.993,0.063c-0.018,0.364-0.037,0.742-0.056,1.133 c-0.02,0.392-0.038,0.781-0.057,1.168c-0.018,0.387-0.042,0.763-0.069,1.126c0.41-0.056,0.851-0.098,1.322-0.126 c0.471-0.028,0.925-0.046,1.363-0.056c0.439-0.009,0.803-0.004,1.092,0.014c0.158,0,0.294,0.054,0.405,0.161 c0.112,0.107,0.173,0.25,0.182,0.427c0.01,0.187-0.049,0.336-0.175,0.448c-0.126,0.112-0.264,0.168-0.412,0.168 c-0.233-0.018-0.563-0.025-0.986-0.021c-0.425,0.005-0.887,0.023-1.385,0.056c-0.499,0.033-0.991,0.081-1.477,0.147 c-0.037,0.634-0.079,1.275-0.126,1.923c-0.047,0.649-0.093,1.285-0.14,1.91c0.326-0.019,0.688-0.042,1.084-0.07 c0.396-0.028,0.81-0.054,1.238-0.077c0.429-0.023,0.844-0.044,1.245-0.063c0.401-0.018,0.76-0.028,1.077-0.028 c0.187,0,0.326,0.056,0.42,0.168c0.093,0.112,0.14,0.247,0.14,0.406c0,0.177-0.047,0.327-0.14,0.448 c-0.094,0.121-0.233,0.182-0.42,0.182c-0.186,0-0.375,0-0.566,0c-0.191,0-0.38,0.005-0.566,0.014 c-0.439,0.009-0.882,0.028-1.329,0.056c-0.448,0.028-0.894,0.061-1.336,0.098C359.878,164.926,359.437,164.968,358.999,165.015z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M242.26,121.984c31.495,0,62.99,0,94.485,0c8.832,0,17.664,0,26.496,0c0.804,0,0.806-1.25,0-1.25 c-31.495,0-62.99,0-94.485,0c-8.832,0-17.664,0-26.496,0C241.455,120.734,241.454,121.984,242.26,121.984L242.26,121.984z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M243.735,131.574c17.705,0,35.409,0,53.114,0c0.804,0,0.806-1.25,0-1.25 c-17.705,0-35.409,0-53.114,0C242.931,130.324,242.929,131.574,243.735,131.574L243.735,131.574z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M240.784,93.583c15.123,0,30.245,0,45.368,0c0.804,0,0.806-1.25,0-1.25 c-15.123,0-30.245,0-45.368,0C239.98,92.333,239.979,93.583,240.784,93.583L240.784,93.583z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M355.495,91.739c3.443,0,6.885,0,10.328,0c0.804,0,0.806-1.25,0-1.25c-3.443,0-6.885,0-10.328,0 C354.691,90.489,354.689,91.739,355.495,91.739L355.495,91.739z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9015 -0.4328 0.4328 0.9015 15.259 169.5664)",
    style: {
      fill: "#8380FF"
    },
    cx: 380.139,
    cy: 51.262,
    rx: 17.435,
    ry: 17.435
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M380.55,41.015c0.24,6.831,0.183,13.667-0.17,20.493c-0.042,0.804,1.208,0.802,1.25,0 c0.353-6.826,0.41-13.662,0.17-20.493C381.772,40.213,380.522,40.209,380.55,41.015L380.55,41.015z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M371.868,51.995c6.293,0,12.585,0,18.878,0c0.804,0,0.806-1.25,0-1.25 c-6.293,0-12.585,0-18.878,0C371.064,50.745,371.063,51.995,371.868,51.995L371.868,51.995z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Boxes"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8380FF"
    },
    d: "M362.193,419.075c-1.903,2.679-53.233,39.914-55.53,41.817c-0.208,0.175-1.017,0.251-2.329,0.219 c-13.002-0.131-74.874-8.956-76.613-12.423c-1.903-3.806-3.051-70.927-3.051-70.927l55.912-33.812c0,0,54.206,4.538,74.36,6.244 c3.937,0.339,6.572,0.558,7.25,0.623C366.392,351.199,364.107,416.407,362.193,419.075z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 305.78,
    y: 387.763,
    transform: "matrix(0.9999 -0.0106 0.0106 0.9999 -4.4702 3.2627)",
    style: {
      fill: "#421B36"
    },
    width: 1,
    height: 73.134
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M305.914,388.437c6.662-5.281,13.761-10.011,20.862-14.673 c7.712-5.063,15.516-9.985,23.259-15.001c3.799-2.461,7.586-4.942,11.31-7.516c0.658-0.454,0.033-1.538-0.631-1.079 c-14.687,10.147-30.095,19.209-44.772,29.374c-3.71,2.569-7.375,5.207-10.912,8.011 C304.4,388.052,305.29,388.932,305.914,388.437L305.914,388.437z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M225.521,378.876c20.629,2.793,41.337,4.947,62.001,7.452c5.933,0.719,11.862,1.468,17.784,2.27 c0.787,0.107,1.127-1.098,0.332-1.205c-20.629-2.793-41.337-4.947-62.001-7.452c-5.933-0.719-11.862-1.468-17.784-2.27 C225.067,377.565,224.726,378.769,225.521,378.876L225.521,378.876z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M344.084,384.246c-3.78,2.419-7.595,4.865-10.856,7.973c-2.337,2.227-5.813,6.364-2.647,9.443 c1.375,1.338,3.231,0.966,4.755,0.102c2.024-1.146,3.974-2.493,5.888-3.812c1.881-1.296,3.715-2.669,5.423-4.188 c1.478-1.315,2.966-2.761,3.724-4.628c0.736-1.813,0.947-4.086-0.734-5.452C347.967,382.329,345.702,383.351,344.084,384.246 c-0.704,0.389-0.074,1.469,0.631,1.079c1.395-0.771,3.657-1.874,4.694,0.002c0.775,1.401-0.059,3.37-0.857,4.574 c-0.947,1.429-2.31,2.593-3.61,3.69c-1.389,1.172-2.853,2.252-4.349,3.282c-1.494,1.029-3.021,2.008-4.551,2.982 c-1.347,0.857-3.377,2.353-4.751,0.739c-2.46-2.891,1.753-6.568,3.721-8.32c2.979-2.652,6.352-4.805,9.702-6.949 C345.39,384.893,344.764,383.81,344.084,384.246L344.084,384.246z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M259.322,397.645c0,0-0.133-13.147,0.222-13.995c1.298-3.097,52.147-37.09,52.147-37.09 l13.002,1.091l-52.579,37.924l0.418,14.318L259.322,397.645z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M264.495,437.627c0,0-0.459,13.438,0.922,14.476c1.381,1.038,14.941,2.068,14.941,2.068 s0.049-13.877-0.776-14.613C278.757,438.822,264.495,437.627,264.495,437.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M284.1,439.768c0,0-0.459,13.438,0.922,14.476c1.381,1.039,14.941,2.068,14.941,2.068 s0.049-13.877-0.776-14.613C298.363,440.963,284.1,439.768,284.1,439.768z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M361.669,350.707c0.662,0.057,1.082,0.095,1.351,0.121c-0.001,0.01-0.003,0.019-0.004,0.029 c-0.461-0.026-1.13-0.07-0.823-0.04c0.212,0.019,0.406,0.211,0.586,0.545c-0.215,0.252-0.53,0.458-0.803,0.694 c-0.499,0.058-1.004,0.098-1.588-0.103c0.026-0.162,0.049-0.306,0.075-0.462L361.669,350.707z M352.08,415.194 c-3.101,1.969,1.176,5.012,1.742,1.164C352.762,415.371,352.762,415.371,352.08,415.194z M319.1,439.107 c0.257-0.408-0.169-0.599-0.37-0.853c-0.337-1.561-2.183-0.803-2.759,0.264C316.309,440.171,318.33,440.626,319.1,439.107z  M317.868,393.087c-0.993,0.406-2.085,0.855-1.136,1.983c-0.162,0.237-0.28,0.408-0.435,0.634 C318.332,397.215,320.263,393.802,317.868,393.087z M328.925,444.447c0.145-0.107,0.289-0.213,0.435-0.32 C329.193,444.204,329.049,444.314,328.925,444.447z M312.943,428.692c-0.252,1.78,1.654,2.759,2.865,1.439 C316.62,428.823,313.87,427.499,312.943,428.692z M331.446,406.627c-0.698-1.074-2.199-0.428-2.775,0.495 C328.782,409.69,332.21,408.887,331.446,406.627z M317.337,402.466c2.241-0.145,2.285-2.418,0.094-2.717 C315.835,399.673,316.066,402.262,317.337,402.466z M356.876,356.157c-1-0.776-2.601-0.983-3.033,0.545 c0.216,0.342,0.437,0.693,0.662,1.054C355.909,358.525,357.127,357.639,356.876,356.157z M349.608,405.829 c-1.755,0.253-2.462,1.287-1.093,2.637C350.412,409.051,351.461,406.781,349.608,405.829z M306.035,437.83l0.018,1.668 c0.286-0.475,0.4-1.08,0.158-1.551C306.155,437.909,306.092,437.868,306.035,437.83z M329.359,381.312 c-0.143,0.241-0.311,0.53-0.481,0.821c0.252,0.599,0.259,1.341,1.177,1.406c2.795-1.254,1.048-3.114-1.187-3.123 C328.658,380.946,329.324,380.893,329.359,381.312z M325.803,441.641c0.118,0.342,0.229,0.67,0.368,1.075 C330.815,444.843,327.556,437.611,325.803,441.641z M311.341,421.369c0.737-0.428,0.737-0.428,1.163-1.373 C312.311,416.236,307.528,420.787,311.341,421.369z M349.706,414.735c0.813-0.718,1.51-1.816,0.251-2.492 C347.154,412.261,346.575,414.368,349.706,414.735z M354.202,425.582c0.327-0.25,0.645-0.495,0.957-0.734 C354.715,424.896,354.328,425.141,354.202,425.582z M333.59,427.948c-1.249-0.213-1.851,1.105-1.294,2.113 C333.798,432.162,336.122,427.913,333.59,427.948z M323.707,437.186c-1.4,0.435-1.319,1.933-0.331,2.786 C325.814,439.612,326.124,437.611,323.707,437.186z M347.833,419.816c0.231,0.673,0.585,1.146,1.134,1.481 c0.651-0.366,1.145-0.715,1.74-1.216C350.921,418.081,348.205,418.046,347.833,419.816z M317.488,443.421 c-0.931,0.376-1.028,1.15-1.204,1.988c0.375,0.294,0.739,0.579,1.064,0.832c0.509-0.115,0.926-0.21,1.339-0.304 C319.797,444.669,318.557,443.961,317.488,443.421z M314.925,453.181c-1.718-0.051-2.189,1.583-1.11,2.389 c0.61-0.449,1.249-0.919,1.915-1.41C315.624,453.722,315.354,453.335,314.925,453.181z M363.963,379.832 c0.202,0.058,0.393,0.086,0.576,0.101c0.007-0.792,0.013-1.581,0.016-2.364C363.803,378.033,363.194,379.092,363.963,379.832z  M322.664,413.152c0.087,2.328,1.991,2.434,2.792,0.419C325,412.005,323.539,411.806,322.664,413.152z M336.563,437.42 c-1.652,0.341-1.798,1.536-1.101,2.198c0.668-0.494,1.334-0.988,1.999-1.48C337.162,437.899,336.859,437.657,336.563,437.42z  M358.891,405.361c2.474-0.877-0.255-4.632-1.628-1.45C357.015,404.85,357.98,405.61,358.891,405.361z M356.859,388.425 c-0.7-0.587-0.817-1.505-1.815-1.658c-0.415,0.537-0.803,1.038-1.169,1.512c0.166,0.494,0.63,0.837,0.909,1.259 C356.285,389.694,356.327,389.669,356.859,388.425z M313.778,392.422c1.886,0.181,2.404-0.354,2.121-2.184 C314.491,389.301,312.489,390.878,313.778,392.422z M330.049,374.366c-0.39,0.785-1.527,0.812-1.094,1.98 c1.137,0.664,1.137,0.664,2.14,0.612c0.279-0.382,0.856-0.879,0.563-1.409C331.286,375.146,330.66,373.671,330.049,374.366z  M329.63,412.274c-0.506,0.52-0.48,1.143-0.567,1.763C331.353,416.828,333.26,411.674,329.63,412.274z M339.514,434.249 c-1.032-0.061-0.798,1.071-1.375,1.648c0.342,0.536,0.823,0.757,1.31,0.766c0.603-0.448,1.202-0.893,1.798-1.336 C341.296,434.598,340.183,434.168,339.514,434.249z M322.017,441.142c-1.354-1.364-3.308-0.012-2.224,1.613 C320.854,443.933,322.595,442.563,322.017,441.142z M321.315,392.674c0.363-0.434,0.761-0.757,0.919-1.275 c-0.599-1.289-0.678-1.331-2.139-1.117c-0.229,0.443-0.49,0.776-0.844,1.195C319.428,392.674,320.425,392.461,321.315,392.674z  M351.249,409.315c0,0.636,0,1.283,0,1.894C353.665,413.108,355.11,407.861,351.249,409.315z M321.06,415.171 c-1.011,0.199-1.41,0.908-1.556,2.005c1.062,0.709,2.077,1.151,2.817-0.158C322.028,415.788,322.028,415.788,321.06,415.171z  M307.069,460.574c0.328-0.251,0.812-0.615,1.441-1.083C307.841,459.252,307.156,459.606,307.069,460.574z M320.88,421.473 c-1.017-0.02-1.893,1.613-1.072,2.161c0.391,0.143,0.674,0.318,0.818,0.731c1.031,0.488,1.681-1.124,1.393-1.995 C321.586,422.03,321.215,421.737,320.88,421.473z M348.065,388.815c0.436,0.419,0.556,0.889,1.12,1.042 c0.241-0.128,0.536-0.286,0.867-0.466c0.11-0.662,0.199-1.203,0.301-1.822C349.23,386.005,347.64,387.137,348.065,388.815z  M352.741,402.743c-0.42,0.142-0.784,0.266-1.131,0.386C348.853,406.873,356.577,405.147,352.741,402.743z M360.445,356.263 c0,0.451,0,0.835,0,1.181c1.059,1.083,2.076,0.751,2.767-0.472C362.789,355.52,361.504,355.101,360.445,356.263z M311.58,433.987 c1.13-1.173,1.51-2.464-0.248-3.098C309.328,431.582,309.809,433.342,311.58,433.987z M318.531,450.104 c-0.421-0.097-0.836-0.192-1.313-0.301c-0.766,1.087-0.818,1.418-0.463,2.746c0.542-0.008,0.951-0.024,1.263-0.072 c0.258-0.19,0.521-0.383,0.784-0.577C318.866,451.543,318.749,450.988,318.531,450.104z M341.563,400.085 c0.081,0.54,0.171,1.131,0.264,1.751C345.418,403.656,344.261,397.763,341.563,400.085z M356.065,395.827 c0.193-0.278,0.434-0.622,0.709-1.017c-0.407-1.152-1.044-2.122-2.366-1.341C353.759,394.661,354.419,396.312,356.065,395.827z  M329.37,402.204c1.184,0.356,2.637-0.863,1.983-2.067C329.973,398.678,327.947,400.726,329.37,402.204z M333.468,390.039 c-0.868,0.237-1.415,0.784-1.737,1.745C334.723,393.763,336.048,391.665,333.468,390.039z M318.892,432.186 c-0.224-0.747-0.764-1.004-1.227-1.271c-0.952,0.12-0.837,1.049-1.328,1.465C316.889,434.682,318.5,434.25,318.892,432.186z  M327.703,398.977c1.941-1.868-1.128-4.176-1.901-1.202C326.404,399.082,326.43,399.099,327.703,398.977z M327.449,437.144 c0.315-0.436,0.611-0.844,0.891-1.233c-0.344-0.72-0.344-0.72-0.137-1.592c-1.352-0.253-2.021,0.577-2.755,1.368 C325.83,436.616,326.659,436.787,327.449,437.144z M334.557,402.866c-0.376-0.09-0.785-0.19-1.316-0.318 C329.732,405.266,334.933,406.83,334.557,402.866z M361.519,414.801c1.806,0.065,1.892-2.257,0.21-2.847 C360.295,412.452,359.802,414.419,361.519,414.801z M322.693,426.723c0.76,1.017,2.483,0.732,2.723-0.564 C324.384,424.282,322.425,424.319,322.693,426.723z M318.078,380.959c-0.702,0.362-2.725,0.281-1.738,1.497 c0.64,1.519,2.071,1.222,2.803-0.087C319.017,381.794,318.746,381.329,318.078,380.959z M328.513,385.024 c-0.144-0.946-0.974-0.918-1.645-1.162C323.757,385.436,327.936,387.996,328.513,385.024z M317.958,406.006 c-0.627-0.04-1.155-0.513-1.837-0.495c0.308,1.006,0.593,1.937,0.882,2.885c1.001,0.143,1.21,0.038,2.073-1.068 C318.84,406.781,318.07,406.663,317.958,406.006z M311.545,456.11c-1.217,0.391-1.932,0.999-1.252,2.059 c0.62-0.458,1.309-0.967,2.055-1.517C312.175,456.386,311.918,456.18,311.545,456.11z M344.319,413.709 c-0.399-1.586-1.504-1.779-2.75-0.856c-0.173,0.865,0.235,1.393,0.805,1.901C343.128,414.556,344.583,414.794,344.319,413.709z  M344.684,404.397c0.213,0.295,0.437,0.607,0.721,1c0.557-0.145,1.011-0.263,1.478-0.385 C348.229,402.505,345.291,401.575,344.684,404.397z M305.915,427.07c0.471-0.822,0.382-1.5-0.025-2.217L305.915,427.07z  M357.517,378.065c0.017,0.91-0.261,1.927,1.073,2.348c1.344-0.361,1.24-1.149,1.12-2.312 C358.989,377.416,358.29,377.573,357.517,378.065z M310.045,445.563c3.075,2.213,3.77-2.537,0.547-1.676 C310.374,444.416,309.893,444.878,310.045,445.563z M322.216,448.045c-0.419-0.837-0.987-1.403-2.061-1.114 C317.964,448.858,321.421,450.508,322.216,448.045z M312.851,388.396c-0.267-0.85-0.889-1.22-1.76-1.367 c-0.305,0.163-0.799,0.301-1,0.648C310.015,390.026,311.684,390.183,312.851,388.396z M356.315,414.33 c0.971-0.928-0.16-1.685-0.987-2.168C352.771,413.056,354.389,415.865,356.315,414.33z M305.984,433.217 c0.33-0.448,0.384-1.132-0.018-1.593L305.984,433.217z M357.508,415.916c-0.119,1.148-0.02,2.207,1.387,2.343 C360.584,416.78,359.547,414.263,357.508,415.916z M310.512,439.734c1.404,0.252,2.977-0.252,2.003-1.946 C311.158,436.48,309.551,438.31,310.512,439.734z M339.696,409.101c-0.973,0.472-0.973,0.472-1.322,1.801 C339.758,413.07,342.673,410.47,339.696,409.101z M328.237,390.995c-0.718-1.684-2.905-0.816-2.412,0.914 C326.905,393.265,328.338,392.734,328.237,390.995z M354.177,406.625c-0.099,0.419-0.189,0.796-0.295,1.243 C356.991,410.344,357.914,404.298,354.177,406.625z M349.217,380.379c-1.372,0.683-1.724,2.829,0.005,3.222 C349.836,381.838,352.047,381.79,349.217,380.379z M319.546,435.758c-0.378,0.818,0.989,0.556,1.118,1.287 c0.626-0.441,1.274-0.721,1.678-1.531C321.322,433.529,320.335,434.031,319.546,435.758z M322.684,420.466 c1.023,0.663,1.907,0.501,2.821-0.392C324.296,417.692,322.996,417.623,322.684,420.466z M321.439,430.745 c0.094-0.703,0.322-1.104,0.852-1.622c-0.673-0.781-1.499-0.841-2.335-1.039c-0.222,0.498-0.425,0.949-0.651,1.456 C319.996,429.991,320.281,431.059,321.439,430.745z M344.002,425.421c-1.044-1.035-2.657,0.093-2.214,1.515 C343.095,428.12,344.999,427.073,344.002,425.421z M345.208,421.918c-1.426,1.718-0.322,1.785,0.963,2.549 C347.938,423.371,347.24,421.504,345.208,421.918z M314.44,424.24c0.678-0.197,1.143-0.554,1.51-1.124 c-0.25-0.767-0.819-1.253-1.414-1.662c-0.861,0.184-1.254,0.692-1.378,1.507C313.473,423.495,313.91,423.938,314.44,424.24z  M315.993,398.046c-0.384-0.775-0.81-1.456-1.865-1.508C311.434,397.507,315.125,400.569,315.993,398.046z M308.133,408.792 c-1.44,0.74-1.41,3.056,0.475,2.868C310.354,411.608,309.15,409.283,308.133,408.792z M308.31,405.371 c1.032,0.17,1.574-1.592,0.758-2.225C307.296,401.737,305.713,405.187,308.31,405.371z M350.231,401.745 c0.367-0.426-0.087-1.846-0.625-1.811c-0.72,0.15-1.585,0.058-2.043,0.998C348.108,402.365,349.051,402.98,350.231,401.745z  M359.862,397.941c-0.026-1.119-0.644-1.642-1.68-1.466C355.619,397.137,359.678,400.846,359.862,397.941z M335.217,369.474 c0.414,0.6,1.03,1.031,1.617,1.54C339.568,369.637,335.703,366.3,335.217,369.474z M356.702,370.613 c-0.585-0.858-0.296-1.734-0.949-2.468c-0.876-0.038-1.463,0.313-1.919,1.02C354.481,370.112,355.534,371.634,356.702,370.613z  M306.182,451.035l0.007,0.625c0.063-0.083,0.122-0.16,0.188-0.246C306.313,451.268,306.247,451.156,306.182,451.035z  M334.592,397.172c-0.375-0.304-0.742-0.602-1.194-0.969c-1.787,0.552-1.717,3.084,0.341,2.794 C333.989,398.4,334.931,398.101,334.592,397.172z M337.697,394.108c-0.837-1.201-2.296-1.146-2.44,0.518 C335.456,396.796,337.903,396.009,337.697,394.108z M330.634,393.394c-0.539,0.089-1.002,0.164-1.598,0.263 C327.448,396.376,333.784,396.749,330.634,393.394z M312.788,382.433l-1.38,0.895 C312.01,383.263,312.582,382.924,312.788,382.433z M356.87,419.376c-0.75-1.006-1.585-0.8-2.435-0.434 c-0.09,0.53-0.171,0.994-0.278,1.615C355.448,421.474,356.684,420.948,356.87,419.376z M314.028,434.654 c-1.122-0.315-1.14,1.724-0.359,2.135c0.55-0.174,0.967-0.155,1.531,0.06C316.26,435.742,315.651,433.795,314.028,434.654z  M358.735,421.457c-1.114,0.341-1.736,1.19-1.597,1.857c0.72-0.562,1.374-1.078,1.959-1.546 C358.993,421.668,358.876,421.565,358.735,421.457z M348.508,370.652c2.194,0.326,2.541-2.366,0.464-2.693 c-0.314,0.237-0.615,0.466-0.893,0.676C348.072,369.389,347.9,370.105,348.508,370.652z M339.26,390.265 c-0.367-0.15-0.592,0.255-0.817,0.545C338.404,395.761,343.427,389.97,339.26,390.265z M305.475,387.386l0.021,1.906 C306.409,388.641,306.479,387.875,305.475,387.386z M307.775,415.647c-0.733,0.621-1.146,2.386,0.281,2.324 C310.388,418.38,309.485,414.321,307.775,415.647z M363.584,404.138c0.066,0.089,0.123,0.151,0.184,0.226 c0.019-0.335,0.037-0.672,0.056-1.014C363.72,403.614,363.679,403.894,363.584,404.138z M362.182,399.763 c-0.442,0-0.863,0-1.29,0c-0.284,0.474-0.546,0.91-0.862,1.438C361.869,402.672,364.756,401.392,362.182,399.763z  M325.207,432.191c0.116-0.856-0.927-0.876-1.519-1.04c-0.939-0.139-0.85,1.018-1.023,1.685 C323.588,434.106,325.021,433.823,325.207,432.191z M357.268,353.7c0.482,1.904,2.756,1.508,2.83-0.46 c-0.482-0.244-0.932-0.521-1.424-0.588l-1.249,0.81C357.375,353.538,357.317,353.626,357.268,353.7z M351.21,384.983 c0.092,1.349,1.912,2.132,2.389,0.483C354.194,384.083,351.173,383.103,351.21,384.983z M314.4,415.416 c-0.333,0.587-0.333,0.587-1.198,0.957C313.165,420.237,317.949,416.836,314.4,415.416z M347.016,409.247 c-1.853-0.971-2.947,1.622-1.077,2.66C346.938,411.585,347.708,409.888,347.016,409.247z M344.671,416.129 c0.371,1.037,0.371,1.037,1.047,1.724C348.966,418.088,346.159,413.545,344.671,416.129z M340.967,429.773 c0.463-1.806-2.241-3.011-2.356-0.72c0.569,0.581,0.88,1.051,1.356,1.837C340.365,430.432,340.602,430.17,340.967,429.773z  M332.357,384.251c-1.517,4.11,4.202,1.827,1.098-0.522C333.149,383.875,332.806,384.039,332.357,384.251z M356.908,400.472 c-0.619-0.65-1.248-1.031-2.135-0.775c-0.236,0.564-0.466,1.113-0.736,1.758C355.43,402.557,356.379,401.9,356.908,400.472z  M342.688,393.061c-0.707,0.164-0.946,0.754-1.153,1.351c0.189,1.099,1.364,1.677,2.232,0.851 C344.128,393.863,343.892,393.605,342.688,393.061z M359.756,409.673c-0.429-0.211-0.852-0.421-1.311-0.647 c-0.348,0.173-0.688,0.341-1.025,0.508c-0.258,2.047,1.118,2.073,2.789,1.7C359.734,410.661,359.692,410.35,359.756,409.673z  M347.524,378.808c-0.494-0.572-0.939-1.095-1.551-1.487c-1.18,0.552-0.954,1.323-0.903,2.428 c0.348,0.152,0.659,0.287,0.864,0.376C346.83,379.996,346.979,379.221,347.524,378.808z M362.75,369.976 c-0.043-0.521-0.082-0.988-0.127-1.52c-0.665,0-1.335,0-2.019,0C359.488,370.335,361.425,371.599,362.75,369.976z  M305.682,406.016l0.026,2.38c0.328-0.345,0.376-0.931,0.849-1.214C306.238,406.619,305.954,406.239,305.682,406.016z  M363.553,398.063c0.179,0.227,0.341,0.431,0.494,0.625c0.028-0.638,0.054-1.282,0.08-1.934 C363.762,396.941,363.534,397.335,363.553,398.063z M332.122,379.582c1.473,0.388,3.009,0.624,2.441-1.456 c-0.323-0.219-0.677-0.46-1.053-0.717C332.706,377.9,331.898,378.339,332.122,379.582z M337.321,405.893 c-0.78,0.278-1.64,0.22-2.288,0.897c0.446,0.766,0.816,1.555,1.831,1.681c0.641-0.29,0.775-0.993,1.236-1.484 C337.835,406.613,337.59,406.271,337.321,405.893z M364.47,367.493c-0.018-0.744-0.039-1.47-0.062-2.182 c-0.038,0.029-0.074,0.053-0.114,0.087C363.404,366.329,363.734,367.22,364.47,367.493z M335.698,425.268 c-0.71,0.409-0.372,1.014,0,1.648c0.403,1.177,1.333,0.427,2.093,0.106C337.805,425.91,336.785,424.561,335.698,425.268z  M362.752,389.511c0.012-0.76-0.003-1.381-0.062-2.095c-0.4-0.252-0.752-0.475-1.208-0.763c-0.584,0.814-0.964,1.506-0.828,2.475 C361.292,389.321,361.93,389.613,362.752,389.511z M311.422,427.157c2.293-0.134,1.298-2.937-0.484-2.08 C309.49,425.613,310.038,427.273,311.422,427.157z M361.36,418.88c-0.938,0.026-1.164,1.037-0.793,1.692 c0.887-0.74,1.456-1.258,1.626-1.497c0.028-0.039,0.056-0.094,0.084-0.159C362.035,418.832,361.732,418.808,361.36,418.88z  M308.618,390.272c-1.432,0.296-3.005,1.569-0.915,2.276C309.54,393.303,309.9,391.368,308.618,390.272z M360.606,376.587 c1.046,1.022,2.243,0.363,2.412-0.959c-0.822-0.488-1.357-1.642-2.325-1.006C361.015,375.418,360.091,375.967,360.606,376.587z  M332.481,434.537c0.085,0.64,0.104,1.176,0.087,1.857C335.487,438.3,335.183,432.897,332.481,434.537z M363.18,382.732 c0.374-0.789-0.793-1.785-1.617-1.755C359.056,381.319,361.936,384.603,363.18,382.732z M336.667,387.012 c-1.402,0.288-1.161,1.457-0.814,2.531c1.384,0.099,1.384,0.099,2.119-1.623C337.709,387.368,337.167,387.21,336.667,387.012z  M333.283,421.723c-0.245,0.122-0.512,0.254-0.752,0.372c-0.049,0.47-0.092,0.881-0.135,1.288 c0.729,1.651,2.366,0.515,2.495-0.733C334.519,421.955,333.9,421.873,333.283,421.723z M328.36,410.886 c-0.104-0.869-0.127-1.801-1.456-2.044c-0.413,0.726-2.008,1.673-0.586,2.276C327.079,411.257,327.773,411.673,328.36,410.886z  M358.596,358.468c-1.067,0.165-0.86,1.057-1.317,1.896C359.707,362.438,360.95,359.947,358.596,358.468z M305.773,414.208 c0.295-0.178,0.585-0.423,0.839-0.713c-0.377-0.359-0.529-0.87-0.86-1.201L305.773,414.208z M339.343,377.587 c-0.687,0.528-1.039,1.08-0.962,1.865C340.507,381.393,342.268,378.01,339.343,377.587z M351.251,423.532 c0.724,0.547,1.473,0.549,2.246,0.049c0.714-1.423-0.815-1.475-1.765-1.842C350.881,422.345,350.881,422.345,351.251,423.532z  M355.702,377.016c1.624-0.435,1.071-2.354-0.413-2.55c-0.335,0.232-0.749,0.517-1.204,0.832 c0.171,0.498,0.282,0.817,0.395,1.146C354.914,376.647,355.335,376.845,355.702,377.016z M314.823,440.35 c-0.844,0.505-0.844,0.505-1.388,1.333c0.371,1.04,0.371,1.04,1.316,1.717c0.201-0.099,0.428-0.212,0.744-0.37 C315.474,442.02,315.757,441.033,314.823,440.35z M364.543,373.847c0.005-0.001,0.008-0.003,0.013-0.003 c-0.004-0.878-0.011-1.743-0.021-2.596C363.633,371.895,363.449,373.272,364.543,373.847z M340.98,372.07 c-0.59-0.505-1.969-1.087-2.264-0.381c0.128,0.502-0.221,0.864-0.337,1.276C339.417,374.57,340.863,373.738,340.98,372.07z  M315.694,403.469c-0.651-0.662-1.288-0.068-1.95-0.233C312.251,406.133,316.301,406.208,315.694,403.469z M327.943,405.019 c0.215-0.335,0.416-0.651,0.651-1.019c-0.733-1.46-2.684-1.487-2.997,0.408C326.416,404.709,327.042,405.376,327.943,405.019z  M311.08,408.52c2.607-0.106,0.906-3.102-0.799-2.17C309.688,406.753,310.106,408.635,311.08,408.52z M319.45,397.305 c0.223,0.841,0.431,1.669,1.511,2.057c0.316-0.379,0.648-0.775,1.073-1.285C321.887,396.618,320.377,396.22,319.45,397.305z  M344.645,398.064c1.617,2.221,3.353-0.082,1.867-1.795C345.661,396.566,344.838,396.858,344.645,398.064z M310.104,414.124 c0.6,0.618,1.343,0.421,2.08,0.399c0.236-0.326,0.459-0.633,0.707-0.976c-0.25-0.359-0.489-0.703-0.705-1.013 C310.471,412.369,310.335,412.522,310.104,414.124z M328.612,416.552c-0.507-0.361-1.019-0.726-1.589-1.132 c-1.749,0.644-1.087,2.262,0.141,2.826C327.408,417.458,328.417,417.442,328.612,416.552z M360.488,406.56 c-0.117,0.388-0.205,0.672-0.312,1.022c0.322,0.153,0.745,0.231,0.799,0.716c0.598,0.501,1.37-0.431,2.065-0.643 C362.719,406.104,361.724,405.772,360.488,406.56z M332.91,409.115c-0.274,0.415-0.508,0.77-0.756,1.146 C333.161,413.859,336.679,409.33,332.91,409.115z M335.476,412.559c0.351,0.925,0.091,2.408,1.495,2.24 C338.399,414.058,337.362,410.709,335.476,412.559z M307.99,436.753c0.865-0.051,0.997-0.834,1.4-1.318 c-0.13-1.469-1.69-1.472-2.538-0.547C307.112,435.727,307.304,436.396,307.99,436.753z M350.313,376.637 c0.529-2.391-2.31-2.529-2.524-0.139C348.469,377.361,349.44,376.837,350.313,376.637z M315.775,385.412 c-0.262-1.955-2.888-2.507-2.32-0.053C314.599,386.112,315.033,387.025,315.775,385.412z M342.617,387.11 c-0.33,0.371-0.697,0.784-1.05,1.179c0.054,0.39,0.421,0.662,0.607,1.002c1.295,0.5,1.803-0.1,2.228-1.277 C343.757,387.649,343.385,387.09,342.617,387.11z M340.384,396.695c-0.388-0.291-0.895-0.727-1.369-0.354 c-0.199,0.583-0.393,1.147-0.613,1.788c0.489,0.199,0.738,0.786,1.335,0.899C340.192,398.223,341.764,397.464,340.384,396.695z  M310.017,395.193c1.501,1.129,3.601,0.17,2.071-1.441c-0.436-0.392-0.973,0.042-1.48-0.078 C309.812,393.731,310.039,394.596,310.017,395.193z M305.543,393.491l0.021,1.943c0.227-0.098,0.46-0.229,0.698-0.4 C306.322,394.178,305.994,393.686,305.543,393.491z M322.03,403.642c-0.64-0.462-1.062-0.885-1.833-1.012 c-0.265,0.527-0.497,0.989-0.716,1.423C320.12,405.92,321.961,405.158,322.03,403.642z M320.098,409.445 c-1.034,2.348,0.824,2.402,2.194,1.186C322.692,409.207,321.068,409.014,320.098,409.445z M346.739,360.904 c0.211-0.275,0.328-0.526,0.384-0.755l-1.484,0.963c0.054,0.034,0.099,0.073,0.156,0.104 C346.145,361.1,346.473,360.991,346.739,360.904z M343.594,406.288c-0.397-0.112-0.765-0.215-1.141-0.32 c-0.395,0.305-0.762,0.598-1.032,1.241C342.797,408.915,344.787,408.842,343.594,406.288z M341.972,381.094 c0,0.597,0,1.151,0,1.794c0.955,1.117,2.357-0.203,2.278-1.437c-0.477-0.237-0.937-0.467-1.407-0.701 C342.549,380.865,342.274,380.974,341.972,381.094z M339.58,383.932c-0.293,0.215-0.631,0.462-0.93,0.681 c-0.045,1.053-0.045,1.053,0.252,1.823c0.868-0.447,2.179-0.281,2.198-1.51C340.7,384.492,340.301,384.043,339.58,383.932z  M318.423,389.295c0.21-0.686,0.236-1.267-0.004-1.862c-1.339-1.021-2.013,0.089-2.089,1.402 C316.892,389.524,317.618,389.385,318.423,389.295z M325.349,388.74c-0.285-0.461-0.57-0.922-0.883-1.427 c-0.436,0-0.902,0-1.446,0C321.672,388.922,324.119,390.159,325.349,388.74z M346.323,364.842 c-0.877,0.467-2.213,1.917-0.915,2.691c0.392-0.11,0.832-0.232,1.255-0.35c-0.019-0.265-0.034-0.457-0.049-0.649 c0.293-0.034,0.54-0.062,0.991-0.115C347.178,365.755,347.176,364.994,346.323,364.842z M311.068,452.807 c0.367,0.01,0.436-0.366,0.637-0.572c0.749-0.281,0.994-0.745,0.875-1.6c-0.887-0.106-1.571-0.7-2.181,0.167 C309.612,451.364,310.376,452.538,311.068,452.807z M357.613,365.603c-0.527,1.429,0.304,2.258,1.645,1.961 C360.779,366.373,358.669,364.472,357.613,365.603z M344.005,369.57c-0.02-1.534-2.288-1.514-2.497-0.014 C341.303,370.975,343.966,371.086,344.005,369.57z M359.734,372.078c-1.131-1.167-2.36-0.949-2.495,0.75 C358.117,374.173,359.868,373.752,359.734,372.078z M306.107,444.354l0.015,1.36C306.39,445.361,306.411,444.829,306.107,444.354 z M327.079,374.117c0.813-0.167,1.575-1.049,1.117-1.684l-1.769,1.148C326.587,373.795,326.781,373.988,327.079,374.117z  M316.419,412.852c-1.087,3.641,3.815,1.254,1.928-0.514C317.723,412.505,317.063,412.68,316.419,412.852z M332.38,441.226 c-0.031,0.256-0.06,0.492-0.09,0.738c0.509-0.376,1.019-0.753,1.529-1.13C333.29,440.81,332.851,441.053,332.38,441.226z  M343.765,374.823c-0.283-0.198-0.594-0.415-0.863-0.602c-0.982,0.139-1.233,0.905-1.649,1.549 C342.461,377.223,344.214,376.934,343.765,374.823z M324.218,408.699c0.137-0.211,0.388-0.459,0.341-0.547 c-0.343-0.63,0.225-1.027,0.415-1.567c-0.827-1.472-1.78-0.031-2.623,0.672C322.865,407.868,323.28,408.571,324.218,408.699z  M323.225,380.85c-0.139,0.588-0.267,1.128-0.395,1.666C325.191,384.7,326.403,379.922,323.225,380.85z M330.414,424.365 c-0.592,0.669-1.041,1.179-1.521,1.721c0.169,0.327,0.322,0.627,0.562,1.089c0.576-0.624,1.141,0.172,1.711-0.158 c0.107-0.303,0.218-0.623,0.348-0.995C331.187,425.529,330.858,425.035,330.414,424.365z M360.699,362.58 c-0.784,1.823,1.619,1.938,2.598,0.899C362.872,362.411,361.53,361.334,360.699,362.58z M358.679,386.697 c0.312-0.238,0.616-0.469,0.906-0.689c0.005-0.619,0.08-1.179-0.075-1.771c-0.967-0.447-2.131,0.51-2.238,1.489 C357.775,386.088,358.085,386.605,358.679,386.697z M357.558,392.127c0.75,1.118,2.615,0.607,2.215-0.771 C358.991,389.791,357.049,390.336,357.558,392.127z M305.847,420.919c0.5-0.761,0.398-1.528-0.022-1.98L305.847,420.919z  M318.438,420.699c0.252-0.28,0.316-0.525,0.035-0.789c-0.308-0.288-0.388-0.534-0.193-0.893 c0.155-1.508-1.709,0.362-2.209,0.685C316.566,420.693,317.408,421.801,318.438,420.699z M331.211,433.539 c0-0.534,0-1.002,0-1.479c-0.541-0.311-0.925-0.827-1.658-0.883c-0.096,0.131-0.357,0.36-0.316,0.448 c0.25,0.54-0.203,0.899-0.293,1.37C329.582,434.026,330.443,433.413,331.211,433.539z M339.969,367.602 c0.395-0.307,0.699-0.543,1.053-0.817c-0.154-0.592-0.302-1.158-0.47-1.802c-0.632,0.426-1.118,0.559-1.826,0.615l-0.053,0.035 c-0.063,0.436-0.118,0.809-0.18,1.23C338.98,367.106,339.439,367.336,339.969,367.602z M327.784,421.83 c-1.558,0.205-2.884,0.931-1.138,2.226C327.922,424.723,328.947,422.881,327.784,421.83z M352.449,365.088 c-1.031,0.463-1.031,0.463-1.37,1.429c0.466,0.407,0.79,1.425,1.44,0.835c0.813-0.358,1.26-0.829,0.966-1.754 C353.105,365.41,352.761,365.242,352.449,365.088z M308.47,427.889c-2.639-0.178-0.871,5.171,1.012,1.115 C309.205,428.558,308.803,428.214,308.47,427.889z M322.152,384.913c-0.391-0.399-0.718-0.73-0.978-0.995 C317.693,384.335,320.147,388.158,322.152,384.913z M306.89,448.718c1.345,1.388,2.575,0.826,2.456-1.183 c-0.633-0.144-1.198-0.273-1.775-0.405C307.317,447.724,307.098,448.231,306.89,448.718z M364.118,386.421 c0.109-0.039,0.216-0.069,0.324-0.101c0.016-0.771,0.031-1.542,0.044-2.314c-0.071-0.021-0.131-0.057-0.207-0.071 c-0.641,0.297-0.386,0.975-0.835,1.378C363.724,385.772,363.918,386.092,364.118,386.421z M333.639,371.344 c-1.558,0.911-1.558,0.911-0.862,2.495C334.326,373.939,335.596,371.888,333.639,371.344z M337.483,401.83 c0.07-0.489,0.134-0.946,0.197-1.375c-0.43-0.811-1.395-0.583-2.119-0.453C334.37,400.873,336.335,402.374,337.483,401.83z  M339.821,424.011c-0.006,0.009-0.022,0.031-0.022,0.031c0.023-0.009,0.046-0.018,0.068-0.027 c-0.01-0.002-0.019-0.004-0.028-0.005c0.347-0.285,0.693-0.568,1.013-0.831c-0.113-0.765-0.408-1.349-1.04-1.771 c-0.797,1.474-1.729-0.05-1.089,2.552C339.129,423.979,339.475,423.995,339.821,424.011z M321.911,378.721 c-0.421-0.277-0.649-0.617-0.8-1.113c-0.41,0.033-0.731-0.115-1.054,0.156c-0.028,0.641-0.532,1.24-0.207,2.109 C320.664,380.004,322.492,379.923,321.911,378.721z M343.203,421.044c1.211-1.054,1.216-1.122,0.129-2.546 c-0.671,0.458-1.538,0.519-1.793,1.401C341.946,420.567,342.601,420.779,343.203,421.044z M353.488,373.264 c-0.095-0.539-0.191-1.072-0.289-1.631c-0.536-0.158-1.036-0.134-1.6-0.025c-0.414,1.211-0.414,1.211-0.183,1.946 C352.086,373.602,352.982,373.84,353.488,373.264z M314.051,449.531c1.201-0.474,2.222-2.014,0.611-2.698 c-0.46,0.165-0.894,0.32-1.346,0.483c0.125,0.251,0.216,0.436,0.305,0.613c-0.156,0.199-0.302,0.383-0.457,0.579 C313.488,448.881,313.769,449.205,314.051,449.531z M322.62,444.572c0.219,0.533,0.442,1.076,0.684,1.662 C326.385,446.416,324.592,442.235,322.62,444.572z M361.129,395.604c2.115-0.284,3.141-0.743,0.801-2.267 c-0.44,0.357-0.84,0.68-1.258,1.018C360.688,394.822,360.501,395.337,361.129,395.604z M331.372,439.784 c-0.271-0.182-0.501-0.335-0.734-0.491c0.718-0.914,0.718-0.914,0.142-1.844c-0.627-0.083-1.268-0.144-1.772,0.401 c0,0.31,0,0.603,0,0.995C329.771,439.18,330.522,440.49,331.372,439.784z M307.535,453.25c-0.923,0.33-0.31,1.219-0.107,1.892 c1.281,0.126,1.281,0.126,2.194-0.466C309.427,453.478,308.48,453.367,307.535,453.25z M345.937,393.061 c0.681-0.413,0.769-1.074,1.035-1.551c-0.176-0.496-0.537-0.685-0.901-1.175c-0.383,0.066-0.716,0.124-0.962,0.167 C344.089,391.535,345.164,392.418,345.937,393.061z M324.498,399.686c-0.462,0.107-0.914,0.209-1.495,0.344 c0.083,0.703,0.152,1.282,0.218,1.841C324.705,402.337,326.189,400.518,324.498,399.686z M363.328,360.094 c0.252,0.4,0.564,0.644,0.882,0.773c-0.035-0.591-0.072-1.166-0.112-1.716C363.779,359.371,363.505,359.714,363.328,360.094z  M353.145,390.443c-3.343-0.406-1.036,5.038,0.381,1.025C353.413,391.164,353.295,390.844,353.145,390.443z M345.778,384.097 c-0.348,0.431-1.203,0.72-0.847,1.311c0.084,0.09,0.209,0.239,0.184,0.32c-0.214,0.705,0.295,0.78,0.794,0.916 c0.351-0.263,0.722-0.539,1.1-0.822c-0.081-0.463-0.152-0.873-0.232-1.337C346.503,384.379,346.189,384.257,345.778,384.097z  M318.87,426.47c-0.162-0.555-0.249-1.002-0.284-1.562c-0.993-0.502-1.971-0.126-2.446,0.916 c0.177,0.257,0.366,0.528,0.508,0.733C317.577,426.273,317.989,426.779,318.87,426.47z M356.33,382.99 c-0.053-0.464,0.121-0.892,0.364-1.26c-0.439-0.934-1.575-0.965-2.242-0.305C354.121,383.19,354.838,383.192,356.33,382.99z  M350.878,360.532c0.701,0.463,1.664,0.899,2.295,0.353c-0.135-0.235-0.243-0.42-0.374-0.648 c0.198-0.148,0.395-0.298,0.593-0.445c-0.131-1.245-2.6-1.535-1.696,0.011C351.365,359.99,351.116,360.235,350.878,360.532z  M337.293,376.643c1.307-1.389-0.427-2.52-1.721-1.555C335.244,376.802,335.843,376.97,337.293,376.643z M305.614,399.939 l0.02,1.789C306.175,401.361,306.425,400.637,305.614,399.939z M315.431,409.921c-0.752-1.17-2.096-0.05-2.268,1.053 C314.564,411.964,315.623,411.981,315.431,409.921z M324.892,376.32c0.185-0.681-0.024-1.132-0.41-1.477l-1.682,1.092 c0.059,0.133,0.128,0.278,0.214,0.446C324.053,376.546,324.053,376.546,324.892,376.32z M309.192,423.056 c-0.128-0.365-0.241-0.687-0.363-1.028c-0.42-0.105-0.747-0.361-1.201-0.322C305.833,423.33,307.867,425.028,309.192,423.056z  M364.283,392.353c0.018-0.576,0.036-1.154,0.052-1.736C363.853,390.909,363.776,391.747,364.283,392.353z M334.25,417.535 c0.146-0.57,0.465-0.911,0.351-1.497c-0.952-1.03-2.968,0.489-2.037,1.638C333.076,417.633,333.658,417.584,334.25,417.535z  M329.617,389.333c1.545-0.715,2.25,0.117,1.413-1.915C329.676,386.681,328.505,388.49,329.617,389.333z M307.467,398.899 c0.144-0.19,0.286-0.379,0.45-0.594c2.491,1.139,1.432-2.687-0.48-1.689C307.497,397.391,307.073,398.316,307.467,398.899z  M337.256,420.818c0.459-0.145,0.497-0.53,0.364-0.95c0.325-1.405-1.338-1.155-2.2-0.629 C335.61,420.264,336.033,421.114,337.256,420.818z M346.385,373.441c0.561-0.12,0.82-0.435,0.818-1.014 c-0.53-0.523-1.127-0.78-1.863-0.554c-0.219,0.308-0.42,0.588-0.728,1.022C345.065,373.7,345.635,374.229,346.385,373.441z  M338.855,403.407c0.152,1.158,0.246,1.393,0.775,1.935c1.431-0.162,1.89-1.699,0.505-2.321 C339.681,403.158,339.311,403.269,338.855,403.407z M354.131,363.202c0.177,0.327,0.379,0.699,0.544,1.001 c1.463,0.056,1.478-0.878,1.771-1.985c-0.309-0.15-0.534-0.258-0.741-0.36C355.029,362.151,354.326,362.324,354.131,363.202z  M325.905,429.437c0.053,1.078,1.635,1.153,2.17,0.349c0.029-1.323,0.029-1.323-0.848-1.63 C326.804,428.566,326.403,428.955,325.905,429.437z M344.676,429.239c0.358,0.973,0.358,0.973,1.394,1.593 c0.425-0.459,1.148-0.739,0.865-1.629C346.145,428.552,345.242,428.122,344.676,429.239z M353.252,398.434 c0.379-1.755-2.649-2.78-1.948-0.544c0.218,0.112,0.438,0.226,0.639,0.33c-0.053,0.28-0.093,0.483-0.137,0.712 C352.542,399.293,352.776,398.524,353.252,398.434z M312.2,401.761c0-0.36,0-0.734,0-1.202c-0.899-1.131-1.686-0.464-2.191,0.586 C310.749,402.089,310.888,402.125,312.2,401.761z M336.364,382.967c0.872,0.294,1.239-0.406,1.416-1.124 c-0.221-0.732-1.49-1.044-2.215-0.725C335.166,382.087,336.189,382.358,336.364,382.967z M336.457,433.673 c1.239-0.002,1.743-2.144,0.009-2.048C335.061,431.388,335.398,433.596,336.457,433.673z M344.343,363.172 c-0.195-0.258-0.434-0.541-0.7-0.765l-1.398,0.908C342.554,364.512,343.408,364.827,344.343,363.172z M338.974,416.031 c-0.445,0.942-0.446,1.626,0.701,1.911c1.099-0.288,0.315-1.185,0.861-1.77C341.201,414.993,339.379,415.438,338.974,416.031z  M348.83,361.854c-1.2,0.565-0.557,1.446-0.546,2.475c0.457-0.092,0.86-0.173,1.228-0.247 C350.085,362.463,350.085,362.463,348.83,361.854z M349.436,395.592c0.541-0.563,0.971-1.132,0.578-1.906 C348.173,392.831,347.047,396.144,349.436,395.592z M341.541,432.628c0.484,0.302,0.912,0.571,1.318,0.824 c0.628-0.406,0.919-0.9,0.995-1.673c-0.674-0.201-1.197-0.547-1.897-0.481C341.772,431.735,341.66,432.149,341.541,432.628z  M309.143,441.567c-0.757-0.592-0.757-0.592-1.703-0.483c-0.183,0.24-0.364,0.478-0.574,0.754 C307.365,443.089,309.568,443.488,309.143,441.567z M328.199,378.791c-0.377-1.12-1.868-0.766-2.442,0.053 C326.236,380.078,328.431,380.414,328.199,378.791z M351.615,379.827c0.684-0.19,1.295-0.361,1.891-0.529 c-0.081-0.853-0.083-0.853-0.701-1.421c-0.472,0.327-1.133,0.056-1.664,0.405C351.299,378.796,351.434,379.241,351.615,379.827z  M350.026,426.926c-0.153-0.717-0.076-1.035,0.157-1.768C347.59,425.009,347.56,428.531,350.026,426.926z M309.383,385.609 c0.132-0.31-0.002-0.589-0.253-0.801l-1.672,1.085C307.98,386.356,308.948,386.298,309.383,385.609z M325.138,394.238 c-0.692-0.978-1.784-0.099-2.277,0.62C323.794,396.251,325.404,395.6,325.138,394.238z M329.771,420.109 c0.192,0.912,0.575,0.78,1.044,0.208c0.551-0.48,0.553-0.484,0.083-1.291c-0.476,0-0.949,0-1.489,0 C328.707,419.76,328.579,420.462,329.771,420.109z M339.982,423.968c-0.039,0.016-0.077,0.031-0.115,0.046 C339.915,424.026,339.955,424.033,339.982,423.968z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8380FF"
    },
    d: "M340.608,354.897c-1.538,2.166-36.418,27.031-38.274,28.569c-0.168,0.141-0.822,0.203-1.883,0.177 c-10.513-0.106-60.54-7.241-61.946-10.044c-1.539-3.077-2.467-57.348-2.467-57.348l38.584-22.097c0,0,43.829,3.669,60.124,5.049 c3.183,0.274,5.314,0.451,5.862,0.504C344.003,300.016,342.155,352.74,340.608,354.897z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M318.902,350.448c-0.31,0.345-0.618,0.691-0.965,1.08c-0.505-0.323-1.35-0.363-1.397-1.08 c-0.088,0-0.175,0-0.263,0c0.573-0.661,0.751-0.835,1.009-1.681C318.557,348.803,319.014,349.06,318.902,350.448z  M310.241,350.448c0.015,0.482,0.067,0.951,0.458,1.291c1.561,0.253,1.938-0.15,1.904-1.291c0.006-0.918-1.083-0.953-1.728-1.394 c-0.444,0.427-0.944,0.726-0.897,1.394C310.066,350.448,310.154,350.448,310.241,350.448z M341.601,350.2 c-0.046,0.08-0.104,0.149-0.129,0.248c0.028,0.085,0.049,0.176,0.068,0.269C341.561,350.551,341.581,350.38,341.601,350.2z  M322.314,350.448c0.087,0,0.174,0,0.262,0c0.262,0.587,0.846,0.737,1.169,1.358c0.522-0.467,1.285-0.576,1.456-1.358 c-0.087,0-0.175,0-0.263,0c-0.07-0.64-0.578-0.898-1.048-1.244c-0.409,0.137-0.806,0.269-1.215,0.406 C322.55,349.901,322.431,350.175,322.314,350.448z M331.123,349.427c-0.526-0.038-0.942-0.069-1.427-0.105 c-0.269,0.367-0.545,0.747-0.821,1.126c0.087,0,0.174,0,0.262,0c-0.062,0.244-0.126,0.487-0.212,0.815 c1.192,0.635,2.528,0.972,2.574-0.815C331.368,350.095,331.238,349.74,331.123,349.427z M315.029,320.441 c-0.474,0.454-0.911,0.435-1.544,0.271c-0.203,0.54-0.384,1.024-0.559,1.491c0.336,1.185,1.918,0.797,2.604,1.745 c0.053,0.06,0.289-0.042,0.488-0.076c-0.151-0.4-0.27-0.721-0.381-1.017C316.298,321.887,316.231,321.688,315.029,320.441z  M320.914,323.432c0.348-0.18,0.692-0.359,1.072-0.556c0.237-1.183,0.069-2.078-1.143-2.558 C318.923,320.952,318.909,322.901,320.914,323.432z M329.057,311.556c-0.572,2.497,1.498,3.316,2.7,0.952 C331.572,311.02,330.068,310.398,329.057,311.556z M313.551,329.437c0.247,0.086,0.531,0.184,0.821,0.285 c0.49-0.225,0.925-0.474,1.347-0.787c0.057-0.482,0.058-0.771,0.051-1.271C314.323,325.882,312.199,327.713,313.551,329.437z  M341.012,334.178c-0.253-0.59-0.563-1.492-1.384-1.179c-1.193,0.52-1.593,2.737-0.023,3.062 C340.403,335.805,341.63,335.128,341.012,334.178z M318.15,329.771c-0.982,0.05-1.376,0.875-2.054,1.49 c0.112,1.821,2.782,1.763,3.068,0.105C318.808,330.804,318.49,330.304,318.15,329.771z M325.437,318.734 c-0.47-0.506-0.959-1.034-1.44-1.553C320.356,318.071,324.377,322.135,325.437,318.734z M325.909,315.123 c-0.736,1.727,2.441,3.033,2.462,0.517C328.399,313.897,326.712,313.693,325.909,315.123z M309.41,329.05c0-0.56,0-1.068,0-1.625 c-0.519-0.263-1.01-0.508-1.469-0.739C305.473,327.994,307.861,330.642,309.41,329.05z M328.215,322.626c0-0.636,0-1.136,0-1.789 c-0.556-0.332-1.095-0.688-1.843-0.343C324.951,322.27,326.396,324.092,328.215,322.626z M336.45,320.318 c2.276-0.24,1.71-2.35-0.064-2.831c-0.752-0.168-0.803,1.002-1.301,1.371C335.112,319.742,335.939,319.856,336.45,320.318z  M332.399,308.414c-0.246,1.026-0.206,2.242,1.012,2.455C336.117,310.284,334.591,307.135,332.399,308.414z M338.438,329.508 c3.357,0.873,3.113-3.424,0.788-2.435C338.292,327.742,338.087,328.376,338.438,329.508z M325.448,325.742 c-0.181-0.53-0.276-1.068-0.32-1.595c-0.654-0.204-1.191-0.572-1.826-0.284c0.1,0.105,0.201,0.208,0.3,0.312 c-0.435,0.222-0.868,0.445-1.302,0.668C322.713,326.143,324.555,326.783,325.448,325.742z M303.165,328.232 c0.096-1.187-0.964-1.693-1.761-1.402l0.027,2.418C302.253,329.633,303.339,329.445,303.165,328.232z M311.947,332.577 c0.353-0.517,0.304-1.247,0.863-1.674c-0.277-1.528-2.753-1.297-2.804,0.393C310.596,332.544,310.76,332.651,311.947,332.577z  M341.573,325.669c0.348,0.289,0.727,0.457,1.095,0.51c0.009-0.859,0.016-1.717,0.02-2.571 C341.462,324.226,341.458,324.25,341.573,325.669z M312.214,319.98c0.587-1.081,0.577-1.266-0.132-2.469 c-0.186-0.011-0.351-0.018-0.503-0.021l-1.736,1.085c-0.028,0.066-0.055,0.124-0.085,0.198 C310.506,319.323,311.158,320.451,312.214,319.98z M317.384,320.073c1.082,0.282,1.981-0.606,1.702-1.706 C317.493,316.262,314.998,318.226,317.384,320.073z M315.676,314.931l-2.3,1.437c0.098,0.164,0.223,0.323,0.407,0.465 C315.295,317.392,316.426,315.979,315.676,314.931z M328.344,335.125c-0.343-0.755-0.061-1.762-1.102-2.087 c-0.576,0.198-1.031,0.585-1.443,0.931C325.387,335.562,327.101,336.877,328.344,335.125z M304.064,325.983 c1.097,0.597,1.782-0.038,2.574-0.632C306.41,322.954,302.821,323.462,304.064,325.983z M308.492,320.426 c-1.171,0.339-1.171,0.339-1.922,1.32C306.757,324.894,311.232,321.763,308.492,320.426z M321.999,315.311 c-1-1.654-2.157-1.218-2.499,0.546C319.817,317.944,322.631,317.07,321.999,315.311z M339.581,310.631 c1.189,0.155,1.041-0.761,1.364-1.588c0.253-1.017-1.11-1.023-1.796-0.973C337.843,308.334,338.386,310.785,339.581,310.631z  M310.079,325.695c0.839,1.129,3.02,0.761,2.486-0.875C311.911,322.987,309.518,323.848,310.079,325.695z M335.468,313.085 c0.293,0.349,0.569,0.679,0.896,1.068c0.632-0.352,1.04-0.581,1.353-0.756C338.485,310.849,334.748,310.195,335.468,313.085z  M338.465,303.664c0.489,0.459,1.12,0.412,1.654,0.574c0.295-0.221,0.538-0.404,0.813-0.609 C341.597,300.891,338.159,300.997,338.465,303.664z M329.908,336.113c-1.22,0.9-1.241,3.419,0.908,2.783 C332.616,337.292,331.367,337.06,329.908,336.113z M339.579,339.264c-1.707,0.913-1.599,3.167,0.487,2.789 C341.64,341.576,340.682,339.888,339.579,339.264z M331.464,319.503c0-0.518,0-1.033,0-1.61 C328.388,315.803,328.585,322.489,331.464,319.503z M319.484,334.247c0.217,0.515,0.403,0.955,0.596,1.414 c0.732,0.179,0.732,0.179,1.605,0.036C323.131,333.991,320.482,332.093,319.484,334.247z M316.36,325.672 c0.519,1.093,2.624,0.801,2.285-0.683c0.007-0.001,0.015-0.001,0.021-0.001C318.845,322.757,315.66,323.853,316.36,325.672z  M336.881,332.808c0.311-0.415,0.616-0.823,0.965-1.29c-0.429-0.452-0.642-0.929-0.735-1.559c-0.543,0.061-1.01,0.113-1.431,0.16 C334.556,331.18,335.651,332.597,336.881,332.808z M342.353,338.691c0.034-0.831,0.065-1.684,0.095-2.551 C341.175,336.719,341.504,338.175,342.353,338.691z M325.093,330.407c-1.166-0.542-2.237-0.138-2.723,1.068 c0.679,1.267,2.497,1.296,3.029-0.229C325.283,330.93,325.196,330.689,325.093,330.407z M329.09,331.569 c0.438,0.212,0.143,0.626,0.376,1.081c1.713,0.537,2.602-1.581,1.292-2.535C329.982,329.745,328.442,330.77,329.09,331.569z  M304.543,345.26c0.489-0.313,0.888-0.712,1.538-0.599c1.673-0.732-1.501-3.451-2.461-0.78 C304.06,344.208,303.757,344.945,304.543,345.26z M335.242,325.116c0.871,1.575,1.023,1.509,2.685,0.536 C338.012,323.903,335.381,322.866,335.242,325.116z M339.881,314.106c-0.367,0.185-0.787,0.396-1.163,0.585 c-0.13,0.53-0.241,0.984-0.365,1.489C339.953,318.214,342.313,315.135,339.881,314.106z M333.477,314.172 c-1.029,0.44-2.352,2.515-0.626,2.739C334.717,316.984,335.171,314.768,333.477,314.172z M339.498,323.428 c2.146-0.797,1.601-3.15-0.627-3.002c-0.204-0.032-0.462,0.283-0.335,0.425c0.506,0.566,0.293,1.209,0.229,1.888 C338.998,322.959,339.243,323.189,339.498,323.428z M326.796,348.427c1.46-0.006,2.141-1.836,0.85-2.559 C325.775,345.588,325.281,347.332,326.796,348.427z M326.492,310.368c0.665-0.218,1.463,0.184,2.065-0.577 c-0.102-1.056-1.169-1.81-1.947-1.693l-0.605,0.378c-0.144,0.215-0.226,0.524-0.213,0.944 C326.048,309.766,326.253,310.043,326.492,310.368z M341.689,332.273c0.298,0.073,0.581,0.143,0.867,0.213 c0.02-0.779,0.037-1.565,0.053-2.356C341.908,330.188,341.702,331.639,341.689,332.273z M333.333,304.405 c0.768-0.303,1.214-0.786,1.268-1.299l-1.657,1.035C333.068,304.232,333.185,304.323,333.333,304.405z M334.408,329.017 c-0.115-0.319-0.24-0.668-0.362-1.009c0.174-0.304,0.507-0.551,0.215-1.01c-0.309-0.088-0.673-0.192-0.998-0.284 c-0.635,0.481-1.088,0.987-1.209,1.704C332.885,329.719,333.21,329.752,334.408,329.017z M318.005,313.942 c0.543-0.156,0.804-0.557,0.865-1.006l-1.239,0.774C317.751,313.79,317.875,313.868,318.005,313.942z M316.251,337.487 c0.182,0.384,0.36,0.758,0.526,1.107c0.492,0.106,0.904,0.193,1.279,0.274C320.22,337.155,317.812,335.23,316.251,337.487z  M332.386,333.903c-0.091,0.333-0.19,0.696-0.304,1.115c0.464,0.255,0.878,0.483,1.348,0.741 C335.974,335.511,334.072,331.918,332.386,333.903z M335.769,336.598c0.01,0.213,0.022,0.457,0.031,0.636 c-0.223,0.266-0.409,0.489-0.572,0.684c0.32,0.783,1.006,0.822,1.593,1.019c0.628-0.271,0.789-0.897,1.178-1.369 C337.576,336.663,336.72,335.889,335.769,336.598z M331.155,307.485c0.432-1.078,0.389-1.876,0.076-2.273l-2.167,1.354 C329.417,307.297,330.255,307.314,331.155,307.485z M321.403,348.159c0.827-0.895,0.989-2.15-0.524-2.203 C318.248,345.742,319.993,349.312,321.403,348.159z M327.894,340.482c-0.551-3.478-3.853,1.473-0.515,1.601 C328.246,341.366,328.24,341.368,327.894,340.482z M320.208,327.197c-1.461,0.107-0.18,1.496-0.123,2.229 c0.923-0.02,1.403-0.257,2.174-1.08C322.055,327.4,321.021,327.319,320.208,327.197z M301.916,345.569 c-0.094,0.117-0.197,0.221-0.3,0.325l0.026,2.368c0.128,0.107,0.255,0.213,0.386,0.322 C303.916,347.901,302.778,346.697,301.916,345.569z M309.557,340.351c-0.377-0.098-0.975,0.076-1.118-0.395 c-0.516-1.157-1.526,0.105-1.538,0.921C307.444,342.323,310.395,342.064,309.557,340.351z M342.274,307.17 c-0.047-0.647-0.098-1.264-0.155-1.842c-0.174,0.097-0.342,0.231-0.493,0.409C341.29,306.337,341.697,306.883,342.274,307.17z  M308.287,335.793c0.513-0.427,0.987-0.856,1.425-1.435c-0.442-0.42-0.841-0.801-1.308-1.244 C306.532,333.702,306.486,335.123,308.287,335.793z M333.338,320.4c-0.628,0.311-0.827,0.903-1.148,1.369 c0.497,2.011,2.297,1.66,2.478-0.265C334.192,321.111,333.77,320.76,333.338,320.4z M323.933,313.76 c0.627-0.262,1.144-0.538,1.398-1.119c-0.505-0.492-1.179-0.718-1.352-1.536C322.122,311.5,322.426,313.157,323.933,313.76z  M341.548,299.745c-0.002,0.002-0.005,0.005-0.007,0.007C341.587,299.753,341.593,299.751,341.548,299.745z M342.686,319.896 c-0.004-0.733-0.011-1.459-0.02-2.176c-0.262,0.005-0.513,0.032-0.759,0.107C341.215,318.877,341.924,319.736,342.686,319.896z  M340.892,346.531c-1.138-0.996-1.968,0.245-2.591,1.197C339.592,348.808,341.361,348.447,340.892,346.531z M316.284,343.409 c0.946,1.576,2.423,2.922,2.624,0.164C318.702,342.561,316.818,342.774,316.284,343.409z M337.758,306.998 c-0.24-0.677-0.477-1.35-0.753-2.126C333.967,304.971,336.317,308.863,337.758,306.998z M301.778,333.35 c-0.112,0.018-0.211,0.046-0.301,0.079l0.023,2.092c0.172,0.081,0.341,0.163,0.526,0.229c0.364-0.252,0.713-0.491,1.141-0.786 C302.977,334.052,302.285,333.756,301.778,333.35z M329.038,325.548c0.35-0.032,0.681-0.062,1.07-0.097 c0.054,0.24,0.108,0.488,0.181,0.817c1.077,0.013,1.283-0.308,1.12-1.688c-0.361-0.242-0.75-0.505-1.149-0.774 c-0.338,0.126-0.657,0.246-1.128,0.421C329.749,324.732,328.851,324.999,329.038,325.548z M342.426,311.506 c-1.037,0.514-1.185,1.954,0.06,2.202c0.034-0.013,0.065-0.025,0.099-0.038c-0.021-0.731-0.045-1.445-0.072-2.139 C342.48,311.526,342.458,311.509,342.426,311.506z M311.151,342.69c-0.274-0.409-0.469-0.352-1.1,0.152 c0.211,1.397,0.316,2.026,1.902,2.133C313.47,344.065,311.765,343.481,311.151,342.69z M328.741,343.92 c0.467,0.367,0.77,0.779,1.034,1.284c1.112-0.257,1.112-0.257,1.147-0.493c-0.09-0.169-0.188-0.355-0.32-0.607 c0.22-0.328,0.399-0.596,0.61-0.91C330.102,342.334,329.226,342.634,328.741,343.92z M310.97,336.716 c-2.194,1.53,1.019,2.99,1.906,1.004C312.481,336.759,311.625,336.897,310.97,336.716z M324.549,345.236 c0.725-0.719,0.597-2.666-0.737-2.29C321.622,343.379,323.113,345.045,324.549,345.236z M306.913,347.207 c0.353,0.663,1.104,0.322,1.521,0.656c0.451-0.241,0.827-0.442,1.34-0.718C309.171,345.537,307.269,345.373,306.913,347.207z  M342.143,343.105c-0.268,0.185-0.55,0.438-0.836,0.783c0.261,0.255,0.492,0.533,0.745,0.77 C342.083,344.156,342.113,343.638,342.143,343.105z M328.179,327.502c-0.678,0.199-1.373,0.402-2.101,0.615 c0,0.449,0,0.865,0,1.288c0.473,0.122,0.886,0.226,1.392,0.357C327.926,328.911,329.253,328.465,328.179,327.502z  M332.777,348.341c2.019-0.637,1.349-0.398,1.431-2.211C332.123,345.845,331.587,346.593,332.777,348.341z M334.051,339.621 c-1.139-0.474-2.149,0.632-1.585,1.657C334.284,341.718,335.342,341.656,334.051,339.621z M313.94,341.82 c0.248,0,0.545,0,0.816,0c0.394-0.425,0.765-0.827,1.13-1.221c-0.486-0.738-1.189-0.975-1.986-1.057 C313.263,340.344,313.647,341.003,313.94,341.82z M316.021,347.25c-0.46-1.495-2.11-1.516-2.415,0.145 C314.328,348.103,316.078,348.754,316.021,347.25z M335.516,344.751c0.634,0.194,1.195,0.357,1.858,0.133 c-0.09-0.597,0.055-0.96,0.44-1.436C336.536,342.193,335.484,343.288,335.516,344.751z M301.549,339.879l0.022,1.963 c0.253,0.118,0.54,0.206,0.857,0.237c1.089-0.793-0.153-1.451-0.461-2.217C301.814,339.859,301.675,339.866,301.549,339.879z  M319.91,341.371c1.169,0.991,1.654,0.316,2.338-0.656C321.732,339.331,319.181,340.021,319.91,341.371z M323.941,338.704 c0.413-0.275,0.797-0.53,1.216-0.809c-0.355-0.502-0.504-0.861-0.581-1.461c-0.876,0.243-1.723,0.067-1.86,1.245 C323.146,338.038,323.429,338.488,323.941,338.704z M315.419,336.02c0.183-1.061,0.138-1.978-0.588-2.759 c-1.055,0.59-1.055,0.59-1.21,1.351C314.105,335.302,314.598,335.698,315.419,336.02z M305.385,332.598 c1.533-0.338,0.024-3.36-0.83-2.2c0.104,0.173,0.21,0.35,0.314,0.523c-0.178,0.196-0.347,0.381-0.537,0.59 C304.678,331.869,304.999,332.198,305.385,332.598z M304.457,338.141c0.545-0.648,1.251,0.005,1.771-0.508 c-0.116-0.675-0.624-0.859-1.071-1.138C304.49,336.676,303.239,337.939,304.457,338.141z M326.887,327.122 c-0.2-0.204-0.295-0.036-0.462,0.115C326.68,327.452,326.729,327.314,326.887,327.122z M306.042,350.448 c-0.084-0.315-0.169-0.63-0.25-0.941c-0.553-0.365-1.128-0.37-1.79-0.145c-0.106,0.356-0.214,0.721-0.322,1.086 c-0.088,0-0.175,0-0.263,0c0.321,1.565,2.792,1.746,3.149,0C306.392,350.448,306.217,350.448,306.042,350.448z M337.536,350.448 c-0.068-0.631-0.551-0.89-1.034-1.223c-0.219,0.171-0.401,0.312-0.602,0.471c0.225,0.167,0.374,0.276,0.515,0.379 c-0.078,0.152-0.134,0.263-0.191,0.373c-0.35,0-0.7,0-1.05,0C335.546,351.601,337.801,352.201,337.536,350.448z M312.859,356.786 c-0.45-0.869-1.816-2.391-2.476-0.944c0.104,0.852-0.012,1.057-0.332,1.888C311.212,358.718,312.479,358.341,312.859,356.786z  M302.937,359.13c-0.439-0.501-0.829-0.658-1.181-0.6l0.028,2.564C302.893,361.289,303.96,360.539,302.937,359.13z  M306.476,375.81c-0.186-0.431-0.372-0.864-0.548-1.275c-1.236-0.739-1.904,0.546-2.517,1.431 C304.71,377.495,305.337,377.436,306.476,375.81z M317.47,370.908c0.836-0.228,1.227-0.809,1.445-1.574 c-0.229-2.357-2.663-1.401-2.535,0.521C316.725,370.24,317.039,370.645,317.47,370.908z M302.786,352.724 c-0.454-0.285-0.804-0.364-1.098-0.323l0.027,2.399C302.81,354.947,303.68,354.234,302.786,352.724z M321.979,367.484 c-0.265-0.821,0.059-1.604-0.438-2.339c-0.741-0.335-1.748-0.267-2.04,0.613C320.098,367.569,320.188,367.636,321.979,367.484z  M334.939,353.96c-1.038-2.934-5.66,0.095-1.2,0.989C334.134,354.624,334.495,354.326,334.939,353.96z M314.137,352.405 c-2.408,1.842,0.714,4.336,1.611,1.483C315.082,352.978,315.082,352.978,314.137,352.405z M306.361,363.137 c-0.592-1.627-2.342-1.845-2.632,0.078C304.321,364.799,305.787,364.723,306.361,363.137z M302.266,371.314 c-0.143,0.008-0.249,0.051-0.367,0.084l0.026,2.301C303.127,373.623,304.413,372.579,302.266,371.314z M316.181,363.147 c0.408,0.397,0.864,0.841,1.302,1.269c0.528-0.148,0.97-0.272,1.372-0.385c0.19-0.754-0.27-1.221-0.583-1.915 C317.406,361.819,316.279,361.897,316.181,363.147z M308.219,352.428c-0.485,0.133-0.892,0.244-1.274,0.349 c-0.216,1.507,0.035,1.63,1.385,1.901c0.415-0.269,0.911-0.592,1.402-0.91C309.639,352.713,308.715,352.801,308.219,352.428z  M333.658,358.722c-1.053-0.176-1.726,0.755-1.436,1.725c0.626-0.492,1.227-0.966,1.807-1.425 C333.923,358.911,333.803,358.808,333.658,358.722z M340.863,353.326c-0.019-0.077-0.024-0.155-0.061-0.23 c-1.037-1.784-2.802-0.299-1.993,1.43c0.128,0.136,0.262,0.232,0.4,0.296C340.013,354.14,340.58,353.63,340.863,353.326z  M321.238,358.692c-1.596,0.571-1.783,0.917-1.106,2.324C322.042,361.545,323.145,359.627,321.238,358.692z M330.685,358.02 c0.846-0.578,1.208-2.191-0.124-2.44C328.474,355.83,328.594,358.541,330.685,358.02z M306.273,356.427 c-0.643-0.651-1.357-0.784-2.151-0.549c-0.902,1.456-0.082,1.836,1.19,2.217C306.23,358.19,306.069,357.113,306.273,356.427z  M307.176,378.031c0,0.617,0,1.162,0,1.705c0.657-0.502,1.361-1.04,2.112-1.614C309.009,377.601,308.296,377.333,307.176,378.031 z M307.827,358.671c-0.309,0.306-0.635,0.629-0.962,0.953c0.249,0.475,0.459,0.879,0.716,1.368 C309.808,361.562,310.092,358.79,307.827,358.671z M326.762,352.433c-0.611,0.165-1.392,0.699-0.757,1.339 c0.931,2,1.614,1.245,2.622-0.345C327.804,353.297,327.496,352.412,326.762,352.433z M309.376,366.944 c0.401-1.057-0.617-2.286-1.61-1.873C306.126,366.172,307.896,368.041,309.376,366.944z M317.667,358.36 c1.802-0.986,1.387-3.43-0.852-2.48c-0.049,0.411-0.089,0.745-0.128,1.081c0.568,0.263,0.164,0.645,0.107,1.032 C317.097,358.121,317.406,358.251,317.667,358.36z M323.707,361.819c-0.474,0.236-0.782,0.583-1.114,1.048 c0.406,0.471,0.753,0.874,1.135,1.316c0.397-0.132,0.791-0.263,1.126-0.374C325.587,362.571,324.919,361.99,323.707,361.819z  M319.948,352.987c-0.598,1.851,1.777,2.315,2.309,0.554C321.747,352.839,320.46,351.735,319.948,352.987z M326.762,361.238 c0.772-0.682,1.712-0.347,1.854-1.719C326.853,358.174,324.953,359.455,326.762,361.238z M325.116,355.938 c-0.696-0.472-1.401-0.147-2.158-0.068c-0.075,0.439-0.143,0.846-0.206,1.213c0.748,0.605,0.748,0.605,2.107,0.402 C325.213,357.032,325.331,356.519,325.116,355.938z M311.552,374.464c-0.316,0.22-0.662,0.461-1.015,0.706 c-0.015,0.607-0.094,1.359,0.289,1.777c0.488-0.373,0.988-0.755,1.501-1.148C312.369,375.228,312.304,374.729,311.552,374.464z  M311.956,362.168c-0.451,0.047-0.824,0.085-1.232,0.126c-0.232,0.25-0.568,0.514-0.677,0.865 c1.165,1.277,1.505,1.331,2.858,0.014C312.64,362.691,312.304,362.383,311.956,362.168z M304.993,370.442 c0.595-0.252,1.326-0.225,1.56-1.072c-0.259-0.398-0.578-0.78-1.112-1.006C303.719,368.789,303.051,369.544,304.993,370.442z  M309.434,372.202c-0.242-0.255-0.502-0.53-0.735-0.775c-0.669,0.096-1.303,0.052-1.786,0.583 c-0.235,0.759,0.329,1.131,0.773,1.615C308.275,373.112,309.109,373.043,309.434,372.202z M329.266,362.759 c0.311-0.242,0.625-0.486,0.929-0.724C329.757,362.04,329.426,362.362,329.266,362.759z M335.502,356.812 c0.024,0.211,0.134,0.534,0.286,0.809c0.547-0.439,1.053-0.848,1.531-1.236C336.757,355.73,335.897,355.648,335.502,356.812z  M302.322,377.393c-0.125,0.053-0.236,0.101-0.354,0.151l0.022,1.97c0.316-0.026,0.633-0.176,0.868-0.531 C302.729,378.355,302.711,377.888,302.322,377.393z M313.592,365.462c-0.037,0.328-0.066,0.585-0.111,0.98 c0.69,0.207,1.302,0.917,1.974,0.701c-0.005-0.297-0.228-0.605-0.032-0.952C315.792,365.031,314.252,364.735,313.592,365.462z  M314.886,373.621c0.527-0.507,0.813-0.744,0.846-1.446c-0.504-0.115-0.914-0.209-1.344-0.306 C312.728,372.599,313.226,373.776,314.886,373.621z M302.298,365.122c-0.167,0.212-0.314,0.37-0.463,0.509l0.018,1.649 C303.261,367.096,303.675,365.898,302.298,365.122z M314.6,358.958c-3.103,0.378-0.101,3.054,0.921,0.953 C315.208,359.587,314.912,359.282,314.6,358.958z M304.371,381.884c0.335-0.257,0.702-0.539,1.105-0.847 C304.808,380.77,304.198,381.375,304.371,381.884z M310.596,370.339c0.591-0.454,1.237-0.153,1.664-0.805 C311.562,368.406,310.117,369.04,310.596,370.339z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M301.086,324.34c0.07,6.659,0.141,13.319,0.211,19.978c0.112,10.614,0.224,21.228,0.337,31.842 c0.026,2.436,0.051,4.873,0.077,7.309c0.008,0.804,1.258,0.806,1.25,0c-0.07-6.659-0.141-13.318-0.211-19.978 c-0.112-10.614-0.224-21.228-0.336-31.842c-0.026-2.436-0.052-4.873-0.077-7.309 C302.328,323.536,301.078,323.534,301.086,324.34L301.086,324.34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M301.813,324.968c11.931-9.439,25.677-16.193,38.17-24.81c0.658-0.454,0.034-1.538-0.631-1.079 c-12.584,8.679-26.405,15.496-38.423,25.005C300.299,324.583,301.188,325.462,301.813,324.968L301.813,324.968z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M301.537,323.923c-16.574-2.243-33.209-3.979-49.811-5.987 c-4.904-0.593-9.804-1.211-14.699-1.873c-0.391-0.053-0.794,0.153-0.791,0.603c0.037,5.315,0.098,10.63,0.169,15.945 c0.126,9.478,0.273,18.958,0.594,28.432c0.113,3.343,0.216,6.696,0.504,10.03c0.13,1.508,0.006,2.974,1.593,3.577 c2.84,1.079,6.045,1.462,9.019,1.984c5.249,0.921,10.522,1.709,15.797,2.468c11.65,1.678,23.326,3.189,35.012,4.588 c1.137,0.136,2.273,0.271,3.41,0.404c0.797,0.093,0.791-1.158,0-1.25c-11.155-1.304-22.298-2.732-33.421-4.285 c-5.543-0.774-11.082-1.577-16.605-2.478c-3.738-0.61-7.514-1.194-11.188-2.131c-0.49-0.125-0.981-0.254-1.459-0.421 c-0.224-0.078-0.632-0.268-0.63-0.267c-0.05-0.043,0.051,0.2,0.026,0.031c-0.017-0.112-0.059-0.222-0.079-0.334 c-0.064-0.357-0.105-0.673-0.143-1.034c-0.317-2.944-0.402-5.92-0.514-8.877c-0.35-9.231-0.496-18.471-0.628-27.707 c-0.058-4.017-0.106-8.034-0.147-12.051c-0.014-1.364-0.027-2.728-0.039-4.092c-0.006-0.699,0.121-1.551-0.018-2.238 c-0.018-0.09-0.001-0.199-0.002-0.292c-0.264,0.201-0.527,0.402-0.791,0.603c16.574,2.243,33.209,3.979,49.812,5.987 c4.904,0.593,9.804,1.211,14.699,1.873C301.992,325.235,302.332,324.03,301.537,323.923L301.537,323.923z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M327.765,324.718c-3.065,1.961-6.158,3.945-8.802,6.465c-1.945,1.854-4.752,5.257-2.141,7.805 c1.15,1.122,2.711,0.826,3.99,0.102c1.636-0.927,3.213-2.016,4.761-3.082c1.529-1.053,3.02-2.17,4.409-3.405 c1.212-1.078,2.423-2.264,3.042-3.795c0.611-1.51,0.764-3.386-0.624-4.525C331.007,323.141,329.125,323.967,327.765,324.718 c-0.704,0.389-0.074,1.469,0.631,1.079c1.061-0.586,2.839-1.488,3.632-0.042c0.6,1.095-0.072,2.641-0.693,3.578 c-0.759,1.146-1.858,2.079-2.9,2.959c-1.116,0.941-2.291,1.808-3.492,2.635c-1.208,0.832-2.443,1.624-3.68,2.411 c-1.031,0.656-2.64,1.874-3.696,0.616c-1.912-2.278,1.473-5.19,3.009-6.558c2.401-2.137,5.121-3.872,7.821-5.6 C329.071,325.365,328.445,324.283,327.765,324.718L327.765,324.718z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M264.056,332.328c0,0-0.108-10.63,0.18-11.316c1.05-2.504,35.539-24.747,35.539-24.747 l10.513,0.882l-35.889,25.422l0.338,11.577L264.056,332.328z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M282.587,366.687c0,0-0.371,10.865,0.745,11.705c1.116,0.84,12.08,1.672,12.08,1.672 s0.04-11.22-0.627-11.815C294.118,367.654,282.587,366.687,282.587,366.687z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8380FF"
    },
    d: "M436.823,432.448c-1.538,2.166-36.418,27.031-38.274,28.569c-0.168,0.142-0.822,0.203-1.883,0.177 c-10.513-0.106-60.54-7.242-61.946-10.044c-1.538-3.077-2.467-57.348-2.467-57.348l38.584-22.097c0,0,43.829,3.669,60.124,5.049 c3.183,0.274,5.314,0.451,5.862,0.504C440.218,377.567,438.371,430.291,436.823,432.448z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M429.582,413.01c1.642-1.397,1.57-1.208,2.941,0.174c0.376,1.314-0.836,1.489-1.797,1.856 C429.851,414.683,429.603,413.953,429.582,413.01z M405.648,452.769c1.929-0.344,1.97-2.689-0.066-2.743 C403.717,449.827,404.025,452.778,405.648,452.769z M397.683,410.102l0.011,0.979 C397.875,410.76,397.841,410.418,397.683,410.102z M408.142,405.237c1.551,0.467,2.815-0.173,2.24-1.939 c-0.705-0.571-1.709-1.315-1.799,0.142C406.88,403.582,407.334,404.05,408.142,405.237z M416.805,404.146 c-0.559-2.039-2.4-2.104-3.155-0.169C414.519,405.383,416.118,405.956,416.805,404.146z M411.184,412.234 c-1.354,1.393,1.152,3.128,2.414,1.89C413.977,412.738,412.297,411.334,411.184,412.234z M419.968,440.066 c-0.187-1.861-1.088-3.91-2.936-1.916C416.322,439.392,418.829,440.131,419.968,440.066z M437.379,415.038 c0.306-0.207,0.65-0.44,1.01-0.684c0.013-0.32,0.025-0.642,0.037-0.965C437.627,410.452,433.519,413.818,437.379,415.038z  M432.237,408.067c0.095-0.434,0.186-0.846,0.283-1.286c-0.336-0.31-0.65-0.6-0.982-0.905 C428.224,406.227,429.853,410.105,432.237,408.067z M416.246,409.241c-0.53-0.96-1.526,0.086-2.264,0.319 c-0.407,1.893,1.624,2.81,2.729,1.214C417.021,410.198,416.429,409.75,416.246,409.241z M411.972,396.113 c0.567-0.245,1.311-0.209,1.6-1.068C413.012,391.263,408.831,394.811,411.972,396.113z M417.873,393.303 c-0.376,0.509-0.757,0.855-0.946,1.456C418.544,398.446,421.722,393.703,417.873,393.303z M402.75,434.002 c-0.751,0.528-1.328,1.117-1.67,1.954c0.495,0.38,0.934,0.718,1.421,1.09C404.351,436.477,404.702,434.622,402.75,434.002z  M404.969,439.923c1.573,1.24,3.373-2.261,0.756-2.651C404.142,437.669,404.297,438.93,404.969,439.923z M397.609,403.467 l0.013,1.16c0.103-0.157,0.191-0.337,0.253-0.548C397.821,403.865,397.724,403.66,397.609,403.467z M424.317,399.448 c-0.5,0.478-0.601,1.255-0.98,1.919c0.945,1.629,2.188,0.39,2.911-0.447C426.125,399.56,425.152,399.582,424.317,399.448z  M406.026,405.931c-2.37,0.561-1.694,2.324,0.082,2.831C407.833,408.136,407.514,406.578,406.026,405.931z M432.291,382.031 c-0.497-0.373-0.365-1.336-1.291-1.489l-1.308,0.817c-0.084,0.266-0.158,0.498-0.226,0.714 C429.767,383.69,432.292,383.821,432.291,382.031z M424.236,387.266c-1.04,0.154-0.866,0.849-0.806,1.666 c1.12,0.671,1.12,0.671,1.925,0.569c0.298-0.423,0.592-0.839,0.927-1.313C425.989,387.131,425.309,386.673,424.236,387.266z  M399.704,437.159c-2.29,0.584-1.617,4.05,0.776,2.729c-0.067-0.621,0.017-1.156,0.339-1.655 C400.383,437.812,400.024,437.467,399.704,437.159z M426.835,398.684c1.389,1.057,2.934-0.168,2.271-1.773 c-0.642-0.635-2.46-0.738-2.185,0.428C426.803,397.73,426.218,398.365,426.835,398.684z M409.723,430.208 c0.916-0.625,0.309-1.356-0.078-2.141c-0.71-0.988-2.16,0.215-2.011,1.22C407.459,430.4,409.063,430.958,409.723,430.208z  M414.826,424.43c2.699,0.561,1.307-5.115-0.861-2.004C413.797,423.295,414.052,424.031,414.826,424.43z M425.556,418.831 c-2.471-0.518-3.332,1.455-0.915,2.499C425.853,421.198,426.431,419.717,425.556,418.831z M419.557,408.213 c0.133-0.353,0.253-0.668,0.366-0.97c-1.068-2.419-2.223-1.663-3.075,0.33C417.649,408.481,418.603,408.258,419.557,408.213z  M405.381,446.147c0.538,0.888,1.385-0.208,1.739-0.743c0.793-0.909-0.664-1.454-1.232-1.896 c-0.758,0.097-1.016,0.688-1.325,1.186C404.363,445.327,405.198,445.587,405.381,446.147z M410.163,398.916 c0.111-0.426,0.226-0.875,0.352-1.367c-1.554-1.599-3.358-0.949-2.757,1.296C408.645,398.622,409.335,399.261,410.163,398.916z  M421.294,433.983c-0.376,0.459-0.701,0.854-1.086,1.323c0.074,1.241,1.243,1.963,2.329,1.431 C423.343,435.866,422.302,434.207,421.294,433.983z M433.89,399.023c3.095,0.721,1.117-4.823-1.284-1.71 C433.291,397.898,433.182,398.698,433.89,399.023z M416,392.595c0.179-0.363,0.352-0.713,0.523-1.06 c-0.118-0.34-0.231-0.663-0.375-1.08c-0.242-0.123-0.456-0.185-0.657-0.223l-1.446,0.904 C413.786,392.14,414.456,393.469,416,392.595z M402.287,399.059c1.16-0.118,1.462-0.7,1.332-1.409l-1.858,1.161 C401.908,398.908,402.078,398.995,402.287,399.059z M431.186,399.675c-0.456,0.175-0.938,0.359-1.381,0.529 c-0.86,1.698,1.354,2.536,2.409,1.63C432.369,400.162,432.369,400.162,431.186,399.675z M428.464,392.883 c0.474-1.251,0.614-2.982-1.206-2.93c-0.589,0.667-0.769,1.08-0.988,2.02C427.026,392.306,427.528,392.996,428.464,392.883z  M433.958,415.237c-0.359,0.296-0.753,0.618-1.173,0.963c0.327,0.755,0.517,1.527,1.281,2c0.769-0.154,1.302-0.585,1.563-1.423 C435.147,416.218,434.947,415.369,433.958,415.237z M398.352,420.751c1.853,1.222,3.606-1.525,1.327-2.364 C398.271,418.757,397.989,419.276,398.352,420.751z M409.676,449.124c0.278-0.335,0.545-0.658,0.826-0.997 c-0.467-0.593-0.68-1.375-1.624-1.463c-0.355,0.235-0.745,0.497-1.168,0.779C407.419,449.406,408.17,449.319,409.676,449.124z  M412.401,430.856c-2.333,0.862-1.845,3.48,0.665,2.745C413.7,432.918,413.266,431.487,412.401,430.856z M413.562,407.657 c-0.396-0.622-0.428-1.527-1.539-1.679c-1.583,0.679-1.743,2.345,0.09,2.764C412.741,408.567,413.205,408.208,413.562,407.657z  M435.722,379.419c-0.004-0.699-0.277-1.174-0.656-1.417l-2.039,1.274C433.281,380.749,434.901,380.487,435.722,379.419z  M410.799,425.25c0.034,1.06,0.332,1.89,1.213,2.373c0.925-0.372,1.225-0.648,1.586-1.566 C412.848,424.978,412.119,424.578,410.799,425.25z M431.15,427.644c0.445-0.474,1.11-0.844,1.343-1.788 c-0.501-0.32-0.751-0.884-1.357-1.059C429.339,425.09,429.222,427.389,431.15,427.644z M401.405,447.784 c-0.344,2.175,1.896,2.266,2.765,0.525C403.546,446.413,402.697,446.827,401.405,447.784z M417.454,399.757 c-0.101,0.286-0.214,0.604-0.346,0.979C418.98,404.879,422.017,399.02,417.454,399.757z M426.846,383.99 c-0.146,1.463-0.534,2.572,1.4,2.204C430.574,385.501,428.634,383.089,426.846,383.99z M414.653,417.913 c1.589-0.062,2.411-1.048,1.47-2.561C414.535,414.418,413.249,416.987,414.653,417.913z M419.659,413.556 c-0.237-0.557-0.19-1.307-0.976-1.531c-1.889,0.204-1.996,2.538-0.216,3.008C419.058,414.724,419.438,414.218,419.659,413.556z  M435.332,385.884c0.351-1.102-0.025-1.813-0.959-2.264c-1.549,0.358-1.174,1.126-1.387,2.4 C433.838,386.375,434.596,386.179,435.332,385.884z M437.3,427.689c0.112-0.063,0.21-0.118,0.306-0.172 c0.071-0.773,0.14-1.62,0.207-2.531C435.788,424.659,435.43,426.298,437.3,427.689z M399.87,427.397 c1.313-0.769,1.039-1.979-0.146-2.701c-0.645-0.538-1.059,0.352-1.34,0.863C397.715,426.706,398.906,427.219,399.87,427.397z  M405.679,421.063c0.445,0.111,0.733-0.017,0.878-0.513c0.1-0.67,0.716-0.941,0.903-1.526c-0.813-0.11-0.813-0.11-1.698-0.803 C404.527,418.962,403.714,420.729,405.679,421.063z M417.119,432.436c0.065,1.74,1.965,1.225,2.859,0.249 C419.328,431.143,417.539,430.265,417.119,432.436z M401.923,455.634c0.572-0.073,1.121-0.143,1.608-0.206 c0.577-0.657,0.425-1.357,0.379-2.103C402.654,452.613,400.101,454.606,401.923,455.634z M406.651,414.429 c1.953-3.47-4.23-2.32-1.523,0.359C405.639,414.668,406.096,414.56,406.651,414.429z M435.03,403.063c-0.613,0-1.166,0-1.703,0 c-1.672,1.664,1.679,3.421,2.357,1.209C435.472,403.881,435.25,403.471,435.03,403.063z M436.476,399.834 c-0.733,0.658-0.573,2.491,0.532,2.417C439.721,402.613,438.294,398.891,436.476,399.834z M433.284,423.859 c0.52,0.127,1.016,0.248,1.645,0.399C437.124,421.147,431.531,420.566,433.284,423.859z M435.355,409.436 c-1.589-0.497-2.468-0.301-2.514,1.499c0.348,0.577,0.857,0.91,1.668,1.004C434.881,411.041,435.598,410.377,435.355,409.436z  M427.864,437.152c0.459-0.352,0.85-0.661,1.248-0.976c0.228-1.243-0.989-2.606-1.895-1.593 C426.286,435.754,426.372,436.541,427.864,437.152z M427.354,409.359c-1.305,1.311-0.756,1.912,0.739,2.529 C429.932,411.49,429.163,408.699,427.354,409.359z M402.707,443.406c0.363-0.631,0.363-0.631,1.178-0.951 C403.042,438.502,398.976,442.038,402.707,443.406z M413.7,448.263c0.179,0.486,0.517,0.844,0.917,1.031 c0.526-0.383,1.053-0.767,1.584-1.154C415.911,446.435,414.818,446.306,413.7,448.263z M437.713,408.516 c0.818-0.768,1.456-2.079-0.041-2.639c-0.546,0.372-1.59,0.261-1.684,1.063C435.783,408.351,436.642,408.111,437.713,408.516z  M423.541,431.623c0.064,0.639,0.12,1.188,0.173,1.726c0.394,0.207,0.739,0.387,1.162,0.609 C426.959,432.666,425.82,430.472,423.541,431.623z M425.737,394.492c-0.053-1.777-2.633-1.444-2.244,0.443 C423.44,396.447,426.033,396.244,425.737,394.492z M432.888,435.506c0.017,0.072,0.044,0.129,0.065,0.194 c0.668-0.517,1.264-0.986,1.78-1.401C433.519,434.238,433.681,434.847,432.888,435.506z M422.2,396.525 c-0.963-0.169-1.624,0.058-1.911,0.959C420.875,400.326,424.117,398.809,422.2,396.525z M422.49,385.859l-0.926,0.578 C421.94,386.401,422.268,386.172,422.49,385.859z M413.283,419.378c-0.523-0.861-1.302-0.566-2.029-0.585 c-0.218,0.31-0.414,0.589-0.596,0.849C410.73,421.786,413.412,421.457,413.283,419.378z M420.348,409.471 c-0.329,0.882,0.009,1.532,0.615,2.142c0.849,0.152,1.437-0.23,1.854-0.926C422.403,409.353,421.65,408.602,420.348,409.471z  M420.595,423.909c0.235,0.106,0.499,0.225,0.814,0.37c0.454-0.624,1.277-0.766,1.624-1.446 C421.912,421.036,419.421,421.351,420.595,423.909z M413.722,435.021c0.334,0.632,0.633,1.2,0.932,1.769 c0.907-0.081,1.139-0.168,1.884-0.708C416.375,434.554,414.764,433.625,413.722,435.021z M436.843,393.28 c-1.65,1.785-0.512,1.787,0.775,2.884c0.246-0.134,0.436-0.237,0.649-0.354c0.044-0.621,0.145-1.166,0.332-1.779 C437.99,393.77,437.442,393.535,436.843,393.28z M436.269,389.223c0.644,0.357,2.57,0.879,2.247-0.468 c-0.1-0.305-0.061-0.516,0.065-0.719c-0.005-0.137-0.01-0.276-0.016-0.412c-0.159-0.201-0.316-0.4-0.49-0.62 c-0.501,0.184-1.366,0.21-1.482,0.811C436.687,388.373,435.424,388.733,436.269,389.223z M419.411,387.783l-2.204,1.377 C418.415,390.142,419.464,389.279,419.411,387.783z M425.625,406.57c-0.684-0.301-1.384-0.681-2.135,0.017 C422.429,409.112,426.557,409.554,425.625,406.57z M399.569,456.161c-0.534,0.405-0.936,0.712-1.363,1.037l0.002,0.188 C399.341,460.524,402.726,456.767,399.569,456.161z M401.985,402.87c-1.19,1.315,0.79,3.496,1.874,1.914 C404.383,403.667,403.185,402.352,401.985,402.87z M416.498,397.146c-0.497-0.803-1.162-0.773-1.963-0.572 c-0.186,0.482-0.383,0.995-0.562,1.46C415.346,399.953,416.225,398.974,416.498,397.146z M398.765,443.544 c-0.037,1.103-0.576,2.229,0.727,3.04c0.678-0.397,1.074-0.893,1.301-1.643c-0.29-0.452-0.615-0.957-0.967-1.503 C399.467,443.474,399.136,443.506,398.765,443.544z M404.803,433.384c0.449,0.447,0.951,0.344,1.366,0.277 C409.387,431.342,404.473,429.653,404.803,433.384z M418.7,443.778c-2.045,0.296-1.934,2.498,0.016,2.525 c0.305-0.223,0.609-0.445,0.913-0.668C419.693,444.941,419.239,443.947,418.7,443.778z M409.203,411.633 c1.688-0.283,0.775-2.942-0.89-2.731C407.376,409.661,407.884,411.605,409.203,411.633z M431.256,386.997 c-4.053,0.946,0.662,4.9,0.677,1.005C432.191,387.551,431.545,387.278,431.256,386.997z M410.144,434.673 c-0.397-0.202-0.809-0.411-1.225-0.621c-0.33,0.127-0.644,0.249-0.979,0.378c-0.029,0.59-0.057,1.143-0.09,1.792 C408.968,437.121,410.705,436.129,410.144,434.673z M436.823,432.448c0.122-0.171,0.246-0.659,0.37-1.41 c-1.631,0.587-1.564,1.531-0.965,2.008C436.524,432.78,436.735,432.573,436.823,432.448z M400.785,432.022 c-0.581-1.51-3.445-0.48-2.24,1.316C399.807,434.125,400.502,433.219,400.785,432.022z M417.901,421.012 c2.667,0.821,1.659-3.615-0.387-2.146C416.659,419.715,417.454,420.293,417.901,421.012z M409.554,417.622 c0.995-1.298,0.986-1.462-0.146-2.245c-0.439,0.111-0.894,0.227-1.39,0.351c-0.172,0.319-0.356,0.659-0.568,1.054 C408.326,417.678,408.423,417.714,409.554,417.622z M402.526,430.544c0.506-0.488,1.186-0.61,1.408-1.32 c-0.358-0.433-0.151-1.196-1.008-1.566C401.955,428.853,399.928,429.471,402.526,430.544z M406.946,425.121 c-0.57-0.049-1.085-0.094-1.708-0.147c-0.265,0.29-0.494,0.544-0.707,0.775c0.409,1.023,0.593,1.185,1.826,1.632 c0.323-0.423,0.749-0.737,0.969-1.247C407.209,425.822,407.076,425.472,406.946,425.121z M401.528,452.257 c-0.682-0.895-1.015-1.824-1.882-2.424c-1.29,0.299-0.29,0.926-1.141,1.256c-0.809,0.46,0.312,1.537,0.949,1.166 C400.241,451.836,400.694,452.393,401.528,452.257z M398.177,407.785c0.416,0.322,0.808,0.486,1.265,0.709 c0.578-0.526,1.045-0.948,1.555-1.412C400.344,405.138,398.22,405.972,398.177,407.785z M421.972,402.911 c-0.557,0.173-1.084,0.337-1.634,0.508c-0.096,0.174-0.2,0.361-0.339,0.615C420.793,406.392,424.558,404.654,421.972,402.911z  M435.788,419.499c0.003,1.226,1.021,1.494,2.033,1.599c0.109-0.096,0.191-0.195,0.262-0.295c0.031-0.538,0.06-1.09,0.089-1.651 c-0.444-0.219-0.837-0.412-1.236-0.608C436.53,418.916,436.214,419.171,435.788,419.499z M412.986,450.095 c-1.231-0.33-1.504-0.42-2.07,1.049c0.099,0.202,0.201,0.412,0.302,0.62c0.638-0.463,1.288-0.936,1.944-1.413 C413.118,450.267,413.061,450.182,412.986,450.095z M428.46,417.616c0.966-1.197,0.145-2.972-1.412-2.068 C425.675,416.483,427.189,418.09,428.46,417.616z M411.622,444.026c-0.334,0.63-1.285,1.041-0.637,1.826 c0.517,0.877,2.458,0.454,2.063-0.659C413.384,444.308,412.212,443.105,411.622,444.026z M431.369,433.702 c0.372-0.336,0.771-0.591,0.913-1.035c-0.563-0.641-1.067-1.215-1.633-1.859C429.124,431.797,429.58,433.588,431.369,433.702z  M406.079,399.594c-0.534,0.534-1.255,0.643-1.762,1.168c0.248,0.597,0.495,1.079,0.835,1.613 c0.894-0.367,1.952-0.465,1.909-1.791C406.503,400.413,406.343,400.147,406.079,399.594z M430.978,393.124 c-0.844,0.17-0.99,0.905-1.254,1.543C431.678,397.054,433.589,394.04,430.978,393.124z M408.984,424.502 c1.023-0.559,1.181-1.335,0.901-2.262c-0.657-0.468-0.66-0.461-1.337-0.486C407.883,422.696,407.391,424.255,408.984,424.502z  M407.76,454.276c0.354-0.257,0.718-0.521,1.083-0.786c-0.264,0.061-0.527,0.137-0.797,0.147 C407.938,453.878,407.847,454.081,407.76,454.276z M406.632,395.767l-0.511,0.319c0.04,0.021,0.082,0.04,0.12,0.065 C406.39,396.007,406.515,395.887,406.632,395.767z M436.664,382.999c0.916,0.238,1.324,0.034,1.575-0.48 c-0.051-0.54-0.107-1.047-0.168-1.515C436.807,380.134,435.465,381.477,436.664,382.999z M418.45,427.182 c0.97,0.614,1.017-0.66,1.406-1.247c-0.441-0.666-0.441-0.666-1.594-1.063c-0.326,0.305-0.671,0.63-1.07,1.005 C417.556,426.768,417.556,426.768,418.45,427.182z M424.958,414.812c0.769-0.368,0.959-1.072,1.237-1.764 C423.776,411.074,422.482,413.371,424.958,414.812z M398.58,401.87c1.728,0.496,2.737-0.723,1.589-2.065l-1.656,1.034 C398.459,401.175,398.472,401.535,398.58,401.87z M407.86,441.033c-0.182,1.628,0.408,2.115,2.013,1.822 c0.127-0.51,0.23-0.923,0.328-1.316C409.829,440.681,408.544,440.563,407.86,441.033z M430.119,437.863 c0.227-0.171,0.448-0.339,0.666-0.504C430.447,437.374,430.233,437.549,430.119,437.863z M413.311,401.014 c0.017-1.942-1.758-1.708-2.535-0.26C411.016,402.026,413.17,402.388,413.311,401.014z M398.54,412.876 c-1.044,1.43,0.426,1.826,1.671,1.867c0.162-0.437,0.306-0.827,0.42-1.129c-0.216-0.473-0.391-0.854-0.609-1.333 C399.441,412.514,399.004,412.689,398.54,412.876z M403.871,416.014c-1.206-1.177-1.582-0.439-2.455,0.523 C402.542,418.237,403.91,418.28,403.871,416.014z M423.24,438.662c0.369,0.339,0.65,0.77,0.795,1.245 c1.508,0.21,1.885-0.538,1.621-1.8C424.526,437.473,424.29,437.525,423.24,438.662z M421.691,392.659c0-0.158,0-0.325,0-0.582 c0.983,0.145,1.169,0.012,1.157-0.738c0.128-1.057-1.365-1.098-2.092-1c-0.073,0.711-0.137,1.333-0.207,2.029 C420.884,392.529,421.17,392.913,421.691,392.659z M421.569,415.69c-1.828,0.182-1.492,2.025,0.121,2.218 C423.252,417.516,423.013,415.938,421.569,415.69z M413.956,429.313c0.515,0.647,0.995,1.34,1.976,1.453 c0.365-0.832,0.378-1.523,0.138-2.36C414.893,428.08,414.85,428.099,413.956,429.313z M410.928,438.946 c0.571,1.04,2.344,1.678,2.619,0.065C413.093,437.966,410.424,437.207,410.928,438.946z M427.909,402.606 c-0.442,0.632-0.837,1.277-1.13,1.984c1.478,0.735,1.917,0.679,2.594-0.325C428.907,403.732,428.714,402.952,427.909,402.606z  M432.781,391.44c0.381,0.387,0.148,1,0.745,1.264c0.549-0.412,1.425-0.305,1.852-1.102c-0.433-0.491-0.851-0.967-1.26-1.431 C433.297,390.263,433.322,391.07,432.781,391.44z M414.323,441.102c-0.104,0.227-0.226,0.497-0.34,0.747 c0.842,1.111,0.875,1.136,1.855,1.42c0.308-0.469,0.488-1.003,0.609-1.547C415.899,440.899,415.012,440.955,414.323,441.102z  M403.938,410.196c-0.504-2.511-3.862,1.185-1.492,1.476C403.25,411.651,403.976,410.875,403.938,410.196z M430.655,421.099 c0.609-0.206,1.062-0.445,1.635-0.828c-0.111-1.65-1.413-1.881-2.548-0.836C430.137,419.91,430.03,420.644,430.655,421.099z  M428.862,424.121c-0.088-0.84,0.001-1.941-0.762-2.424c-0.568-0.2-1.397,0.373-0.888,0.907 C426.515,423.816,427.589,424.478,428.862,424.121z M420.87,440.939c-1.11,1.237,0.982,2.75,1.933,1.471 C422.471,441.168,422.337,440.44,420.87,440.939z M427.646,430.527c0.282,0,0.666,0,1.106,0c1.112-2.212-0.73-2.498-2.016-1.288 C427.057,429.692,427.324,430.072,427.646,430.527z M432.849,429.214c0.226,1.214,1.614,1.886,2.56,0.886c0-0.273,0-0.57,0-0.888 C434.492,428.452,433.711,428.782,432.849,429.214z M403.76,422.739c-0.49-0.442-2.161-1.76-2.044-0.34 c0.152,0.285,0.124,0.559,0.025,0.873C401.694,424.56,403.318,424.109,403.76,422.739z M422.324,428.522 c-0.758-0.77-1.736-0.096-0.968,0.849c-0.218,0.121-0.438,0.242-0.719,0.397C421.144,431.642,423.381,429.794,422.324,428.522z  M425.673,426.698c-0.107-0.516-0.212-1.014-0.32-1.538c-0.758-0.216-1.247,0.13-1.724,0.69 C424.239,426.509,424.753,427.856,425.673,426.698z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M397.301,401.891c0.07,6.659,0.141,13.319,0.211,19.978c0.112,10.614,0.224,21.228,0.336,31.842 c0.026,2.436,0.052,4.873,0.077,7.309c0.008,0.804,1.258,0.806,1.25,0c-0.07-6.659-0.141-13.318-0.211-19.978 c-0.112-10.614-0.224-21.228-0.337-31.842c-0.026-2.436-0.051-4.873-0.077-7.309 C398.543,401.087,397.293,401.085,397.301,401.891L397.301,401.891z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M398.028,402.518c11.931-9.439,25.677-16.193,38.17-24.81c0.658-0.454,0.034-1.538-0.631-1.079 c-12.584,8.679-26.405,15.496-38.423,25.005C396.514,402.133,397.404,403.013,398.028,402.518L398.028,402.518z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M397.752,401.474c-16.574-2.243-33.209-3.979-49.811-5.987 c-4.904-0.593-9.804-1.211-14.699-1.874c-0.391-0.053-0.794,0.153-0.791,0.603c0.037,5.315,0.098,10.63,0.169,15.945 c0.126,9.478,0.273,18.958,0.594,28.432c0.113,3.343,0.216,6.696,0.504,10.03c0.13,1.508,0.006,2.974,1.593,3.577 c2.84,1.079,6.045,1.462,9.019,1.984c5.249,0.921,10.522,1.708,15.797,2.468c11.65,1.678,23.326,3.189,35.012,4.588 c1.137,0.136,2.273,0.271,3.41,0.403c0.797,0.093,0.791-1.158,0-1.25c-11.155-1.303-22.298-2.732-33.421-4.285 c-5.542-0.774-11.082-1.577-16.605-2.478c-3.738-0.61-7.514-1.194-11.188-2.131c-0.49-0.125-0.981-0.254-1.459-0.421 c-0.224-0.078-0.632-0.268-0.63-0.267c-0.05-0.043,0.051,0.2,0.026,0.031c-0.017-0.112-0.059-0.222-0.079-0.334 c-0.064-0.357-0.104-0.673-0.143-1.034c-0.317-2.944-0.402-5.92-0.514-8.877c-0.35-9.231-0.496-18.471-0.628-27.707 c-0.057-4.017-0.106-8.034-0.147-12.051c-0.014-1.364-0.027-2.728-0.039-4.092c-0.006-0.699,0.121-1.551-0.018-2.238 c-0.018-0.09-0.001-0.199-0.002-0.292c-0.264,0.201-0.527,0.402-0.791,0.603c16.573,2.243,33.209,3.979,49.811,5.987 c4.904,0.593,9.804,1.211,14.699,1.874C398.207,402.786,398.547,401.581,397.752,401.474L397.752,401.474z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M423.98,402.269c-3.065,1.961-6.158,3.945-8.802,6.465c-1.945,1.854-4.752,5.257-2.141,7.805 c1.15,1.122,2.711,0.826,3.99,0.102c1.636-0.927,3.213-2.016,4.761-3.082c1.529-1.053,3.02-2.171,4.409-3.405 c1.212-1.078,2.423-2.264,3.042-3.795c0.611-1.51,0.764-3.386-0.624-4.524C427.222,400.692,425.34,401.518,423.98,402.269 c-0.704,0.389-0.074,1.469,0.631,1.079c1.061-0.586,2.839-1.489,3.632-0.042c0.6,1.096-0.072,2.641-0.693,3.578 c-0.759,1.146-1.858,2.079-2.9,2.959c-1.116,0.941-2.291,1.808-3.492,2.635c-1.208,0.832-2.443,1.624-3.68,2.411 c-1.031,0.656-2.64,1.874-3.696,0.616c-1.912-2.278,1.473-5.19,3.009-6.558c2.401-2.137,5.121-3.872,7.821-5.6 C425.286,402.916,424.66,401.834,423.98,402.269L423.98,402.269z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M360.271,409.879c0,0-0.108-10.63,0.18-11.316c1.05-2.504,35.539-24.747,35.539-24.747 l10.513,0.882l-35.889,25.422l0.338,11.577L360.271,409.879z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M378.802,444.238c0,0-0.371,10.865,0.745,11.705c1.116,0.84,12.08,1.672,12.08,1.672 s0.04-11.22-0.627-11.815C390.334,445.204,378.802,444.238,378.802,444.238z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M308.496,378.272c11.748-9.45,23.495-18.901,35.243-28.351c0.627-0.504-0.263-1.384-0.884-0.884 c-11.748,9.451-23.495,18.901-35.243,28.351C306.985,377.893,307.874,378.772,308.496,378.272L308.496,378.272z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_00000168090531184540882930000013469966503898384789_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE7A"
    },
    d: "M194.079,121.541c-0.027-0.627-0.088-1.271-0.168-1.942c-0.786-6.541-2.269-11.317-4.599-14.743 c-0.194-0.291-0.406-0.574-0.618-0.847c-7.733-9.967-25.372-9.296-31.26,2.013c-0.883,1.704,0.389,4.123,0.406,6.065 c0.009,1.289,0.106,2.675,0.265,4.105c0.168,1.554,0.415,3.16,0.697,4.741c0.327,1.81,0.706,3.593,1.077,5.235 c0.803,3.496,1.616,6.33,1.933,7.433l0.009,0.027c0.088,0.3,0.141,0.468,0.141,0.468l-0.3,7.592l-0.053,1.289l-0.079,1.995 l-0.079,1.964l12.574,8.356l6.312-7.43l0.112-2.449l0.23-4.9l0.018-0.45c0,0,0.177-0.027,0.503-0.097 C183.724,139.427,194.9,136.178,194.079,121.541z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M186.472,111.011c0.107,0.666-0.292,1.284-0.892,1.381c-0.6,0.097-1.173-0.364-1.281-1.03 c-0.107-0.666,0.292-1.284,0.892-1.381C185.791,109.885,186.365,110.346,186.472,111.011z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M174.224,112.139c0.107,0.666-0.292,1.284-0.892,1.381c-0.6,0.097-1.174-0.364-1.281-1.03 c-0.107-0.666,0.292-1.284,0.892-1.381C173.543,111.012,174.117,111.473,174.224,112.139z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M165.889,107.475c0.984-0.831,2.393-1.381,3.627-1.692c1.245-0.314,2.383-0.11,3.626-0.184 c0.737-0.044,0.812-0.969,0.167-1.231c-2.832-1.147-6.007,0.671-7.918,2.608C165.067,107.304,165.547,107.764,165.889,107.475 L165.889,107.475z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M185.058,103.466c-2.27-1.842-5.642-1.125-6.834,1.547c-1.794,4.021,1.08,9.881,3.821,12.791 c0.503,0.534,1.457-0.171,1.032-0.796c-1.587-2.336-3.184-4.666-3.789-7.487c-0.409-1.909-0.459-4.327,1.436-5.415 c1.121-0.644,2.855-0.592,4.071-0.189C185.041,103.998,185.269,103.637,185.058,103.466L185.058,103.466z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M186.194,90.771c0,0,3.305-2.118-0.402-5.058c-5.584-4.429-13.886,1.039-13.886,1.039 s0.274-2.166-3.11-1.892c-9.623,0.78-10.425,9.305-10.425,9.305c-9.953,4.005-10.098,10.993-9.106,16.94 c2.08,12.473,12.558,22.519,12.558,22.519l-2.445-11.986c0,0,5.168-3.012,3.04-9.437c-1.106-3.341-3.7-2.86-3.293-5.793 c0.407-2.933,9.291-6.803,9.291-6.803l3.802-0.815c0,0,5.172,5.404,11.485,6.581c5.823,1.086,5.768-3.736,5.768-3.736 s4.656,0.517,5.173-4.426C195.428,89.716,186.194,90.771,186.194,90.771z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE7A"
    },
    d: "M159.298,116.576c-1.884-0.923-4.388-0.343-5.192,0.484c-0.805,0.827-1.202,1.986-1.297,3.136 c-0.158,1.912,0.54,3.944,2.045,5.134c1.505,1.19,4.911,1.409,6.406,0.206L159.298,116.576z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M155.858,121.715c0.291-0.269,1.035-0.504,1.417-0.562c0.616-0.093,1.04,0.17,1.525,0.503 c0.566,0.388,1.084-0.431,0.691-0.895c-0.54-0.637-1.52-0.896-2.325-0.731c-0.387,0.079-0.804,0.268-1.084,0.555 c-0.313,0.32-0.292,0.628-0.405,1.025C155.645,121.717,155.78,121.787,155.858,121.715L155.858,121.715z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M158.534,96.178c-1.053-2.714-1.722-5.512-2.179-8.385c-0.109-0.686-1.142-0.391-1.04,0.287 c0.437,2.924,1.363,5.68,2.608,8.356C158.08,96.777,158.672,96.534,158.534,96.178L158.534,96.178z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M160.363,96.915c-2.147-2.054-4.543-3.783-7.211-5.096c-0.738-0.363-1.388,0.722-0.65,1.112 c2.532,1.338,4.922,2.887,7.123,4.723C160.132,98.077,160.856,97.388,160.363,96.915L160.363,96.915z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M171.979,138.775c3.43,1.945,7.029,2.924,10.933,1.913c0.7-0.181,0.401-1.213-0.296-1.074 c-3.72,0.739-6.97-0.21-10.597-0.934C171.964,138.668,171.925,138.744,171.979,138.775L171.979,138.775z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M181.571,121.822c-1.965-0.36-3.441-1.038-4.941-2.354c-0.805-0.706-1.848,0.356-1.167,1.167 c1.414,1.684,3.997,2.511,6.108,1.919C181.911,122.458,181.953,121.892,181.571,121.822L181.571,121.822z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M190.149,199.986c0.241,0.764,12.922,33.929,28.358,33.165 c15.435-0.764,17.55-19.924,17.267-28.581c-0.079-2.405-0.112-4.818-0.119-7.048c-0.018-5.914-4.453-10.88-10.331-11.534 l-8.124-0.904c-8.431-23.901-16.325-34.467-18.708-32.294C194.874,156.089,190.149,199.986,190.149,199.986z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M220.163,187.094c-2.347,4.397-3.582,9.487-4.691,14.312c-1.17,5.09-2.2,10.364-2.226,15.606 c-0.004,0.861-1.343,0.863-1.338,0c0.026-5.355,1.078-10.762,2.274-15.962c1.136-4.942,2.423-10.128,4.826-14.632 C219.413,185.658,220.569,186.334,220.163,187.094L220.163,187.094z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M209.408,230.462c6.017,5.713,15.374,3.5,20.492-2.217c6.26-6.992,6.902-16.953,6.963-25.888 c0.035-5.133-0.437-10.386-3.018-14.933c-0.397-0.7-1.477-0.07-1.079,0.631c2.112,3.72,2.726,7.959,2.831,12.181 c0.11,4.395-0.04,8.897-0.696,13.247c-1.143,7.58-4.964,16.228-12.989,18.548c-3.994,1.155-8.547,0.466-11.62-2.452 C209.709,229.024,208.823,229.906,209.408,230.462L209.408,230.462z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M142.725,153.147c0,0,26.201,34.495,29.267,34.88c3.066,0.385,17.175-38.31,17.175-38.31 l-9.008-2.944c0,0-4.543,5.316-18.901,0.62L142.725,153.147z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M173.957,157.082c0,0.11,11.68,64.248,11.68,68.829s-7.273,18.831-9.4,16.419 c-2.127-2.411-8.705-12.098-8.372-16.802c0.333-4.704,2.993-68.183,2.993-68.183L173.957,157.082z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M173.6,149.238c0,0,2.862,2.807,3.145,4.648c0.462,3.011-3.718,6.023-3.718,6.023 s-4.74-1.359-5.174-4.858c-0.076-0.611,1.434-5.239,2.291-5.905L173.6,149.238z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M158.689,148.19c0,0,1.735-6.374,2.955-6.044s9.607,4.535,10.038,5.735 c0.432,1.2-3.808,8.308-3.808,8.308S159.169,150.83,158.689,148.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M185.381,147.946c0,0-3.591-5.436-4.811-5.105c-1.22,0.331-8.164,3.931-8.596,5.131 c-0.432,1.2,6.168,7.319,6.168,7.319S184.901,150.586,185.381,147.946z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M157.515,149.51c0.992,1.88,2.144,3.664,3.451,5.341c1.026,1.316,2.434,3.532,4.379,3.264 c1.814-0.249,3.062-2.355,3.974-3.743c1.16-1.766,2.071-3.682,2.748-5.682c0.259-0.764-0.948-1.091-1.205-0.332 c-0.581,1.716-1.351,3.355-2.308,4.894c-0.463,0.745-0.966,1.467-1.514,2.152c-0.468,0.584-1.066,1.369-1.862,1.474 c-0.797,0.105-1.402-0.631-1.878-1.166c-0.626-0.703-1.222-1.433-1.785-2.188c-1.094-1.469-2.064-3.025-2.919-4.644 C158.218,148.168,157.139,148.799,157.515,149.51L157.515,149.51z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M171.414,148.839c0.868,1.309,1.795,2.581,2.784,3.802c0.517,0.639,1.054,1.264,1.626,1.854 c0.463,0.478,0.972,1.053,1.607,1.295c0.681,0.26,1.274,0.034,1.805-0.417c0.719-0.611,1.397-1.277,2.093-1.915 c1.498-1.372,2.996-2.744,4.494-4.117c0.594-0.544-0.291-1.427-0.884-0.884c-1.237,1.133-2.475,2.267-3.712,3.401 c-0.619,0.567-1.238,1.133-1.856,1.7c-0.293,0.268-0.578,0.548-0.879,0.805c-0.365,0.312-0.56,0.348-0.948,0.048 c-0.994-0.768-1.822-1.855-2.602-2.829c-0.869-1.085-1.68-2.217-2.448-3.375C172.05,147.541,170.967,148.166,171.414,148.839 L171.414,148.839z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M155.277,150.136c0.625-0.252,1.25-0.504,1.875-0.756c0.21-0.085,0.42-0.167,0.629-0.254 c0.283-0.117,0.365-0.27,0.476-0.515c0.66-1.462,1.338-2.919,2.084-4.339c0.204-0.389,0.413-0.776,0.643-1.15 c0.082-0.134,0.17-0.264,0.26-0.393c0.077-0.11-0.074,0.085-0.018,0.023c0.009-0.01,0.064-0.062,0.063-0.073 c-0.008-0.05,0.163-0.125-0.009-0.007c0.66-0.452,0.035-1.535-0.631-1.079c-0.339,0.232-0.562,0.6-0.771,0.944 c-0.302,0.497-0.572,1.014-0.837,1.532c-0.568,1.111-1.1,2.24-1.619,3.375c-0.116,0.254-0.232,0.508-0.346,0.763 c0.124-0.096,0.249-0.191,0.374-0.287c-0.835,0.337-1.669,0.673-2.504,1.01c-0.313,0.126-0.533,0.417-0.437,0.769 C154.59,149.997,154.962,150.263,155.277,150.136L155.277,150.136z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M180.455,143.745c1.275,0.818,2.414,1.87,3.304,3.098c0.913,1.261,1.611,3.034,3.417,3.105 c0.804,0.032,0.803-1.218,0-1.25c-0.672-0.026-1.136-0.634-1.469-1.15c-0.416-0.645-0.813-1.286-1.289-1.89 c-0.931-1.178-2.068-2.183-3.331-2.993C180.407,142.23,179.779,143.312,180.455,143.745L180.455,143.745z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M214.559,451.025c-0.784-0.568-1.777-0.916-2.567-1.621 c-3.601-3.21-6.883-7.988-8.452-12.399c-1.914-5.379,4.511-25.938,5.019-26.444l-22.786,4.709c0,0,1.55,18.654,0.725,24.635 c-0.825,5.981-5.93,20.672-4.114,24.327c1.817,3.655,28.189,8.536,38.105,9.419c15.405,1.373,20.908-5.172,21.007-7.15 C241.564,465.145,218.912,454.179,214.559,451.025z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M241.206,466.037c-0.473-0.395-0.942-0.699-1.802-1.239c0,0,0.038-0.103,0,0 c-0.33,0.201-10.329,5.989-27.454,5.047c-17.415-0.96-30.502-10.855-30.502-10.855c-0.324,2.307-0.387,4.288,0.122,5.308 c0.058,0.117,0.142,0.231,0.243,0.347c0.207,0.239,0.512,0.481,0.897,0.725c5.569,3.519,28.367,7.663,37.47,8.475 c12.001,1.072,17.939-2.568,20.224-5.225C241.55,467.215,241.694,466.444,241.206,466.037z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M235.746,462.648l-20.957-11.623c-2.135-1.249-4.288-3.492-6.45-6.209c0,0,0.198-0.144,0,0 c-2.3-5.855-7.398-6.494-10.081-3.173c-1.783,2.207-2.043,5.722-1.986,8.056c-0.252,0.011-0.503,0.028-0.755,0.025 c-6.447-0.098-10.746-4.814-10.746-4.814c-1.315,5.048-2.605,10.301-3.113,13.788c0,0,13.669,10.348,30.858,11.298 c17.189,0.95,27.145-5.176,27.145-5.176L235.746,462.648z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M202.065,454.892c1.34-0.894,2.352-2.153,3.698-3.065c1.49-1.009,3.105-1.67,4.832-2.232 c0.896-0.292,0.533-1.488-0.388-1.331c-3.235,0.55-7.785,3.106-8.376,6.457C201.81,454.837,201.939,454.975,202.065,454.892 L202.065,454.892z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M209.442,457.918c2.219-1.578,3.914-3.701,6.796-4.231c0.943-0.173,0.71-1.568-0.224-1.562 c-1.685,0.01-3.269,0.919-4.481,1.963c-1.081,0.93-2.303,2.251-2.353,3.689 C209.176,457.891,209.336,457.994,209.442,457.918L209.442,457.918z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M216.244,461.083c1.053-0.672,1.673-1.819,2.593-2.643c1.061-0.95,2.3-1.34,3.549-1.981 c0.973-0.499,0.247-1.692-0.697-1.562c-2.506,0.345-6.2,3.238-6.129,5.815C215.568,461.019,215.947,461.273,216.244,461.083 L216.244,461.083z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M181.986,459.54c13.155,9.731,29.828,13.394,45.878,10.307 c4.199-0.808,8.596-1.889,12.027-4.566c0.661-0.516-0.268-1.433-0.922-0.922c-3.06,2.386-7.065,3.342-10.797,4.1 c-3.819,0.777-7.711,1.177-11.609,1.186c-7.725,0.018-15.455-1.533-22.543-4.62c-4.036-1.758-7.839-3.995-11.377-6.612 C181.969,457.914,181.317,459.045,181.986,459.54L181.986,459.54z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M115.52,423.166c0.255,0.764,0.787,10.853-2.218,18.422s15.851,9.863,15.851,9.863 s3.417-20.627,5.074-26.87C135.882,418.337,115.52,423.166,115.52,423.166z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M93.696,466.357c0,0,0.037,2.421,0.547,4.587c0.51,2.166,8.027,3.185,17.837,2.421 c9.81-0.764,15.289-5.479,15.671-5.988c0.382-0.51,1.106-7.999,1.106-7.999L93.696,466.357z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M113.736,441.003c-0.352,0.296-9.556,14.27-12.613,16.436c-3.058,2.166-7.899,5.351-7.39,9.683 c0.51,4.332,18.984,3.058,26.119,1.019c7.135-2.038,7.007-1.147,8.154-3.695c1.147-2.548,1.147-12.868,1.147-14.27 C129.152,448.775,124.184,432.212,113.736,441.003z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M104.418,453.922c3.434-0.976,7.543-0.907,10.614,1.102c0.507,0.332,0.198,1.267-0.436,1.034 c-3.343-1.224-6.334-1.96-9.902-1.136C104.045,455.073,103.773,454.106,104.418,453.922L104.418,453.922z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M108.041,450.406c3.114-1.074,6.732-0.325,9.66,0.97c0.692,0.306,0.192,1.52-0.521,1.236 c-3.039-1.211-5.84-1.391-9.059-1.619C107.783,450.969,107.716,450.518,108.041,450.406L108.041,450.406z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M111.087,446.589c3.204-1.021,6.482-0.926,9.64,0.217c0.872,0.316,0.484,1.725-0.384,1.395 c-2.921-1.109-5.953-1.355-9.019-0.752C110.765,447.558,110.536,446.764,111.087,446.589L111.087,446.589z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8380FF"
    },
    d: "M208.393,242.932l-66.555-1.243c-0.264,1.421-5.928,28.451-12.46,61.304 c-10.011,50.349-24.453,120.236-22.232,126.704c1.801,5.243,23.789,9.847,26.095,7.777l41.319-148.184 c0,0,0.65,140.872,4.945,146.573c4.294,5.701,31.571,2.046,31.571-0.045C211.076,427.308,213.76,270.252,208.393,242.932z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M208.971,245.338l0.088,1.12c-0.127,0.013-0.254,0.026-0.377,0.048 c-0.793,0.292-1.052-0.482-0.91-1.057L208.971,245.338z M208.683,250.513c-0.981,0.296-1.008,0.336-0.91,1.21 c-0.087,0.672,0.121,1.268,0.91,1.044c0-0.084,0-0.167,0-0.251c0.355,0.041,0.632-0.007,0.846-0.108l-0.158-2.001 c-0.195-0.099-0.423-0.158-0.689-0.145C208.683,250.346,208.683,250.43,208.683,250.513z M208.683,258.777 c0.481,0.061,0.896-0.133,1.328-0.268l-0.127-1.61c-0.179-0.413-0.509-0.68-1.201-0.626c0,0.083,0,0.166,0,0.25 C207.676,256.898,207.212,258.788,208.683,258.777z M146.664,259.527c-0.534-0.141-1.003-0.567-1.731-0.306 C142.433,262.468,148.661,263.071,146.664,259.527z M149.852,250.816l-2.254,0.209c-0.193,0.233-0.356,0.492-0.5,0.891 C148.578,254.454,150.811,251.994,149.852,250.816z M150.781,259.397c-1.257,1.782,0.768,3.778,2.118,1.801 C153.839,259.901,151.848,258.696,150.781,259.397z M161.849,264.139c0.776-1.484-1.108-1.77-2.033-1.207 c-0.663,0.127-0.283,1.239-0.252,1.904c0.934-0.205,1.87,0.759,2.754-0.027C162.129,264.538,161.99,264.339,161.849,264.139z  M139.94,265.143c-0.905,0.407-1.488,0.949-1.828,1.846C139.555,269.224,142.606,267.117,139.94,265.143z M152.914,254.075 c-1.068-0.887-2.167-1.022-2.706,0.437C150.658,257.001,153.647,255.899,152.914,254.075z M174.105,261.118 c1.351,1.192,2.333,1.207,3.037-0.617C176.313,258.582,174.455,259.358,174.105,261.118z M181.624,267.998 c0.505-0.76,1.928-0.77,1.425-2.032C180.957,264.042,179.009,267.318,181.624,267.998z M167.796,264.467 c0.154-1.524,0.103-1.594-1.488-2.028C164,263.523,165.849,266.108,167.796,264.467z M137.587,262.912 c-0.024-0.036-0.059-0.059-0.087-0.091l-0.432,2.108C137.698,264.692,138.137,263.957,137.587,262.912z M147.408,258.276 c0.368,0.26,0.735,0.52,1.138,0.805C152.328,258.024,147.624,253.821,147.408,258.276z M144.218,272.516 c0.814-0.06,1.677-0.125,2.577-0.196C146.652,271.067,144.852,270.783,144.218,272.516z M142.621,259.058 c2.07-0.553,1.006-3.328-0.843-2.631C140.877,257.416,141.337,258.857,142.621,259.058z M156.111,263.899 c-0.28-0.495-0.38-1.089-0.847-1.442c-1.574-0.137-2.704,1.062-1.47,2.371C154.664,264.822,155.501,264.866,156.111,263.899z  M159.161,269.423c0.372,0.442,0.526,1.088,1.114,1.384C164.287,270.373,160.194,266.438,159.161,269.423z M144.055,266.385 c0.38,1.567,0.981,1.294,2.315,1.425C147.76,265.872,145.152,264.352,144.055,266.385z M189.623,257.772 c0.49,0.253,0.367,0.612,0.306,1.006c0.762,0.174,1.408,0.059,1.922-0.494C192.57,254.689,188.699,256.434,189.623,257.772z  M137.495,270.479c0.648-1.579-0.196-2.458-1.115-2.193l-0.45,2.197C136.439,270.841,137.041,270.988,137.495,270.479z  M141.917,264.75c0.605-0.265,1.236,0.225,1.838,0.016c0.081-0.368,0.153-0.687,0.246-1.111 C142.723,261.384,140.099,262.781,141.917,264.75z M177.556,268.814c0.589-0.092,1.177-0.186,1.765-0.283 c-0.122-0.125-0.253-0.25-0.422-0.378C178.435,268.381,178.007,268.591,177.556,268.814z M150.597,272.006 c0.582-0.05,1.173-0.102,1.776-0.157c-0.204-0.197-0.481-0.364-0.876-0.453C151.098,271.432,150.798,271.683,150.597,272.006z  M184.501,256.217c-0.165,0.709-0.507,1.108-1.202,1.416C184.79,261.354,187.733,256.795,184.501,256.217z M172.731,265.004 c0.745-0.051,1.036-1.049,1.182-1.708c-0.566-1.765-1.946-0.59-2.582,0.405C170.65,264.508,172.215,264.758,172.731,265.004z  M171.391,251.469c0.103,1.793,2.247,1.71,2.648,0.189C174.003,250.306,171.741,249.811,171.391,251.469z M163.676,267.86 c0.672-0.004,1.167,0.104,1.062-0.793C165.381,263.313,159.865,266.833,163.676,267.86z M164.362,249.472l-1.46,0.135 C163.318,249.893,163.895,249.807,164.362,249.472z M141.4,252.168c0.324,0.681,0.978,0.744,1.625,0.887 c0.414-0.416,0.781-1.085,0.84-1.684l-2.148,0.199C141.617,251.758,141.414,251.933,141.4,252.168z M196.642,247.061 c0.513-0.138,0.838-0.386,1.027-0.676l-1.6,0.148C196.21,246.725,196.392,246.904,196.642,247.061z M164.422,259.303 c-1.484-0.842-2.402,1.12-1.402,2.214C164.542,262.129,165.598,260.25,164.422,259.303z M153.35,258.109 c0.521,1.025,2.048,1.046,2.431-0.063C156.316,255.771,153.389,256.045,153.35,258.109z M172.988,268.441 c-0.774,0.1-1.247,0.517-1.57,1.273c0.817-0.112,1.637-0.228,2.458-0.346c-0.01-0.109-0.027-0.222-0.055-0.339 C173.556,268.842,173.259,268.631,172.988,268.441z M188.81,248.214c-0.459-0.414-1.072-0.712-1.687-0.813 c-1.293,0.547-0.516,2.265,0.597,2.674C188.419,249.594,189.276,249.307,188.81,248.214z M162.02,251.495 c-0.418-0.499-0.777-0.93-1.136-1.359c-0.652-0.173-0.965,0.299-1.35,0.721C159.34,253.05,161.23,253.457,162.02,251.495z  M192.687,248.172c-0.408,1.499,1.445,2.276,2.159,1.08C195.606,247.76,192.909,246.382,192.687,248.172z M157.558,261.61 c0.642,0.004,1.274,0.035,1.455-0.884C157.83,257.522,154.653,260.777,157.558,261.61z M168.713,249.069 c0.175,0.314,0.495,0.642,1.053,0.959c0.391-0.271,0.727-0.505,1.099-0.766c0.021-0.146,0.02-0.267,0.024-0.395L168.713,249.069 z M180.42,248.956c0.222,1.406,2.62,0.983,2.228-0.493c0.004,0,0.007,0,0.01,0c0.034-0.287-0.005-0.507-0.085-0.679 l-1.962,0.182C180.413,248.236,180.317,248.575,180.42,248.956z M180.291,254.419c0.013,1.206,1.607,1.969,2.31,0.881 C183.789,253.563,181.275,252.74,180.291,254.419z M147.734,264.766c0.421,0.1,0.848,0.201,1.36,0.322 c0.182-0.814,0.786-1.428,0.745-2.248c-1.819-1.241-1.669,0.054-2.5,1.013C147.469,264.153,147.595,264.447,147.734,264.766z  M147.499,269.767c0.458,0.222,0.213,0.785,0.542,1.035c0.426,0,0.827,0,1.244,0c0.252-0.619,0.483-1.187,0.753-1.848 c-0.571-0.911-2.041-0.467-2.571,0.263C147.345,269.399,147.294,269.668,147.499,269.767z M153.168,269.388 c0.619,0.74,0.748,1.654,1.96,1.617c0.408-0.468,0.5-1.084,0.718-1.727c-0.433-0.492-0.965-0.623-1.463-0.867 C153.888,268.62,153.379,268.796,153.168,269.388z M194.438,261.733c0.609-0.938,0.617-1.745-0.329-2.526 c-1.422,0.584-1.973,1.681-0.826,2.887C193.718,261.958,194.104,261.838,194.438,261.733z M150.749,265.891 c-1.558,2.505,0.27,1.954,2.005,1.284C154.048,265.875,151.693,265.75,150.749,265.891z M179.725,252.258 c0-0.571,0-1.011,0-1.445c-1.222-0.814-1.936-0.712-2.064,0.808C176.814,252.85,179.171,252.943,179.725,252.258z  M170.259,253.46c-0.406,0.328-1.039-0.069-1.527,0.314c-0.225,0.712-0.028,1.327,0.272,1.926 C170.824,256.759,171.497,254.207,170.259,253.46z M180.473,261.477c0.442,0.254,0.802,0.542,1.262,0.565 c0.387-0.488,0.746-0.94,1.199-1.51C181.838,258.777,180.049,259.459,180.473,261.477z M196.113,258.52 c0.769,0.074,1.248-0.171,2.023,0.298c-0.193-0.685-0.208-1.117,0.045-1.705C196.581,255.561,195.173,256.833,196.113,258.52z  M183.905,264.485c0.357,0.116,0.705,0.23,1.058,0.346c1.427-0.468,1.081-2.171-0.23-2.411 C183.64,262.363,183.053,263.679,183.905,264.485z M141.464,270.119c1.056,1.939,1.965,0.485,2.369-0.737 C143.185,267.945,140.967,268.658,141.464,270.119z M166.638,250.106c-1.263,0.293-1.808,2.124-0.347,2.467 C167.964,252.608,168.44,250.514,166.638,250.106z M177.039,255.26c0.017-2.161-2.068-2.415-2.626-0.238 C175.29,255.427,176.363,256.521,177.039,255.26z M160.68,256.408c-1.157,0.169-0.98,1.086-1.311,1.905 C161.146,260.013,163.002,256.985,160.68,256.408z M158.242,255.76c0.127-0.334,0.192-0.619,0.335-0.853 c0.775-0.994-1.085-1.511-1.794-1.231c-0.184,0.373-0.361,0.732-0.528,1.074C156.795,255.884,156.813,255.893,158.242,255.76z  M156.409,266.105c0.135,1.277,1.519,2.612,2.266,0.918C159.482,265.491,157.114,264.706,156.409,266.105z M186.426,267.125 c0.036,0.044,0.067,0.074,0.102,0.114c0.834-0.163,1.663-0.331,2.483-0.503C188.625,265.01,186.814,265.702,186.426,267.125z  M153.227,251.508c0.423,0.389,0.313,1.284,1.262,1.272c0.525-0.364,1.073-0.728,1.606-1.137 C155.516,249.984,153.907,250.355,153.227,251.508z M166.067,268.455c-0.872,0.766-0.769,1.576-0.158,1.969 c0.576-0.07,1.155-0.142,1.736-0.215C168.148,268.937,167.504,268.401,166.067,268.455z M140.489,271.69 c-0.444-0.193-0.85-0.37-1.257-0.547c-0.591,0.727-0.792,1.316-0.774,1.759c0.6-0.036,1.281-0.078,2.033-0.127 C140.558,272.479,140.569,272.122,140.489,271.69z M186.447,254.592c0.801,1.305,2.087,1.714,2.705,0.044 C188.29,253.253,187.092,252.939,186.447,254.592z M186.713,260.073c-0.439,1.715,1.761,2.321,2.369,0.711 C189.458,259.658,187.315,259.242,186.713,260.073z M140.166,253.419c-0.273,0.113-0.54,0.224-0.808,0.336l-0.395,1.928 c0.223,0.198,0.529,0.351,0.781,0.349C140.543,255.357,141.391,254.129,140.166,253.419z M199.128,249.564 c1.535,0.326,1.676-0.697,1.667-2.025C199.353,246.813,197.643,248.331,199.128,249.564z M174.944,249.491 c1.186,0.468,1.798-0.388,1.766-1.164l-2.156,0.2C174.681,248.84,174.804,249.146,174.944,249.491z M177.455,256.796 c-0.439,1.857,2.494,2.542,2.45,0.355C178.704,256.136,178.642,256.128,177.455,256.796z M165.745,256.764 c-0.1,0.831,0.265,1.249,0.255,2.001c0.214,0.107,0.433,0.214,0.693,0.342c0.879-0.618,0.874-1.476,1.096-2.238 c-0.496-0.264-0.763-0.675-1.276-0.684C166.242,256.391,165.949,256.611,165.745,256.764z M139.472,261.534 c1.418-0.681,1.418-0.681,1.272-1.924c-0.383-0.147-0.764-0.293-1.208-0.463C138.453,259.681,138.162,261.249,139.472,261.534z  M177.495,263.081c0.19,0.715,0.024,1.449,0.649,2.01c0.274-0.016,0.592-0.036,0.881-0.053c0.261-0.74,0.963-1.299,0.456-2.2 C178.759,262.691,178.061,262.376,177.495,263.081z M204.498,260.073c0.505,0.734,0.016,1.765,0.976,2 c0.805-0.384,1.39-0.865,1.412-1.82C206.337,259.579,205.111,259.357,204.498,260.073z M205.678,253.772 c-0.717-0.49-0.955,0.337-1.251,0.9c0.721,1.582,2.502,1.673,2.47-0.227C206.955,253.666,206.073,254.141,205.678,253.772z  M203.704,245.826l-2.221,0.206C202.32,247.389,203.241,247.04,203.704,245.826z M206.314,247.591 c-1.743-0.499-2.738,2.314-0.664,2.154C206.977,249.587,206.752,248.601,206.314,247.591z M192.95,253.599 c-0.58,0.587-0.63,1.09-0.14,1.638C195.264,256.432,195.715,253.06,192.95,253.599z M203.866,257.279 c-0.488-1.585-2.419-0.855-2.145,0.564C202.198,259.528,203.596,258.465,203.866,257.279z M199.476,253.339 c-0.474,0.323-0.916,0.614-1.062,1.269c0.792,0.538,1.286,1.469,2.213,0.589c0.06-0.315,0.128-0.673,0.196-1.025 C200.5,253.661,200.006,253.484,199.476,253.339z M173.589,257.416c-0.818-1.166-2.025-0.969-2.152,0.501 c0.12,0.245,0.245,0.501,0.346,0.707C173.033,259,173.514,258.95,173.589,257.416z M203.595,250.49 c-0.768,0.09-1.493-0.047-2.151,0.339c0.107,0.761,0.561,1.231,0.963,1.724C203.836,252.933,203.877,251.475,203.595,250.49z  M170.383,259.409c-0.915-0.23-1.524,0.155-2.018,1.053c0.49,0.363,0.916,0.678,1.343,0.993 c0.372-0.294,0.898-0.457,1.149-0.865C170.829,259.938,170.839,259.935,170.383,259.409z M185.658,252.449 c0.014-0.747,0.172-2.074-0.931-1.825C182.884,251.432,183.59,253.636,185.658,252.449z M201.753,263.439 c0.594-0.193,1.177-0.389,1.746-0.589C202.962,261.937,202.05,262.524,201.753,263.439z M174.762,266.317 c-0.2,1.574,0.37,1.792,1.729,1.151C177.53,265.563,176.081,265.199,174.762,266.317z M197.286,264.559 c0.574-1.106,0.502-1.435-0.492-2.337c-0.337,0.169-0.698,0.35-1.024,0.514C195.627,264.251,195.841,264.506,197.286,264.559z  M197.542,250.895c-0.731-1.07-1.517,0.571-2.136,0.861C195.781,253.803,198.166,252.298,197.542,250.895z M199.44,259.368 c-1.781,0.452-0.179,2.586,1.274,2.362C200.878,260.868,200.208,259.682,199.44,259.368z M168.26,266.894 c0.543,0.33,1.123,0.624,1.756,0.901c0.709-0.436,0.711-0.97,0.51-1.59C169.603,265.743,168.622,265.47,168.26,266.894z  M191.315,250.919c-0.732-0.936-1.864,0.294-1.587,1.234C190.787,253.579,192.399,252.286,191.315,250.919z M193.821,265.653 c0.183-0.044,0.367-0.088,0.548-0.133c-0.061-0.05-0.121-0.1-0.193-0.147C194.052,265.472,193.939,265.56,193.821,265.653z  M162.476,254.872c0.86,0.194,1.583,0.911,2.354,0.369C165.422,253.23,163.002,253.066,162.476,254.872z M146.117,253.817 c-0.514,0.355-0.866-0.088-1.39-0.143c-0.227,0.614-0.105,1.178-0.101,1.77c0.464,0.184,0.9,0.357,1.316,0.522 C146.062,255.358,147.183,253.809,146.117,253.817z M190.869,262.238c-0.872,0.148-1.049,0.809-1.287,1.422 c0.723,0.543,0.831,0.558,2.274,0.312C192.108,263.035,191.329,262.716,190.869,262.238z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M180.68,438.032c10.056,2.223,20.578,1.671,30.337-1.628c0.758-0.256,0.433-1.464-0.332-1.205 c-9.548,3.228-19.828,3.804-29.672,1.628C180.229,436.654,179.894,437.858,180.68,438.032L180.68,438.032z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M106.26,431.932c8.34,4.094,17.54,6.145,26.831,5.95c0.803-0.017,0.806-1.267,0-1.25 c-9.066,0.19-18.058-1.783-26.2-5.779C106.172,430.499,105.537,431.577,106.26,431.932L106.26,431.932z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M120.098,434.921c5.788-22.239,11.216-44.571,16.431-66.951 c5.281-22.666,10.344-45.383,15.3-68.122c2.728-12.517,5.424-25.041,8.105-37.568c0.168-0.785-1.037-1.12-1.205-0.332 c-4.811,22.474-9.667,44.938-14.674,67.368c-5.071,22.713-10.293,45.392-15.793,68.005 c-3.028,12.447-6.142,24.872-9.369,37.269C118.69,435.367,119.896,435.7,120.098,434.921L120.098,434.921z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M199.655,437.499c1.12-22.212,1.48-44.461,1.064-66.698 c-0.412-22.071-1.582-44.129-3.509-66.119c-1.093-12.473-2.431-24.923-4.007-37.344c-0.1-0.787-1.351-0.797-1.25,0 c2.798,22.064,4.842,44.222,6.111,66.426c1.26,22.039,1.764,44.122,1.508,66.195c-0.145,12.52-0.537,25.036-1.168,37.54 C198.364,438.303,199.614,438.301,199.655,437.499L199.655,437.499z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M187.58,149.268c0,0,15.315,2.764,16.184,6.023c0.869,3.259,7.062,86.962,5.324,93.479 c-1.738,6.518-30.13,10.133-32.52,7.743s-0.946-6.095-0.946-6.095v-66.48L187.58,149.268z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D2F4"
    },
    d: "M154.455,149.268l21.168,34.671v67.597c0,0-1.295,4.616-4.12,5.326 c-2.824,0.71-33.892-2.225-36.282-5.484c-2.39-3.259,2.874-51.506,2.874-51.506s1.637-15.624,1.42-22.141 c-0.217-6.518-0.362-23.202-0.362-23.202S150.327,149.485,154.455,149.268z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8380FF"
    },
    d: "M144.069,152.346c3.462,3.468,9.846,58.48,7.891,61.328c-1.669,2.431,7.356,0,7.356,0 c0.116-24.456-1.986-46.487-8.801-63.476L144.069,152.346z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8380FF"
    },
    d: "M199.813,152.597c0.044,0.958-5.306,58.197-7.12,60.522c-1.813,2.325-7.348,0.341-7.348,0.341 l7.321-63.093C195.539,150.893,198.206,151.51,199.813,152.597z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8380FF"
    },
    points: "137.328,207.278 136.413,216.872 208.39,216.872 207.825,207.278  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8380FF"
    },
    points: "135.035,234.783 134.656,243.738 209.399,244.385 209.227,234.783  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M176.48,255.203c1.258-18.505,1.213-37.08,0.513-55.607c-0.197-5.221-0.45-10.441-0.745-15.658 c-0.045-0.8-1.296-0.805-1.25,0c1.046,18.514,1.567,37.075,0.999,55.616c-0.16,5.221-0.412,10.438-0.766,15.649 C175.175,256.006,176.425,256.002,176.48,255.203L176.48,255.203z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M171.494,208.644c-0.888,1.515,0.485,2.881,1.855,2.162c0.246-0.569,0.469-1.13,0.67-1.683 C173.603,208.298,172.315,207.783,171.494,208.644z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M170.827,213.364c0.171-0.867-0.01-1.553-0.659-2.18c-0.683,0.061-1.295,0.115-1.947,0.174 C167.731,213.192,169.247,214.856,170.827,213.364z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M174.074,204.798c-0.44-1.847,0.558-2.842-2.289-2.477 C170.78,204.092,172.212,205.626,174.074,204.798z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M166.886,214.105c-2.162,0.14-1.722,3.31,0.351,2.845 C168.588,216.491,168.33,214.266,166.886,214.105z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M142.593,229.046c1.73-0.668,1.227-0.763,1.12-2.286c-0.08-0.109-0.163-0.202-0.247-0.284 l-1.729,1.999C142.01,228.658,142.289,228.844,142.593,229.046z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M141.106,230.175c-0.187-0.113-0.359-0.237-0.527-0.361l-1.684,1.947 C139.779,232.23,140.82,231.493,141.106,230.175z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M174.747,193.394c0.006,0.793-1.161,1.569-0.212,2.174c0.241,0.079,0.471,0.115,0.693,0.128 c-0.118-0.979-0.276-1.749-0.446-2.347C174.771,193.366,174.757,193.376,174.747,193.394z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M147.689,226.869c-1.224,1.879,1.1,2.714,2.458,1.404 C149.784,226.777,148.84,225.138,147.689,226.869z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M173.454,192.94c0.632-0.335,0.722-0.865,0.539-1.391c-0.095-0.125-0.159-0.182-0.159-0.182 l-1.325,1.532C172.787,193.008,173.107,193.035,173.454,192.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M168.414,218.99c0.053,0.081,0.113,0.148,0.176,0.212c0.494-0.722,0.97-1.444,1.422-2.165 C169.005,217.132,168.171,218.015,168.414,218.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M167.872,208.934c-0.771-0.72-2.171-1.045-2.705,0.133c0.466,0.793,0.588,1.931,1.756,1.926 C167.335,210.361,168.766,209.816,167.872,208.934z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M157.477,225.991c0.516-0.251,0.87-0.411,1.408-0.635c-0.066-0.876-0.164-1.804-0.973-2.292 C156.19,223.608,155.444,225.237,157.477,225.991z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M169.587,205.006c-1.111,0.793-1.701,1.922-0.524,2.949c1.239,0.249,1.375-0.984,2.132-1.443 C170.882,205.599,170.154,205.442,169.587,205.006z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M146.988,224.347c-0.343-0.39-0.682-0.641-0.998-0.788l-1.433,1.657 c0.122,0.223,0.295,0.45,0.533,0.673C145.93,226.389,146.974,225.267,146.988,224.347z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M161.84,214.884c-0.263-0.292-0.535-0.594-0.806-0.896c-1.061,0.233-1.617,0.712-1.859,1.544 C159.865,217.607,162.178,216.694,161.84,214.884z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M145.657,229.312c-1.751-0.203-1.217,2.628-0.027,2.621 C147.449,231.698,147.533,229.375,145.657,229.312z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M157.039,213.721c0.534-0.111,1.008-0.209,1.469-0.305c0.057-0.63,0.057-0.63,0.548-1.302 c-0.631-1.141-1.552-0.922-2.493-0.78l-0.196,0.226C156.346,212.386,156.269,213.181,157.039,213.721z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M151.708,219.779c0.656-0.152,1.1-0.788,1.21-1.441c0.483-0.897-0.834-0.787-1.352-0.995 c-0.06-0.021-0.113-0.027-0.168-0.037l-1.044,1.207C150.372,219.227,150.805,219.954,151.708,219.779z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M170.706,194.983l-0.399,0.462c0.054-0.004,0.108-0.007,0.164-0.001 C170.553,195.284,170.629,195.134,170.706,194.983z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M157.915,219.773c1.373-0.206,1.085-2.521-0.357-2.659 C155.679,217.64,156.235,220.002,157.915,219.773z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M148.672,220.457l-1.264,1.462C149.279,224.074,151.475,221.036,148.672,220.457z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M162.19,221.512c-0.752-0.78-1.595-1.946-2.555-0.85c0,0.635,0,1.168,0,1.728 c0.382,0.207,0.739,0.4,1.042,0.565C161.538,222.832,161.683,222.09,162.19,221.512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M174.125,197.794c-0.262-2.032-3.093-2.006-2.704,0.155 C172,199.126,173.408,198.622,174.125,197.794z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M137.765,240.25c0.105-2.254-1.664-2.904-2.406-0.617 C135.188,240.908,137.032,241.146,137.765,240.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M150.421,224.216c-0.449,1.606,2.539,2.265,2.433,0.314 C152.639,223.191,150.798,222.625,150.421,224.216z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M162.881,205.352c-0.173,0.694-0.357,1.317-0.15,2.133 C165.785,208.282,165.931,204.583,162.881,205.352z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M142.423,232.319c-1.394,0.337-1.407,1.547-0.407,2.432c0.405,0,0.808,0,1.193,0 c0.239-0.35,0.445-0.653,0.636-0.932C143.728,232.973,143.283,232.5,142.423,232.319z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M174.524,206.094c0.054,0.271,0.12,0.525,0.2,0.767c0.114-0.446,0.212-0.885,0.288-1.314 C174.828,205.677,174.66,205.86,174.524,206.094z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M150.957,237.537c0.034,0.029,0.064,0.037,0.097,0.061c0.637-0.459,1.286-0.954,1.94-1.475 C151.648,234.721,149.223,235.774,150.957,237.537z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M162.8,213.452c0.426,0.069,0.867,0.139,1.284,0.207 C166.97,211.304,160.679,210.093,162.8,213.452z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M153.1,230.544c-0.6-1.412-1.746-1.541-2.756-0.44c0.144,0.432,0.284,0.852,0.431,1.29 C151.939,231.911,152.699,231.878,153.1,230.544z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M147.116,239.128c0.033,0.307,0.151,0.557,0.293,0.787c0.202-0.114,0.388-0.211,0.597-0.331 c0.391-0.225,0.791-0.472,1.194-0.729C148.654,238.438,147.835,238.327,147.116,239.128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M155.385,216.39c0.142-0.386,0.279-0.758,0.423-1.146c-0.565-0.29-0.613-0.989-1.265-1.134 c-0.26,0.172-0.561,0.372-0.893,0.592l-0.286,0.33C153.106,216.293,154.28,217.297,155.385,216.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M175.359,201.757c0.038-0.783,0.058-1.508,0.061-2.181c-0.294,0.046-0.612,0.135-0.972,0.322 C174.184,200.926,174.606,201.49,175.359,201.757z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M170.751,199.759c-0.264-0.17-0.572-0.368-0.832-0.536 C165.728,200.954,171.527,203.557,170.751,199.759z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M162.366,218.067c0.063,0.936,0.485,1.585,1.445,1.909 C165.893,218.487,164.379,216.447,162.366,218.067z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M139.264,235.049c-0.381,0.744-0.78,1.323-0.923,2.013 C140.625,239.084,141.998,236.02,139.264,235.049z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M162.705,223.692c-0.837,1.209,0.115,1.433,0.824,2.099c0.39-0.458,0.775-0.92,1.155-1.386 C164.38,223.628,163.386,223.014,162.705,223.692z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M158.909,230.805c0.112-0.573-0.272-1.222-0.821-1.671c-1.413,0.921-2.825,2.386-0.143,2.618 C158.267,231.44,158.589,231.125,158.909,230.805z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M155.29,232.692c-1.173-0.742-1.788-0.07-1.941,1.142c0.197,0.313,0.386,0.618,0.607,0.972 c0.26-0.135,0.599-0.189,0.927-0.252c0.347-0.3,0.695-0.606,1.044-0.92C155.622,233.406,155.106,233.296,155.29,232.692z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M137.852,233.737c-0.07-0.195-0.13-0.364-0.195-0.544l-1.378,1.593 C136.734,234.949,137.309,234.744,137.852,233.737z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M141.875,238.617c-0.094,0.753-0.094,0.753-0.724,1.401 C143.365,243.034,145.357,237.655,141.875,238.617z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M155.951,220.743c-0.401-0.136-0.885-0.347-1.245-0.554c-0.626,0.418-1.086,0.858-1.062,1.712 c0.222,0.234,0.497,0.526,0.734,0.778c0.738-0.038,1.22-0.403,1.72-0.863C156.097,221.465,156.152,221.095,155.951,220.743z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M160.489,208.288c-0.695-0.074-0.832,0.77-1.393,1.045c0.307,1.299,1.667,0.866,2.648,0.931 c0.115-0.351,0.203-0.616,0.277-0.844C161.757,208.691,161.167,208.423,160.489,208.288z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M160.793,226.321c-1.053-0.135-1.619,1.292-1.005,2.211c0.673,0.214,1.336-0.047,1.726-0.459 c0.026-0.028,0.051-0.056,0.077-0.084C162.057,227.418,162.004,226.613,160.793,226.321z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M147.165,233.533c0.551,0.516,0.851,1.494,1.702,1.237c0.481-0.137,1.296-0.553,0.862-1.152 C149.102,232.556,147.555,231.992,147.165,233.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M166.106,204.697c1.426-0.189,1.618-0.344,1.945-1.544c-0.359-0.826-1.213-0.533-1.871-0.857 c-0.598,0.54-0.631,1.072-0.114,1.639C166.212,204.179,165.724,204.462,166.106,204.697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M134.709,242.227l-0.019,0.551c0.092-0.035,0.182-0.069,0.278-0.105 C134.891,242.5,134.804,242.353,134.709,242.227z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M155.046,226.463c-1.426-0.154-3.034,1.647-1.081,2.083 C155.287,228.761,156.343,226.836,155.046,226.463z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M145.626,238.024c0.422-0.23,0.781-0.425,1.198-0.653c0.24-0.788-1.544-3.346-1.337-1.488 C143.347,236.481,144.835,237.139,145.626,238.024z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M165.733,220.937c-0.098,0.296-0.203,0.605-0.305,0.909c0.296,0.393,0.528,0.593,0.753,0.677 c0.438-0.57,0.863-1.144,1.28-1.719C167.001,220.468,166.238,220.404,165.733,220.937z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M138.386,242.83c-0.033,1.32,1.51,0.528,2.174,0.057 C141.01,240.695,138.696,241.103,138.386,242.83z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M139.153,154.528c-0.688,0.351-3.694,0.409-9.883,8.786 c-6.189,8.377-10.354,25.904-11.501,40.892c-1.146,14.988,3.345,35.393,19.161,31.284c11.49-2.985,39.996-36.426,37.704-46.337 c-1.527-6.601-8.742-10.19-12.421-12.702c-1.767-1.207-4.977,1.342-6.465,2.914c-5.697,6.016-13.922,15.461-13.558,14.25 c0.458-1.524,0.996-5.585,0.923-21.121C143.08,165.148,139.153,154.528,139.153,154.528z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE7A"
    },
    d: "M163.482,177.076c0,0,12.741-17.615,20.89-20.544c8.15-2.929,23.611,3.893,23.22,6.381 c-0.39,2.487-0.707,3.086-3.319,2.683s-6.585-3.48-8.125-3.264c-1.54,0.216-1.54,0.216-1.54,0.216s6.294,6.23,0.993,9.715 c0,0-0.127,2.389-2.885,3.361c0,0-0.041,2.777-3.853,4.143c-3.811,1.366-5.757-1.748-5.757-1.748s-1.991,4.467-4.959,5.038 c-2.969,0.57-2.969,0.57-2.969,0.57s-2.953,6.388-5.27,6.775C167.592,190.788,155.913,186.453,163.482,177.076z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M180.492,168.196c2.667-0.005,5.277,0.73,7.582,2.062c1.134,0.655,2.164,1.467,3.086,2.396 c0.881,0.889,1.701,1.963,1.768,3.259c0.044,0.852-1.276,1.077-1.321,0.218c-0.059-1.145-0.847-2.015-1.632-2.779 c-0.854-0.831-1.84-1.55-2.884-2.123c-2.067-1.136-4.386-1.708-6.74-1.703C179.491,169.528,179.639,168.197,180.492,168.196 L180.492,168.196z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M195.052,173.038c-1.784-5.576-7.254-9.15-13.094-8.41c-0.854,0.108-1.073-1.212-0.218-1.321 c6.385-0.809,12.563,3.028,14.532,9.181C196.532,173.301,195.314,173.857,195.052,173.038L195.052,173.038z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M194.519,163.656c-2.527-2.192-5.888-3.274-9.22-2.898c-0.854,0.096-1.075-1.224-0.218-1.321 c3.671-0.415,7.434,0.715,10.231,3.14C195.958,163.138,195.172,164.222,194.519,163.656L194.519,163.656z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M182.372,178.097c0.69-1.382,1.555-2.664,2.603-3.799c0.237-0.256,0.633-0.386,0.936-0.142 c0.257,0.207,0.396,0.661,0.142,0.936c-0.495,0.536-0.954,1.105-1.371,1.705c-0.205,0.295-0.399,0.597-0.583,0.906 c-0.048,0.08-0.094,0.16-0.14,0.24c-0.023,0.04-0.046,0.08-0.068,0.121c0.028-0.051,0.022-0.04-0.017,0.031 c-0.088,0.163-0.173,0.328-0.256,0.493c-0.156,0.312-0.517,0.534-0.868,0.378C182.443,178.828,182.205,178.432,182.372,178.097 L182.372,178.097z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M157.189,178.823c-9.58,9.665-18.626,19.846-27.096,30.497 c-0.536,0.674-1.477-0.279-0.946-0.946c8.47-10.651,17.516-20.832,27.097-30.497 C156.849,177.264,157.796,178.211,157.189,178.823L157.189,178.823z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M171.019,191.365c-6.24-0.387-11.564-4.845-12.945-10.961c-0.189-0.839,1.101-1.197,1.29-0.356 c1.246,5.516,5.989,9.626,11.654,9.978C171.874,190.08,171.88,191.419,171.019,191.365L171.019,191.365z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M133.685,162.89c2.491,2.985,4.982,5.969,7.473,8.954c0.516,0.618,1.396-0.27,0.884-0.884 c-2.491-2.985-4.982-5.969-7.473-8.954C134.053,161.388,133.173,162.277,133.685,162.89L133.685,162.89z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M135.387,236.334c-6.068,0.256-11.182-3.993-13.828-9.173 c-2.945-5.765-3.462-12.618-3.584-18.985c-0.255-13.262,2.634-26.632,8.46-38.558c2.793-5.717,6.634-11.202,12.703-13.724 c0.732-0.304,0.411-1.514-0.332-1.205c-5.525,2.296-9.39,6.795-12.227,11.939c-3.308,5.998-5.694,12.593-7.336,19.231 c-1.694,6.851-2.553,13.918-2.532,20.976c0.02,6.62,0.497,13.696,3.226,19.817c2.704,6.067,8.478,11.227,15.451,10.932 C136.188,237.55,136.193,236.3,135.387,236.334L135.387,236.334z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M206.943,145.686c-1.443,1.152-14.052,42.208-12.71,44.331 c1.256,1.987,31.417,0.046,31.417,0.046s16.25-41.477,16.319-42.75c0.01-0.194-0.203-1.985-1.564-2.293 C233.568,143.471,207.914,144.911,206.943,145.686z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M220.112,155.345c-0.682,0.976-0.514,2.271,0.374,2.891c0.888,0.621,2.161,0.332,2.843-0.644 c0.682-0.976,0.514-2.27-0.374-2.891C222.067,154.08,220.794,154.369,220.112,155.345z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8380FF"
    },
    d: "M197.505,189.27c1.718-7.66,3.736-15.255,5.954-22.784c1.852-6.284,3.787-12.583,6.23-18.666 c-0.201,0.153-0.402,0.306-0.603,0.459c8.8-0.506,17.623-1.01,26.439-1.09c1.456-0.013,3.382-0.269,4.757,0.188 c0.765,0.254,1.093-0.952,0.332-1.205c-1.199-0.398-2.729-0.236-3.968-0.237c-2.53-0.002-5.06,0.074-7.588,0.16 c-5.432,0.183-10.861,0.445-16.288,0.733c-1.228,0.065-2.457,0.131-3.685,0.202c-0.304,0.018-0.494,0.188-0.603,0.459 c-2.443,6.084-4.378,12.382-6.23,18.666c-2.218,7.53-4.236,15.124-5.955,22.784 C196.124,189.721,197.329,190.056,197.505,189.27L197.505,189.27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8380FF"
    },
    d: "M207.158,146.706c0.411,0.513,0.882,0.973,1.293,1.486c0.094,0.117,0.299,0.183,0.442,0.183 c0.153,0,0.336-0.068,0.442-0.183c0.109-0.119,0.19-0.275,0.183-0.442c-0.007-0.055-0.015-0.111-0.022-0.166 c-0.03-0.106-0.083-0.198-0.161-0.276c-0.412-0.513-0.882-0.973-1.293-1.486c-0.094-0.117-0.299-0.183-0.442-0.183 c-0.153,0-0.336,0.068-0.442,0.183c-0.109,0.119-0.191,0.275-0.183,0.442c0.007,0.055,0.015,0.111,0.022,0.166 C207.027,146.536,207.081,146.628,207.158,146.706L207.158,146.706z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE7A"
    },
    d: "M240.362,164.65c0,0,3.735-1.62,2.145-5.755c-1.591-4.135-14.741-5.089-16.013-4.347 c-1.273,0.742-1.167,3.391,0,4.347c1.166,0.956,6.575,1.38,6.575,1.38c2.304,0.335,3.165,1.194,3.182,2.36 c0,0-8.709-1.684-11.148-0.623c-2.439,1.061-1.462,4.35-0.036,5.098c0,0-4.956,1.604-0.829,6.834c0,0-2.834,2.131-1.562,3.828 c1.273,1.697,6.469,2.094,6.469,2.094l-4.878,13.669c0,0-1.061,3.219,0.424,3.219c1.485,0,6.755-3.075,7.99-8.484 c1.236-5.408,1.766-9.544,1.766-9.544S238.975,166.704,240.362,164.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M222.207,167.04c2.727-0.373,5.541-0.175,8.254,0.227c2.482,0.367,6.283,1.007,6.521,4.119 c0.065,0.854-1.265,0.85-1.33,0c-0.11-1.438-1.752-1.991-2.923-2.309c-1.066-0.29-2.163-0.478-3.258-0.614 c-2.261-0.281-4.643-0.45-6.91-0.14C221.724,168.437,221.362,167.156,222.207,167.04L222.207,167.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M221.571,173.677c2.297-0.567,4.761-0.639,7.113-0.491c1.119,0.07,2.254,0.195,3.342,0.471 c1.066,0.27,2.177,0.765,2.508,1.905c0.24,0.824-1.044,1.175-1.283,0.354c-0.236-0.81-1.525-0.983-2.23-1.12 c-1.009-0.196-2.039-0.278-3.066-0.315c-2.004-0.073-4.076-0.004-6.031,0.479C221.093,175.165,220.739,173.883,221.571,173.677 L221.571,173.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M225.099,160.391c3.041-0.312,6.162,0.143,9.134,0.784c1.276,0.275,2.544,0.6,3.787,1 c0.707,0.228,1.479,0.453,2.115,0.847c0.727,0.45,0.059,1.601-0.671,1.149c-0.583-0.361-1.29-0.553-1.938-0.757 c-1.198-0.379-2.418-0.689-3.646-0.955c-2.863-0.619-5.85-1.037-8.78-0.737C224.249,161.808,224.255,160.477,225.099,160.391 L225.099,160.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M231.085,154.901c-0.281,1.157-1.154,2.094-2.267,2.497c-1.173,0.425-2.494,0.1-3.436-0.677 c-0.277-0.229-0.237-0.704,0-0.941c0.274-0.274,0.663-0.229,0.941,0c0.054,0.045,0.095,0.075,0.209,0.144 c0.09,0.055,0.184,0.105,0.28,0.149c0.112,0.051-0.135-0.042,0.07,0.027c0.045,0.015,0.089,0.031,0.134,0.045 c0.113,0.035,0.227,0.06,0.343,0.084c0.108,0.022,0.004,0.004,0.068,0.01c0.047,0.004,0.094,0.008,0.141,0.01 c0.118,0.005,0.235,0.004,0.353-0.005c0.018-0.001,0.165-0.021,0.068-0.005c0.046-0.008,0.093-0.016,0.139-0.027 c0.115-0.025,0.225-0.06,0.336-0.097c0.031-0.01,0.094-0.037,0.029-0.009c0.051-0.022,0.102-0.048,0.151-0.074 c0.089-0.047,0.176-0.099,0.26-0.155c-0.002,0.001,0.136-0.099,0.096-0.067c-0.047,0.037,0.077-0.067,0.088-0.077 c0.075-0.068,0.147-0.139,0.215-0.214c0.038-0.042,0.075-0.084,0.11-0.128c-0.054,0.068,0.02-0.03,0.037-0.055 c0.057-0.083,0.11-0.17,0.158-0.259c0.027-0.049,0.052-0.1,0.075-0.15c0.05-0.107-0.043,0.138,0.023-0.059 c0.036-0.107,0.069-0.213,0.096-0.323c0.085-0.349,0.48-0.558,0.818-0.465C230.977,154.181,231.17,154.551,231.085,154.901 L231.085,154.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M228.735,161.398c0.004,1.253-0.755,2.49-1.911,2.999c-1.224,0.539-2.69,0.27-3.645-0.668 c-0.256-0.252-0.252-0.688,0-0.941c0.257-0.257,0.684-0.253,0.941,0c0.047,0.046,0.094,0.09,0.143,0.133 c0.083,0.074-0.009-0.001,0.045,0.036c0.099,0.068,0.2,0.131,0.306,0.186c0.013,0.007,0.162,0.076,0.098,0.049 c-0.064-0.027,0.089,0.032,0.103,0.037c0.113,0.038,0.229,0.069,0.347,0.093c0.042,0.008,0.146,0.023,0.049,0.012 c0.065,0.007,0.13,0.012,0.195,0.015c0.109,0.005,0.217,0,0.326-0.007c0.199-0.013-0.114,0.029,0.081-0.011 c0.053-0.011,0.106-0.022,0.159-0.035c0.053-0.013,0.105-0.028,0.156-0.045c0.005-0.002,0.194-0.076,0.083-0.027 c0.097-0.043,0.191-0.094,0.281-0.151c0.054-0.034,0.107-0.069,0.158-0.107c-0.074,0.055,0.011-0.011,0.039-0.036 c0.088-0.077,0.171-0.16,0.248-0.248c0.01-0.011,0.11-0.138,0.068-0.082c-0.042,0.056,0.051-0.077,0.059-0.089 c0.064-0.098,0.122-0.201,0.173-0.306c0.018-0.037,0.054-0.134,0.022-0.046c0.022-0.06,0.043-0.12,0.062-0.181 c0.031-0.102,0.054-0.205,0.073-0.31c-0.024,0.133,0.005-0.063,0.006-0.076c0.004-0.064,0.005-0.128,0.005-0.192 c-0.001-0.348,0.307-0.681,0.665-0.665C228.431,160.749,228.733,161.025,228.735,161.398L228.735,161.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M227.495,168.031c-0.115,1.182-0.792,2.303-1.877,2.84c-1.126,0.559-2.542,0.479-3.57-0.265 c-0.291-0.21-0.433-0.578-0.239-0.91c0.168-0.287,0.617-0.451,0.91-0.239c0.093,0.067,0.188,0.131,0.289,0.187 c0.05,0.028,0.102,0.053,0.153,0.079c0.056,0.028-0.037-0.009,0.063,0.027c0.108,0.039,0.217,0.074,0.329,0.101 c0.067,0.016,0.135,0.03,0.202,0.042c-0.072-0.013-0.008,0,0.028,0.003c0.114,0.01,0.229,0.016,0.344,0.013 c0.069-0.001,0.137-0.006,0.206-0.012c0.037-0.003,0.1-0.016,0.028-0.003c0.113-0.02,0.225-0.045,0.335-0.078 c0.066-0.02,0.131-0.042,0.195-0.067c-0.078,0.031,0.029-0.014,0.055-0.028c0.096-0.048,0.189-0.101,0.279-0.16 c0.045-0.029,0.089-0.06,0.132-0.092c-0.073,0.055,0.013-0.014,0.04-0.038c0.081-0.071,0.157-0.146,0.23-0.225 c0.036-0.04,0.071-0.08,0.105-0.122c-0.057,0.071,0.01-0.016,0.031-0.046c0.061-0.088,0.117-0.18,0.168-0.275 c0.025-0.047,0.049-0.095,0.073-0.144c0.052-0.105-0.003,0.017,0.02-0.048c0.036-0.101,0.07-0.202,0.095-0.307 c0.013-0.052,0.023-0.105,0.034-0.157c0.032-0.141-0.005,0.079,0.011-0.078c0.034-0.345,0.282-0.682,0.665-0.665 C227.161,167.381,227.531,167.661,227.495,168.031L227.495,168.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M226.97,174.18c-0.019,1.104-0.585,2.136-1.503,2.749c-0.973,0.651-2.247,0.665-3.285,0.173 c-0.315-0.149-0.422-0.626-0.239-0.91c0.209-0.324,0.573-0.398,0.91-0.239c0.176,0.083-0.12-0.037,0.063,0.028 c0.038,0.014,0.076,0.027,0.114,0.039c0.105,0.034,0.213,0.061,0.321,0.081c0.056,0.01,0.13,0.016,0.032,0.007 c0.05,0.005,0.1,0.009,0.15,0.011c0.111,0.005,0.221,0.004,0.332-0.004c0.04-0.003,0.08-0.007,0.12-0.011 c-0.149,0.016,0.045-0.011,0.061-0.015c0.098-0.02,0.196-0.046,0.291-0.078c0.048-0.016,0.094-0.034,0.142-0.051 c0.069-0.025-0.073,0.04,0.034-0.018c0.096-0.052,0.191-0.102,0.282-0.163c0.039-0.026,0.078-0.053,0.115-0.082 c-0.074,0.057-0.024,0.017,0.018-0.021c0.07-0.062,0.137-0.128,0.201-0.198c0.032-0.035,0.061-0.072,0.092-0.107 c-0.095,0.105,0.019-0.027,0.032-0.046c0.053-0.077,0.103-0.158,0.148-0.24c0.023-0.041,0.044-0.083,0.064-0.126 c0.026-0.054,0.045-0.11,0.012-0.022c0.033-0.088,0.065-0.176,0.09-0.268c0.015-0.054,0.029-0.109,0.04-0.164 c0.004-0.018,0.033-0.173,0.017-0.078c-0.016,0.093,0.007-0.077,0.007-0.08c0.004-0.057,0.006-0.113,0.007-0.169 c0.006-0.348,0.302-0.681,0.665-0.665C226.66,173.531,226.976,173.807,226.97,174.18L226.97,174.18z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421B36"
    },
    d: "M231.1,193.858c-1.787,1.569-3.837,3.064-6.255,3.398c-2.068,0.286-4.36-0.306-5.687-2.004 c-0.524-0.671,0.416-1.625,0.946-0.946c1.1,1.409,2.971,1.911,4.696,1.613c2.064-0.357,3.816-1.657,5.353-3.007 C230.798,192.346,231.748,193.288,231.1,193.858L231.1,193.858z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCashBooking);
export default __webpack_public_path__ + "static/media/new_cash_booking.a225ca68.svg";
export { ForwardRef as ReactComponent };